/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AboutPageDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  CookiesPageDefaultContentTemplateDynamicZoneInput: {
    input: any;
    output: any;
  };
  CopyrightPageDefaultContentTemplateDynamicZoneInput: {
    input: any;
    output: any;
  };
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  KnowledgeBaseDefaultContentTemplateDynamicZoneInput: {
    input: any;
    output: any;
  };
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: { input: any; output: any };
  PodcastDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  PrivacyPolicyPageDefaultContentTemplateDynamicZoneInput: {
    input: any;
    output: any;
  };
  ResourceDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  TermsAndConditionsPageDefaultContentTemplateDynamicZoneInput: {
    input: any;
    output: any;
  };
  /** A time string with format HH:mm:ss.SSS */
  Time: { input: any; output: any };
};

export type AboutPage = {
  __typename?: "AboutPage";
  DefaultContentTemplate: Array<
    Maybe<AboutPageDefaultContentTemplateDynamicZone>
  >;
  /** @deprecated Use root level fields instead */
  attributes: AboutPage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: AboutPage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  pageTitle: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type AboutPageDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type AboutPageInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<Scalars["AboutPageDefaultContentTemplateDynamicZoneInput"]["input"]>
  >;
  pageTitle?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type AccessControlList = {
  __typename?: "AccessControlList";
  /** @deprecated Use root level fields instead */
  attributes: AccessControlList;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: AccessControlList;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  isInstructor?: Maybe<Scalars["Boolean"]["output"]>;
  isMAT?: Maybe<Scalars["Boolean"]["output"]>;
  manageStaff?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  reportingTools?: Maybe<Scalars["Boolean"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type AccessControlListEntityResponseCollection = {
  __typename?: "AccessControlListEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<AccessControlList>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<AccessControlList>;
  pageInfo: Pagination;
};

export type AccessControlListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AccessControlListFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  isInstructor?: InputMaybe<BooleanFilterInput>;
  isMAT?: InputMaybe<BooleanFilterInput>;
  manageStaff?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AccessControlListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AccessControlListFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reportingTools?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AccessControlListInput = {
  isInstructor?: InputMaybe<Scalars["Boolean"]["input"]>;
  isMAT?: InputMaybe<Scalars["Boolean"]["input"]>;
  manageStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  reportingTools?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AdminPage = {
  __typename?: "AdminPage";
  adminTabs?: Maybe<ComponentReportingToolsAdminTabs>;
  /** @deprecated Use root level fields instead */
  attributes: AdminPage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: AdminPage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type AdminPageInput = {
  adminTabs?: InputMaybe<ComponentReportingToolsAdminTabsInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Answer = {
  __typename?: "Answer";
  answer?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: Answer;
  comment?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Answer;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  question?: Maybe<Question>;
  school?: Maybe<School>;
  survey?: Maybe<Survey>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  user?: Maybe<UsersPermissionsUser>;
};

export type AnswerEntityResponseCollection = {
  __typename?: "AnswerEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Answer>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Answer>;
  pageInfo: Pagination;
};

export type AnswerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AnswerFiltersInput>>>;
  answer?: InputMaybe<IntFilterInput>;
  comment?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<AnswerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AnswerFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  question?: InputMaybe<QuestionFiltersInput>;
  school?: InputMaybe<SchoolFiltersInput>;
  survey?: InputMaybe<SurveyFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type AnswerInput = {
  answer?: InputMaybe<Scalars["Int"]["input"]>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  question?: InputMaybe<Scalars["ID"]["input"]>;
  school?: InputMaybe<Scalars["ID"]["input"]>;
  survey?: InputMaybe<Scalars["ID"]["input"]>;
  user?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AnswerRelationResponseCollection = {
  __typename?: "AnswerRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Answer>;
  nodes: Array<Answer>;
};

export type Author = {
  __typename?: "Author";
  /** @deprecated Use root level fields instead */
  attributes: Author;
  avatar: UploadFile;
  bio?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Author;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  role?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type AuthorEntityResponseCollection = {
  __typename?: "AuthorEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Author>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Author>;
  pageInfo: Pagination;
};

export type AuthorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AuthorFiltersInput>>>;
  bio?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AuthorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AuthorFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AuthorInput = {
  avatar?: InputMaybe<Scalars["ID"]["input"]>;
  bio?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
};

export type AuthorRelationResponseCollection = {
  __typename?: "AuthorRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Author>;
  nodes: Array<Author>;
};

export type Bookmark = {
  __typename?: "Bookmark";
  /** @deprecated Use root level fields instead */
  attributes: Bookmark;
  category?: Maybe<Enum_Bookmark_Category>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Bookmark;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  knowledgeBaseType?: Maybe<KnowledgeBaseType>;
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  relationId?: Maybe<Scalars["String"]["output"]>;
  staff?: Maybe<UsersPermissionsUser>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum BookmarkCategory {
  Course = "COURSE",
  KnowledgeBase = "KNOWLEDGE_BASE",
  Podcast = "PODCAST",
  Resource = "RESOURCE",
}

export type BookmarkEntityResponseCollection = {
  __typename?: "BookmarkEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Bookmark>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Bookmark>;
  pageInfo: Pagination;
};

export type BookmarkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BookmarkFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  knowledgeBaseType?: InputMaybe<KnowledgeBaseTypeFiltersInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<BookmarkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BookmarkFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  relationId?: InputMaybe<StringFilterInput>;
  staff?: InputMaybe<UsersPermissionsUserFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BookmarkInput = {
  category?: InputMaybe<Enum_Bookmark_Category>;
  knowledgeBaseType?: InputMaybe<Scalars["ID"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  relationId?: InputMaybe<Scalars["String"]["input"]>;
  staff?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BookmarkPage = {
  __typename?: "BookmarkPage";
  /** @deprecated Use root level fields instead */
  attributes: BookmarkPage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: BookmarkPage;
  description?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["ID"]["output"];
  emptyStateText?: Maybe<Scalars["String"]["output"]>;
  goToResourceText?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  loadingText?: Maybe<Scalars["String"]["output"]>;
  openButtonTxt?: Maybe<Scalars["String"]["output"]>;
  pageTitle?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  removeFromBookmarksText?: Maybe<Scalars["String"]["output"]>;
  searchPlaceholder?: Maybe<Scalars["String"]["output"]>;
  sections?: Maybe<Array<Maybe<ComponentBookmarkSections>>>;
  tabKnowledgeBase?: Maybe<Scalars["String"]["output"]>;
  tabLearn?: Maybe<Scalars["String"]["output"]>;
  tabPodcast?: Maybe<Scalars["String"]["output"]>;
  tabResource?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type BookmarkPageSectionsArgs = {
  filters?: InputMaybe<ComponentBookmarkSectionsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type BookmarkPageInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  emptyStateText?: InputMaybe<Scalars["String"]["input"]>;
  goToResourceText?: InputMaybe<Scalars["String"]["input"]>;
  loadingText?: InputMaybe<Scalars["String"]["input"]>;
  openButtonTxt?: InputMaybe<Scalars["String"]["input"]>;
  pageTitle?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  removeFromBookmarksText?: InputMaybe<Scalars["String"]["input"]>;
  searchPlaceholder?: InputMaybe<Scalars["String"]["input"]>;
  sections?: InputMaybe<Array<InputMaybe<ComponentBookmarkSectionsInput>>>;
  tabKnowledgeBase?: InputMaybe<Scalars["String"]["input"]>;
  tabLearn?: InputMaybe<Scalars["String"]["input"]>;
  tabPodcast?: InputMaybe<Scalars["String"]["input"]>;
  tabResource?: InputMaybe<Scalars["String"]["input"]>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars["Boolean"]["input"]>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars["Boolean"]["input"]>>>;
  contains?: InputMaybe<Scalars["Boolean"]["input"]>;
  containsi?: InputMaybe<Scalars["Boolean"]["input"]>;
  endsWith?: InputMaybe<Scalars["Boolean"]["input"]>;
  eq?: InputMaybe<Scalars["Boolean"]["input"]>;
  eqi?: InputMaybe<Scalars["Boolean"]["input"]>;
  gt?: InputMaybe<Scalars["Boolean"]["input"]>;
  gte?: InputMaybe<Scalars["Boolean"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["Boolean"]["input"]>>>;
  lt?: InputMaybe<Scalars["Boolean"]["input"]>;
  lte?: InputMaybe<Scalars["Boolean"]["input"]>;
  ne?: InputMaybe<Scalars["Boolean"]["input"]>;
  nei?: InputMaybe<Scalars["Boolean"]["input"]>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars["Boolean"]["input"]>;
  notContainsi?: InputMaybe<Scalars["Boolean"]["input"]>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars["Boolean"]["input"]>>>;
  notNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  null?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<InputMaybe<Scalars["Boolean"]["input"]>>>;
  startsWith?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Calendar = {
  __typename?: "Calendar";
  /** @deprecated Use root level fields instead */
  attributes: Calendar;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Calendar;
  documentId: Scalars["ID"]["output"];
  eventDays?: Maybe<Array<Maybe<ComponentCommonDays>>>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  year?: Maybe<Scalars["Int"]["output"]>;
};

export type CalendarEventDaysArgs = {
  filters?: InputMaybe<ComponentCommonDaysFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CalendarEntityResponseCollection = {
  __typename?: "CalendarEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Calendar>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Calendar>;
  pageInfo: Pagination;
};

export type CalendarFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CalendarFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  eventDays?: InputMaybe<ComponentCommonDaysFiltersInput>;
  not?: InputMaybe<CalendarFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CalendarFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  year?: InputMaybe<IntFilterInput>;
};

export type CalendarInput = {
  eventDays?: InputMaybe<Array<InputMaybe<ComponentCommonDaysInput>>>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CalendarPage = {
  __typename?: "CalendarPage";
  NoDaysMonthText?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: CalendarPage;
  calendarFeedbackMessage?: Maybe<ComponentCalendarCalendarFeedbackMessage>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: CalendarPage;
  description?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["ID"]["output"];
  downloadButtonText?: Maybe<Scalars["String"]["output"]>;
  file?: Maybe<UploadFile>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  monthThemesTitle?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CalendarPageInput = {
  NoDaysMonthText?: InputMaybe<Scalars["String"]["input"]>;
  calendarFeedbackMessage?: InputMaybe<ComponentCalendarCalendarFeedbackMessageInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  downloadButtonText?: InputMaybe<Scalars["String"]["input"]>;
  file?: InputMaybe<Scalars["ID"]["input"]>;
  monthThemesTitle?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompletedTask = {
  __typename?: "CompletedTask";
  answer?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: CompletedTask;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: CompletedTask;
  day: Scalars["Date"]["output"];
  documentId: Scalars["ID"]["output"];
  done: Scalars["Boolean"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  metadata: Scalars["JSON"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  relationID: Scalars["Int"]["output"];
  staff?: Maybe<UsersPermissionsUser>;
  type: Enum_Completedtask_Type;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CompletedTaskEntityResponseCollection = {
  __typename?: "CompletedTaskEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<CompletedTask>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<CompletedTask>;
  pageInfo: Pagination;
};

export type CompletedTaskFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CompletedTaskFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  day?: InputMaybe<DateFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  done?: InputMaybe<BooleanFilterInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<CompletedTaskFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CompletedTaskFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  relationID?: InputMaybe<IntFilterInput>;
  staff?: InputMaybe<UsersPermissionsUserFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CompletedTaskInput = {
  answer?: InputMaybe<Scalars["String"]["input"]>;
  day?: InputMaybe<Scalars["Date"]["input"]>;
  done?: InputMaybe<Scalars["Boolean"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  relationID?: InputMaybe<Scalars["Int"]["input"]>;
  staff?: InputMaybe<Scalars["ID"]["input"]>;
  type?: InputMaybe<Enum_Completedtask_Type>;
};

export type ComponentAdminManagementActivationPoster = {
  __typename?: "ComponentAdminManagementActivationPoster";
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementActivationPoster;
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementActivationPoster;
  id: Scalars["ID"]["output"];
  pdfTemplate: Scalars["String"]["output"];
};

export type ComponentAdminManagementChartsTitles = {
  __typename?: "ComponentAdminManagementChartsTitles";
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementChartsTitles;
  dailyUsers?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementChartsTitles;
  featureUsage?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  mostUsedFeatures?: Maybe<Scalars["String"]["output"]>;
  schoolMood?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentAdminManagementDashboard = {
  __typename?: "ComponentAdminManagementDashboard";
  allSchools?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementDashboard;
  chartsTitles?: Maybe<ComponentAdminManagementChartsTitles>;
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementDashboard;
  header?: Maybe<ComponentAdminManagementHeader>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentAdminManagementFinishingCardCharacterCompass = {
  __typename?: "ComponentAdminManagementFinishingCardCharacterCompass";
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementFinishingCardCharacterCompass;
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementFinishingCardCharacterCompass;
  days?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  trackAgain?: Maybe<Scalars["String"]["output"]>;
  traits?: Maybe<Scalars["String"]["output"]>;
  youHaveTracked?: Maybe<Scalars["String"]["output"]>;
  yourCalendar?: Maybe<Scalars["String"]["output"]>;
  yourStreak?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentAdminManagementFinishingCardLeadershipWheel = {
  __typename?: "ComponentAdminManagementFinishingCardLeadershipWheel";
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementFinishingCardLeadershipWheel;
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementFinishingCardLeadershipWheel;
  days?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  trackAgain?: Maybe<Scalars["String"]["output"]>;
  traits?: Maybe<Scalars["String"]["output"]>;
  youHaveTracked?: Maybe<Scalars["String"]["output"]>;
  yourCalendar?: Maybe<Scalars["String"]["output"]>;
  yourStreak?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentAdminManagementHeader = {
  __typename?: "ComponentAdminManagementHeader";
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementHeader;
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementHeader;
  engagementPastWeek?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  overallMood?: Maybe<Scalars["String"]["output"]>;
  totalUsers?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentAdminManagementInvitationPreview = {
  __typename?: "ComponentAdminManagementInvitationPreview";
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementInvitationPreview;
  closeBtn?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementInvitationPreview;
  dialogTitle?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  sendInvitationBtn?: Maybe<Scalars["String"]["output"]>;
  userPreviewEmailLabel?: Maybe<Scalars["String"]["output"]>;
  userPreviewForenameLabel?: Maybe<Scalars["String"]["output"]>;
  userPreviewNoStaffLabel?: Maybe<Scalars["String"]["output"]>;
  userPreviewSurnameLabel?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentAdminManagementInvitationUsingFile = {
  __typename?: "ComponentAdminManagementInvitationUsingFile";
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementInvitationUsingFile;
  button?: Maybe<Scalars["String"]["output"]>;
  closeBtn?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementInvitationUsingFile;
  dialogTitle?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  seePreviewBtn?: Maybe<Scalars["String"]["output"]>;
  sendInvitationBtn?: Maybe<Scalars["String"]["output"]>;
  uploadFileBtn?: Maybe<Scalars["String"]["output"]>;
  uploadSpreadsheetBtn?: Maybe<Scalars["String"]["output"]>;
  warningMsgDialog?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentAdminManagementSchoolManagement = {
  __typename?: "ComponentAdminManagementSchoolManagement";
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementSchoolManagement;
  btnCopyCodeTxt: Scalars["String"]["output"];
  btnCopyMessagTxt: Scalars["String"]["output"];
  btnDownloadPdf: Scalars["String"]["output"];
  btnImportStaffWondeTxt?: Maybe<Scalars["String"]["output"]>;
  btnInviteStaffTxt?: Maybe<Scalars["String"]["output"]>;
  btnShareCodeTxt: Scalars["String"]["output"];
  copyPasteTitle: Scalars["String"]["output"];
  copyTxtSubTItle: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementSchoolManagement;
  downloadQrCode: Scalars["String"]["output"];
  downloadQrCodeDescription: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  invitationPreview?: Maybe<ComponentAdminManagementInvitationPreview>;
  invitationUsingFile?: Maybe<ComponentAdminManagementInvitationUsingFile>;
  orText?: Maybe<Scalars["String"]["output"]>;
  sendEmailSubTitle: Scalars["String"]["output"];
  shareCodeTitle: Scalars["String"]["output"];
  tabs?: Maybe<ComponentAdminManagementTabs>;
  template?: Maybe<Scalars["String"]["output"]>;
  toastErrorDownloadingPDFTitle?: Maybe<Scalars["String"]["output"]>;
  toastPDFDownloadedDescription?: Maybe<Scalars["String"]["output"]>;
  toastPDFDownloadedTitle?: Maybe<Scalars["String"]["output"]>;
  toastStaffImportedDescription?: Maybe<Scalars["String"]["output"]>;
  toastStaffImportedTitle?: Maybe<Scalars["String"]["output"]>;
  toastStaffInvitedDescription?: Maybe<Scalars["String"]["output"]>;
  toastStaffInvitedTitle?: Maybe<Scalars["String"]["output"]>;
  tooltipCopiedMessage?: Maybe<Scalars["String"]["output"]>;
  welcomeDescription: Scalars["String"]["output"];
  welcomeTitle: Scalars["String"]["output"];
  yourAccessCode: Scalars["String"]["output"];
};

export type ComponentAdminManagementStep1 = {
  __typename?: "ComponentAdminManagementStep1";
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementStep1;
  buttonTxt: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementStep1;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image: UploadFile;
  title: Scalars["String"]["output"];
};

export type ComponentAdminManagementStep2 = {
  __typename?: "ComponentAdminManagementStep2";
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementStep2;
  autumTermTitle: Scalars["String"]["output"];
  btnText: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementStep2;
  id: Scalars["ID"]["output"];
  springTerm: Scalars["String"]["output"];
  subTitle: Scalars["String"]["output"];
  summerTerm: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentAdminManagementTabs = {
  __typename?: "ComponentAdminManagementTabs";
  adminManagementTabName?: Maybe<Scalars["String"]["output"]>;
  announcementsTabName?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementTabs;
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementTabs;
  id: Scalars["ID"]["output"];
  reportingDashboardTabName?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentAdminManagementUserImportFromFileModal = {
  __typename?: "ComponentAdminManagementUserImportFromFileModal";
  /** @deprecated Use root level fields instead */
  attributes: ComponentAdminManagementUserImportFromFileModal;
  closeButtonText?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentAdminManagementUserImportFromFileModal;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  importStaffButtonText?: Maybe<Scalars["String"]["output"]>;
  previewTitle: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  toastStaffImportedDescription?: Maybe<Scalars["String"]["output"]>;
  toastStaffImportedTitle?: Maybe<Scalars["String"]["output"]>;
  uploadFileButtonText?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentAdminManagementUserImportFromFileModalInput = {
  closeButtonText?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  importStaffButtonText?: InputMaybe<Scalars["String"]["input"]>;
  previewTitle?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  toastStaffImportedDescription?: InputMaybe<Scalars["String"]["input"]>;
  toastStaffImportedTitle?: InputMaybe<Scalars["String"]["input"]>;
  uploadFileButtonText?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentBookmarkSections = {
  __typename?: "ComponentBookmarkSections";
  /** @deprecated Use root level fields instead */
  attributes: ComponentBookmarkSections;
  /** @deprecated Use root level fields instead */
  data: ComponentBookmarkSections;
  id: Scalars["ID"]["output"];
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type ComponentBookmarkSectionsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBookmarkSectionsFiltersInput>>>;
  key?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentBookmarkSectionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBookmarkSectionsFiltersInput>>>;
  value?: InputMaybe<StringFilterInput>;
};

export type ComponentBookmarkSectionsInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCalendarCalendarFeedbackMessage = {
  __typename?: "ComponentCalendarCalendarFeedbackMessage";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCalendarCalendarFeedbackMessage;
  calendarNotFound?: Maybe<Scalars["String"]["output"]>;
  calendarPermissionDenied?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentCalendarCalendarFeedbackMessage;
  eventAddedSuccessApple?: Maybe<Scalars["String"]["output"]>;
  eventAddedSuccessGeneric?: Maybe<Scalars["String"]["output"]>;
  eventAddedSuccessGoogle?: Maybe<Scalars["String"]["output"]>;
  eventAlreadyExists?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
};

export type ComponentCalendarCalendarFeedbackMessageInput = {
  calendarNotFound?: InputMaybe<Scalars["String"]["input"]>;
  calendarPermissionDenied?: InputMaybe<Scalars["String"]["input"]>;
  eventAddedSuccessApple?: InputMaybe<Scalars["String"]["input"]>;
  eventAddedSuccessGeneric?: InputMaybe<Scalars["String"]["input"]>;
  eventAddedSuccessGoogle?: InputMaybe<Scalars["String"]["input"]>;
  eventAlreadyExists?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ComponentCalendarRelatedcontentcalendar = {
  __typename?: "ComponentCalendarRelatedcontentcalendar";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCalendarRelatedcontentcalendar;
  /** @deprecated Use root level fields instead */
  data: ComponentCalendarRelatedcontentcalendar;
  id: Scalars["ID"]["output"];
};

export type ComponentCalendarResource = {
  __typename?: "ComponentCalendarResource";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCalendarResource;
  /** @deprecated Use root level fields instead */
  data: ComponentCalendarResource;
  id: Scalars["ID"]["output"];
  knowledgeBase?: Maybe<KnowledgeBase>;
};

export type ComponentCommonAudio = {
  __typename?: "ComponentCommonAudio";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonAudio;
  audio: UploadFile;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonAudio;
  id: Scalars["ID"]["output"];
  transcription?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentCommonAudioFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonAudioFiltersInput>>>;
  not?: InputMaybe<ComponentCommonAudioFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonAudioFiltersInput>>>;
  transcription?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonAudioInput = {
  audio?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  transcription?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonAuthor = {
  __typename?: "ComponentCommonAuthor";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonAuthor;
  author?: Maybe<Author>;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonAuthor;
  id: Scalars["ID"]["output"];
  publicationDate: Scalars["Date"]["output"];
};

export type ComponentCommonAuthorDetailed = {
  __typename?: "ComponentCommonAuthorDetailed";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonAuthorDetailed;
  authors: Array<Maybe<Author>>;
  authors_connection?: Maybe<AuthorRelationResponseCollection>;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonAuthorDetailed;
  id: Scalars["ID"]["output"];
};

export type ComponentCommonAuthorDetailedAuthorsArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentCommonAuthorDetailedAuthors_ConnectionArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentCommonBreadcrumb = {
  __typename?: "ComponentCommonBreadcrumb";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonBreadcrumb;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonBreadcrumb;
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  url: Scalars["String"]["output"];
};

export type ComponentCommonBullet = {
  __typename?: "ComponentCommonBullet";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonBullet;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonBullet;
  id: Scalars["ID"]["output"];
  item: Array<Maybe<ComponentCommonList>>;
};

export type ComponentCommonBulletItemArgs = {
  filters?: InputMaybe<ComponentCommonListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentCommonButton = {
  __typename?: "ComponentCommonButton";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonButton;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonButton;
  id: Scalars["ID"]["output"];
  link: Scalars["String"]["output"];
  text: Scalars["String"]["output"];
};

export type ComponentCommonButtonInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  link?: InputMaybe<Scalars["String"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonConfirmModal = {
  __typename?: "ComponentCommonConfirmModal";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonConfirmModal;
  cancelButton?: Maybe<Scalars["String"]["output"]>;
  confirmButton?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonConfirmModal;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentCommonConfirmModalInput = {
  cancelButton?: InputMaybe<Scalars["String"]["input"]>;
  confirmButton?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonContentTemplateLabels = {
  __typename?: "ComponentCommonContentTemplateLabels";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonContentTemplateLabels;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonContentTemplateLabels;
  downloadableContentLabel?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
};

export type ComponentCommonContentTemplateLabelsInput = {
  downloadableContentLabel?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ComponentCommonDays = {
  __typename?: "ComponentCommonDays";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonDays;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonDays;
  description?: Maybe<Scalars["String"]["output"]>;
  endDate?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  related_knowledge_base?: Maybe<KnowledgeBase>;
  startDate: Scalars["Date"]["output"];
  wholeMonth?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComponentCommonDaysFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonDaysFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonDaysFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonDaysFiltersInput>>>;
  related_knowledge_base?: InputMaybe<KnowledgeBaseFiltersInput>;
  startDate?: InputMaybe<DateFilterInput>;
  wholeMonth?: InputMaybe<BooleanFilterInput>;
};

export type ComponentCommonDaysInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  related_knowledge_base?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  wholeMonth?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ComponentCommonDefaultContentTemplate = {
  __typename?: "ComponentCommonDefaultContentTemplate";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonDefaultContentTemplate;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonDefaultContentTemplate;
  divider?: Maybe<Array<Maybe<ComponentCommonDivider>>>;
  downloadableContentSection?: Maybe<ComponentDefaultContentTemplateSectionDownloadableContent>;
  id: Scalars["ID"]["output"];
};

export type ComponentCommonDefaultContentTemplateDividerArgs = {
  filters?: InputMaybe<ComponentCommonDividerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentCommonDivider = {
  __typename?: "ComponentCommonDivider";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonDivider;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonDivider;
  id: Scalars["ID"]["output"];
};

export type ComponentCommonDividerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonDividerFiltersInput>>>;
  not?: InputMaybe<ComponentCommonDividerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonDividerFiltersInput>>>;
};

export type ComponentCommonDownloadableContent = {
  __typename?: "ComponentCommonDownloadableContent";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonDownloadableContent;
  content: UploadFile;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonDownloadableContent;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentCommonDownloadableContentFiltersInput = {
  and?: InputMaybe<
    Array<InputMaybe<ComponentCommonDownloadableContentFiltersInput>>
  >;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonDownloadableContentFiltersInput>;
  or?: InputMaybe<
    Array<InputMaybe<ComponentCommonDownloadableContentFiltersInput>>
  >;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonDownloadableContentInput = {
  content?: InputMaybe<Scalars["ID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonDownloadableContentList = {
  __typename?: "ComponentCommonDownloadableContentList";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonDownloadableContentList;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonDownloadableContentList;
  id: Scalars["ID"]["output"];
  list?: Maybe<Array<Maybe<ComponentCommonDownloadableContent>>>;
};

export type ComponentCommonDownloadableContentListListArgs = {
  filters?: InputMaybe<ComponentCommonDownloadableContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentCommonEmailSent = {
  __typename?: "ComponentCommonEmailSent";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonEmailSent;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonEmailSent;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentCommonEmailSentInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonEmbedded = {
  __typename?: "ComponentCommonEmbedded";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonEmbedded;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonEmbedded;
  id: Scalars["ID"]["output"];
  link: Scalars["String"]["output"];
  provider: Enum_Componentcommonembedded_Provider;
};

export type ComponentCommonEmbeddedFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonEmbeddedFiltersInput>>>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonEmbeddedFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonEmbeddedFiltersInput>>>;
  provider?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonEmbeddedInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  link?: InputMaybe<Scalars["String"]["input"]>;
  provider?: InputMaybe<Enum_Componentcommonembedded_Provider>;
};

export type ComponentCommonFaq = {
  __typename?: "ComponentCommonFaq";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonFaq;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonFaq;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentCommonFaqComponent = {
  __typename?: "ComponentCommonFaqComponent";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonFaqComponent;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonFaqComponent;
  faq?: Maybe<Array<Maybe<ComponentCommonFaq>>>;
  id: Scalars["ID"]["output"];
};

export type ComponentCommonFaqComponentFaqArgs = {
  filters?: InputMaybe<ComponentCommonFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentCommonFaqFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonFaqFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonFaqFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonFaqFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonFaqInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonField = {
  __typename?: "ComponentCommonField";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonField;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonField;
  id: Scalars["ID"]["output"];
  label: Scalars["String"]["output"];
  placeholder: Scalars["String"]["output"];
};

export type ComponentCommonFieldInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  placeholder?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonFieldSelect = {
  __typename?: "ComponentCommonFieldSelect";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonFieldSelect;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonFieldSelect;
  id: Scalars["ID"]["output"];
  label: Scalars["String"]["output"];
  options?: Maybe<Array<Maybe<ComponentCommonText>>>;
  placeholder: Scalars["String"]["output"];
};

export type ComponentCommonFieldSelectOptionsArgs = {
  filters?: InputMaybe<ComponentCommonTextFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentCommonFieldSelectInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  options?: InputMaybe<Array<InputMaybe<ComponentCommonTextInput>>>;
  placeholder?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonGender = {
  __typename?: "ComponentCommonGender";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonGender;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonGender;
  id: Scalars["ID"]["output"];
  option: Scalars["String"]["output"];
};

export type ComponentCommonH3 = {
  __typename?: "ComponentCommonH3";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonH3;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonH3;
  id: Scalars["ID"]["output"];
  text: Scalars["String"]["output"];
};

export type ComponentCommonHeroSection = {
  __typename?: "ComponentCommonHeroSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonHeroSection;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonHeroSection;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image: UploadFile;
  title: Scalars["String"]["output"];
};

export type ComponentCommonInPartnershipWith = {
  __typename?: "ComponentCommonInPartnershipWith";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonInPartnershipWith;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonInPartnershipWith;
  id: Scalars["ID"]["output"];
  partnership: Scalars["String"]["output"];
};

export type ComponentCommonLearnHighlight = {
  __typename?: "ComponentCommonLearnHighlight";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonLearnHighlight;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonLearnHighlight;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image: UploadFile;
  title: Scalars["String"]["output"];
};

export type ComponentCommonLearnHighlightInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonLink = {
  __typename?: "ComponentCommonLink";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonLink;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonLink;
  file?: Maybe<UploadFile>;
  id: Scalars["ID"]["output"];
  text: Scalars["String"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentCommonLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonLinkFiltersInput>>>;
  not?: InputMaybe<ComponentCommonLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonLinkFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonLinkInput = {
  file?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonLinkList = {
  __typename?: "ComponentCommonLinkList";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonLinkList;
  course?: Maybe<Course>;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonLinkList;
  id: Scalars["ID"]["output"];
  knowledgeBase?: Maybe<KnowledgeBase>;
  podcast?: Maybe<KnowledgeBase>;
  redirectToCalendar?: Maybe<Scalars["Boolean"]["output"]>;
  redirectToCurrentCharacterExercise?: Maybe<Scalars["Boolean"]["output"]>;
  redirectToLeadershipWheel?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComponentCommonLinkListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonLinkListFiltersInput>>>;
  course?: InputMaybe<CourseFiltersInput>;
  knowledgeBase?: InputMaybe<KnowledgeBaseFiltersInput>;
  not?: InputMaybe<ComponentCommonLinkListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonLinkListFiltersInput>>>;
  podcast?: InputMaybe<KnowledgeBaseFiltersInput>;
  redirectToCalendar?: InputMaybe<BooleanFilterInput>;
  redirectToCurrentCharacterExercise?: InputMaybe<BooleanFilterInput>;
  redirectToLeadershipWheel?: InputMaybe<BooleanFilterInput>;
};

export type ComponentCommonLinkListInput = {
  course?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  knowledgeBase?: InputMaybe<Scalars["ID"]["input"]>;
  podcast?: InputMaybe<Scalars["ID"]["input"]>;
  redirectToCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
  redirectToCurrentCharacterExercise?: InputMaybe<Scalars["Boolean"]["input"]>;
  redirectToLeadershipWheel?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ComponentCommonList = {
  __typename?: "ComponentCommonList";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonList;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonList;
  id: Scalars["ID"]["output"];
  text: Scalars["String"]["output"];
};

export type ComponentCommonListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonListFiltersInput>>>;
  not?: InputMaybe<ComponentCommonListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonListFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonMedia = {
  __typename?: "ComponentCommonMedia";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonMedia;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonMedia;
  id: Scalars["ID"]["output"];
  media: UploadFile;
};

export type ComponentCommonMediaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonMediaFiltersInput>>>;
  not?: InputMaybe<ComponentCommonMediaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonMediaFiltersInput>>>;
};

export type ComponentCommonMediaInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  media?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ComponentCommonMessageSection = {
  __typename?: "ComponentCommonMessageSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonMessageSection;
  comeBackTitle: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentCommonMessageSection;
  id: Scalars["ID"]["output"];
  youAreDoneTitle: Scalars["String"]["output"];
};

export type ComponentCommonMessageSectionInput = {
  comeBackTitle?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  youAreDoneTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonMinutes = {
  __typename?: "ComponentCommonMinutes";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonMinutes;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonMinutes;
  id: Scalars["ID"]["output"];
  minute?: Maybe<Scalars["Int"]["output"]>;
};

export type ComponentCommonMinutesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonMinutesFiltersInput>>>;
  minute?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<ComponentCommonMinutesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonMinutesFiltersInput>>>;
};

export type ComponentCommonMonth = {
  __typename?: "ComponentCommonMonth";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonMonth;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonMonth;
  days?: Maybe<Array<Maybe<ComponentCommonDays>>>;
  id: Scalars["ID"]["output"];
  month: Scalars["String"]["output"];
};

export type ComponentCommonMonthDaysArgs = {
  filters?: InputMaybe<ComponentCommonDaysFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentCommonObjectives = {
  __typename?: "ComponentCommonObjectives";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonObjectives;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonObjectives;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type ComponentCommonObjectivesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonObjectivesFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonObjectivesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonObjectivesFiltersInput>>>;
};

export type ComponentCommonObjectivesInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ComponentCommonObjectivesSection = {
  __typename?: "ComponentCommonObjectivesSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonObjectivesSection;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonObjectivesSection;
  id: Scalars["ID"]["output"];
  objectives?: Maybe<Array<Maybe<ComponentCommonObjectives>>>;
  title: Scalars["String"]["output"];
};

export type ComponentCommonObjectivesSectionObjectivesArgs = {
  filters?: InputMaybe<ComponentCommonObjectivesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentCommonObjectivesSectionFiltersInput = {
  and?: InputMaybe<
    Array<InputMaybe<ComponentCommonObjectivesSectionFiltersInput>>
  >;
  not?: InputMaybe<ComponentCommonObjectivesSectionFiltersInput>;
  objectives?: InputMaybe<ComponentCommonObjectivesFiltersInput>;
  or?: InputMaybe<
    Array<InputMaybe<ComponentCommonObjectivesSectionFiltersInput>>
  >;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonObjectivesSectionInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  objectives?: InputMaybe<Array<InputMaybe<ComponentCommonObjectivesInput>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonQuote = {
  __typename?: "ComponentCommonQuote";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonQuote;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonQuote;
  id: Scalars["ID"]["output"];
  quote: Scalars["String"]["output"];
};

export type ComponentCommonRawTextWithLinks = {
  __typename?: "ComponentCommonRawTextWithLinks";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonRawTextWithLinks;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonRawTextWithLinks;
  finalState?: Maybe<ComponentLeadershipWheelFinalState>;
  id: Scalars["ID"]["output"];
  text?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentCommonRawTextWithLinksInput = {
  finalState?: InputMaybe<ComponentLeadershipWheelFinalStateInput>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonRelatedContent = {
  __typename?: "ComponentCommonRelatedContent";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonRelatedContent;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonRelatedContent;
  id: Scalars["ID"]["output"];
};

export type ComponentCommonRoles = {
  __typename?: "ComponentCommonRoles";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonRoles;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonRoles;
  id: Scalars["ID"]["output"];
  role?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentCommonRolesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonRolesFiltersInput>>>;
  not?: InputMaybe<ComponentCommonRolesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonRolesFiltersInput>>>;
  role?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonRolesInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonSearchSection = {
  __typename?: "ComponentCommonSearchSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonSearchSection;
  chooseATraitTitle: Scalars["String"]["output"];
  chooseCollectionTitle: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentCommonSearchSection;
  id: Scalars["ID"]["output"];
  searchInput: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  types?: Maybe<Array<Maybe<ComponentCommonTypes>>>;
  whatKindTitle: Scalars["String"]["output"];
};

export type ComponentCommonSearchSectionTypesArgs = {
  filters?: InputMaybe<ComponentCommonTypesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentCommonSidebarMenu = {
  __typename?: "ComponentCommonSidebarMenu";
  aboutTitle?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonSidebarMenu;
  bookmarkTitle?: Maybe<Scalars["String"]["output"]>;
  calendarTitle?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonSidebarMenu;
  downloadsTitle?: Maybe<Scalars["String"]["output"]>;
  frameworkTitle?: Maybe<Scalars["String"]["output"]>;
  helpTitle?: Maybe<Scalars["String"]["output"]>;
  helpUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  logOutTitle?: Maybe<Scalars["String"]["output"]>;
  meetTheCharacterTitle?: Maybe<Scalars["String"]["output"]>;
  profileTitle?: Maybe<Scalars["String"]["output"]>;
  rateTheAppTitle?: Maybe<Scalars["String"]["output"]>;
  reflectionVideosTitle?: Maybe<Scalars["String"]["output"]>;
  reportingTitle?: Maybe<Scalars["String"]["output"]>;
  searchTitle?: Maybe<Scalars["String"]["output"]>;
  settingTitle?: Maybe<Scalars["String"]["output"]>;
  wellbeingAwarenessDaysTitle?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentCommonSteps = {
  __typename?: "ComponentCommonSteps";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonSteps;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonSteps;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image: UploadFile;
  textBtn: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentCommonStepsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonStepsFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonStepsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonStepsFiltersInput>>>;
  textBtn?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonStepsInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  textBtn?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonTags = {
  __typename?: "ComponentCommonTags";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonTags;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonTags;
  id: Scalars["ID"]["output"];
};

export type ComponentCommonText = {
  __typename?: "ComponentCommonText";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonText;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonText;
  id: Scalars["ID"]["output"];
  option: Scalars["String"]["output"];
};

export type ComponentCommonTextEditor = {
  __typename?: "ComponentCommonTextEditor";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonTextEditor;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonTextEditor;
  id: Scalars["ID"]["output"];
  markdownText?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentCommonTextEditorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonTextEditorFiltersInput>>>;
  markdownText?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonTextEditorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonTextEditorFiltersInput>>>;
};

export type ComponentCommonTextEditorInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  markdownText?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonTextFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonTextFiltersInput>>>;
  not?: InputMaybe<ComponentCommonTextFiltersInput>;
  option?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonTextFiltersInput>>>;
};

export type ComponentCommonTextInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  option?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonTitle = {
  __typename?: "ComponentCommonTitle";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonTitle;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonTitle;
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentCommonTitleText = {
  __typename?: "ComponentCommonTitleText";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonTitleText;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonTitleText;
  id: Scalars["ID"]["output"];
  text: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentCommonToast = {
  __typename?: "ComponentCommonToast";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonToast;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonToast;
  id: Scalars["ID"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentCommonToastInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentCommonTranscript = {
  __typename?: "ComponentCommonTranscript";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonTranscript;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonTranscript;
  id: Scalars["ID"]["output"];
};

export type ComponentCommonTranslations = {
  __typename?: "ComponentCommonTranslations";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonTranslations;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonTranslations;
  id: Scalars["ID"]["output"];
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type ComponentCommonTypes = {
  __typename?: "ComponentCommonTypes";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonTypes;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonTypes;
  id: Scalars["ID"]["output"];
  type: Scalars["String"]["output"];
};

export type ComponentCommonTypesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonTypesFiltersInput>>>;
  not?: InputMaybe<ComponentCommonTypesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonTypesFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonWelcomePageMessage = {
  __typename?: "ComponentCommonWelcomePageMessage";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCommonWelcomePageMessage;
  /** @deprecated Use root level fields instead */
  data: ComponentCommonWelcomePageMessage;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentCoursePageLesson = {
  __typename?: "ComponentCoursePageLesson";
  /** @deprecated Use root level fields instead */
  attributes: ComponentCoursePageLesson;
  beginButtonLabel?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentCoursePageLesson;
  id: Scalars["ID"]["output"];
  lockedButtonlabel?: Maybe<Scalars["String"]["output"]>;
  offlineModeLockedButtonLabel?: Maybe<Scalars["String"]["output"]>;
  watchAgainButtonlabel?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentCoursePageLessonInput = {
  beginButtonLabel?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  lockedButtonlabel?: InputMaybe<Scalars["String"]["input"]>;
  offlineModeLockedButtonLabel?: InputMaybe<Scalars["String"]["input"]>;
  watchAgainButtonlabel?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentDefaultContentTemplateSectionDownloadableContent = {
  __typename?: "ComponentDefaultContentTemplateSectionDownloadableContent";
  /** @deprecated Use root level fields instead */
  attributes: ComponentDefaultContentTemplateSectionDownloadableContent;
  /** @deprecated Use root level fields instead */
  data: ComponentDefaultContentTemplateSectionDownloadableContent;
  downlodable_content?: Maybe<Array<Maybe<ComponentCommonDownloadableContent>>>;
  id: Scalars["ID"]["output"];
  layout_order?: Maybe<Scalars["Int"]["output"]>;
};

export type ComponentDefaultContentTemplateSectionDownloadableContentDownlodable_ContentArgs =
  {
    filters?: InputMaybe<ComponentCommonDownloadableContentFiltersInput>;
    pagination?: InputMaybe<PaginationArg>;
    sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  };

export type ComponentDefaultContentTemplateTimer = {
  __typename?: "ComponentDefaultContentTemplateTimer";
  /** @deprecated Use root level fields instead */
  attributes: ComponentDefaultContentTemplateTimer;
  audio?: Maybe<ComponentTimerTimerAudio>;
  audioLabels?: Maybe<ComponentTimerTimerAudioLabels>;
  /** @deprecated Use root level fields instead */
  data: ComponentDefaultContentTemplateTimer;
  id: Scalars["ID"]["output"];
  prompt?: Maybe<ComponentTimerTimerPrompt>;
  promptLabels?: Maybe<ComponentTimerTimerPromptLabels>;
  type: Enum_Componentdefaultcontenttemplatetimer_Type;
  video?: Maybe<ComponentTimerTimerVideo>;
  videoLabels?: Maybe<ComponentTimerTimerVideoLabels>;
};

export type ComponentEmailTemplateWelcomeEmailStaff = {
  __typename?: "ComponentEmailTemplateWelcomeEmailStaff";
  /** @deprecated Use root level fields instead */
  attributes: ComponentEmailTemplateWelcomeEmailStaff;
  content?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentEmailTemplateWelcomeEmailStaff;
  fromEmail?: Maybe<Scalars["String"]["output"]>;
  fromName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  subject?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentEmailTemplateWelcomeEmailStaffInput = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  fromEmail?: InputMaybe<Scalars["String"]["input"]>;
  fromName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentHomeActivitySection = {
  __typename?: "ComponentHomeActivitySection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeActivitySection;
  btnText: Scalars["String"]["output"];
  completedImage?: Maybe<UploadFile>;
  cover: UploadFile;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeActivitySection;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  subTitle: Scalars["String"]["output"];
  thumbnailDefault?: Maybe<UploadFile>;
  title: Scalars["String"]["output"];
};

export type ComponentHomeArticlesAndPodcastsSection = {
  __typename?: "ComponentHomeArticlesAndPodcastsSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeArticlesAndPodcastsSection;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeArticlesAndPodcastsSection;
  description?: Maybe<Scalars["String"]["output"]>;
  icon?: Maybe<UploadFile>;
  id: Scalars["ID"]["output"];
  listenNowPodcast?: Maybe<Scalars["String"]["output"]>;
  readNowArticle?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  viewAllArticle?: Maybe<Scalars["String"]["output"]>;
  viewAllPodcasts?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentHomeArticlesAndPodcastsSectionInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  icon?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  listenNowPodcast?: InputMaybe<Scalars["String"]["input"]>;
  readNowArticle?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  viewAllArticle?: InputMaybe<Scalars["String"]["input"]>;
  viewAllPodcasts?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentHomeCardsSection = {
  __typename?: "ComponentHomeCardsSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeCardsSection;
  characterCompass: ComponentHomeHomeCard;
  dailyInspirationTitle: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentHomeCardsSection;
  id: Scalars["ID"]["output"];
  pickUpWhereYouLeftOff?: Maybe<ComponentHomePickUpWhereYouLeftOff>;
  programmes?: Maybe<ComponentHomeProgrammes>;
};

export type ComponentHomeDailySection = {
  __typename?: "ComponentHomeDailySection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeDailySection;
  characterCompassBtnLabel: Scalars["String"]["output"];
  characterCompassDescription: Scalars["String"]["output"];
  characterCompassTItle: Scalars["String"]["output"];
  characterCompassThankYouTitle?: Maybe<Scalars["String"]["output"]>;
  characterExerciseBtnLabel: Scalars["String"]["output"];
  characterExerciseDescription: Scalars["String"]["output"];
  characterExerciseThankYouTitle?: Maybe<Scalars["String"]["output"]>;
  characterExerciseTitle: Scalars["String"]["output"];
  dailyQuoteThankYouTitle?: Maybe<Scalars["String"]["output"]>;
  dailyQuoteTitle: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentHomeDailySection;
  id: Scalars["ID"]["output"];
  prefixCharacterExerciseCard?: Maybe<Scalars["String"]["output"]>;
  questionsFeedbackDescription?: Maybe<Scalars["String"]["output"]>;
  questionsFeedbackImage?: Maybe<UploadFile>;
  questionsFeedbackPlaceholder?: Maybe<Scalars["String"]["output"]>;
  questionsFeedbackThanksDisclaimer?: Maybe<Scalars["String"]["output"]>;
  questionsFeedbackThanksMessage?: Maybe<Scalars["String"]["output"]>;
  questionsFeedbackTitle?: Maybe<Scalars["String"]["output"]>;
  questionsSubTitle?: Maybe<Scalars["String"]["output"]>;
  questionsThankYouTitle?: Maybe<Scalars["String"]["output"]>;
  questionsTitle?: Maybe<Scalars["String"]["output"]>;
  titleCharacterExerciseCard?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentHomeDoneSection = {
  __typename?: "ComponentHomeDoneSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeDoneSection;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeDoneSection;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  recommendationTitle?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentHomeFinishingCard = {
  __typename?: "ComponentHomeFinishingCard";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeFinishingCard;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeFinishingCard;
  finishingCardLeadershipWheel?: Maybe<ComponentAdminManagementFinishingCardLeadershipWheel>;
  id: Scalars["ID"]["output"];
};

export type ComponentHomeHeaderSection = {
  __typename?: "ComponentHomeHeaderSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeHeaderSection;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeHeaderSection;
  description: Scalars["String"]["output"];
  helloLabel: Scalars["String"]["output"];
  icon?: Maybe<UploadFile>;
  id: Scalars["ID"]["output"];
};

export type ComponentHomeHeaderSectionInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  helloLabel?: InputMaybe<Scalars["String"]["input"]>;
  icon?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ComponentHomeHomeCard = {
  __typename?: "ComponentHomeHomeCard";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeHomeCard;
  completedBtn?: Maybe<Scalars["String"]["output"]>;
  ctaBtn: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentHomeHomeCard;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentHomeKeyDatesSection = {
  __typename?: "ComponentHomeKeyDatesSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeKeyDatesSection;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeKeyDatesSection;
  description?: Maybe<Scalars["String"]["output"]>;
  icon?: Maybe<UploadFile>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  viewAllKeyDatesLabel?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentHomeLatestUpdatesSection = {
  __typename?: "ComponentHomeLatestUpdatesSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeLatestUpdatesSection;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeLatestUpdatesSection;
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentHomeLatestUpdatesSectionInput = {
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentHomeKeyDatesSectionInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  icon?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  viewAllKeyDatesLabel?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentHomeLatestSection = {
  __typename?: "ComponentHomeLatestSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeLatestSection;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeLatestSection;
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  viewAll: Scalars["String"]["output"];
};

export type ComponentHomeLeadershipWheelSection = {
  __typename?: "ComponentHomeLeadershipWheelSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeLeadershipWheelSection;
  btnText?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeLeadershipWheelSection;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  image?: Maybe<UploadFile>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentHomeLeadershipWheelSectionInput = {
  btnText?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentHomeOnboardingQuestions = {
  __typename?: "ComponentHomeOnboardingQuestions";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeOnboardingQuestions;
  btnLabel: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentHomeOnboardingQuestions;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentHomePickUpWhereYouLeftOff = {
  __typename?: "ComponentHomePickUpWhereYouLeftOff";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomePickUpWhereYouLeftOff;
  btnText: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentHomePickUpWhereYouLeftOff;
  id: Scalars["ID"]["output"];
  prefix: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentHomeProgrammes = {
  __typename?: "ComponentHomeProgrammes";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeProgrammes;
  btnText: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentHomeProgrammes;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentHomeResourceSection = {
  __typename?: "ComponentHomeResourceSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeResourceSection;
  categories: Array<Maybe<ResourceCategory>>;
  categories_connection?: Maybe<ResourceCategoryRelationResponseCollection>;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeResourceSection;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  viewAllResourcesLabel?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentHomeResourceSectionCategoriesArgs = {
  filters?: InputMaybe<ResourceCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentHomeResourceSectionCategories_ConnectionArgs = {
  filters?: InputMaybe<ResourceCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentHomeResourceSectionInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  viewAllResourcesLabel?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentHomeSections = {
  __typename?: "ComponentHomeSections";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeSections;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeSections;
  id: Scalars["ID"]["output"];
  latestPodcastTitle: Scalars["String"]["output"];
  learnTitle: Scalars["String"]["output"];
  trendingThisWeekTitle: Scalars["String"]["output"];
  wildcardTitle?: Maybe<Scalars["String"]["output"]>;
  yourDailyBubbleTitle: Scalars["String"]["output"];
  yourWeeklyQuestionDescription?: Maybe<Scalars["String"]["output"]>;
  yourWeeklyQuestionOnboardingTitle?: Maybe<Scalars["String"]["output"]>;
  yourWeeklyquestionTitle: Scalars["String"]["output"];
};

export type ComponentHomeStatsAndStreaks = {
  __typename?: "ComponentHomeStatsAndStreaks";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeStatsAndStreaks;
  characterCompassTitle: Scalars["String"]["output"];
  characterCompassTotalLabel: Scalars["String"]["output"];
  characterExerciseTitle: Scalars["String"]["output"];
  characterExerciseTotalLabel: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentHomeStatsAndStreaks;
  id: Scalars["ID"]["output"];
  maxStreakDaysLabel: Scalars["String"]["output"];
  maxStreakTitle: Scalars["String"]["output"];
  streakDaysLabel: Scalars["String"]["output"];
  streakTitle: Scalars["String"]["output"];
};

export type ComponentHomeWelcomeCard = {
  __typename?: "ComponentHomeWelcomeCard";
  /** @deprecated Use root level fields instead */
  attributes: ComponentHomeWelcomeCard;
  /** @deprecated Use root level fields instead */
  data: ComponentHomeWelcomeCard;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image: UploadFile;
  title: Scalars["String"]["output"];
};

export type ComponentKnowledgeBaseKnowledgeBaseRelated = {
  __typename?: "ComponentKnowledgeBaseKnowledgeBaseRelated";
  /** @deprecated Use root level fields instead */
  attributes: ComponentKnowledgeBaseKnowledgeBaseRelated;
  /** @deprecated Use root level fields instead */
  data: ComponentKnowledgeBaseKnowledgeBaseRelated;
  id: Scalars["ID"]["output"];
  knowledgeBases: Array<Maybe<KnowledgeBase>>;
  knowledgeBases_connection?: Maybe<KnowledgeBaseRelationResponseCollection>;
};

export type ComponentKnowledgeBaseKnowledgeBaseRelatedKnowledgeBasesArgs = {
  filters?: InputMaybe<KnowledgeBaseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentKnowledgeBaseKnowledgeBaseRelatedKnowledgeBases_ConnectionArgs =
  {
    filters?: InputMaybe<KnowledgeBaseFiltersInput>;
    pagination?: InputMaybe<PaginationArg>;
    sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  };

export type ComponentKnowledgeBaseLatestPerContentTypeSection = {
  __typename?: "ComponentKnowledgeBaseLatestPerContentTypeSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentKnowledgeBaseLatestPerContentTypeSection;
  /** @deprecated Use root level fields instead */
  data: ComponentKnowledgeBaseLatestPerContentTypeSection;
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentKnowledgeBaseWellbeingAwarenessDaysSection = {
  __typename?: "ComponentKnowledgeBaseWellbeingAwarenessDaysSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentKnowledgeBaseWellbeingAwarenessDaysSection;
  /** @deprecated Use root level fields instead */
  data: ComponentKnowledgeBaseWellbeingAwarenessDaysSection;
  id: Scalars["ID"]["output"];
  linkLabel?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
};

export type ComponentLeadershipWheelFinalState = {
  __typename?: "ComponentLeadershipWheelFinalState";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLeadershipWheelFinalState;
  course?: Maybe<Course>;
  /** @deprecated Use root level fields instead */
  data: ComponentLeadershipWheelFinalState;
  id: Scalars["ID"]["output"];
  knowledgeBase?: Maybe<KnowledgeBase>;
  redirectToCalendar?: Maybe<Scalars["Boolean"]["output"]>;
  redirectToCurrentCharacterExercise?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComponentLeadershipWheelFinalStateInput = {
  course?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  knowledgeBase?: InputMaybe<Scalars["ID"]["input"]>;
  redirectToCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
  redirectToCurrentCharacterExercise?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ComponentLeadershipWheelMessages = {
  __typename?: "ComponentLeadershipWheelMessages";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLeadershipWheelMessages;
  /** @deprecated Use root level fields instead */
  data: ComponentLeadershipWheelMessages;
  id: Scalars["ID"]["output"];
  initial?: Maybe<Scalars["String"]["output"]>;
  initialTitle?: Maybe<Scalars["String"]["output"]>;
  privacyStatement?: Maybe<Scalars["String"]["output"]>;
  subTrait?: Maybe<Scalars["String"]["output"]>;
  subTraitTitle?: Maybe<Scalars["String"]["output"]>;
  trait?: Maybe<Scalars["String"]["output"]>;
  traitTitle?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentLeadershipWheelMessagesInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  initial?: InputMaybe<Scalars["String"]["input"]>;
  initialTitle?: InputMaybe<Scalars["String"]["input"]>;
  privacyStatement?: InputMaybe<Scalars["String"]["input"]>;
  subTrait?: InputMaybe<Scalars["String"]["input"]>;
  subTraitTitle?: InputMaybe<Scalars["String"]["input"]>;
  trait?: InputMaybe<Scalars["String"]["input"]>;
  traitTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentLeadershipWheelOnboarding = {
  __typename?: "ComponentLeadershipWheelOnboarding";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLeadershipWheelOnboarding;
  /** @deprecated Use root level fields instead */
  data: ComponentLeadershipWheelOnboarding;
  id: Scalars["ID"]["output"];
  steps?: Maybe<Array<Maybe<ComponentCommonSteps>>>;
};

export type ComponentLeadershipWheelOnboardingStepsArgs = {
  filters?: InputMaybe<ComponentCommonStepsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentLeadershipWheelOnboardingInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  steps?: InputMaybe<Array<InputMaybe<ComponentCommonStepsInput>>>;
};

export type ComponentLeadershipWheelSubTrait = {
  __typename?: "ComponentLeadershipWheelSubTrait";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLeadershipWheelSubTrait;
  /** @deprecated Use root level fields instead */
  data: ComponentLeadershipWheelSubTrait;
  description: Scalars["String"]["output"];
  focusArea: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  microExercisePrompt?: Maybe<MicroExercisePrompt>;
};

export type ComponentLeadershipWheelSubTraitFiltersInput = {
  and?: InputMaybe<
    Array<InputMaybe<ComponentLeadershipWheelSubTraitFiltersInput>>
  >;
  description?: InputMaybe<StringFilterInput>;
  focusArea?: InputMaybe<StringFilterInput>;
  microExercisePrompt?: InputMaybe<MicroExercisePromptFiltersInput>;
  not?: InputMaybe<ComponentLeadershipWheelSubTraitFiltersInput>;
  or?: InputMaybe<
    Array<InputMaybe<ComponentLeadershipWheelSubTraitFiltersInput>>
  >;
};

export type ComponentLeadershipWheelSubTraitInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  focusArea?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  microExercisePrompt?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ComponentLeadershipWheelTypeSection = {
  __typename?: "ComponentLeadershipWheelTypeSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLeadershipWheelTypeSection;
  /** @deprecated Use root level fields instead */
  data: ComponentLeadershipWheelTypeSection;
  id: Scalars["ID"]["output"];
  mainGradientFrom: Scalars["String"]["output"];
  mainGradientTo: Scalars["String"]["output"];
  secondaryGradientFrom: Scalars["String"]["output"];
  secondaryGradientTo: Scalars["String"]["output"];
  tertiaryGradientFrom?: Maybe<Scalars["String"]["output"]>;
  tertiaryGradientTo?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentLeadershipWheelTypeSectionFiltersInput = {
  and?: InputMaybe<
    Array<InputMaybe<ComponentLeadershipWheelTypeSectionFiltersInput>>
  >;
  mainGradientFrom?: InputMaybe<StringFilterInput>;
  mainGradientTo?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentLeadershipWheelTypeSectionFiltersInput>;
  or?: InputMaybe<
    Array<InputMaybe<ComponentLeadershipWheelTypeSectionFiltersInput>>
  >;
  secondaryGradientFrom?: InputMaybe<StringFilterInput>;
  secondaryGradientTo?: InputMaybe<StringFilterInput>;
  tertiaryGradientFrom?: InputMaybe<StringFilterInput>;
  tertiaryGradientTo?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentLeadershipWheelTypeSectionInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  mainGradientFrom?: InputMaybe<Scalars["String"]["input"]>;
  mainGradientTo?: InputMaybe<Scalars["String"]["input"]>;
  secondaryGradientFrom?: InputMaybe<Scalars["String"]["input"]>;
  secondaryGradientTo?: InputMaybe<Scalars["String"]["input"]>;
  tertiaryGradientFrom?: InputMaybe<Scalars["String"]["input"]>;
  tertiaryGradientTo?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentLearnCourseCompletedSection = {
  __typename?: "ComponentLearnCourseCompletedSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnCourseCompletedSection;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnCourseCompletedSection;
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentLearnCourseCompletedSectionFiltersInput = {
  and?: InputMaybe<
    Array<InputMaybe<ComponentLearnCourseCompletedSectionFiltersInput>>
  >;
  message?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentLearnCourseCompletedSectionFiltersInput>;
  or?: InputMaybe<
    Array<InputMaybe<ComponentLearnCourseCompletedSectionFiltersInput>>
  >;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentLearnCourseCompletedSectionInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentLearnCourseFields = {
  __typename?: "ComponentLearnCourseFields";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnCourseFields;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnCourseFields;
  field?: Maybe<Enum_Componentlearncoursefields_Field>;
  id: Scalars["ID"]["output"];
};

export type ComponentLearnCourseInfoBox = {
  __typename?: "ComponentLearnCourseInfoBox";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnCourseInfoBox;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnCourseInfoBox;
  id: Scalars["ID"]["output"];
};

export type ComponentLearnCourseLesson = {
  __typename?: "ComponentLearnCourseLesson";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnCourseLesson;
  authors: Array<Maybe<Author>>;
  authors_connection?: Maybe<AuthorRelationResponseCollection>;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnCourseLesson;
  description: Scalars["String"]["output"];
  downloadableContent?: Maybe<Array<Maybe<ComponentCommonDownloadableContent>>>;
  duration?: Maybe<Scalars["String"]["output"]>;
  faq?: Maybe<Array<Maybe<ComponentCommonFaq>>>;
  highlightContent?: Maybe<ComponentLearnHighlightContent>;
  id: Scalars["ID"]["output"];
  lessonStableId: Scalars["String"]["output"];
  objectivesSection?: Maybe<ComponentCommonObjectivesSection>;
  textContent?: Maybe<ComponentCommonTextEditor>;
  thumbnail: UploadFile;
  title: Scalars["String"]["output"];
};

export type ComponentLearnCourseLessonAuthorsArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentLearnCourseLessonAuthors_ConnectionArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentLearnCourseLessonDownloadableContentArgs = {
  filters?: InputMaybe<ComponentCommonDownloadableContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentLearnCourseLessonFaqArgs = {
  filters?: InputMaybe<ComponentCommonFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentLearnCourseLessonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLearnCourseLessonFiltersInput>>>;
  authors?: InputMaybe<AuthorFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  downloadableContent?: InputMaybe<ComponentCommonDownloadableContentFiltersInput>;
  duration?: InputMaybe<StringFilterInput>;
  faq?: InputMaybe<ComponentCommonFaqFiltersInput>;
  highlightContent?: InputMaybe<ComponentLearnHighlightContentFiltersInput>;
  lessonStableId?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentLearnCourseLessonFiltersInput>;
  objectivesSection?: InputMaybe<ComponentCommonObjectivesSectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLearnCourseLessonFiltersInput>>>;
  textContent?: InputMaybe<ComponentCommonTextEditorFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentLearnCourseLessonInput = {
  authors?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  downloadableContent?: InputMaybe<
    Array<InputMaybe<ComponentCommonDownloadableContentInput>>
  >;
  duration?: InputMaybe<Scalars["String"]["input"]>;
  faq?: InputMaybe<Array<InputMaybe<ComponentCommonFaqInput>>>;
  highlightContent?: InputMaybe<ComponentLearnHighlightContentInput>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  lessonStableId?: InputMaybe<Scalars["String"]["input"]>;
  objectivesSection?: InputMaybe<ComponentCommonObjectivesSectionInput>;
  textContent?: InputMaybe<ComponentCommonTextEditorInput>;
  thumbnail?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentLearnCourseModule = {
  __typename?: "ComponentLearnCourseModule";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnCourseModule;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnCourseModule;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lessons?: Maybe<Array<Maybe<ComponentLearnCourseLesson>>>;
  moduleStableId: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentLearnCourseModuleLessonsArgs = {
  filters?: InputMaybe<ComponentLearnCourseLessonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentLearnCourseModuleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLearnCourseModuleFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  lessons?: InputMaybe<ComponentLearnCourseLessonFiltersInput>;
  moduleStableId?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentLearnCourseModuleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLearnCourseModuleFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentLearnCourseModuleInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  lessons?: InputMaybe<Array<InputMaybe<ComponentLearnCourseLessonInput>>>;
  moduleStableId?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentLearnCourseRelatedContent = {
  __typename?: "ComponentLearnCourseRelatedContent";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnCourseRelatedContent;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnCourseRelatedContent;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentLearnFeebackSection = {
  __typename?: "ComponentLearnFeebackSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnFeebackSection;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnFeebackSection;
  description: Scalars["String"]["output"];
  enterYourFeedback: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  sendFeedback: Scalars["String"]["output"];
  submitYourFeedback?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
};

export type ComponentLearnFeebackSectionInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  enterYourFeedback?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  sendFeedback?: InputMaybe<Scalars["String"]["input"]>;
  submitYourFeedback?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentLearnFeedback = {
  __typename?: "ComponentLearnFeedback";
  answer?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnFeedback;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnFeedback;
  id: Scalars["ID"]["output"];
  question?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentLearnFeedbackFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLearnFeedbackFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentLearnFeedbackFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLearnFeedbackFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentLearnFeedbackInput = {
  answer?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  question?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentLearnHighlightContent = {
  __typename?: "ComponentLearnHighlightContent";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnHighlightContent;
  audio?: Maybe<ComponentCommonAudio>;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnHighlightContent;
  embedded?: Maybe<ComponentCommonEmbedded>;
  id: Scalars["ID"]["output"];
  image?: Maybe<ComponentCommonMedia>;
};

export type ComponentLearnHighlightContentFiltersInput = {
  and?: InputMaybe<
    Array<InputMaybe<ComponentLearnHighlightContentFiltersInput>>
  >;
  audio?: InputMaybe<ComponentCommonAudioFiltersInput>;
  embedded?: InputMaybe<ComponentCommonEmbeddedFiltersInput>;
  image?: InputMaybe<ComponentCommonMediaFiltersInput>;
  not?: InputMaybe<ComponentLearnHighlightContentFiltersInput>;
  or?: InputMaybe<
    Array<InputMaybe<ComponentLearnHighlightContentFiltersInput>>
  >;
};

export type ComponentLearnHighlightContentInput = {
  audio?: InputMaybe<ComponentCommonAudioInput>;
  embedded?: InputMaybe<ComponentCommonEmbeddedInput>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<ComponentCommonMediaInput>;
};

export type ComponentLearnMarkAsCompleteButton = {
  __typename?: "ComponentLearnMarkAsCompleteButton";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnMarkAsCompleteButton;
  completedLabel?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnMarkAsCompleteButton;
  id: Scalars["ID"]["output"];
  markAsCompleteLabel?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentLearnMarkAsCompleteButtonInput = {
  completedLabel?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  markAsCompleteLabel?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentLearnModalLeavePage = {
  __typename?: "ComponentLearnModalLeavePage";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnModalLeavePage;
  cancelButton: Scalars["String"]["output"];
  confirmButton: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentLearnModalLeavePage;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentLearnModalLeavePageInput = {
  cancelButton?: InputMaybe<Scalars["String"]["input"]>;
  confirmButton?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentLearnNextLesson = {
  __typename?: "ComponentLearnNextLesson";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnNextLesson;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnNextLesson;
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentLearnQuestions = {
  __typename?: "ComponentLearnQuestions";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLearnQuestions;
  /** @deprecated Use root level fields instead */
  data: ComponentLearnQuestions;
  id: Scalars["ID"]["output"];
  question: Scalars["String"]["output"];
};

export type ComponentLearnQuestionsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLearnQuestionsFiltersInput>>>;
  not?: InputMaybe<ComponentLearnQuestionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLearnQuestionsFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentLearnQuestionsInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  question?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentLoginLoginFieldErrors = {
  __typename?: "ComponentLoginLoginFieldErrors";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLoginLoginFieldErrors;
  /** @deprecated Use root level fields instead */
  data: ComponentLoginLoginFieldErrors;
  id: Scalars["ID"]["output"];
  identifierRequired?: Maybe<Scalars["String"]["output"]>;
  passwordRequired?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentLoginLoginFieldErrorsInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  identifierRequired?: InputMaybe<Scalars["String"]["input"]>;
  passwordRequired?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentLoginToastMessagesLogin = {
  __typename?: "ComponentLoginToastMessagesLogin";
  /** @deprecated Use root level fields instead */
  attributes: ComponentLoginToastMessagesLogin;
  /** @deprecated Use root level fields instead */
  data: ComponentLoginToastMessagesLogin;
  error?: Maybe<ComponentCommonToast>;
  id: Scalars["ID"]["output"];
  success?: Maybe<ComponentCommonToast>;
};

export type ComponentLoginToastMessagesLoginInput = {
  error?: InputMaybe<ComponentCommonToastInput>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  success?: InputMaybe<ComponentCommonToastInput>;
};

export type ComponentNotificationPreferencePreferences = {
  __typename?: "ComponentNotificationPreferencePreferences";
  /** @deprecated Use root level fields instead */
  attributes: ComponentNotificationPreferencePreferences;
  /** @deprecated Use root level fields instead */
  data: ComponentNotificationPreferencePreferences;
  id: Scalars["ID"]["output"];
  type: Enum_Componentnotificationpreferencepreferences_Type;
  value: Scalars["Boolean"]["output"];
};

export type ComponentOnBoardingOnBoardingContainer = {
  __typename?: "ComponentOnBoardingOnBoardingContainer";
  /** @deprecated Use root level fields instead */
  attributes: ComponentOnBoardingOnBoardingContainer;
  button?: Maybe<ComponentCommonButton>;
  /** @deprecated Use root level fields instead */
  data: ComponentOnBoardingOnBoardingContainer;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  image?: Maybe<UploadFile>;
  title: Scalars["String"]["output"];
};

export type ComponentOnBoardingOnBoardingContainerInput = {
  button?: InputMaybe<ComponentCommonButtonInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentOnBoardingTimes = {
  __typename?: "ComponentOnBoardingTimes";
  /** @deprecated Use root level fields instead */
  attributes: ComponentOnBoardingTimes;
  /** @deprecated Use root level fields instead */
  data: ComponentOnBoardingTimes;
  id: Scalars["ID"]["output"];
  time: Scalars["Time"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentPodcastEmailTemplate = {
  __typename?: "ComponentPodcastEmailTemplate";
  admin?: Maybe<ComponentPodcastEmailTemplatePodcast>;
  /** @deprecated Use root level fields instead */
  attributes: ComponentPodcastEmailTemplate;
  /** @deprecated Use root level fields instead */
  data: ComponentPodcastEmailTemplate;
  id: Scalars["ID"]["output"];
  user?: Maybe<ComponentPodcastEmailTemplatePodcast>;
};

export type ComponentPodcastEmailTemplatePodcast = {
  __typename?: "ComponentPodcastEmailTemplatePodcast";
  /** @deprecated Use root level fields instead */
  attributes: ComponentPodcastEmailTemplatePodcast;
  content?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentPodcastEmailTemplatePodcast;
  fromEmail?: Maybe<Scalars["String"]["output"]>;
  fromName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  subject?: Maybe<Scalars["String"]["output"]>;
  toEmail?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentPodcastGetInTouch = {
  __typename?: "ComponentPodcastGetInTouch";
  /** @deprecated Use root level fields instead */
  attributes: ComponentPodcastGetInTouch;
  boxText: Scalars["String"]["output"];
  buttonText: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentPodcastGetInTouch;
  descriptionModal: Scalars["String"]["output"];
  emailPlaceholder: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  submitText: Scalars["String"]["output"];
  thanksDescription: Scalars["String"]["output"];
  thanksTitle: Scalars["String"]["output"];
  titleModal: Scalars["String"]["output"];
  yourTextPlaceholder: Scalars["String"]["output"];
};

export type ComponentPodcastIntro = {
  __typename?: "ComponentPodcastIntro";
  /** @deprecated Use root level fields instead */
  attributes: ComponentPodcastIntro;
  /** @deprecated Use root level fields instead */
  data: ComponentPodcastIntro;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  thumbnail: UploadFile;
  title: Scalars["String"]["output"];
};

export type ComponentPodcastListPageCard = {
  __typename?: "ComponentPodcastListPageCard";
  /** @deprecated Use root level fields instead */
  attributes: ComponentPodcastListPageCard;
  /** @deprecated Use root level fields instead */
  data: ComponentPodcastListPageCard;
  id: Scalars["ID"]["output"];
  watchAgainButtonLabel?: Maybe<Scalars["String"]["output"]>;
  watchButtonLabel?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentPodcastListPageCardInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  watchAgainButtonLabel?: InputMaybe<Scalars["String"]["input"]>;
  watchButtonLabel?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentPodcastPodcastPlatformLink = {
  __typename?: "ComponentPodcastPodcastPlatformLink";
  /** @deprecated Use root level fields instead */
  attributes: ComponentPodcastPodcastPlatformLink;
  /** @deprecated Use root level fields instead */
  data: ComponentPodcastPodcastPlatformLink;
  id: Scalars["ID"]["output"];
  platform?: Maybe<PodcastPlatform>;
  url: Scalars["String"]["output"];
};

export type ComponentPodcastPodcastPlatformLinkFiltersInput = {
  and?: InputMaybe<
    Array<InputMaybe<ComponentPodcastPodcastPlatformLinkFiltersInput>>
  >;
  not?: InputMaybe<ComponentPodcastPodcastPlatformLinkFiltersInput>;
  or?: InputMaybe<
    Array<InputMaybe<ComponentPodcastPodcastPlatformLinkFiltersInput>>
  >;
  platform?: InputMaybe<PodcastPlatformFiltersInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentPodcastPodcastPlatformLinkInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  platform?: InputMaybe<Scalars["ID"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentPodcastPodcastRelated = {
  __typename?: "ComponentPodcastPodcastRelated";
  /** @deprecated Use root level fields instead */
  attributes: ComponentPodcastPodcastRelated;
  /** @deprecated Use root level fields instead */
  data: ComponentPodcastPodcastRelated;
  id: Scalars["ID"]["output"];
  podcasts: Array<Maybe<Podcast>>;
  podcasts_connection?: Maybe<PodcastRelationResponseCollection>;
};

export type ComponentPodcastPodcastRelatedPodcastsArgs = {
  filters?: InputMaybe<PodcastFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentPodcastPodcastRelatedPodcasts_ConnectionArgs = {
  filters?: InputMaybe<PodcastFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentProfilePageFinishingCardCharacterExercises = {
  __typename?: "ComponentProfilePageFinishingCardCharacterExercises";
  /** @deprecated Use root level fields instead */
  attributes: ComponentProfilePageFinishingCardCharacterExercises;
  /** @deprecated Use root level fields instead */
  data: ComponentProfilePageFinishingCardCharacterExercises;
  id: Scalars["ID"]["output"];
  minutes?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentProfilePageFinishingCardCharacterExercisesInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  minutes?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentProfilePageFinishingCardMaxStreak = {
  __typename?: "ComponentProfilePageFinishingCardMaxStreak";
  /** @deprecated Use root level fields instead */
  attributes: ComponentProfilePageFinishingCardMaxStreak;
  /** @deprecated Use root level fields instead */
  data: ComponentProfilePageFinishingCardMaxStreak;
  days?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentProfilePageFinishingCardMaxStreakInput = {
  days?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentProfilePageFinishingCardStreak = {
  __typename?: "ComponentProfilePageFinishingCardStreak";
  /** @deprecated Use root level fields instead */
  attributes: ComponentProfilePageFinishingCardStreak;
  /** @deprecated Use root level fields instead */
  data: ComponentProfilePageFinishingCardStreak;
  days?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentProfilePageFinishingCardStreakInput = {
  days?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentProfilePageFinishingCardTraits = {
  __typename?: "ComponentProfilePageFinishingCardTraits";
  /** @deprecated Use root level fields instead */
  attributes: ComponentProfilePageFinishingCardTraits;
  /** @deprecated Use root level fields instead */
  data: ComponentProfilePageFinishingCardTraits;
  id: Scalars["ID"]["output"];
  traits?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentProfilePageFinishingCardTraitsInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  traits?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentProfilePageStatsAndStreaks = {
  __typename?: "ComponentProfilePageStatsAndStreaks";
  /** @deprecated Use root level fields instead */
  attributes: ComponentProfilePageStatsAndStreaks;
  /** @deprecated Use root level fields instead */
  data: ComponentProfilePageStatsAndStreaks;
  finishingCardCharacterExercise?: Maybe<ComponentProfilePageFinishingCardCharacterExercises>;
  finishingCardLeadershipWheel?: Maybe<ComponentProfilePageFinishingCardTraits>;
  finishingCardMaxStreak?: Maybe<ComponentProfilePageFinishingCardMaxStreak>;
  finishingCardStreak?: Maybe<ComponentProfilePageFinishingCardStreak>;
  id: Scalars["ID"]["output"];
};

export type ComponentProfilePageStatsAndStreaksInput = {
  finishingCardCharacterExercise?: InputMaybe<ComponentProfilePageFinishingCardCharacterExercisesInput>;
  finishingCardLeadershipWheel?: InputMaybe<ComponentProfilePageFinishingCardTraitsInput>;
  finishingCardMaxStreak?: InputMaybe<ComponentProfilePageFinishingCardMaxStreakInput>;
  finishingCardStreak?: InputMaybe<ComponentProfilePageFinishingCardStreakInput>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ComponentProfilePolicyLinksSection = {
  __typename?: "ComponentProfilePolicyLinksSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentProfilePolicyLinksSection;
  cookiesTitle?: Maybe<Scalars["String"]["output"]>;
  copyrightTitle?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentProfilePolicyLinksSection;
  id: Scalars["ID"]["output"];
  privacyPolicyTitle?: Maybe<Scalars["String"]["output"]>;
  sectionTitle?: Maybe<Scalars["String"]["output"]>;
  termsAndConditionsTitle?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentProfilePolicyLinksSectionInput = {
  cookiesTitle?: InputMaybe<Scalars["String"]["input"]>;
  copyrightTitle?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  privacyPolicyTitle?: InputMaybe<Scalars["String"]["input"]>;
  sectionTitle?: InputMaybe<Scalars["String"]["input"]>;
  termsAndConditionsTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentProfileProfileInfoSection = {
  __typename?: "ComponentProfileProfileInfoSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentProfileProfileInfoSection;
  /** @deprecated Use root level fields instead */
  data: ComponentProfileProfileInfoSection;
  editYourInfoCta: Scalars["String"]["output"];
  forenamePlaceholder: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastSignInTitle?: Maybe<Scalars["String"]["output"]>;
  memberSinceTitle: Scalars["String"]["output"];
  roleTitle?: Maybe<Scalars["String"]["output"]>;
  saveYourChangesCta: Scalars["String"]["output"];
  saveYourChangesSettingsCta?: Maybe<Scalars["String"]["output"]>;
  surnamePlaceholder: Scalars["String"]["output"];
  unrecognisedActivityMessage?: Maybe<Scalars["String"]["output"]>;
  youLocationTitle: Scalars["String"]["output"];
};

export type ComponentProfileProfileInfoSectionInput = {
  editYourInfoCta?: InputMaybe<Scalars["String"]["input"]>;
  forenamePlaceholder?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  lastSignInTitle?: InputMaybe<Scalars["String"]["input"]>;
  memberSinceTitle?: InputMaybe<Scalars["String"]["input"]>;
  roleTitle?: InputMaybe<Scalars["String"]["input"]>;
  saveYourChangesCta?: InputMaybe<Scalars["String"]["input"]>;
  saveYourChangesSettingsCta?: InputMaybe<Scalars["String"]["input"]>;
  surnamePlaceholder?: InputMaybe<Scalars["String"]["input"]>;
  unrecognisedActivityMessage?: InputMaybe<Scalars["String"]["input"]>;
  youLocationTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentProfileProfileNotificationsSection = {
  __typename?: "ComponentProfileProfileNotificationsSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentProfileProfileNotificationsSection;
  confirmYourChangesCta: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentProfileProfileNotificationsSection;
  id: Scalars["ID"]["output"];
  yourNotificationsTitle: Scalars["String"]["output"];
};

export type ComponentProfileProfileNotificationsSectionInput = {
  confirmYourChangesCta?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  yourNotificationsTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentProfileProfilePasswordSection = {
  __typename?: "ComponentProfileProfilePasswordSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentProfileProfilePasswordSection;
  confirmYourChangesCta: Scalars["String"]["output"];
  confirmYourPasswordField: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentProfileProfilePasswordSection;
  id: Scalars["ID"]["output"];
  yourCurrentPasswordField: Scalars["String"]["output"];
  yourNewPasswordField: Scalars["String"]["output"];
  yourPasswordTitle: Scalars["String"]["output"];
};

export type ComponentProfileProfilePasswordSectionInput = {
  confirmYourChangesCta?: InputMaybe<Scalars["String"]["input"]>;
  confirmYourPasswordField?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  yourCurrentPasswordField?: InputMaybe<Scalars["String"]["input"]>;
  yourNewPasswordField?: InputMaybe<Scalars["String"]["input"]>;
  yourPasswordTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentProfileProfileSubtraitsSection = {
  __typename?: "ComponentProfileProfileSubtraitsSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentProfileProfileSubtraitsSection;
  confirmYouChangesCta: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentProfileProfileSubtraitsSection;
  id: Scalars["ID"]["output"];
  whichAreasTitle: Scalars["String"]["output"];
  yourFocusTitle: Scalars["String"]["output"];
};

export type ComponentProfileProfileSubtraitsSectionInput = {
  confirmYouChangesCta?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  whichAreasTitle?: InputMaybe<Scalars["String"]["input"]>;
  yourFocusTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentProfileTraitTrackingSection = {
  __typename?: "ComponentProfileTraitTrackingSection";
  /** @deprecated Use root level fields instead */
  attributes: ComponentProfileTraitTrackingSection;
  btnStartTrackingLabel: Scalars["String"]["output"];
  btnStopTrackingLabel: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentProfileTraitTrackingSection;
  id: Scalars["ID"]["output"];
  notRecordedDescription?: Maybe<Scalars["String"]["output"]>;
  notRecordedIcon: UploadFile;
  notRecordedLabel: Scalars["String"]["output"];
  notTrackingIcon: UploadFile;
  title: Scalars["String"]["output"];
};

export type ComponentProfileTraitTrackingSectionInput = {
  btnStartTrackingLabel?: InputMaybe<Scalars["String"]["input"]>;
  btnStopTrackingLabel?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  notRecordedDescription?: InputMaybe<Scalars["String"]["input"]>;
  notRecordedIcon?: InputMaybe<Scalars["ID"]["input"]>;
  notRecordedLabel?: InputMaybe<Scalars["String"]["input"]>;
  notTrackingIcon?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentReflectionVideosPageReflectionVideoProperties = {
  __typename?: "ComponentReflectionVideosPageReflectionVideoProperties";
  /** @deprecated Use root level fields instead */
  attributes: ComponentReflectionVideosPageReflectionVideoProperties;
  /** @deprecated Use root level fields instead */
  data: ComponentReflectionVideosPageReflectionVideoProperties;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  video?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentRegisterFeedbackFeedback = {
  __typename?: "ComponentRegisterFeedbackFeedback";
  /** @deprecated Use root level fields instead */
  attributes: ComponentRegisterFeedbackFeedback;
  /** @deprecated Use root level fields instead */
  data: ComponentRegisterFeedbackFeedback;
  emailSent?: Maybe<ComponentCommonEmailSent>;
  id: Scalars["ID"]["output"];
  passwordResetError?: Maybe<ComponentCommonEmailSent>;
  passwordResetSuccess?: Maybe<ComponentCommonEmailSent>;
};

export type ComponentRegisterFeedbackFeedbackInput = {
  emailSent?: InputMaybe<ComponentCommonEmailSentInput>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  passwordResetError?: InputMaybe<ComponentCommonEmailSentInput>;
  passwordResetSuccess?: InputMaybe<ComponentCommonEmailSentInput>;
};

export type ComponentRegisterRegisterFieldErrors = {
  __typename?: "ComponentRegisterRegisterFieldErrors";
  /** @deprecated Use root level fields instead */
  attributes: ComponentRegisterRegisterFieldErrors;
  confirmPasswordDidNotMatch?: Maybe<Scalars["String"]["output"]>;
  confirmPasswordRequired?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentRegisterRegisterFieldErrors;
  emailRequired?: Maybe<Scalars["String"]["output"]>;
  forenameRequired?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  passwordRequired?: Maybe<Scalars["String"]["output"]>;
  schoolCodeRequired?: Maybe<Scalars["String"]["output"]>;
  surnameRequired?: Maybe<Scalars["String"]["output"]>;
  termsAndConditionsRequired?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentRegisterRegisterFieldErrorsInput = {
  confirmPasswordDidNotMatch?: InputMaybe<Scalars["String"]["input"]>;
  confirmPasswordRequired?: InputMaybe<Scalars["String"]["input"]>;
  emailRequired?: InputMaybe<Scalars["String"]["input"]>;
  forenameRequired?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  passwordRequired?: InputMaybe<Scalars["String"]["input"]>;
  schoolCodeRequired?: InputMaybe<Scalars["String"]["input"]>;
  surnameRequired?: InputMaybe<Scalars["String"]["input"]>;
  termsAndConditionsRequired?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentRegisterToastMessagesRegister = {
  __typename?: "ComponentRegisterToastMessagesRegister";
  /** @deprecated Use root level fields instead */
  attributes: ComponentRegisterToastMessagesRegister;
  /** @deprecated Use root level fields instead */
  data: ComponentRegisterToastMessagesRegister;
  error?: Maybe<ComponentCommonToast>;
  id: Scalars["ID"]["output"];
  success?: Maybe<ComponentCommonToast>;
};

export type ComponentRegisterToastMessagesRegisterInput = {
  error?: InputMaybe<ComponentCommonToastInput>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  success?: InputMaybe<ComponentCommonToastInput>;
};

export type ComponentReportingToolsAdminTabs = {
  __typename?: "ComponentReportingToolsAdminTabs";
  /** @deprecated Use root level fields instead */
  attributes: ComponentReportingToolsAdminTabs;
  /** @deprecated Use root level fields instead */
  data: ComponentReportingToolsAdminTabs;
  id: Scalars["ID"]["output"];
  manageStaff?: Maybe<Scalars["String"]["output"]>;
  reportingTools?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentReportingToolsAdminTabsInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  manageStaff?: InputMaybe<Scalars["String"]["input"]>;
  reportingTools?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentReportingToolsDesktopPreferedBox = {
  __typename?: "ComponentReportingToolsDesktopPreferedBox";
  /** @deprecated Use root level fields instead */
  attributes: ComponentReportingToolsDesktopPreferedBox;
  /** @deprecated Use root level fields instead */
  data: ComponentReportingToolsDesktopPreferedBox;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentReportingToolsInviteUsers = {
  __typename?: "ComponentReportingToolsInviteUsers";
  /** @deprecated Use root level fields instead */
  attributes: ComponentReportingToolsInviteUsers;
  /** @deprecated Use root level fields instead */
  data: ComponentReportingToolsInviteUsers;
  description?: Maybe<Scalars["String"]["output"]>;
  dialogConfirmButton?: Maybe<Scalars["String"]["output"]>;
  dialogDescription?: Maybe<Scalars["String"]["output"]>;
  dialogTitle?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  importStaffSpreadsheet?: Maybe<Scalars["String"]["output"]>;
  inviteStaff?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  toastStaffInvitedDescription?: Maybe<Scalars["String"]["output"]>;
  toastStaffInvitedTitle?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentReportingToolsInviteUsersInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  dialogConfirmButton?: InputMaybe<Scalars["String"]["input"]>;
  dialogDescription?: InputMaybe<Scalars["String"]["input"]>;
  dialogTitle?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  importStaffSpreadsheet?: InputMaybe<Scalars["String"]["input"]>;
  inviteStaff?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  toastStaffInvitedDescription?: InputMaybe<Scalars["String"]["input"]>;
  toastStaffInvitedTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentReportingToolsStaffStatus = {
  __typename?: "ComponentReportingToolsStaffStatus";
  /** @deprecated Use root level fields instead */
  attributes: ComponentReportingToolsStaffStatus;
  /** @deprecated Use root level fields instead */
  data: ComponentReportingToolsStaffStatus;
  id: Scalars["ID"]["output"];
  invitedPendingSignUpColor?: Maybe<Scalars["String"]["output"]>;
  invitedPendingSignUpMessage?: Maybe<Scalars["String"]["output"]>;
  pendingInviteColor?: Maybe<Scalars["String"]["output"]>;
  pendingInviteMessage?: Maybe<Scalars["String"]["output"]>;
  registeredOnboardedColor?: Maybe<Scalars["String"]["output"]>;
  registeredOnboardedMessage?: Maybe<Scalars["String"]["output"]>;
  registeredPendingOnboardingColor?: Maybe<Scalars["String"]["output"]>;
  registeredPendingOnboardingMessage?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentReportingToolsStaffStatusInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  invitedPendingSignUpColor?: InputMaybe<Scalars["String"]["input"]>;
  invitedPendingSignUpMessage?: InputMaybe<Scalars["String"]["input"]>;
  pendingInviteColor?: InputMaybe<Scalars["String"]["input"]>;
  pendingInviteMessage?: InputMaybe<Scalars["String"]["input"]>;
  registeredOnboardedColor?: InputMaybe<Scalars["String"]["input"]>;
  registeredOnboardedMessage?: InputMaybe<Scalars["String"]["input"]>;
  registeredPendingOnboardingColor?: InputMaybe<Scalars["String"]["input"]>;
  registeredPendingOnboardingMessage?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentReportingToolsUsersEmptyState = {
  __typename?: "ComponentReportingToolsUsersEmptyState";
  /** @deprecated Use root level fields instead */
  attributes: ComponentReportingToolsUsersEmptyState;
  /** @deprecated Use root level fields instead */
  data: ComponentReportingToolsUsersEmptyState;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentReportingToolsUsersEmptyStateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentResourceAssets = {
  __typename?: "ComponentResourceAssets";
  assets: Array<Maybe<ResourceAsset>>;
  assets_connection?: Maybe<ResourceAssetRelationResponseCollection>;
  /** @deprecated Use root level fields instead */
  attributes: ComponentResourceAssets;
  /** @deprecated Use root level fields instead */
  data: ComponentResourceAssets;
  id: Scalars["ID"]["output"];
  sectionTitle?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentResourceAssetsAssetsArgs = {
  filters?: InputMaybe<ResourceAssetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentResourceAssetsAssets_ConnectionArgs = {
  filters?: InputMaybe<ResourceAssetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentResourceResourcesRelated = {
  __typename?: "ComponentResourceResourcesRelated";
  /** @deprecated Use root level fields instead */
  attributes: ComponentResourceResourcesRelated;
  /** @deprecated Use root level fields instead */
  data: ComponentResourceResourcesRelated;
  id: Scalars["ID"]["output"];
  resources: Array<Maybe<Resource>>;
  resources_connection?: Maybe<ResourceRelationResponseCollection>;
};

export type ComponentResourceResourcesRelatedResourcesArgs = {
  filters?: InputMaybe<ResourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentResourceResourcesRelatedResources_ConnectionArgs = {
  filters?: InputMaybe<ResourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentSchollDomains = {
  __typename?: "ComponentSchollDomains";
  /** @deprecated Use root level fields instead */
  attributes: ComponentSchollDomains;
  /** @deprecated Use root level fields instead */
  data: ComponentSchollDomains;
  domain: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type ComponentSchollDomainsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSchollDomainsFiltersInput>>>;
  domain?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSchollDomainsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSchollDomainsFiltersInput>>>;
};

export type ComponentSchollDomainsInput = {
  domain?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ComponentSchollTermDates = {
  __typename?: "ComponentSchollTermDates";
  /** @deprecated Use root level fields instead */
  attributes: ComponentSchollTermDates;
  autumnTermEndDate?: Maybe<Scalars["Date"]["output"]>;
  autumnTermStartDate?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentSchollTermDates;
  id: Scalars["ID"]["output"];
  springTermEndDate?: Maybe<Scalars["Date"]["output"]>;
  springTermStartDate?: Maybe<Scalars["Date"]["output"]>;
  summerTermEndDate?: Maybe<Scalars["Date"]["output"]>;
  summerTermStartDate?: Maybe<Scalars["Date"]["output"]>;
};

export type ComponentSchollTermDatesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSchollTermDatesFiltersInput>>>;
  autumnTermEndDate?: InputMaybe<DateFilterInput>;
  autumnTermStartDate?: InputMaybe<DateFilterInput>;
  not?: InputMaybe<ComponentSchollTermDatesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSchollTermDatesFiltersInput>>>;
  springTermEndDate?: InputMaybe<DateFilterInput>;
  springTermStartDate?: InputMaybe<DateFilterInput>;
  summerTermEndDate?: InputMaybe<DateFilterInput>;
  summerTermStartDate?: InputMaybe<DateFilterInput>;
};

export type ComponentSchollTermDatesInput = {
  autumnTermEndDate?: InputMaybe<Scalars["Date"]["input"]>;
  autumnTermStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  springTermEndDate?: InputMaybe<Scalars["Date"]["input"]>;
  springTermStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  summerTermEndDate?: InputMaybe<Scalars["Date"]["input"]>;
  summerTermStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type ComponentSchollWondeRoles = {
  __typename?: "ComponentSchollWondeRoles";
  /** @deprecated Use root level fields instead */
  attributes: ComponentSchollWondeRoles;
  /** @deprecated Use root level fields instead */
  data: ComponentSchollWondeRoles;
  id: Scalars["ID"]["output"];
  role?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentSchollWondeRolesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSchollWondeRolesFiltersInput>>>;
  not?: InputMaybe<ComponentSchollWondeRolesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSchollWondeRolesFiltersInput>>>;
  role?: InputMaybe<StringFilterInput>;
};

export type ComponentSchollWondeRolesInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
};

export type ComponentSharedMetaSocial = {
  __typename?: "ComponentSharedMetaSocial";
  /** @deprecated Use root level fields instead */
  attributes: ComponentSharedMetaSocial;
  /** @deprecated Use root level fields instead */
  data: ComponentSharedMetaSocial;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image?: Maybe<UploadFile>;
  socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork;
  title: Scalars["String"]["output"];
};

export type ComponentSharedMetaSocialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedMetaSocialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialFiltersInput>>>;
  socialNetwork?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedSeo = {
  __typename?: "ComponentSharedSeo";
  /** @deprecated Use root level fields instead */
  attributes: ComponentSharedSeo;
  canonicalURL?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentSharedSeo;
  id: Scalars["ID"]["output"];
  keywords?: Maybe<Scalars["String"]["output"]>;
  metaDescription: Scalars["String"]["output"];
  metaImage?: Maybe<UploadFile>;
  metaRobots?: Maybe<Scalars["String"]["output"]>;
  metaSocial?: Maybe<Array<Maybe<ComponentSharedMetaSocial>>>;
  metaTitle: Scalars["String"]["output"];
  metaViewport?: Maybe<Scalars["String"]["output"]>;
  structuredData?: Maybe<Scalars["JSON"]["output"]>;
};

export type ComponentSharedSeoMetaSocialArgs = {
  filters?: InputMaybe<ComponentSharedMetaSocialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentSurveyAnswers = {
  __typename?: "ComponentSurveyAnswers";
  /** @deprecated Use root level fields instead */
  attributes: ComponentSurveyAnswers;
  color?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentSurveyAnswers;
  id: Scalars["ID"]["output"];
  option?: Maybe<Scalars["String"]["output"]>;
  scale?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Enum_Componentsurveyanswers_Type>;
};

export type ComponentSurveyAnswersFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSurveyAnswersFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSurveyAnswersFiltersInput>;
  option?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSurveyAnswersFiltersInput>>>;
  scale?: InputMaybe<IntFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentSurveyAnswersInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  option?: InputMaybe<Scalars["String"]["input"]>;
  scale?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<Enum_Componentsurveyanswers_Type>;
};

export type ComponentSurveyHolidays = {
  __typename?: "ComponentSurveyHolidays";
  /** @deprecated Use root level fields instead */
  attributes: ComponentSurveyHolidays;
  /** @deprecated Use root level fields instead */
  data: ComponentSurveyHolidays;
  date: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
};

export type ComponentSurveyRepetableSurvey = {
  __typename?: "ComponentSurveyRepetableSurvey";
  /** @deprecated Use root level fields instead */
  attributes: ComponentSurveyRepetableSurvey;
  /** @deprecated Use root level fields instead */
  data: ComponentSurveyRepetableSurvey;
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  frequency?: Maybe<Enum_Componentsurveyrepetablesurvey_Frequency>;
  id: Scalars["ID"]["output"];
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ComponentSurveySingleSurvey = {
  __typename?: "ComponentSurveySingleSurvey";
  /** @deprecated Use root level fields instead */
  attributes: ComponentSurveySingleSurvey;
  /** @deprecated Use root level fields instead */
  data: ComponentSurveySingleSurvey;
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ComponentTimerTimerAudio = {
  __typename?: "ComponentTimerTimerAudio";
  /** @deprecated Use root level fields instead */
  attributes: ComponentTimerTimerAudio;
  /** @deprecated Use root level fields instead */
  data: ComponentTimerTimerAudio;
  id: Scalars["ID"]["output"];
  prompt?: Maybe<Scalars["String"]["output"]>;
  spokenGuidance?: Maybe<UploadFile>;
  title: Scalars["String"]["output"];
};

export type ComponentTimerTimerAudioLabels = {
  __typename?: "ComponentTimerTimerAudioLabels";
  /** @deprecated Use root level fields instead */
  attributes: ComponentTimerTimerAudioLabels;
  backDailyBubbleButton: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentTimerTimerAudioLabels;
  id: Scalars["ID"]["output"];
  minutes: Array<Maybe<ComponentCommonMinutes>>;
  pauseButtonLabel?: Maybe<Scalars["String"]["output"]>;
  playButtonLabel?: Maybe<Scalars["String"]["output"]>;
  restartButtonLabel?: Maybe<Scalars["String"]["output"]>;
  startExerciseButton: Scalars["String"]["output"];
  stopButtonLabel?: Maybe<Scalars["String"]["output"]>;
  thankYouTitle: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentTimerTimerAudioLabelsMinutesArgs = {
  filters?: InputMaybe<ComponentCommonMinutesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ComponentTimerTimerPrompt = {
  __typename?: "ComponentTimerTimerPrompt";
  /** @deprecated Use root level fields instead */
  attributes: ComponentTimerTimerPrompt;
  /** @deprecated Use root level fields instead */
  data: ComponentTimerTimerPrompt;
  durationInSeconds?: Maybe<Scalars["Long"]["output"]>;
  id: Scalars["ID"]["output"];
  prompt: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type ComponentTimerTimerPromptLabels = {
  __typename?: "ComponentTimerTimerPromptLabels";
  /** @deprecated Use root level fields instead */
  attributes: ComponentTimerTimerPromptLabels;
  backDailyBubbleButton: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentTimerTimerPromptLabels;
  id: Scalars["ID"]["output"];
  pauseButtonLabel?: Maybe<Scalars["String"]["output"]>;
  playButtonLabel?: Maybe<Scalars["String"]["output"]>;
  restartButtonLabel?: Maybe<Scalars["String"]["output"]>;
  startExerciseButton: Scalars["String"]["output"];
  stopButtonLabel?: Maybe<Scalars["String"]["output"]>;
  thankYouTitle?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentTimerTimerVideo = {
  __typename?: "ComponentTimerTimerVideo";
  /** @deprecated Use root level fields instead */
  attributes: ComponentTimerTimerVideo;
  /** @deprecated Use root level fields instead */
  data: ComponentTimerTimerVideo;
  id: Scalars["ID"]["output"];
  thumbnail?: Maybe<UploadFile>;
  video: UploadFile;
  videoTitle: Scalars["String"]["output"];
};

export type ComponentTimerTimerVideoLabels = {
  __typename?: "ComponentTimerTimerVideoLabels";
  /** @deprecated Use root level fields instead */
  attributes: ComponentTimerTimerVideoLabels;
  backDailyBubbleButton: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ComponentTimerTimerVideoLabels;
  id: Scalars["ID"]["output"];
  thankYouTitle: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentWildcardAnnouncementActions = {
  __typename?: "ComponentWildcardAnnouncementActions";
  /** @deprecated Use root level fields instead */
  attributes: ComponentWildcardAnnouncementActions;
  /** @deprecated Use root level fields instead */
  data: ComponentWildcardAnnouncementActions;
  deleteBtn?: Maybe<Scalars["String"]["output"]>;
  duplicateBtn?: Maybe<Scalars["String"]["output"]>;
  editBtn?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  publishBtn?: Maybe<Scalars["String"]["output"]>;
  unpublishBtn?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentWildcardAnnouncementDeleteDialog = {
  __typename?: "ComponentWildcardAnnouncementDeleteDialog";
  /** @deprecated Use root level fields instead */
  attributes: ComponentWildcardAnnouncementDeleteDialog;
  cancelBtn?: Maybe<Scalars["String"]["output"]>;
  confirmBtn?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentWildcardAnnouncementDeleteDialog;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentWildcardAnnouncementForm = {
  __typename?: "ComponentWildcardAnnouncementForm";
  /** @deprecated Use root level fields instead */
  attributes: ComponentWildcardAnnouncementForm;
  charactersLabel?: Maybe<Scalars["String"]["output"]>;
  createBtn?: Maybe<Scalars["String"]["output"]>;
  createError?: Maybe<Scalars["String"]["output"]>;
  createSuccess?: Maybe<Scalars["String"]["output"]>;
  createSuccessDescription?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ComponentWildcardAnnouncementForm;
  datesDescription?: Maybe<Scalars["String"]["output"]>;
  datesTitle?: Maybe<Scalars["String"]["output"]>;
  defaultSchoolTitle?: Maybe<Scalars["String"]["output"]>;
  descriptionPlaceholder?: Maybe<Scalars["String"]["output"]>;
  descriptionSubtitle?: Maybe<Scalars["String"]["output"]>;
  descriptionTitle?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  logoDescription?: Maybe<Scalars["String"]["output"]>;
  logoRequired?: Maybe<Scalars["String"]["output"]>;
  logoRequiredDescription?: Maybe<Scalars["String"]["output"]>;
  logoSelected?: Maybe<Scalars["String"]["output"]>;
  logoTitle?: Maybe<Scalars["String"]["output"]>;
  logoUploadBtn?: Maybe<Scalars["String"]["output"]>;
  logoUploadPrompt?: Maybe<Scalars["String"]["output"]>;
  savingBtn?: Maybe<Scalars["String"]["output"]>;
  schoolsDescription?: Maybe<Scalars["String"]["output"]>;
  schoolsTitle?: Maybe<Scalars["String"]["output"]>;
  updateBtn?: Maybe<Scalars["String"]["output"]>;
  updateError?: Maybe<Scalars["String"]["output"]>;
  updateSuccess?: Maybe<Scalars["String"]["output"]>;
  updateSuccessDescription?: Maybe<Scalars["String"]["output"]>;
  validations?: Maybe<ComponentWildcardValidation>;
};

export type ComponentWildcardAnnouncementPreview = {
  __typename?: "ComponentWildcardAnnouncementPreview";
  /** @deprecated Use root level fields instead */
  attributes: ComponentWildcardAnnouncementPreview;
  /** @deprecated Use root level fields instead */
  data: ComponentWildcardAnnouncementPreview;
  deleteError?: Maybe<Scalars["String"]["output"]>;
  deleteErrorDescription?: Maybe<Scalars["String"]["output"]>;
  deleteSuccess?: Maybe<Scalars["String"]["output"]>;
  deleteSuccessDescription?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  like?: Maybe<Scalars["String"]["output"]>;
  liveFromLabel?: Maybe<Scalars["String"]["output"]>;
  liveLabel?: Maybe<Scalars["String"]["output"]>;
  publishError?: Maybe<Scalars["String"]["output"]>;
  publishErrorDescription?: Maybe<Scalars["String"]["output"]>;
  publishSuccess?: Maybe<Scalars["String"]["output"]>;
  publishSuccessDescription?: Maybe<Scalars["String"]["output"]>;
  scheduledLabel?: Maybe<Scalars["String"]["output"]>;
  totalLikesLabel?: Maybe<Scalars["String"]["output"]>;
  unpublishError?: Maybe<Scalars["String"]["output"]>;
  unpublishErrorDescription?: Maybe<Scalars["String"]["output"]>;
  unpublishSuccess?: Maybe<Scalars["String"]["output"]>;
  unpublishSuccessDescription?: Maybe<Scalars["String"]["output"]>;
  untilLabel?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentWildcardCta = {
  __typename?: "ComponentWildcardCta";
  /** @deprecated Use root level fields instead */
  attributes: ComponentWildcardCta;
  course?: Maybe<Course>;
  /** @deprecated Use root level fields instead */
  data: ComponentWildcardCta;
  id: Scalars["ID"]["output"];
  knowledgeBase?: Maybe<KnowledgeBase>;
  redirectToCalendar?: Maybe<Scalars["Boolean"]["output"]>;
  redirectToLeadershipWheel?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComponentWildcardCtaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentWildcardCtaFiltersInput>>>;
  course?: InputMaybe<CourseFiltersInput>;
  knowledgeBase?: InputMaybe<KnowledgeBaseFiltersInput>;
  not?: InputMaybe<ComponentWildcardCtaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentWildcardCtaFiltersInput>>>;
  redirectToCalendar?: InputMaybe<BooleanFilterInput>;
  redirectToLeadershipWheel?: InputMaybe<BooleanFilterInput>;
};

export type ComponentWildcardCtaInput = {
  course?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  knowledgeBase?: InputMaybe<Scalars["ID"]["input"]>;
  redirectToCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
  redirectToLeadershipWheel?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ComponentWildcardValidation = {
  __typename?: "ComponentWildcardValidation";
  /** @deprecated Use root level fields instead */
  attributes: ComponentWildcardValidation;
  /** @deprecated Use root level fields instead */
  data: ComponentWildcardValidation;
  dateRangeLimit?: Maybe<Scalars["String"]["output"]>;
  descriptionMaxLength?: Maybe<Scalars["String"]["output"]>;
  descriptionRequired?: Maybe<Scalars["String"]["output"]>;
  endDateAfterStart?: Maybe<Scalars["String"]["output"]>;
  endDateValid?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  logoDimensions?: Maybe<Scalars["String"]["output"]>;
  logoRequired?: Maybe<Scalars["String"]["output"]>;
  logoSize?: Maybe<Scalars["String"]["output"]>;
  schoolRequired?: Maybe<Scalars["String"]["output"]>;
  startDateFuture?: Maybe<Scalars["String"]["output"]>;
};

export type CookiesPage = {
  __typename?: "CookiesPage";
  DefaultContentTemplate: Array<
    Maybe<CookiesPageDefaultContentTemplateDynamicZone>
  >;
  /** @deprecated Use root level fields instead */
  attributes: CookiesPage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: CookiesPage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CookiesPageDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type CookiesPageInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<Scalars["CookiesPageDefaultContentTemplateDynamicZoneInput"]["input"]>
  >;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CopyrightPage = {
  __typename?: "CopyrightPage";
  DefaultContentTemplate: Array<
    Maybe<CopyrightPageDefaultContentTemplateDynamicZone>
  >;
  /** @deprecated Use root level fields instead */
  attributes: CopyrightPage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: CopyrightPage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CopyrightPageDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type CopyrightPageInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<
      Scalars["CopyrightPageDefaultContentTemplateDynamicZoneInput"]["input"]
    >
  >;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type Course = {
  __typename?: "Course";
  /** @deprecated Use root level fields instead */
  attributes: Course;
  courseCompletedSection?: Maybe<ComponentLearnCourseCompletedSection>;
  course_category?: Maybe<CourseCategory>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Course;
  description: Scalars["String"]["output"];
  documentId: Scalars["ID"]["output"];
  duration?: Maybe<Scalars["String"]["output"]>;
  feedback: Array<Maybe<CourseFeedback>>;
  feedbackQuestions?: Maybe<Array<Maybe<ComponentLearnQuestions>>>;
  feedback_connection?: Maybe<CourseFeedbackRelationResponseCollection>;
  hero: UploadFile;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  modules?: Maybe<Array<Maybe<ComponentLearnCourseModule>>>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  slug?: Maybe<Scalars["String"]["output"]>;
  textContent?: Maybe<ComponentCommonTextEditor>;
  thumbnail: UploadFile;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CourseFeedbackArgs = {
  filters?: InputMaybe<CourseFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CourseFeedbackQuestionsArgs = {
  filters?: InputMaybe<ComponentLearnQuestionsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CourseFeedback_ConnectionArgs = {
  filters?: InputMaybe<CourseFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CourseModulesArgs = {
  filters?: InputMaybe<ComponentLearnCourseModuleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CourseCategory = {
  __typename?: "CourseCategory";
  /** @deprecated Use root level fields instead */
  attributes: CourseCategory;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: CourseCategory;
  description?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CourseCategoryEntityResponseCollection = {
  __typename?: "CourseCategoryEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<CourseCategory>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<CourseCategory>;
  pageInfo: Pagination;
};

export type CourseCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CourseCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CourseCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CourseCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CourseCategoryInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type CourseEntityResponseCollection = {
  __typename?: "CourseEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Course>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Course>;
  pageInfo: Pagination;
};

export type CourseFeedback = {
  __typename?: "CourseFeedback";
  answers?: Maybe<Array<Maybe<ComponentLearnFeedback>>>;
  /** @deprecated Use root level fields instead */
  attributes: CourseFeedback;
  course?: Maybe<Course>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: CourseFeedback;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  staff?: Maybe<UsersPermissionsUser>;
  submittedDate?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  user?: Maybe<UsersPermissionsUser>;
};

export type CourseFeedbackAnswersArgs = {
  filters?: InputMaybe<ComponentLearnFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CourseFeedbackEntityResponseCollection = {
  __typename?: "CourseFeedbackEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<CourseFeedback>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<CourseFeedback>;
  pageInfo: Pagination;
};

export type CourseFeedbackFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CourseFeedbackFiltersInput>>>;
  answers?: InputMaybe<ComponentLearnFeedbackFiltersInput>;
  course?: InputMaybe<CourseFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<CourseFeedbackFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CourseFeedbackFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  staff?: InputMaybe<UsersPermissionsUserFiltersInput>;
  submittedDate?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type CourseFeedbackInput = {
  answers?: InputMaybe<Array<InputMaybe<ComponentLearnFeedbackInput>>>;
  course?: InputMaybe<Scalars["ID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  staff?: InputMaybe<Scalars["ID"]["input"]>;
  submittedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  user?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CourseFeedbackRelationResponseCollection = {
  __typename?: "CourseFeedbackRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<CourseFeedback>;
  nodes: Array<CourseFeedback>;
};

export type CourseFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CourseFiltersInput>>>;
  courseCompletedSection?: InputMaybe<ComponentLearnCourseCompletedSectionFiltersInput>;
  course_category?: InputMaybe<CourseCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  duration?: InputMaybe<StringFilterInput>;
  feedback?: InputMaybe<CourseFeedbackFiltersInput>;
  feedbackQuestions?: InputMaybe<ComponentLearnQuestionsFiltersInput>;
  modules?: InputMaybe<ComponentLearnCourseModuleFiltersInput>;
  not?: InputMaybe<CourseFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CourseFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  textContent?: InputMaybe<ComponentCommonTextEditorFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CourseInput = {
  courseCompletedSection?: InputMaybe<ComponentLearnCourseCompletedSectionInput>;
  course_category?: InputMaybe<Scalars["ID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  duration?: InputMaybe<Scalars["String"]["input"]>;
  feedback?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  feedbackQuestions?: InputMaybe<
    Array<InputMaybe<ComponentLearnQuestionsInput>>
  >;
  hero?: InputMaybe<Scalars["ID"]["input"]>;
  modules?: InputMaybe<Array<InputMaybe<ComponentLearnCourseModuleInput>>>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  textContent?: InputMaybe<ComponentCommonTextEditorInput>;
  thumbnail?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CoursePage = {
  __typename?: "CoursePage";
  /** @deprecated Use root level fields instead */
  attributes: CoursePage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: CoursePage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  lesson?: Maybe<ComponentCoursePageLesson>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CoursePageInput = {
  lesson?: InputMaybe<ComponentCoursePageLessonInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type CurrentSurveyResult = {
  __typename?: "CurrentSurveyResult";
  questions?: Maybe<Array<Maybe<QuestionEntity>>>;
  survey?: Maybe<SurveyEntity>;
};

export type CustomMeasure = {
  __typename?: "CustomMeasure";
  name?: Maybe<Scalars["String"]["output"]>;
  questions?: Maybe<Array<Maybe<CustomQuestion>>>;
};

export type CustomQuestion = {
  __typename?: "CustomQuestion";
  name?: Maybe<Scalars["String"]["output"]>;
  results?: Maybe<Array<Maybe<CustomResult>>>;
};

export type CustomResult = {
  __typename?: "CustomResult";
  option?: Maybe<Scalars["String"]["output"]>;
  percentage?: Maybe<Scalars["Float"]["output"]>;
  scale?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["Int"]["output"]>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars["Date"]["input"]>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars["Date"]["input"]>>>;
  contains?: InputMaybe<Scalars["Date"]["input"]>;
  containsi?: InputMaybe<Scalars["Date"]["input"]>;
  endsWith?: InputMaybe<Scalars["Date"]["input"]>;
  eq?: InputMaybe<Scalars["Date"]["input"]>;
  eqi?: InputMaybe<Scalars["Date"]["input"]>;
  gt?: InputMaybe<Scalars["Date"]["input"]>;
  gte?: InputMaybe<Scalars["Date"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["Date"]["input"]>>>;
  lt?: InputMaybe<Scalars["Date"]["input"]>;
  lte?: InputMaybe<Scalars["Date"]["input"]>;
  ne?: InputMaybe<Scalars["Date"]["input"]>;
  nei?: InputMaybe<Scalars["Date"]["input"]>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars["Date"]["input"]>;
  notContainsi?: InputMaybe<Scalars["Date"]["input"]>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars["Date"]["input"]>>>;
  notNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  null?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<InputMaybe<Scalars["Date"]["input"]>>>;
  startsWith?: InputMaybe<Scalars["Date"]["input"]>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  contains?: InputMaybe<Scalars["DateTime"]["input"]>;
  containsi?: InputMaybe<Scalars["DateTime"]["input"]>;
  endsWith?: InputMaybe<Scalars["DateTime"]["input"]>;
  eq?: InputMaybe<Scalars["DateTime"]["input"]>;
  eqi?: InputMaybe<Scalars["DateTime"]["input"]>;
  gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  ne?: InputMaybe<Scalars["DateTime"]["input"]>;
  nei?: InputMaybe<Scalars["DateTime"]["input"]>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars["DateTime"]["input"]>;
  notContainsi?: InputMaybe<Scalars["DateTime"]["input"]>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  notNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  null?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  startsWith?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Day = {
  __typename?: "Day";
  day?: Maybe<Scalars["Date"]["output"]>;
  emotion?: Maybe<Scalars["String"]["output"]>;
};

export type DayManager = {
  __typename?: "DayManager";
  day?: Maybe<Scalars["Date"]["output"]>;
  emotions?: Maybe<Array<Maybe<EmotionsSizeManager>>>;
};

export type DeleteMutationResponse = {
  __typename?: "DeleteMutationResponse";
  documentId: Scalars["ID"]["output"];
};

export type DocumentsHistoryDocumentHistory = {
  __typename?: "DocumentsHistoryDocumentHistory";
  active?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: DocumentsHistoryDocumentHistory;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  data: Scalars["JSON"]["output"];
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  targetId: Scalars["String"]["output"];
  targetUid: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  versionNumber: Scalars["Int"]["output"];
};

export type DocumentsHistoryDocumentHistoryEntityResponseCollection = {
  __typename?: "DocumentsHistoryDocumentHistoryEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<DocumentsHistoryDocumentHistory>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<DocumentsHistoryDocumentHistory>;
  pageInfo: Pagination;
};

export type DocumentsHistoryDocumentHistoryFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<
    Array<InputMaybe<DocumentsHistoryDocumentHistoryFiltersInput>>
  >;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  data?: InputMaybe<JsonFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DocumentsHistoryDocumentHistoryFiltersInput>;
  or?: InputMaybe<
    Array<InputMaybe<DocumentsHistoryDocumentHistoryFiltersInput>>
  >;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  targetId?: InputMaybe<StringFilterInput>;
  targetUid?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  versionNumber?: InputMaybe<IntFilterInput>;
};

export type DocumentsHistoryDocumentHistoryInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  data?: InputMaybe<Scalars["JSON"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  targetId?: InputMaybe<Scalars["String"]["input"]>;
  targetUid?: InputMaybe<Scalars["String"]["input"]>;
  versionNumber?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum Enum_Bookmark_Category {
  Course = "COURSE",
  KnowledgeBase = "KNOWLEDGE_BASE",
  Podcast = "PODCAST",
  Resource = "RESOURCE",
}

export enum Enum_Completedtask_Type {
  CharacterExercise = "CHARACTER_EXERCISE",
  LeadershipWheel = "LEADERSHIP_WHEEL",
  Quote = "QUOTE",
  WeeklyQuestion = "WEEKLY_QUESTION",
}

export enum Enum_Componentcommonembedded_Provider {
  Vimeo = "VIMEO",
  Youtube = "YOUTUBE",
}

export enum Enum_Componentdefaultcontenttemplatetimer_Type {
  Audio = "AUDIO",
  Prompt = "PROMPT",
  Video = "VIDEO",
}

export enum Enum_Componentlearncoursefields_Field {
  Authors = "authors",
  CourseCategory = "course_category",
  Description = "description",
  Hero = "hero",
  Modules = "modules",
  Slug = "slug",
  Thumbnail = "thumbnail",
  Title = "title",
  Type = "type",
}

export enum Enum_Componentnotificationpreferencepreferences_Type {
  Courses = "COURSES",
  NewContentNotification = "NEW_CONTENT_NOTIFICATION",
  Reminder = "REMINDER",
}

export enum Enum_Componentsharedmetasocial_Socialnetwork {
  Facebook = "Facebook",
  Twitter = "Twitter",
}

export enum Enum_Componentsurveyanswers_Type {
  Negative = "NEGATIVE",
  Neutral = "NEUTRAL",
  Positive = "POSITIVE",
}

export enum Enum_Componentsurveyrepetablesurvey_Frequency {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
  Yearly = "YEARLY",
}

export enum Enum_Edwingroupstrapiv5Auditlogsedwingroupauditlog_Action {
  Create = "CREATE",
  Delete = "DELETE",
  DeleteMany = "DELETE_MANY",
  Update = "UPDATE",
  UpdateMany = "UPDATE_MANY",
}

export enum Enum_Importeduser_Origin {
  Spreadsheet = "SPREADSHEET",
  Wonde = "WONDE",
}

export enum Enum_Interactionsga_Feature {
  Bookmarks = "BOOKMARKS",
  Characterexercise = "CHARACTEREXERCISE",
  Knowledgebase = "KNOWLEDGEBASE",
  Leadershipwheel = "LEADERSHIPWHEEL",
  Learn = "LEARN",
  Mindfulexercise = "MINDFULEXERCISE",
  Podcast = "PODCAST",
  Search = "SEARCH",
  Wellbeingawareness = "WELLBEINGAWARENESS",
}

export enum Enum_Interactionsga_Metric {
  ActiveUsers = "activeUsers",
  AverageEngagementTimePerSession = "averageEngagementTimePerSession",
  AverageSessionDuration = "averageSessionDuration",
  BounceRate = "bounceRate",
  EngagedSessions = "engagedSessions",
  EngagedSessionsPerUser = "engagedSessionsPerUser",
  EngagementRate = "engagementRate",
  EventCount = "eventCount",
  PageViews = "pageViews",
  ScreenPageViews = "screenPageViews",
  Sessions = "sessions",
  SessionsPerUser = "sessionsPerUser",
  UserEngagement = "userEngagement",
  UserEngagementDuration = "userEngagementDuration",
}

export enum Enum_Keydate_Datetype {
  AvailableFrom = "available_from",
  Deadline = "deadline",
  MonthAction = "month_action",
  Range = "range",
  Specific = "specific",
  TbcRelative = "tbc_relative",
}

export enum Enum_Like_Type {
  KnowledgeBase = "KNOWLEDGE_BASE",
  Learn = "LEARN",
  Wildcard = "WILDCARD",
}

export enum Enum_Location_Location {
  Inside = "INSIDE",
  Outside = "OUTSIDE",
}

export enum Enum_Microexerciseprompt_Type {
  Exercise = "EXERCISE",
  Prompt = "PROMPT",
}

export enum Enum_Notificationtemplate_Category {
  Resource = "RESOURCE",
}

export enum Enum_Notificationtemplate_Type {
  Created = "CREATED",
  Reminder = "REMINDER",
  Updated = "UPDATED",
}

export enum Enum_Notification_Priority {
  High = "HIGH",
  Low = "LOW",
  Normal = "NORMAL",
}

export enum Enum_Resourceassetdownloadhistory_Accesstype {
  Download = "DOWNLOAD",
  Preview = "PREVIEW",
}

export enum Enum_Resourceasset_Previewstatus {
  Processing = "processing",
  Ready = "ready",
  Unavailable = "unavailable",
}

export enum Enum_Resourceasset_Scanstatus {
  Infected = "infected",
  Processing = "processing",
  Verified = "verified",
}

export enum Enum_Resource_Resourcestatus {
  New = "New",
  Updated = "Updated",
}

export enum Enum_Scheduledemail_Emailstatus {
  ScheduledWorkingDay = "SCHEDULED_WORKING_DAY",
  Sent = "SENT",
}

export enum Enum_Scheduledemail_Type {
  OnboardingNotCompleted = "ONBOARDING_NOT_COMPLETED",
  Reinvitation_3Days = "REINVITATION_3_DAYS",
  Reinvitation_6Days = "REINVITATION_6_DAYS",
}

export enum Enum_Userspermissionsuser_Registrationdevice {
  Mobile = "mobile",
  Tablet = "tablet",
  Web = "web",
}

export enum Enum_Wildcard_Wildcardstatus {
  Deleted = "DELETED",
  Draft = "DRAFT",
  Published = "PUBLISHED",
}

export type EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog = {
  __typename?: "EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog";
  action?: Maybe<Enum_Edwingroupstrapiv5Auditlogsedwingroupauditlog_Action>;
  /** @deprecated Use root level fields instead */
  attributes: EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog;
  collection?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog;
  date?: Maybe<Scalars["DateTime"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  payload?: Maybe<Scalars["JSON"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  user?: Maybe<Scalars["String"]["output"]>;
};

export type EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogEntityResponseCollection =
  {
    __typename?: "EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogEntityResponseCollection";
    /** @deprecated Use `nodes` field instead */
    data: Array<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog>;
    /** @deprecated Use the `pageInfo` field instead */
    meta: ResponseCollectionMeta;
    nodes: Array<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog>;
    pageInfo: Pagination;
  };

export type EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<
    Array<InputMaybe<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogFiltersInput>>
  >;
  collection?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogFiltersInput>;
  or?: InputMaybe<
    Array<InputMaybe<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogFiltersInput>>
  >;
  payload?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<StringFilterInput>;
};

export type EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogInput = {
  action?: InputMaybe<Enum_Edwingroupstrapiv5Auditlogsedwingroupauditlog_Action>;
  collection?: InputMaybe<Scalars["String"]["input"]>;
  date?: InputMaybe<Scalars["DateTime"]["input"]>;
  payload?: InputMaybe<Scalars["JSON"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

export type EdwinPluginSsoV5Roles = {
  __typename?: "EdwinPluginSsoV5Roles";
  /** @deprecated Use root level fields instead */
  attributes: EdwinPluginSsoV5Roles;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: EdwinPluginSsoV5Roles;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  oauth_type: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  roles?: Maybe<Scalars["JSON"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type EdwinPluginSsoV5RolesEntityResponseCollection = {
  __typename?: "EdwinPluginSsoV5RolesEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<EdwinPluginSsoV5Roles>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<EdwinPluginSsoV5Roles>;
  pageInfo: Pagination;
};

export type EdwinPluginSsoV5RolesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EdwinPluginSsoV5RolesFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EdwinPluginSsoV5RolesFiltersInput>;
  oauth_type?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<EdwinPluginSsoV5RolesFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  roles?: InputMaybe<JsonFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EdwinPluginSsoV5RolesInput = {
  oauth_type?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  roles?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type EdwinPluginSsoV5Whitelists = {
  __typename?: "EdwinPluginSsoV5Whitelists";
  /** @deprecated Use root level fields instead */
  attributes: EdwinPluginSsoV5Whitelists;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: EdwinPluginSsoV5Whitelists;
  documentId: Scalars["ID"]["output"];
  email: Scalars["String"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type EdwinPluginSsoV5WhitelistsEntityResponseCollection = {
  __typename?: "EdwinPluginSsoV5WhitelistsEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<EdwinPluginSsoV5Whitelists>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<EdwinPluginSsoV5Whitelists>;
  pageInfo: Pagination;
};

export type EdwinPluginSsoV5WhitelistsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EdwinPluginSsoV5WhitelistsFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EdwinPluginSsoV5WhitelistsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EdwinPluginSsoV5WhitelistsFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EdwinPluginSsoV5WhitelistsInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type EmailTemplate = {
  __typename?: "EmailTemplate";
  activateMyAccountEmail?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  adminWelcomeEmail?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  /** @deprecated Use root level fields instead */
  attributes: EmailTemplate;
  codeDistributionStaffEmail?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: EmailTemplate;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  onboardingNotCompleted?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  reInviteUsersAfter3Days?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  reInviteUsersAfter6Days?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  resetPassword?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type EmailTemplateInput = {
  activateMyAccountEmail?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  adminWelcomeEmail?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  codeDistributionStaffEmail?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  onboardingNotCompleted?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  reInviteUsersAfter3Days?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  reInviteUsersAfter6Days?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  resetPassword?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
};

export type EmotionCount = {
  __typename?: "EmotionCount";
  count?: Maybe<Scalars["Int"]["output"]>;
  emotion?: Maybe<Scalars["String"]["output"]>;
  overallMoodIcon?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type EmotionsPerDay = {
  __typename?: "EmotionsPerDay";
  days?: Maybe<Array<Maybe<Day>>>;
};

export type EmotionsPerDayManager = {
  __typename?: "EmotionsPerDayManager";
  days?: Maybe<Array<Maybe<DayManager>>>;
  school?: Maybe<Scalars["String"]["output"]>;
};

export type EmotionsSizeManager = {
  __typename?: "EmotionsSizeManager";
  emotion?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<Scalars["Int"]["output"]>;
};

export type Error = {
  __typename?: "Error";
  code: Scalars["String"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
};

export type FetchMyBookmarksPagination = {
  __typename?: "FetchMyBookmarksPagination";
  page?: Maybe<Scalars["Int"]["output"]>;
  pageCount?: Maybe<Scalars["Int"]["output"]>;
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type FetchMyBookmarksResponse = {
  __typename?: "FetchMyBookmarksResponse";
  pagination?: Maybe<FetchMyBookmarksPagination>;
  results?: Maybe<Array<Maybe<Bookmark>>>;
  types?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars["String"]["input"]>;
  caption?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>;
  contains?: InputMaybe<Scalars["Float"]["input"]>;
  containsi?: InputMaybe<Scalars["Float"]["input"]>;
  endsWith?: InputMaybe<Scalars["Float"]["input"]>;
  eq?: InputMaybe<Scalars["Float"]["input"]>;
  eqi?: InputMaybe<Scalars["Float"]["input"]>;
  gt?: InputMaybe<Scalars["Float"]["input"]>;
  gte?: InputMaybe<Scalars["Float"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>;
  lt?: InputMaybe<Scalars["Float"]["input"]>;
  lte?: InputMaybe<Scalars["Float"]["input"]>;
  ne?: InputMaybe<Scalars["Float"]["input"]>;
  nei?: InputMaybe<Scalars["Float"]["input"]>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars["Float"]["input"]>;
  notContainsi?: InputMaybe<Scalars["Float"]["input"]>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>;
  notNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  null?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>;
  startsWith?: InputMaybe<Scalars["Float"]["input"]>;
};

export type ForgotPassword = {
  __typename?: "ForgotPassword";
  /** @deprecated Use root level fields instead */
  attributes: ForgotPassword;
  backToLoginCta: Scalars["String"]["output"];
  chooseANewPasswordTitle: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  customerEmailAddressTitle: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: ForgotPassword;
  documentId: Scalars["ID"]["output"];
  feedback?: Maybe<ComponentRegisterFeedbackFeedback>;
  forgotPasswordDescription: Scalars["String"]["output"];
  forgotPasswordTitle: Scalars["String"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  pageImage: UploadFile;
  passwordsShouldBeDescription: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  repeatYourPassword: Scalars["String"]["output"];
  resetMyPasswordCta: Scalars["String"]["output"];
  sendMeCta: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  yourNewPassword: Scalars["String"]["output"];
};

export type ForgotPasswordInput = {
  backToLoginCta?: InputMaybe<Scalars["String"]["input"]>;
  chooseANewPasswordTitle?: InputMaybe<Scalars["String"]["input"]>;
  customerEmailAddressTitle?: InputMaybe<Scalars["String"]["input"]>;
  feedback?: InputMaybe<ComponentRegisterFeedbackFeedbackInput>;
  forgotPasswordDescription?: InputMaybe<Scalars["String"]["input"]>;
  forgotPasswordTitle?: InputMaybe<Scalars["String"]["input"]>;
  pageImage?: InputMaybe<Scalars["ID"]["input"]>;
  passwordsShouldBeDescription?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  repeatYourPassword?: InputMaybe<Scalars["String"]["input"]>;
  resetMyPasswordCta?: InputMaybe<Scalars["String"]["input"]>;
  sendMeCta?: InputMaybe<Scalars["String"]["input"]>;
  yourNewPassword?: InputMaybe<Scalars["String"]["input"]>;
};

export type Frequency = {
  __typename?: "Frequency";
  days?: Maybe<Scalars["Int"]["output"]>;
  feature?: Maybe<Scalars["String"]["output"]>;
  streaks?: Maybe<Streak>;
};

export type FrequencyBySchool = {
  __typename?: "FrequencyBySchool";
  frequency?: Maybe<Frequency>;
  school?: Maybe<Scalars["Int"]["output"]>;
};

export type GenericMorph =
  | AboutPage
  | AccessControlList
  | AdminPage
  | Answer
  | Author
  | Bookmark
  | BookmarkPage
  | Calendar
  | CalendarPage
  | CompletedTask
  | ComponentAdminManagementActivationPoster
  | ComponentAdminManagementChartsTitles
  | ComponentAdminManagementDashboard
  | ComponentAdminManagementFinishingCardCharacterCompass
  | ComponentAdminManagementFinishingCardLeadershipWheel
  | ComponentAdminManagementHeader
  | ComponentAdminManagementInvitationPreview
  | ComponentAdminManagementInvitationUsingFile
  | ComponentAdminManagementSchoolManagement
  | ComponentAdminManagementStep1
  | ComponentAdminManagementStep2
  | ComponentAdminManagementTabs
  | ComponentAdminManagementUserImportFromFileModal
  | ComponentBookmarkSections
  | ComponentCalendarCalendarFeedbackMessage
  | ComponentCalendarRelatedcontentcalendar
  | ComponentCalendarResource
  | ComponentCommonAudio
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBreadcrumb
  | ComponentCommonBullet
  | ComponentCommonButton
  | ComponentCommonConfirmModal
  | ComponentCommonContentTemplateLabels
  | ComponentCommonDays
  | ComponentCommonDefaultContentTemplate
  | ComponentCommonDivider
  | ComponentCommonDownloadableContent
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmailSent
  | ComponentCommonEmbedded
  | ComponentCommonFaq
  | ComponentCommonFaqComponent
  | ComponentCommonField
  | ComponentCommonFieldSelect
  | ComponentCommonGender
  | ComponentCommonH3
  | ComponentCommonHeroSection
  | ComponentCommonInPartnershipWith
  | ComponentCommonLearnHighlight
  | ComponentCommonLink
  | ComponentCommonLinkList
  | ComponentCommonList
  | ComponentCommonMedia
  | ComponentCommonMessageSection
  | ComponentCommonMinutes
  | ComponentCommonMonth
  | ComponentCommonObjectives
  | ComponentCommonObjectivesSection
  | ComponentCommonQuote
  | ComponentCommonRawTextWithLinks
  | ComponentCommonRelatedContent
  | ComponentCommonRoles
  | ComponentCommonSearchSection
  | ComponentCommonSidebarMenu
  | ComponentCommonSteps
  | ComponentCommonTags
  | ComponentCommonText
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | ComponentCommonTitleText
  | ComponentCommonToast
  | ComponentCommonTranscript
  | ComponentCommonTranslations
  | ComponentCommonTypes
  | ComponentCommonWelcomePageMessage
  | ComponentCoursePageLesson
  | ComponentDefaultContentTemplateSectionDownloadableContent
  | ComponentDefaultContentTemplateTimer
  | ComponentEmailTemplateWelcomeEmailStaff
  | ComponentHomeActivitySection
  | ComponentHomeArticlesAndPodcastsSection
  | ComponentHomeCardsSection
  | ComponentHomeDailySection
  | ComponentHomeDoneSection
  | ComponentHomeFinishingCard
  | ComponentHomeHeaderSection
  | ComponentHomeHomeCard
  | ComponentHomeKeyDatesSection
  | ComponentHomeLatestSection
  | ComponentHomeLeadershipWheelSection
  | ComponentHomeOnboardingQuestions
  | ComponentHomePickUpWhereYouLeftOff
  | ComponentHomeProgrammes
  | ComponentHomeResourceSection
  | ComponentHomeSections
  | ComponentHomeStatsAndStreaks
  | ComponentHomeWelcomeCard
  | ComponentKnowledgeBaseKnowledgeBaseRelated
  | ComponentKnowledgeBaseLatestPerContentTypeSection
  | ComponentKnowledgeBaseWellbeingAwarenessDaysSection
  | ComponentLeadershipWheelFinalState
  | ComponentLeadershipWheelMessages
  | ComponentLeadershipWheelOnboarding
  | ComponentLeadershipWheelSubTrait
  | ComponentLeadershipWheelTypeSection
  | ComponentLearnCourseCompletedSection
  | ComponentLearnCourseFields
  | ComponentLearnCourseInfoBox
  | ComponentLearnCourseLesson
  | ComponentLearnCourseModule
  | ComponentLearnCourseRelatedContent
  | ComponentLearnFeebackSection
  | ComponentLearnFeedback
  | ComponentLearnHighlightContent
  | ComponentLearnMarkAsCompleteButton
  | ComponentLearnModalLeavePage
  | ComponentLearnNextLesson
  | ComponentLearnQuestions
  | ComponentLoginLoginFieldErrors
  | ComponentLoginToastMessagesLogin
  | ComponentNotificationPreferencePreferences
  | ComponentOnBoardingOnBoardingContainer
  | ComponentOnBoardingTimes
  | ComponentPodcastEmailTemplate
  | ComponentPodcastEmailTemplatePodcast
  | ComponentPodcastGetInTouch
  | ComponentPodcastIntro
  | ComponentPodcastListPageCard
  | ComponentPodcastPodcastPlatformLink
  | ComponentPodcastPodcastRelated
  | ComponentProfilePageFinishingCardCharacterExercises
  | ComponentProfilePageFinishingCardMaxStreak
  | ComponentProfilePageFinishingCardStreak
  | ComponentProfilePageFinishingCardTraits
  | ComponentProfilePageStatsAndStreaks
  | ComponentProfilePolicyLinksSection
  | ComponentProfileProfileInfoSection
  | ComponentProfileProfileNotificationsSection
  | ComponentProfileProfilePasswordSection
  | ComponentProfileProfileSubtraitsSection
  | ComponentProfileTraitTrackingSection
  | ComponentReflectionVideosPageReflectionVideoProperties
  | ComponentRegisterFeedbackFeedback
  | ComponentRegisterRegisterFieldErrors
  | ComponentRegisterToastMessagesRegister
  | ComponentReportingToolsAdminTabs
  | ComponentReportingToolsDesktopPreferedBox
  | ComponentReportingToolsInviteUsers
  | ComponentReportingToolsStaffStatus
  | ComponentReportingToolsUsersEmptyState
  | ComponentResourceAssets
  | ComponentResourceResourcesRelated
  | ComponentSchollDomains
  | ComponentSchollTermDates
  | ComponentSchollWondeRoles
  | ComponentSharedMetaSocial
  | ComponentSharedSeo
  | ComponentSurveyAnswers
  | ComponentSurveyHolidays
  | ComponentSurveyRepetableSurvey
  | ComponentSurveySingleSurvey
  | ComponentTimerTimerAudio
  | ComponentTimerTimerAudioLabels
  | ComponentTimerTimerPrompt
  | ComponentTimerTimerPromptLabels
  | ComponentTimerTimerVideo
  | ComponentTimerTimerVideoLabels
  | ComponentWildcardAnnouncementActions
  | ComponentWildcardAnnouncementDeleteDialog
  | ComponentWildcardAnnouncementForm
  | ComponentWildcardAnnouncementPreview
  | ComponentWildcardCta
  | ComponentWildcardValidation
  | CookiesPage
  | CopyrightPage
  | Course
  | CourseCategory
  | CourseFeedback
  | CoursePage
  | DocumentsHistoryDocumentHistory
  | EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog
  | EdwinPluginSsoV5Roles
  | EdwinPluginSsoV5Whitelists
  | EmailTemplate
  | ForgotPassword
  | GlobalFooter
  | GlobalMenu
  | HomeFinishedPage
  | HomePage
  | I18NLocale
  | ImportedUser
  | InteractionsGa
  | InvitedUser
  | KeyDate
  | KeyDatePage
  | KnowledgeBase
  | KnowledgeBaseCategory
  | KnowledgeBasePage
  | KnowledgeBaseType
  | LeadershipWheel
  | LeadershipWheelPage
  | Learn
  | LearnItem
  | LearnPage
  | Like
  | Location
  | LogKeyDateScraping
  | LoginPage
  | LoginTracker
  | ManageUsersPage
  | Measure
  | MicroExercisePrompt
  | NotFoundPage
  | Notification
  | NotificationSystem
  | NotificationTemplate
  | NotificationUser
  | OnBoardingPage
  | Podcast
  | PodcastDetailPage
  | PodcastListPage
  | PodcastListeningTime
  | PodcastPlatform
  | PrivacyPolicyPage
  | ProfilePage
  | Question
  | Quote
  | QuotePage
  | RegisterPage
  | Resource
  | ResourceAsset
  | ResourceAssetDownloadHistory
  | ResourceAssetHistory
  | ResourceCategory
  | ResourceHistory
  | ResourceHubPage
  | ResourceType
  | ReviewWorkflowsWorkflow
  | ReviewWorkflowsWorkflowStage
  | Scale
  | ScheduledEmail
  | School
  | SearchPage
  | SectionType
  | Step1
  | Step2
  | Step3
  | Step4
  | Step5
  | Subscription
  | Survey
  | SurveyMethodology
  | SurveyUser
  | TermAndCondition
  | TermsAndConditionsPage
  | TopicLabel
  | Tracking
  | UploadFile
  | UsersPermissionsPermission
  | UsersPermissionsRole
  | UsersPermissionsUser
  | WatermarkSettings
  | Wildcard;

export type GlobalFooter = {
  __typename?: "GlobalFooter";
  /** @deprecated Use root level fields instead */
  attributes: GlobalFooter;
  bestPlacesToWorkLogo?: Maybe<UploadFile>;
  copyright?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: GlobalFooter;
  documentId: Scalars["ID"]["output"];
  edwinPeoplelogo: UploadFile;
  email?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  linkedinUrl?: Maybe<Scalars["String"]["output"]>;
  links?: Maybe<Array<Maybe<ComponentCommonLink>>>;
  partOfLogo?: Maybe<UploadFile>;
  phone?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type GlobalFooterLinksArgs = {
  filters?: InputMaybe<ComponentCommonLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type GlobalFooterInput = {
  bestPlacesToWorkLogo?: InputMaybe<Scalars["ID"]["input"]>;
  copyright?: InputMaybe<Scalars["String"]["input"]>;
  edwinPeoplelogo?: InputMaybe<Scalars["ID"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  linkedinUrl?: InputMaybe<Scalars["String"]["input"]>;
  links?: InputMaybe<Array<InputMaybe<ComponentCommonLinkInput>>>;
  partOfLogo?: InputMaybe<Scalars["ID"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GlobalMenu = {
  __typename?: "GlobalMenu";
  /** @deprecated Use root level fields instead */
  attributes: GlobalMenu;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: GlobalMenu;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  links?: Maybe<Array<Maybe<ComponentCommonLink>>>;
  logo: UploadFile;
  mobileLogo: UploadFile;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type GlobalMenuLinksArgs = {
  filters?: InputMaybe<ComponentCommonLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type GlobalMenuInput = {
  links?: InputMaybe<Array<InputMaybe<ComponentCommonLinkInput>>>;
  logo?: InputMaybe<Scalars["ID"]["input"]>;
  mobileLogo?: InputMaybe<Scalars["ID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type HomeFinishedPage = {
  __typename?: "HomeFinishedPage";
  /** @deprecated Use root level fields instead */
  attributes: HomeFinishedPage;
  continueYourWeelbeingJourneyTitle: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: HomeFinishedPage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  knowledgeBasesDescription: Scalars["String"]["output"];
  knowledgeBasesTitle: Scalars["String"]["output"];
  messageSection: ComponentCommonMessageSection;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  toolkitsDescription: Scalars["String"]["output"];
  toolkitsTitle: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type HomeFinishedPageInput = {
  continueYourWeelbeingJourneyTitle?: InputMaybe<Scalars["String"]["input"]>;
  knowledgeBasesDescription?: InputMaybe<Scalars["String"]["input"]>;
  knowledgeBasesTitle?: InputMaybe<Scalars["String"]["input"]>;
  messageSection?: InputMaybe<ComponentCommonMessageSectionInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  toolkitsDescription?: InputMaybe<Scalars["String"]["input"]>;
  toolkitsTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type HomePage = {
  __typename?: "HomePage";
  articlesAndPodcastsSection?: Maybe<ComponentHomeArticlesAndPodcastsSection>;
  /** @deprecated Use root level fields instead */
  attributes: HomePage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: HomePage;
  documentId: Scalars["ID"]["output"];
  headerSection: ComponentHomeHeaderSection;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  keyDatesSection?: Maybe<ComponentHomeKeyDatesSection>;
  latestUpdatesSection?: Maybe<ComponentHomeLatestUpdatesSection>;
  leadershipWheelSection?: Maybe<ComponentHomeLeadershipWheelSection>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  resourceSection?: Maybe<ComponentHomeResourceSection>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type HomePageInput = {
  articlesAndPodcastsSection?: InputMaybe<ComponentHomeArticlesAndPodcastsSectionInput>;
  headerSection?: InputMaybe<ComponentHomeHeaderSectionInput>;
  keyDatesSection?: InputMaybe<ComponentHomeKeyDatesSectionInput>;
  latestUpdatesSection?: InputMaybe<ComponentHomeLatestUpdatesSectionInput>;
  leadershipWheelSection?: InputMaybe<ComponentHomeLeadershipWheelSectionInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  resourceSection?: InputMaybe<ComponentHomeResourceSectionInput>;
};

export type I18NLocale = {
  __typename?: "I18NLocale";
  /** @deprecated Use root level fields instead */
  attributes: I18NLocale;
  code?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: I18NLocale;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: "I18NLocaleEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<I18NLocale>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  contains?: InputMaybe<Scalars["ID"]["input"]>;
  containsi?: InputMaybe<Scalars["ID"]["input"]>;
  endsWith?: InputMaybe<Scalars["ID"]["input"]>;
  eq?: InputMaybe<Scalars["ID"]["input"]>;
  eqi?: InputMaybe<Scalars["ID"]["input"]>;
  gt?: InputMaybe<Scalars["ID"]["input"]>;
  gte?: InputMaybe<Scalars["ID"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  lt?: InputMaybe<Scalars["ID"]["input"]>;
  lte?: InputMaybe<Scalars["ID"]["input"]>;
  ne?: InputMaybe<Scalars["ID"]["input"]>;
  nei?: InputMaybe<Scalars["ID"]["input"]>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars["ID"]["input"]>;
  notContainsi?: InputMaybe<Scalars["ID"]["input"]>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  notNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  null?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  startsWith?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ImportedUser = {
  __typename?: "ImportedUser";
  /** @deprecated Use root level fields instead */
  attributes: ImportedUser;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ImportedUser;
  documentId: Scalars["ID"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  forename?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  invitationEmailSent?: Maybe<Scalars["Boolean"]["output"]>;
  origin?: Maybe<Enum_Importeduser_Origin>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  school?: Maybe<School>;
  surname?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ImportedUserEntityResponseCollection = {
  __typename?: "ImportedUserEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ImportedUser>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ImportedUser>;
  pageInfo: Pagination;
};

export type ImportedUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ImportedUserFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  forename?: InputMaybe<StringFilterInput>;
  invitationEmailSent?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ImportedUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ImportedUserFiltersInput>>>;
  origin?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  school?: InputMaybe<SchoolFiltersInput>;
  surname?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ImportedUserInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  forename?: InputMaybe<Scalars["String"]["input"]>;
  invitationEmailSent?: InputMaybe<Scalars["Boolean"]["input"]>;
  origin?: InputMaybe<Enum_Importeduser_Origin>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  school?: InputMaybe<Scalars["ID"]["input"]>;
  surname?: InputMaybe<Scalars["String"]["input"]>;
};

export type ImportedUserRelationResponseCollection = {
  __typename?: "ImportedUserRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ImportedUser>;
  nodes: Array<ImportedUser>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  contains?: InputMaybe<Scalars["Int"]["input"]>;
  containsi?: InputMaybe<Scalars["Int"]["input"]>;
  endsWith?: InputMaybe<Scalars["Int"]["input"]>;
  eq?: InputMaybe<Scalars["Int"]["input"]>;
  eqi?: InputMaybe<Scalars["Int"]["input"]>;
  gt?: InputMaybe<Scalars["Int"]["input"]>;
  gte?: InputMaybe<Scalars["Int"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  lt?: InputMaybe<Scalars["Int"]["input"]>;
  lte?: InputMaybe<Scalars["Int"]["input"]>;
  ne?: InputMaybe<Scalars["Int"]["input"]>;
  nei?: InputMaybe<Scalars["Int"]["input"]>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars["Int"]["input"]>;
  notContainsi?: InputMaybe<Scalars["Int"]["input"]>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  notNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  null?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  startsWith?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InteractionsGa = {
  __typename?: "InteractionsGa";
  /** @deprecated Use root level fields instead */
  attributes: InteractionsGa;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: InteractionsGa;
  date?: Maybe<Scalars["Date"]["output"]>;
  deviceCategory?: Maybe<Scalars["String"]["output"]>;
  dimensionValues?: Maybe<Scalars["JSON"]["output"]>;
  documentId: Scalars["ID"]["output"];
  eventName: Scalars["String"]["output"];
  feature?: Maybe<Enum_Interactionsga_Feature>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  metric?: Maybe<Enum_Interactionsga_Metric>;
  metricValue?: Maybe<Scalars["String"]["output"]>;
  pagePath?: Maybe<Scalars["String"]["output"]>;
  pageTitle?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  school_document_id?: Maybe<Scalars["String"]["output"]>;
  school_name?: Maybe<Scalars["String"]["output"]>;
  unifiedScreenName?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  user_document_id?: Maybe<Scalars["String"]["output"]>;
  user_name?: Maybe<Scalars["String"]["output"]>;
  user_role?: Maybe<Scalars["String"]["output"]>;
};

export type InteractionsGaEntityResponseCollection = {
  __typename?: "InteractionsGaEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<InteractionsGa>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<InteractionsGa>;
  pageInfo: Pagination;
};

export type InteractionsGaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InteractionsGaFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  deviceCategory?: InputMaybe<StringFilterInput>;
  dimensionValues?: InputMaybe<JsonFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  eventName?: InputMaybe<StringFilterInput>;
  feature?: InputMaybe<StringFilterInput>;
  metric?: InputMaybe<StringFilterInput>;
  metricValue?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<InteractionsGaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InteractionsGaFiltersInput>>>;
  pagePath?: InputMaybe<StringFilterInput>;
  pageTitle?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  school_document_id?: InputMaybe<StringFilterInput>;
  school_name?: InputMaybe<StringFilterInput>;
  unifiedScreenName?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user_document_id?: InputMaybe<StringFilterInput>;
  user_name?: InputMaybe<StringFilterInput>;
  user_role?: InputMaybe<StringFilterInput>;
};

export type InteractionsGaInput = {
  date?: InputMaybe<Scalars["Date"]["input"]>;
  deviceCategory?: InputMaybe<Scalars["String"]["input"]>;
  dimensionValues?: InputMaybe<Scalars["JSON"]["input"]>;
  eventName?: InputMaybe<Scalars["String"]["input"]>;
  feature?: InputMaybe<Enum_Interactionsga_Feature>;
  metric?: InputMaybe<Enum_Interactionsga_Metric>;
  metricValue?: InputMaybe<Scalars["String"]["input"]>;
  pagePath?: InputMaybe<Scalars["String"]["input"]>;
  pageTitle?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  school_document_id?: InputMaybe<Scalars["String"]["input"]>;
  school_name?: InputMaybe<Scalars["String"]["input"]>;
  unifiedScreenName?: InputMaybe<Scalars["String"]["input"]>;
  user_document_id?: InputMaybe<Scalars["String"]["input"]>;
  user_name?: InputMaybe<Scalars["String"]["input"]>;
  user_role?: InputMaybe<Scalars["String"]["input"]>;
};

export type InvitedUser = {
  __typename?: "InvitedUser";
  /** @deprecated Use root level fields instead */
  attributes: InvitedUser;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: InvitedUser;
  documentId: Scalars["ID"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  forename?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  invitationDate?: Maybe<Scalars["Date"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  role?: Maybe<Scalars["String"]["output"]>;
  school?: Maybe<School>;
  surname?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type InvitedUserEntityResponseCollection = {
  __typename?: "InvitedUserEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<InvitedUser>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<InvitedUser>;
  pageInfo: Pagination;
};

export type InvitedUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InvitedUserFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  forename?: InputMaybe<StringFilterInput>;
  invitationDate?: InputMaybe<DateFilterInput>;
  not?: InputMaybe<InvitedUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InvitedUserFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<StringFilterInput>;
  school?: InputMaybe<SchoolFiltersInput>;
  surname?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type InvitedUserInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  forename?: InputMaybe<Scalars["String"]["input"]>;
  invitationDate?: InputMaybe<Scalars["Date"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  school?: InputMaybe<Scalars["ID"]["input"]>;
  surname?: InputMaybe<Scalars["String"]["input"]>;
};

export type InvitedUserRelationResponseCollection = {
  __typename?: "InvitedUserRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<InvitedUser>;
  nodes: Array<InvitedUser>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars["JSON"]["input"]>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars["JSON"]["input"]>>>;
  contains?: InputMaybe<Scalars["JSON"]["input"]>;
  containsi?: InputMaybe<Scalars["JSON"]["input"]>;
  endsWith?: InputMaybe<Scalars["JSON"]["input"]>;
  eq?: InputMaybe<Scalars["JSON"]["input"]>;
  eqi?: InputMaybe<Scalars["JSON"]["input"]>;
  gt?: InputMaybe<Scalars["JSON"]["input"]>;
  gte?: InputMaybe<Scalars["JSON"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["JSON"]["input"]>>>;
  lt?: InputMaybe<Scalars["JSON"]["input"]>;
  lte?: InputMaybe<Scalars["JSON"]["input"]>;
  ne?: InputMaybe<Scalars["JSON"]["input"]>;
  nei?: InputMaybe<Scalars["JSON"]["input"]>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars["JSON"]["input"]>;
  notContainsi?: InputMaybe<Scalars["JSON"]["input"]>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars["JSON"]["input"]>>>;
  notNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  null?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<InputMaybe<Scalars["JSON"]["input"]>>>;
  startsWith?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type KeyDate = {
  __typename?: "KeyDate";
  academicYear?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: KeyDate;
  bookYourPlaceUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: KeyDate;
  dateType?: Maybe<Enum_Keydate_Datetype>;
  description?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["ID"]["output"];
  endDate?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  isDeleted?: Maybe<Scalars["Boolean"]["output"]>;
  isManual?: Maybe<Scalars["Boolean"]["output"]>;
  learnMoreUrl?: Maybe<Scalars["String"]["output"]>;
  log?: Maybe<LogKeyDateScraping>;
  month?: Maybe<Scalars["String"]["output"]>;
  originalText?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  relativeRule?: Maybe<Scalars["String"]["output"]>;
  requiresReview?: Maybe<Scalars["Boolean"]["output"]>;
  schools: Array<Maybe<School>>;
  schools_connection?: Maybe<SchoolRelationResponseCollection>;
  sectionType?: Maybe<SectionType>;
  source?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["Date"]["output"]>;
  title: Scalars["String"]["output"];
  topicLabel?: Maybe<TopicLabel>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type KeyDateSchoolsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type KeyDateSchools_ConnectionArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type KeyDateConnectionWithSchools = {
  __typename?: "KeyDateConnectionWithSchools";
  nodes?: Maybe<Array<Maybe<KeyDate>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type KeyDateEntityResponseCollection = {
  __typename?: "KeyDateEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<KeyDate>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<KeyDate>;
  pageInfo: Pagination;
};

export type KeyDateFiltersInput = {
  academicYear?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<KeyDateFiltersInput>>>;
  bookYourPlaceUrl?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  dateType?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  isDeleted?: InputMaybe<BooleanFilterInput>;
  isManual?: InputMaybe<BooleanFilterInput>;
  learnMoreUrl?: InputMaybe<StringFilterInput>;
  log?: InputMaybe<LogKeyDateScrapingFiltersInput>;
  month?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<KeyDateFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<KeyDateFiltersInput>>>;
  originalText?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  relativeRule?: InputMaybe<StringFilterInput>;
  requiresReview?: InputMaybe<BooleanFilterInput>;
  schools?: InputMaybe<SchoolFiltersInput>;
  sectionType?: InputMaybe<SectionTypeFiltersInput>;
  source?: InputMaybe<StringFilterInput>;
  startDate?: InputMaybe<DateFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  topicLabel?: InputMaybe<TopicLabelFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type KeyDateInput = {
  academicYear?: InputMaybe<Scalars["String"]["input"]>;
  bookYourPlaceUrl?: InputMaybe<Scalars["String"]["input"]>;
  dateType?: InputMaybe<Enum_Keydate_Datetype>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  isManual?: InputMaybe<Scalars["Boolean"]["input"]>;
  learnMoreUrl?: InputMaybe<Scalars["String"]["input"]>;
  log?: InputMaybe<Scalars["ID"]["input"]>;
  month?: InputMaybe<Scalars["String"]["input"]>;
  originalText?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  relativeRule?: InputMaybe<Scalars["String"]["input"]>;
  requiresReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  schools?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  sectionType?: InputMaybe<Scalars["ID"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicLabel?: InputMaybe<Scalars["ID"]["input"]>;
};

export type KeyDatePage = {
  __typename?: "KeyDatePage";
  addToCalendarLabel?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: KeyDatePage;
  bookYourPlaceLabel?: Maybe<Scalars["String"]["output"]>;
  calendarAppleLabel?: Maybe<Scalars["String"]["output"]>;
  calendarGoogleLabel?: Maybe<Scalars["String"]["output"]>;
  calendarOutlookLabel?: Maybe<Scalars["String"]["output"]>;
  calendarTitle: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: KeyDatePage;
  deadlineLabel?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  learnMoreLabel?: Maybe<Scalars["String"]["output"]>;
  nextMonthButton?: Maybe<Scalars["String"]["output"]>;
  noKeyDatesFoundText?: Maybe<Scalars["String"]["output"]>;
  previousMonthButton?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  searchPlaceholder?: Maybe<Scalars["String"]["output"]>;
  tagAnnouncement?: Maybe<Scalars["String"]["output"]>;
  tagAwarenessDay?: Maybe<Scalars["String"]["output"]>;
  tagEvent?: Maybe<Scalars["String"]["output"]>;
  tagPayment?: Maybe<Scalars["String"]["output"]>;
  tagReminder?: Maybe<Scalars["String"]["output"]>;
  tagTrustAction?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type KeyDatePageInput = {
  addToCalendarLabel?: InputMaybe<Scalars["String"]["input"]>;
  bookYourPlaceLabel?: InputMaybe<Scalars["String"]["input"]>;
  calendarAppleLabel?: InputMaybe<Scalars["String"]["input"]>;
  calendarGoogleLabel?: InputMaybe<Scalars["String"]["input"]>;
  calendarOutlookLabel?: InputMaybe<Scalars["String"]["input"]>;
  calendarTitle?: InputMaybe<Scalars["String"]["input"]>;
  deadlineLabel?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  learnMoreLabel?: InputMaybe<Scalars["String"]["input"]>;
  nextMonthButton?: InputMaybe<Scalars["String"]["input"]>;
  noKeyDatesFoundText?: InputMaybe<Scalars["String"]["input"]>;
  previousMonthButton?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  searchPlaceholder?: InputMaybe<Scalars["String"]["input"]>;
  tagAnnouncement?: InputMaybe<Scalars["String"]["input"]>;
  tagAwarenessDay?: InputMaybe<Scalars["String"]["input"]>;
  tagEvent?: InputMaybe<Scalars["String"]["input"]>;
  tagPayment?: InputMaybe<Scalars["String"]["input"]>;
  tagReminder?: InputMaybe<Scalars["String"]["input"]>;
  tagTrustAction?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type KeyDateRelationResponseCollection = {
  __typename?: "KeyDateRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<KeyDate>;
  nodes: Array<KeyDate>;
};

export type KnowledgeBase = {
  __typename?: "KnowledgeBase";
  DefaultContentTemplate: Array<
    Maybe<KnowledgeBaseDefaultContentTemplateDynamicZone>
  >;
  /** @deprecated Use root level fields instead */
  attributes: KnowledgeBase;
  briefDescription: Scalars["String"]["output"];
  category?: Maybe<KnowledgeBaseCategory>;
  cover: UploadFile;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: KnowledgeBase;
  documentId: Scalars["ID"]["output"];
  duration?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  knowledgeBaseType?: Maybe<KnowledgeBaseType>;
  publicationDate: Scalars["Date"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  slug: Scalars["String"]["output"];
  subHeader?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type KnowledgeBaseCategory = {
  __typename?: "KnowledgeBaseCategory";
  /** @deprecated Use root level fields instead */
  attributes: KnowledgeBaseCategory;
  category: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: KnowledgeBaseCategory;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  subCategories: Array<Maybe<KnowledgeBaseCategory>>;
  subCategories_connection?: Maybe<KnowledgeBaseCategoryRelationResponseCollection>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type KnowledgeBaseCategorySubCategoriesArgs = {
  filters?: InputMaybe<KnowledgeBaseCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type KnowledgeBaseCategorySubCategories_ConnectionArgs = {
  filters?: InputMaybe<KnowledgeBaseCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type KnowledgeBaseCategoryEntityResponseCollection = {
  __typename?: "KnowledgeBaseCategoryEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<KnowledgeBaseCategory>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<KnowledgeBaseCategory>;
  pageInfo: Pagination;
};

export type KnowledgeBaseCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<KnowledgeBaseCategoryFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<KnowledgeBaseCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<KnowledgeBaseCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subCategories?: InputMaybe<KnowledgeBaseCategoryFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type KnowledgeBaseCategoryInput = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  subCategories?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type KnowledgeBaseCategoryRelationResponseCollection = {
  __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<KnowledgeBaseCategory>;
  nodes: Array<KnowledgeBaseCategory>;
};

export type KnowledgeBaseDefaultContentTemplateDynamicZone =
  | ComponentCommonAudio
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonRelatedContent
  | ComponentCommonTags
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | ComponentDefaultContentTemplateTimer
  | ComponentKnowledgeBaseKnowledgeBaseRelated
  | Error;

export type KnowledgeBaseEntity = {
  __typename?: "KnowledgeBaseEntity";
  attributes?: Maybe<KnowledgeBase>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type KnowledgeBaseEntityResponseCollection = {
  __typename?: "KnowledgeBaseEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<KnowledgeBase>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<KnowledgeBase>;
  pageInfo: Pagination;
};

export type KnowledgeBaseFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<KnowledgeBaseFiltersInput>>>;
  briefDescription?: InputMaybe<StringFilterInput>;
  category?: InputMaybe<KnowledgeBaseCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  duration?: InputMaybe<StringFilterInput>;
  knowledgeBaseType?: InputMaybe<KnowledgeBaseTypeFiltersInput>;
  not?: InputMaybe<KnowledgeBaseFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<KnowledgeBaseFiltersInput>>>;
  publicationDate?: InputMaybe<DateFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  subHeader?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type KnowledgeBaseInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<
      Scalars["KnowledgeBaseDefaultContentTemplateDynamicZoneInput"]["input"]
    >
  >;
  briefDescription?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["ID"]["input"]>;
  cover?: InputMaybe<Scalars["ID"]["input"]>;
  duration?: InputMaybe<Scalars["String"]["input"]>;
  knowledgeBaseType?: InputMaybe<Scalars["ID"]["input"]>;
  publicationDate?: InputMaybe<Scalars["Date"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  subHeader?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type KnowledgeBasePage = {
  __typename?: "KnowledgeBasePage";
  /** @deprecated Use root level fields instead */
  attributes: KnowledgeBasePage;
  contentTemplateLabels?: Maybe<ComponentCommonContentTemplateLabels>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: KnowledgeBasePage;
  description?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  moreButtonTitle: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type KnowledgeBasePageInput = {
  contentTemplateLabels?: InputMaybe<ComponentCommonContentTemplateLabelsInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  moreButtonTitle?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type KnowledgeBaseRelationResponseCollection = {
  __typename?: "KnowledgeBaseRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<KnowledgeBase>;
  nodes: Array<KnowledgeBase>;
};

export type KnowledgeBaseType = {
  __typename?: "KnowledgeBaseType";
  /** @deprecated Use root level fields instead */
  attributes: KnowledgeBaseType;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: KnowledgeBaseType;
  description?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  type: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type KnowledgeBaseTypeEntityResponseCollection = {
  __typename?: "KnowledgeBaseTypeEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<KnowledgeBaseType>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<KnowledgeBaseType>;
  pageInfo: Pagination;
};

export type KnowledgeBaseTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<KnowledgeBaseTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<KnowledgeBaseTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<KnowledgeBaseTypeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type KnowledgeBaseTypeInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type KnowledgeBaseTypeWithItems = {
  __typename?: "KnowledgeBaseTypeWithItems";
  documentId: Scalars["ID"]["output"];
  type: Scalars["String"]["output"];
};

export type LeadershipWheel = {
  __typename?: "LeadershipWheel";
  /** @deprecated Use root level fields instead */
  attributes: LeadershipWheel;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: LeadershipWheel;
  description: Scalars["String"]["output"];
  documentId: Scalars["ID"]["output"];
  focusArea: Scalars["String"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  overallMoodIcon?: Maybe<UploadFile>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  subFocusArea?: Maybe<Array<Maybe<ComponentLeadershipWheelSubTrait>>>;
  typeSection: ComponentLeadershipWheelTypeSection;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type LeadershipWheelSubFocusAreaArgs = {
  filters?: InputMaybe<ComponentLeadershipWheelSubTraitFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type LeadershipWheelEntityResponseCollection = {
  __typename?: "LeadershipWheelEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<LeadershipWheel>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<LeadershipWheel>;
  pageInfo: Pagination;
};

export type LeadershipWheelFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LeadershipWheelFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  focusArea?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LeadershipWheelFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LeadershipWheelFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subFocusArea?: InputMaybe<ComponentLeadershipWheelSubTraitFiltersInput>;
  typeSection?: InputMaybe<ComponentLeadershipWheelTypeSectionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LeadershipWheelInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  focusArea?: InputMaybe<Scalars["String"]["input"]>;
  overallMoodIcon?: InputMaybe<Scalars["ID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  subFocusArea?: InputMaybe<
    Array<InputMaybe<ComponentLeadershipWheelSubTraitInput>>
  >;
  typeSection?: InputMaybe<ComponentLeadershipWheelTypeSectionInput>;
};

export type LeadershipWheelPage = {
  __typename?: "LeadershipWheelPage";
  TraitNotFound?: Maybe<ComponentCommonRawTextWithLinks>;
  /** @deprecated Use root level fields instead */
  attributes: LeadershipWheelPage;
  bottomText?: Maybe<Scalars["String"]["output"]>;
  calendarTitle?: Maybe<Scalars["String"]["output"]>;
  changeMyAnswerCta: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: LeadershipWheelPage;
  documentId: Scalars["ID"]["output"];
  goToYourMoodTracker?: Maybe<Scalars["String"]["output"]>;
  howAreYouFeelingTitle: Scalars["String"]["output"];
  howAreYouTitle: Scalars["String"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  messages?: Maybe<ComponentLeadershipWheelMessages>;
  onboarding?: Maybe<ComponentLeadershipWheelOnboarding>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  relatedContentTitle?: Maybe<Scalars["String"]["output"]>;
  relatedContentViewAllLabel?: Maybe<Scalars["String"]["output"]>;
  resetTheWheel?: Maybe<Scalars["String"]["output"]>;
  traitDetailsTitle?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  wellDoneTitle: Scalars["String"]["output"];
  youAreTitle: Scalars["String"]["output"];
};

export type LeadershipWheelPageInput = {
  TraitNotFound?: InputMaybe<ComponentCommonRawTextWithLinksInput>;
  bottomText?: InputMaybe<Scalars["String"]["input"]>;
  calendarTitle?: InputMaybe<Scalars["String"]["input"]>;
  changeMyAnswerCta?: InputMaybe<Scalars["String"]["input"]>;
  goToYourMoodTracker?: InputMaybe<Scalars["String"]["input"]>;
  howAreYouFeelingTitle?: InputMaybe<Scalars["String"]["input"]>;
  howAreYouTitle?: InputMaybe<Scalars["String"]["input"]>;
  messages?: InputMaybe<ComponentLeadershipWheelMessagesInput>;
  onboarding?: InputMaybe<ComponentLeadershipWheelOnboardingInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  relatedContentTitle?: InputMaybe<Scalars["String"]["input"]>;
  relatedContentViewAllLabel?: InputMaybe<Scalars["String"]["input"]>;
  resetTheWheel?: InputMaybe<Scalars["String"]["input"]>;
  traitDetailsTitle?: InputMaybe<Scalars["String"]["input"]>;
  wellDoneTitle?: InputMaybe<Scalars["String"]["input"]>;
  youAreTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type LeadershipWheelTrackerResult = {
  __typename?: "LeadershipWheelTrackerResult";
  day?: Maybe<Scalars["String"]["output"]>;
  focusArea?: Maybe<Scalars["String"]["output"]>;
  isDisabledTracking?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Learn = {
  __typename?: "Learn";
  /** @deprecated Use root level fields instead */
  attributes: Learn;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  course?: Maybe<Course>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Learn;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  learn_items: Array<Maybe<LearnItem>>;
  learn_items_connection?: Maybe<LearnItemRelationResponseCollection>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  users_permissions_user?: Maybe<UsersPermissionsUser>;
};

export type LearnLearn_ItemsArgs = {
  filters?: InputMaybe<LearnItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type LearnLearn_Items_ConnectionArgs = {
  filters?: InputMaybe<LearnItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type LearnEntityResponseCollection = {
  __typename?: "LearnEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Learn>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Learn>;
  pageInfo: Pagination;
};

export type LearnFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LearnFiltersInput>>>;
  completed?: InputMaybe<BooleanFilterInput>;
  completedAt?: InputMaybe<DateTimeFilterInput>;
  course?: InputMaybe<CourseFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  learn_items?: InputMaybe<LearnItemFiltersInput>;
  not?: InputMaybe<LearnFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LearnFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users_permissions_user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type LearnInput = {
  completed?: InputMaybe<Scalars["Boolean"]["input"]>;
  completedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  course?: InputMaybe<Scalars["ID"]["input"]>;
  learn_items?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  users_permissions_user?: InputMaybe<Scalars["ID"]["input"]>;
};

export type LearnItem = {
  __typename?: "LearnItem";
  /** @deprecated Use root level fields instead */
  attributes: LearnItem;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: LearnItem;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  idLesson: Scalars["String"]["output"];
  idModule: Scalars["String"]["output"];
  learn?: Maybe<Learn>;
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type LearnItemEntityResponseCollection = {
  __typename?: "LearnItemEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<LearnItem>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<LearnItem>;
  pageInfo: Pagination;
};

export type LearnItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LearnItemFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  idLesson?: InputMaybe<StringFilterInput>;
  idModule?: InputMaybe<StringFilterInput>;
  learn?: InputMaybe<LearnFiltersInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<LearnItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LearnItemFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LearnItemInput = {
  idLesson?: InputMaybe<Scalars["String"]["input"]>;
  idModule?: InputMaybe<Scalars["String"]["input"]>;
  learn?: InputMaybe<Scalars["ID"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type LearnItemRelationResponseCollection = {
  __typename?: "LearnItemRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<LearnItem>;
  nodes: Array<LearnItem>;
};

export type LearnPage = {
  __typename?: "LearnPage";
  /** @deprecated Use root level fields instead */
  attributes: LearnPage;
  contentTemplateLabels?: Maybe<ComponentCommonContentTemplateLabels>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: LearnPage;
  documentId: Scalars["ID"]["output"];
  emptyCompletedCoursesMessage?: Maybe<Scalars["String"]["output"]>;
  emptyCoursesMessage?: Maybe<Scalars["String"]["output"]>;
  emptyInProgressCoursesMessage?: Maybe<Scalars["String"]["output"]>;
  feedbackSection?: Maybe<ComponentLearnFeebackSection>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  learnHighlight?: Maybe<ComponentCommonLearnHighlight>;
  markCourseAsCompleted?: Maybe<ComponentLearnMarkAsCompleteButton>;
  markLessonAsCompleteButton?: Maybe<ComponentLearnMarkAsCompleteButton>;
  modalLeavePage?: Maybe<ComponentLearnModalLeavePage>;
  modalMarkCourseAsCompleted?: Maybe<ComponentCommonConfirmModal>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type LearnPageInput = {
  contentTemplateLabels?: InputMaybe<ComponentCommonContentTemplateLabelsInput>;
  emptyCompletedCoursesMessage?: InputMaybe<Scalars["String"]["input"]>;
  emptyCoursesMessage?: InputMaybe<Scalars["String"]["input"]>;
  emptyInProgressCoursesMessage?: InputMaybe<Scalars["String"]["input"]>;
  feedbackSection?: InputMaybe<ComponentLearnFeebackSectionInput>;
  learnHighlight?: InputMaybe<ComponentCommonLearnHighlightInput>;
  markCourseAsCompleted?: InputMaybe<ComponentLearnMarkAsCompleteButtonInput>;
  markLessonAsCompleteButton?: InputMaybe<ComponentLearnMarkAsCompleteButtonInput>;
  modalLeavePage?: InputMaybe<ComponentLearnModalLeavePageInput>;
  modalMarkCourseAsCompleted?: InputMaybe<ComponentCommonConfirmModalInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Like = {
  __typename?: "Like";
  /** @deprecated Use root level fields instead */
  attributes: Like;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Like;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  lessonId?: Maybe<Scalars["String"]["output"]>;
  moduleId?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  relationID: Scalars["String"]["output"];
  staff?: Maybe<UsersPermissionsUser>;
  type: Enum_Like_Type;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type LikeEntityResponseCollection = {
  __typename?: "LikeEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Like>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Like>;
  pageInfo: Pagination;
};

export type LikeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LikeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  lessonId?: InputMaybe<StringFilterInput>;
  moduleId?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LikeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LikeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  relationID?: InputMaybe<StringFilterInput>;
  staff?: InputMaybe<UsersPermissionsUserFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LikeInput = {
  lessonId?: InputMaybe<Scalars["String"]["input"]>;
  moduleId?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  relationID?: InputMaybe<Scalars["String"]["input"]>;
  staff?: InputMaybe<Scalars["ID"]["input"]>;
  type?: InputMaybe<Enum_Like_Type>;
};

export type Location = {
  __typename?: "Location";
  /** @deprecated Use root level fields instead */
  attributes: Location;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Location;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  location: Enum_Location_Location;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type LocationEntityResponseCollection = {
  __typename?: "LocationEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Location>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Location>;
  pageInfo: Pagination;
};

export type LocationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LocationFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  location?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LocationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LocationFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LocationInput = {
  location?: InputMaybe<Enum_Location_Location>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type LogKeyDateScraping = {
  __typename?: "LogKeyDateScraping";
  /** @deprecated Use root level fields instead */
  attributes: LogKeyDateScraping;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: LogKeyDateScraping;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  itemsRequiringReview: Scalars["Int"]["output"];
  keyDates: Array<Maybe<KeyDate>>;
  keyDates_connection?: Maybe<KeyDateRelationResponseCollection>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  scrapedAt: Scalars["DateTime"]["output"];
  sourceUrl: Scalars["String"]["output"];
  totalItems: Scalars["Int"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type LogKeyDateScrapingKeyDatesArgs = {
  filters?: InputMaybe<KeyDateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type LogKeyDateScrapingKeyDates_ConnectionArgs = {
  filters?: InputMaybe<KeyDateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type LogKeyDateScrapingEntityResponseCollection = {
  __typename?: "LogKeyDateScrapingEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<LogKeyDateScraping>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<LogKeyDateScraping>;
  pageInfo: Pagination;
};

export type LogKeyDateScrapingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LogKeyDateScrapingFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  itemsRequiringReview?: InputMaybe<IntFilterInput>;
  keyDates?: InputMaybe<KeyDateFiltersInput>;
  not?: InputMaybe<LogKeyDateScrapingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LogKeyDateScrapingFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  scrapedAt?: InputMaybe<DateTimeFilterInput>;
  sourceUrl?: InputMaybe<StringFilterInput>;
  totalItems?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LogKeyDateScrapingInput = {
  itemsRequiringReview?: InputMaybe<Scalars["Int"]["input"]>;
  keyDates?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  scrapedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceUrl?: InputMaybe<Scalars["String"]["input"]>;
  totalItems?: InputMaybe<Scalars["Int"]["input"]>;
};

export type LoginPage = {
  __typename?: "LoginPage";
  /** @deprecated Use root level fields instead */
  attributes: LoginPage;
  confirmEmailTitle: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: LoginPage;
  documentId: Scalars["ID"]["output"];
  fieldErrors?: Maybe<ComponentLoginLoginFieldErrors>;
  forgotYourPasswordCta: Scalars["String"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  loginCta: Scalars["String"]["output"];
  loginTitle: Scalars["String"]["output"];
  pageImage: UploadFile;
  pleaseLoginTItle: Scalars["String"]["output"];
  popUpMessages?: Maybe<ComponentLoginToastMessagesLogin>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  rememberMeTitle: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  yourEmailTitle: Scalars["String"]["output"];
  yourPasswordTitle: Scalars["String"]["output"];
};

export type LoginPageInput = {
  confirmEmailTitle?: InputMaybe<Scalars["String"]["input"]>;
  fieldErrors?: InputMaybe<ComponentLoginLoginFieldErrorsInput>;
  forgotYourPasswordCta?: InputMaybe<Scalars["String"]["input"]>;
  loginCta?: InputMaybe<Scalars["String"]["input"]>;
  loginTitle?: InputMaybe<Scalars["String"]["input"]>;
  pageImage?: InputMaybe<Scalars["ID"]["input"]>;
  pleaseLoginTItle?: InputMaybe<Scalars["String"]["input"]>;
  popUpMessages?: InputMaybe<ComponentLoginToastMessagesLoginInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  rememberMeTitle?: InputMaybe<Scalars["String"]["input"]>;
  yourEmailTitle?: InputMaybe<Scalars["String"]["input"]>;
  yourPasswordTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type LoginTracker = {
  __typename?: "LoginTracker";
  /** @deprecated Use root level fields instead */
  attributes: LoginTracker;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: LoginTracker;
  day?: Maybe<Scalars["Date"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  staff?: Maybe<UsersPermissionsUser>;
  streakCounter?: Maybe<Scalars["Int"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type LoginTrackerEntityResponseCollection = {
  __typename?: "LoginTrackerEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<LoginTracker>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<LoginTracker>;
  pageInfo: Pagination;
};

export type LoginTrackerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LoginTrackerFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  day?: InputMaybe<DateFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<LoginTrackerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LoginTrackerFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  staff?: InputMaybe<UsersPermissionsUserFiltersInput>;
  streakCounter?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LoginTrackerInput = {
  day?: InputMaybe<Scalars["Date"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  staff?: InputMaybe<Scalars["ID"]["input"]>;
  streakCounter?: InputMaybe<Scalars["Int"]["input"]>;
};

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
  contains?: InputMaybe<Scalars["Long"]["input"]>;
  containsi?: InputMaybe<Scalars["Long"]["input"]>;
  endsWith?: InputMaybe<Scalars["Long"]["input"]>;
  eq?: InputMaybe<Scalars["Long"]["input"]>;
  eqi?: InputMaybe<Scalars["Long"]["input"]>;
  gt?: InputMaybe<Scalars["Long"]["input"]>;
  gte?: InputMaybe<Scalars["Long"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
  lt?: InputMaybe<Scalars["Long"]["input"]>;
  lte?: InputMaybe<Scalars["Long"]["input"]>;
  ne?: InputMaybe<Scalars["Long"]["input"]>;
  nei?: InputMaybe<Scalars["Long"]["input"]>;
  not?: InputMaybe<LongFilterInput>;
  notContains?: InputMaybe<Scalars["Long"]["input"]>;
  notContainsi?: InputMaybe<Scalars["Long"]["input"]>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
  notNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  null?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
  startsWith?: InputMaybe<Scalars["Long"]["input"]>;
};

export type ManageUsersPage = {
  __typename?: "ManageUsersPage";
  /** @deprecated Use root level fields instead */
  attributes: ManageUsersPage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ManageUsersPage;
  description?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  inviteStaff?: Maybe<ComponentReportingToolsInviteUsers>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  staffEmptyState?: Maybe<ComponentReportingToolsUsersEmptyState>;
  staffImportFromSpreadsheetDialog?: Maybe<ComponentAdminManagementUserImportFromFileModal>;
  staffListTitle?: Maybe<Scalars["String"]["output"]>;
  staffStatus?: Maybe<ComponentReportingToolsStaffStatus>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ManageUsersPageInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  inviteStaff?: InputMaybe<ComponentReportingToolsInviteUsersInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  staffEmptyState?: InputMaybe<ComponentReportingToolsUsersEmptyStateInput>;
  staffImportFromSpreadsheetDialog?: InputMaybe<ComponentAdminManagementUserImportFromFileModalInput>;
  staffListTitle?: InputMaybe<Scalars["String"]["input"]>;
  staffStatus?: InputMaybe<ComponentReportingToolsStaffStatusInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type Measure = {
  __typename?: "Measure";
  /** @deprecated Use root level fields instead */
  attributes: Measure;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Measure;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  measure: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  questions: Array<Maybe<Question>>;
  questions_connection?: Maybe<QuestionRelationResponseCollection>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type MeasureQuestionsArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MeasureQuestions_ConnectionArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MeasureEntityResponseCollection = {
  __typename?: "MeasureEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Measure>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Measure>;
  pageInfo: Pagination;
};

export type MeasureFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MeasureFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  measure?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MeasureFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MeasureFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  questions?: InputMaybe<QuestionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MeasureInput = {
  measure?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  questions?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type MicroExercisePrompt = {
  __typename?: "MicroExercisePrompt";
  /** @deprecated Use root level fields instead */
  attributes: MicroExercisePrompt;
  content: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: MicroExercisePrompt;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  type: Enum_Microexerciseprompt_Type;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type MicroExercisePromptEntityResponseCollection = {
  __typename?: "MicroExercisePromptEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<MicroExercisePrompt>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<MicroExercisePrompt>;
  pageInfo: Pagination;
};

export type MicroExercisePromptFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MicroExercisePromptFiltersInput>>>;
  content?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MicroExercisePromptFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MicroExercisePromptFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MicroExercisePromptInput = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Enum_Microexerciseprompt_Type>;
};

export type MoodData = {
  __typename?: "MoodData";
  emotion?: Maybe<Scalars["String"]["output"]>;
  idUser?: Maybe<Scalars["String"]["output"]>;
  schoolId?: Maybe<Scalars["String"]["output"]>;
  schoolName?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAccessControlList?: Maybe<AccessControlList>;
  createAnswer?: Maybe<Answer>;
  createAuthor?: Maybe<Author>;
  createBookmark?: Maybe<Bookmark>;
  createCalendar?: Maybe<Calendar>;
  createCompletedTask?: Maybe<CompletedTask>;
  createCourse?: Maybe<Course>;
  createCourseCategory?: Maybe<CourseCategory>;
  createCourseFeedback?: Maybe<CourseFeedback>;
  createDocumentsHistoryDocumentHistory?: Maybe<DocumentsHistoryDocumentHistory>;
  createEdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog?: Maybe<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog>;
  createEdwinPluginSsoV5Roles?: Maybe<EdwinPluginSsoV5Roles>;
  createEdwinPluginSsoV5Whitelists?: Maybe<EdwinPluginSsoV5Whitelists>;
  createImportedUser?: Maybe<ImportedUser>;
  createInteractionsGa?: Maybe<InteractionsGa>;
  createInvitedUser?: Maybe<InvitedUser>;
  createKeyDate?: Maybe<KeyDate>;
  createKnowledgeBase?: Maybe<KnowledgeBase>;
  createKnowledgeBaseCategory?: Maybe<KnowledgeBaseCategory>;
  createKnowledgeBaseType?: Maybe<KnowledgeBaseType>;
  createLeadershipWheel?: Maybe<LeadershipWheel>;
  createLearn?: Maybe<Learn>;
  createLearnItem?: Maybe<LearnItem>;
  createLike?: Maybe<Like>;
  createLocation?: Maybe<Location>;
  createLogKeyDateScraping?: Maybe<LogKeyDateScraping>;
  createLoginTracker?: Maybe<LoginTracker>;
  createMeasure?: Maybe<Measure>;
  createMicroExercisePrompt?: Maybe<MicroExercisePrompt>;
  createNotification?: Maybe<Notification>;
  createNotificationSystem?: Maybe<NotificationSystem>;
  createNotificationTemplate?: Maybe<NotificationTemplate>;
  createNotificationUser?: Maybe<NotificationUser>;
  createPodcast?: Maybe<Podcast>;
  createPodcastListeningTime?: Maybe<PodcastListeningTime>;
  createPodcastPlatform?: Maybe<PodcastPlatform>;
  createQuestion?: Maybe<Question>;
  createQuote?: Maybe<Quote>;
  createResource?: Maybe<Resource>;
  createResourceAsset?: Maybe<ResourceAsset>;
  createResourceAssetDownloadHistory?: Maybe<ResourceAssetDownloadHistory>;
  createResourceAssetHistory?: Maybe<ResourceAssetHistory>;
  createResourceCategory?: Maybe<ResourceCategory>;
  createResourceHistory?: Maybe<ResourceHistory>;
  createResourceType?: Maybe<ResourceType>;
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  createScale?: Maybe<Scale>;
  createScheduledEmail?: Maybe<ScheduledEmail>;
  createSchool?: Maybe<School>;
  createSectionType?: Maybe<SectionType>;
  createSubscription?: Maybe<Subscription>;
  createSurvey?: Maybe<Survey>;
  createSurveyMethodology?: Maybe<SurveyMethodology>;
  createSurveyUser?: Maybe<SurveyUser>;
  createTopicLabel?: Maybe<TopicLabel>;
  createTracking?: Maybe<Tracking>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  createWildcard?: Maybe<Wildcard>;
  deleteAboutPage?: Maybe<DeleteMutationResponse>;
  deleteAccessControlList?: Maybe<DeleteMutationResponse>;
  deleteAdminPage?: Maybe<DeleteMutationResponse>;
  deleteAnswer?: Maybe<DeleteMutationResponse>;
  deleteAuthor?: Maybe<DeleteMutationResponse>;
  deleteBookmark?: Maybe<DeleteMutationResponse>;
  deleteBookmarkPage?: Maybe<DeleteMutationResponse>;
  deleteCalendar?: Maybe<DeleteMutationResponse>;
  deleteCalendarPage?: Maybe<DeleteMutationResponse>;
  deleteCompletedTask?: Maybe<DeleteMutationResponse>;
  deleteCookiesPage?: Maybe<DeleteMutationResponse>;
  deleteCopyrightPage?: Maybe<DeleteMutationResponse>;
  deleteCourse?: Maybe<DeleteMutationResponse>;
  deleteCourseCategory?: Maybe<DeleteMutationResponse>;
  deleteCourseFeedback?: Maybe<DeleteMutationResponse>;
  deleteCoursePage?: Maybe<DeleteMutationResponse>;
  deleteDocumentsHistoryDocumentHistory?: Maybe<DeleteMutationResponse>;
  deleteEdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog?: Maybe<DeleteMutationResponse>;
  deleteEdwinPluginSsoV5Roles?: Maybe<DeleteMutationResponse>;
  deleteEdwinPluginSsoV5Whitelists?: Maybe<DeleteMutationResponse>;
  deleteEmailTemplate?: Maybe<DeleteMutationResponse>;
  deleteForgotPassword?: Maybe<DeleteMutationResponse>;
  deleteGlobalFooter?: Maybe<DeleteMutationResponse>;
  deleteGlobalMenu?: Maybe<DeleteMutationResponse>;
  deleteHomeFinishedPage?: Maybe<DeleteMutationResponse>;
  deleteHomePage?: Maybe<DeleteMutationResponse>;
  deleteImportedUser?: Maybe<DeleteMutationResponse>;
  deleteInteractionsGa?: Maybe<DeleteMutationResponse>;
  deleteInvitedUser?: Maybe<DeleteMutationResponse>;
  deleteKeyDate?: Maybe<DeleteMutationResponse>;
  deleteKeyDatePage?: Maybe<DeleteMutationResponse>;
  deleteKnowledgeBase?: Maybe<DeleteMutationResponse>;
  deleteKnowledgeBaseCategory?: Maybe<DeleteMutationResponse>;
  deleteKnowledgeBasePage?: Maybe<DeleteMutationResponse>;
  deleteKnowledgeBaseType?: Maybe<DeleteMutationResponse>;
  deleteLeadershipWheel?: Maybe<DeleteMutationResponse>;
  deleteLeadershipWheelPage?: Maybe<DeleteMutationResponse>;
  deleteLearn?: Maybe<DeleteMutationResponse>;
  deleteLearnItem?: Maybe<DeleteMutationResponse>;
  deleteLearnPage?: Maybe<DeleteMutationResponse>;
  deleteLike?: Maybe<DeleteMutationResponse>;
  deleteLocation?: Maybe<DeleteMutationResponse>;
  deleteLogKeyDateScraping?: Maybe<DeleteMutationResponse>;
  deleteLoginPage?: Maybe<DeleteMutationResponse>;
  deleteLoginTracker?: Maybe<DeleteMutationResponse>;
  deleteManageUsersPage?: Maybe<DeleteMutationResponse>;
  deleteMeasure?: Maybe<DeleteMutationResponse>;
  deleteMicroExercisePrompt?: Maybe<DeleteMutationResponse>;
  deleteNotFoundPage?: Maybe<DeleteMutationResponse>;
  deleteNotification?: Maybe<DeleteMutationResponse>;
  deleteNotificationSystem?: Maybe<DeleteMutationResponse>;
  deleteNotificationTemplate?: Maybe<DeleteMutationResponse>;
  deleteNotificationUser?: Maybe<DeleteMutationResponse>;
  deleteOnBoardingPage?: Maybe<DeleteMutationResponse>;
  deletePodcast?: Maybe<DeleteMutationResponse>;
  deletePodcastDetailPage?: Maybe<DeleteMutationResponse>;
  deletePodcastListPage?: Maybe<DeleteMutationResponse>;
  deletePodcastListeningTime?: Maybe<DeleteMutationResponse>;
  deletePodcastPlatform?: Maybe<DeleteMutationResponse>;
  deletePrivacyPolicyPage?: Maybe<DeleteMutationResponse>;
  deleteProfilePage?: Maybe<DeleteMutationResponse>;
  deleteQuestion?: Maybe<DeleteMutationResponse>;
  deleteQuote?: Maybe<DeleteMutationResponse>;
  deleteQuotePage?: Maybe<DeleteMutationResponse>;
  deleteRegisterPage?: Maybe<DeleteMutationResponse>;
  deleteResource?: Maybe<DeleteMutationResponse>;
  deleteResourceAsset?: Maybe<DeleteMutationResponse>;
  deleteResourceAssetDownloadHistory?: Maybe<DeleteMutationResponse>;
  deleteResourceAssetHistory?: Maybe<DeleteMutationResponse>;
  deleteResourceCategory?: Maybe<DeleteMutationResponse>;
  deleteResourceHistory?: Maybe<DeleteMutationResponse>;
  deleteResourceHubPage?: Maybe<DeleteMutationResponse>;
  deleteResourceType?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  deleteScale?: Maybe<DeleteMutationResponse>;
  deleteScheduledEmail?: Maybe<DeleteMutationResponse>;
  deleteSchool?: Maybe<DeleteMutationResponse>;
  deleteSearchPage?: Maybe<DeleteMutationResponse>;
  deleteSectionType?: Maybe<DeleteMutationResponse>;
  deleteStep1?: Maybe<DeleteMutationResponse>;
  deleteStep2?: Maybe<DeleteMutationResponse>;
  deleteStep3?: Maybe<DeleteMutationResponse>;
  deleteStep4?: Maybe<DeleteMutationResponse>;
  deleteStep5?: Maybe<DeleteMutationResponse>;
  deleteSubscription?: Maybe<DeleteMutationResponse>;
  deleteSurvey?: Maybe<DeleteMutationResponse>;
  deleteSurveyMethodology?: Maybe<DeleteMutationResponse>;
  deleteSurveyUser?: Maybe<DeleteMutationResponse>;
  deleteTermAndCondition?: Maybe<DeleteMutationResponse>;
  deleteTermsAndConditionsPage?: Maybe<DeleteMutationResponse>;
  deleteTopicLabel?: Maybe<DeleteMutationResponse>;
  deleteTracking?: Maybe<DeleteMutationResponse>;
  deleteUploadFile?: Maybe<UploadFile>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteWatermarkSettings?: Maybe<DeleteMutationResponse>;
  deleteWildcard?: Maybe<DeleteMutationResponse>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateAboutPage?: Maybe<AboutPage>;
  updateAccessControlList?: Maybe<AccessControlList>;
  updateAdminPage?: Maybe<AdminPage>;
  updateAnswer?: Maybe<Answer>;
  updateAuthor?: Maybe<Author>;
  updateBookmark?: Maybe<Bookmark>;
  updateBookmarkPage?: Maybe<BookmarkPage>;
  updateCalendar?: Maybe<Calendar>;
  updateCalendarPage?: Maybe<CalendarPage>;
  updateCompletedTask?: Maybe<CompletedTask>;
  updateCookiesPage?: Maybe<CookiesPage>;
  updateCopyrightPage?: Maybe<CopyrightPage>;
  updateCourse?: Maybe<Course>;
  updateCourseCategory?: Maybe<CourseCategory>;
  updateCourseFeedback?: Maybe<CourseFeedback>;
  updateCoursePage?: Maybe<CoursePage>;
  updateDocumentsHistoryDocumentHistory?: Maybe<DocumentsHistoryDocumentHistory>;
  updateEdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog?: Maybe<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog>;
  updateEdwinPluginSsoV5Roles?: Maybe<EdwinPluginSsoV5Roles>;
  updateEdwinPluginSsoV5Whitelists?: Maybe<EdwinPluginSsoV5Whitelists>;
  updateEmailTemplate?: Maybe<EmailTemplate>;
  updateForgotPassword?: Maybe<ForgotPassword>;
  updateGlobalFooter?: Maybe<GlobalFooter>;
  updateGlobalMenu?: Maybe<GlobalMenu>;
  updateHomeFinishedPage?: Maybe<HomeFinishedPage>;
  updateHomePage?: Maybe<HomePage>;
  updateImportedUser?: Maybe<ImportedUser>;
  updateInteractionsGa?: Maybe<InteractionsGa>;
  updateInvitedUser?: Maybe<InvitedUser>;
  updateKeyDate?: Maybe<KeyDate>;
  updateKeyDatePage?: Maybe<KeyDatePage>;
  updateKnowledgeBase?: Maybe<KnowledgeBase>;
  updateKnowledgeBaseCategory?: Maybe<KnowledgeBaseCategory>;
  updateKnowledgeBasePage?: Maybe<KnowledgeBasePage>;
  updateKnowledgeBaseType?: Maybe<KnowledgeBaseType>;
  updateLeadershipWheel?: Maybe<LeadershipWheel>;
  updateLeadershipWheelPage?: Maybe<LeadershipWheelPage>;
  updateLearn?: Maybe<Learn>;
  updateLearnItem?: Maybe<LearnItem>;
  updateLearnPage?: Maybe<LearnPage>;
  updateLike?: Maybe<Like>;
  updateLocation?: Maybe<Location>;
  updateLogKeyDateScraping?: Maybe<LogKeyDateScraping>;
  updateLoginPage?: Maybe<LoginPage>;
  updateLoginTracker?: Maybe<LoginTracker>;
  updateManageUsersPage?: Maybe<ManageUsersPage>;
  updateMeasure?: Maybe<Measure>;
  updateMicroExercisePrompt?: Maybe<MicroExercisePrompt>;
  updateNotFoundPage?: Maybe<NotFoundPage>;
  updateNotification?: Maybe<Notification>;
  updateNotificationSystem?: Maybe<NotificationSystem>;
  updateNotificationTemplate?: Maybe<NotificationTemplate>;
  updateNotificationUser?: Maybe<NotificationUser>;
  updateOnBoardingPage?: Maybe<OnBoardingPage>;
  updatePodcast?: Maybe<Podcast>;
  updatePodcastDetailPage?: Maybe<PodcastDetailPage>;
  updatePodcastListPage?: Maybe<PodcastListPage>;
  updatePodcastListeningTime?: Maybe<PodcastListeningTime>;
  updatePodcastPlatform?: Maybe<PodcastPlatform>;
  updatePrivacyPolicyPage?: Maybe<PrivacyPolicyPage>;
  updateProfilePage?: Maybe<ProfilePage>;
  updateQuestion?: Maybe<Question>;
  updateQuote?: Maybe<Quote>;
  updateQuotePage?: Maybe<QuotePage>;
  updateRegisterPage?: Maybe<RegisterPage>;
  updateResource?: Maybe<Resource>;
  updateResourceAsset?: Maybe<ResourceAsset>;
  updateResourceAssetDownloadHistory?: Maybe<ResourceAssetDownloadHistory>;
  updateResourceAssetHistory?: Maybe<ResourceAssetHistory>;
  updateResourceCategory?: Maybe<ResourceCategory>;
  updateResourceHistory?: Maybe<ResourceHistory>;
  updateResourceHubPage?: Maybe<ResourceHubPage>;
  updateResourceType?: Maybe<ResourceType>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateScale?: Maybe<Scale>;
  updateScheduledEmail?: Maybe<ScheduledEmail>;
  updateSchool?: Maybe<School>;
  updateSearchPage?: Maybe<SearchPage>;
  updateSectionType?: Maybe<SectionType>;
  updateStep1?: Maybe<Step1>;
  updateStep2?: Maybe<Step2>;
  updateStep3?: Maybe<Step3>;
  updateStep4?: Maybe<Step4>;
  updateStep5?: Maybe<Step5>;
  updateSubscription?: Maybe<Subscription>;
  updateSurvey?: Maybe<Survey>;
  updateSurveyMethodology?: Maybe<SurveyMethodology>;
  updateSurveyUser?: Maybe<SurveyUser>;
  updateTermAndCondition?: Maybe<TermAndCondition>;
  updateTermsAndConditionsPage?: Maybe<TermsAndConditionsPage>;
  updateTopicLabel?: Maybe<TopicLabel>;
  updateTracking?: Maybe<Tracking>;
  updateUploadFile: UploadFile;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateWatermarkSettings?: Maybe<WatermarkSettings>;
  updateWildcard?: Maybe<Wildcard>;
};

export type MutationChangePasswordArgs = {
  currentPassword: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  passwordConfirmation: Scalars["String"]["input"];
};

export type MutationCreateAccessControlListArgs = {
  data: AccessControlListInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateAnswerArgs = {
  data: AnswerInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateAuthorArgs = {
  data: AuthorInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateBookmarkArgs = {
  data: BookmarkInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateCalendarArgs = {
  data: CalendarInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateCompletedTaskArgs = {
  data: CompletedTaskInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateCourseArgs = {
  data: CourseInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateCourseCategoryArgs = {
  data: CourseCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateCourseFeedbackArgs = {
  data: CourseFeedbackInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateDocumentsHistoryDocumentHistoryArgs = {
  data: DocumentsHistoryDocumentHistoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateEdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogArgs = {
  data: EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateEdwinPluginSsoV5RolesArgs = {
  data: EdwinPluginSsoV5RolesInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateEdwinPluginSsoV5WhitelistsArgs = {
  data: EdwinPluginSsoV5WhitelistsInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateImportedUserArgs = {
  data: ImportedUserInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateInteractionsGaArgs = {
  data: InteractionsGaInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateInvitedUserArgs = {
  data: InvitedUserInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateKeyDateArgs = {
  data: KeyDateInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateKnowledgeBaseArgs = {
  data: KnowledgeBaseInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateKnowledgeBaseCategoryArgs = {
  data: KnowledgeBaseCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateKnowledgeBaseTypeArgs = {
  data: KnowledgeBaseTypeInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLeadershipWheelArgs = {
  data: LeadershipWheelInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLearnArgs = {
  data: LearnInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLearnItemArgs = {
  data: LearnItemInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLikeArgs = {
  data: LikeInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLocationArgs = {
  data: LocationInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLogKeyDateScrapingArgs = {
  data: LogKeyDateScrapingInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLoginTrackerArgs = {
  data: LoginTrackerInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateMeasureArgs = {
  data: MeasureInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateMicroExercisePromptArgs = {
  data: MicroExercisePromptInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateNotificationArgs = {
  data: NotificationInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateNotificationSystemArgs = {
  data: NotificationSystemInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateNotificationTemplateArgs = {
  data: NotificationTemplateInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateNotificationUserArgs = {
  data: NotificationUserInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePodcastArgs = {
  data: PodcastInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePodcastListeningTimeArgs = {
  data: PodcastListeningTimeInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePodcastPlatformArgs = {
  data: PodcastPlatformInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateQuestionArgs = {
  data: QuestionInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateQuoteArgs = {
  data: QuoteInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateResourceArgs = {
  data: ResourceInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateResourceAssetArgs = {
  data: ResourceAssetInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateResourceAssetDownloadHistoryArgs = {
  data: ResourceAssetDownloadHistoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateResourceAssetHistoryArgs = {
  data: ResourceAssetHistoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateResourceCategoryArgs = {
  data: ResourceCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateResourceHistoryArgs = {
  data: ResourceHistoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateResourceTypeArgs = {
  data: ResourceTypeInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateScaleArgs = {
  data: ScaleInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateScheduledEmailArgs = {
  data: ScheduledEmailInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSchoolArgs = {
  data: SchoolInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSectionTypeArgs = {
  data: SectionTypeInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSubscriptionArgs = {
  data: SubscriptionInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSurveyArgs = {
  data: SurveyInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSurveyMethodologyArgs = {
  data: SurveyMethodologyInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSurveyUserArgs = {
  data: SurveyUserInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateTopicLabelArgs = {
  data: TopicLabelInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateTrackingArgs = {
  data: TrackingInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};

export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};

export type MutationCreateWildcardArgs = {
  data: WildcardInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationDeleteAccessControlListArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteAnswerArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteAuthorArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteBookmarkArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteCalendarArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteCompletedTaskArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteCourseArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteCourseCategoryArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteCourseFeedbackArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteDocumentsHistoryDocumentHistoryArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteEdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteEdwinPluginSsoV5RolesArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteEdwinPluginSsoV5WhitelistsArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteImportedUserArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteInteractionsGaArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteInvitedUserArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteKeyDateArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteKnowledgeBaseArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteKnowledgeBaseCategoryArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteKnowledgeBaseTypeArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteLeadershipWheelArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteLearnArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteLearnItemArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteLikeArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteLocationArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteLogKeyDateScrapingArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteLoginTrackerArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteMeasureArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteMicroExercisePromptArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteNotificationArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteNotificationSystemArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteNotificationTemplateArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteNotificationUserArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeletePodcastArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeletePodcastListeningTimeArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeletePodcastPlatformArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteQuestionArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteQuoteArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteResourceArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteResourceAssetArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteResourceAssetDownloadHistoryArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteResourceAssetHistoryArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteResourceCategoryArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteResourceHistoryArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteResourceTypeArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteScaleArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteScheduledEmailArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteSchoolArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteSectionTypeArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteSubscriptionArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteSurveyArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteSurveyMethodologyArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteSurveyUserArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteTopicLabelArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteTrackingArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationDeleteUploadFileArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteWildcardArgs = {
  documentId: Scalars["ID"]["input"];
};

export type MutationEmailConfirmationArgs = {
  confirmation: Scalars["String"]["input"];
};

export type MutationForgotPasswordArgs = {
  email: Scalars["String"]["input"];
};

export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};

export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};

export type MutationResetPasswordArgs = {
  code: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  passwordConfirmation: Scalars["String"]["input"];
};

export type MutationUpdateAboutPageArgs = {
  data: AboutPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateAccessControlListArgs = {
  data: AccessControlListInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateAdminPageArgs = {
  data: AdminPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateAnswerArgs = {
  data: AnswerInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateAuthorArgs = {
  data: AuthorInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateBookmarkArgs = {
  data: BookmarkInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateBookmarkPageArgs = {
  data: BookmarkPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCalendarArgs = {
  data: CalendarInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCalendarPageArgs = {
  data: CalendarPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCompletedTaskArgs = {
  data: CompletedTaskInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCookiesPageArgs = {
  data: CookiesPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCopyrightPageArgs = {
  data: CopyrightPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCourseArgs = {
  data: CourseInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCourseCategoryArgs = {
  data: CourseCategoryInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCourseFeedbackArgs = {
  data: CourseFeedbackInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCoursePageArgs = {
  data: CoursePageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateDocumentsHistoryDocumentHistoryArgs = {
  data: DocumentsHistoryDocumentHistoryInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogArgs = {
  data: EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEdwinPluginSsoV5RolesArgs = {
  data: EdwinPluginSsoV5RolesInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEdwinPluginSsoV5WhitelistsArgs = {
  data: EdwinPluginSsoV5WhitelistsInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEmailTemplateArgs = {
  data: EmailTemplateInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateForgotPasswordArgs = {
  data: ForgotPasswordInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateGlobalFooterArgs = {
  data: GlobalFooterInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateGlobalMenuArgs = {
  data: GlobalMenuInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateHomeFinishedPageArgs = {
  data: HomeFinishedPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateHomePageArgs = {
  data: HomePageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateImportedUserArgs = {
  data: ImportedUserInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateInteractionsGaArgs = {
  data: InteractionsGaInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateInvitedUserArgs = {
  data: InvitedUserInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateKeyDateArgs = {
  data: KeyDateInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateKeyDatePageArgs = {
  data: KeyDatePageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateKnowledgeBaseArgs = {
  data: KnowledgeBaseInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateKnowledgeBaseCategoryArgs = {
  data: KnowledgeBaseCategoryInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateKnowledgeBasePageArgs = {
  data: KnowledgeBasePageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateKnowledgeBaseTypeArgs = {
  data: KnowledgeBaseTypeInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLeadershipWheelArgs = {
  data: LeadershipWheelInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLeadershipWheelPageArgs = {
  data: LeadershipWheelPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLearnArgs = {
  data: LearnInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLearnItemArgs = {
  data: LearnItemInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLearnPageArgs = {
  data: LearnPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLikeArgs = {
  data: LikeInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLocationArgs = {
  data: LocationInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLogKeyDateScrapingArgs = {
  data: LogKeyDateScrapingInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLoginPageArgs = {
  data: LoginPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLoginTrackerArgs = {
  data: LoginTrackerInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateManageUsersPageArgs = {
  data: ManageUsersPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateMeasureArgs = {
  data: MeasureInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateMicroExercisePromptArgs = {
  data: MicroExercisePromptInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNotFoundPageArgs = {
  data: NotFoundPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNotificationArgs = {
  data: NotificationInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNotificationSystemArgs = {
  data: NotificationSystemInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNotificationTemplateArgs = {
  data: NotificationTemplateInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNotificationUserArgs = {
  data: NotificationUserInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOnBoardingPageArgs = {
  data: OnBoardingPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePodcastArgs = {
  data: PodcastInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePodcastDetailPageArgs = {
  data: PodcastDetailPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePodcastListPageArgs = {
  data: PodcastListPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePodcastListeningTimeArgs = {
  data: PodcastListeningTimeInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePodcastPlatformArgs = {
  data: PodcastPlatformInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePrivacyPolicyPageArgs = {
  data: PrivacyPolicyPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateProfilePageArgs = {
  data: ProfilePageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateQuestionArgs = {
  data: QuestionInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateQuoteArgs = {
  data: QuoteInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateQuotePageArgs = {
  data: QuotePageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegisterPageArgs = {
  data: RegisterPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateResourceArgs = {
  data: ResourceInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateResourceAssetArgs = {
  data: ResourceAssetInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateResourceAssetDownloadHistoryArgs = {
  data: ResourceAssetDownloadHistoryInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateResourceAssetHistoryArgs = {
  data: ResourceAssetHistoryInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateResourceCategoryArgs = {
  data: ResourceCategoryInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateResourceHistoryArgs = {
  data: ResourceHistoryInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateResourceHubPageArgs = {
  data: ResourceHubPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateResourceTypeArgs = {
  data: ResourceTypeInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateScaleArgs = {
  data: ScaleInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateScheduledEmailArgs = {
  data: ScheduledEmailInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSchoolArgs = {
  data: SchoolInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSearchPageArgs = {
  data: SearchPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSectionTypeArgs = {
  data: SectionTypeInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateStep1Args = {
  data: Step1Input;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateStep2Args = {
  data: Step2Input;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateStep3Args = {
  data: Step3Input;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateStep4Args = {
  data: Step4Input;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateStep5Args = {
  data: Step5Input;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSubscriptionArgs = {
  data: SubscriptionInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSurveyArgs = {
  data: SurveyInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSurveyMethodologyArgs = {
  data: SurveyMethodologyInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSurveyUserArgs = {
  data: SurveyUserInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateTermAndConditionArgs = {
  data: TermAndConditionInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateTermsAndConditionsPageArgs = {
  data: TermsAndConditionsPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateTopicLabelArgs = {
  data: TopicLabelInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateTrackingArgs = {
  data: TrackingInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateUploadFileArgs = {
  id: Scalars["ID"]["input"];
  info?: InputMaybe<FileInfoInput>;
};

export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars["ID"]["input"];
};

export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars["ID"]["input"];
};

export type MutationUpdateWatermarkSettingsArgs = {
  data: WatermarkSettingsInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateWildcardArgs = {
  data: WildcardInput;
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type NotFoundPage = {
  __typename?: "NotFoundPage";
  /** @deprecated Use root level fields instead */
  attributes: NotFoundPage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  cta: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: NotFoundPage;
  description: Scalars["String"]["output"];
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  image: UploadFile;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type NotFoundPageInput = {
  cta?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type Notification = {
  __typename?: "Notification";
  /** @deprecated Use root level fields instead */
  attributes: Notification;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  customTemplate?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Notification;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  isCustom: Scalars["Boolean"]["output"];
  link: Scalars["String"]["output"];
  notificationUsers: Array<Maybe<NotificationUser>>;
  notificationUsers_connection?: Maybe<NotificationUserRelationResponseCollection>;
  priority: Enum_Notification_Priority;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  resource?: Maybe<Resource>;
  schools: Array<Maybe<School>>;
  schools_connection?: Maybe<SchoolRelationResponseCollection>;
  template?: Maybe<NotificationTemplate>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type NotificationNotificationUsersArgs = {
  filters?: InputMaybe<NotificationUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type NotificationNotificationUsers_ConnectionArgs = {
  filters?: InputMaybe<NotificationUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type NotificationSchoolsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type NotificationSchools_ConnectionArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type NotificationEntityResponseCollection = {
  __typename?: "NotificationEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Notification>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Notification>;
  pageInfo: Pagination;
};

export type NotificationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NotificationFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  customTemplate?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  isCustom?: InputMaybe<BooleanFilterInput>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<NotificationFiltersInput>;
  notificationUsers?: InputMaybe<NotificationUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationFiltersInput>>>;
  priority?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  resource?: InputMaybe<ResourceFiltersInput>;
  schools?: InputMaybe<SchoolFiltersInput>;
  template?: InputMaybe<NotificationTemplateFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type NotificationInput = {
  customTemplate?: InputMaybe<Scalars["String"]["input"]>;
  isCustom?: InputMaybe<Scalars["Boolean"]["input"]>;
  link?: InputMaybe<Scalars["String"]["input"]>;
  notificationUsers?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  priority?: InputMaybe<Enum_Notification_Priority>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  resource?: InputMaybe<Scalars["ID"]["input"]>;
  schools?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  template?: InputMaybe<Scalars["ID"]["input"]>;
};

export type NotificationSystem = {
  __typename?: "NotificationSystem";
  /** @deprecated Use root level fields instead */
  attributes: NotificationSystem;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: NotificationSystem;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type NotificationSystemEntityResponseCollection = {
  __typename?: "NotificationSystemEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<NotificationSystem>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<NotificationSystem>;
  pageInfo: Pagination;
};

export type NotificationSystemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NotificationSystemFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<NotificationSystemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationSystemFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type NotificationSystemInput = {
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type NotificationTemplate = {
  __typename?: "NotificationTemplate";
  /** @deprecated Use root level fields instead */
  attributes: NotificationTemplate;
  category: Enum_Notificationtemplate_Category;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: NotificationTemplate;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  template: Scalars["String"]["output"];
  type: Enum_Notificationtemplate_Type;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type NotificationTemplateEntityResponseCollection = {
  __typename?: "NotificationTemplateEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<NotificationTemplate>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<NotificationTemplate>;
  pageInfo: Pagination;
};

export type NotificationTemplateFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NotificationTemplateFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<NotificationTemplateFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationTemplateFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  template?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type NotificationTemplateInput = {
  category?: InputMaybe<Enum_Notificationtemplate_Category>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  template?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Enum_Notificationtemplate_Type>;
};

export type NotificationUser = {
  __typename?: "NotificationUser";
  /** @deprecated Use root level fields instead */
  attributes: NotificationUser;
  clickedAt?: Maybe<Scalars["DateTime"]["output"]>;
  content?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: NotificationUser;
  deliveredAt?: Maybe<Scalars["DateTime"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  notification?: Maybe<Notification>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  seenAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  user?: Maybe<UsersPermissionsUser>;
};

export type NotificationUserEntityResponseCollection = {
  __typename?: "NotificationUserEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<NotificationUser>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<NotificationUser>;
  pageInfo: Pagination;
};

export type NotificationUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NotificationUserFiltersInput>>>;
  clickedAt?: InputMaybe<DateTimeFilterInput>;
  content?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deliveredAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<NotificationUserFiltersInput>;
  notification?: InputMaybe<NotificationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationUserFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seenAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type NotificationUserInput = {
  clickedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  deliveredAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  notification?: InputMaybe<Scalars["ID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  seenAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  user?: InputMaybe<Scalars["ID"]["input"]>;
};

export type NotificationUserRelationResponseCollection = {
  __typename?: "NotificationUserRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<NotificationUser>;
  nodes: Array<NotificationUser>;
};

export type OnBoardingPage = {
  __typename?: "OnBoardingPage";
  /** @deprecated Use root level fields instead */
  attributes: OnBoardingPage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: OnBoardingPage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  logo?: Maybe<UploadFile>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type OnBoardingPageInput = {
  logo?: InputMaybe<Scalars["ID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type PageInfo = {
  __typename?: "PageInfo";
  page?: Maybe<Scalars["Int"]["output"]>;
  pageCount?: Maybe<Scalars["Int"]["output"]>;
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type Pagination = {
  __typename?: "Pagination";
  page: Scalars["Int"]["output"];
  pageCount: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Podcast = {
  __typename?: "Podcast";
  DefaultContentTemplate: Array<
    Maybe<PodcastDefaultContentTemplateDynamicZone>
  >;
  /** @deprecated Use root level fields instead */
  attributes: Podcast;
  briefDescription: Scalars["String"]["output"];
  cover: UploadFile;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Podcast;
  documentId: Scalars["ID"]["output"];
  fullDescription?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  listenings: Array<Maybe<PodcastListeningTime>>;
  listenings_connection?: Maybe<PodcastListeningTimeRelationResponseCollection>;
  platforms?: Maybe<Array<Maybe<ComponentPodcastPodcastPlatformLink>>>;
  publicationDate: Scalars["Date"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type PodcastListeningsArgs = {
  filters?: InputMaybe<PodcastListeningTimeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type PodcastListenings_ConnectionArgs = {
  filters?: InputMaybe<PodcastListeningTimeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type PodcastPlatformsArgs = {
  filters?: InputMaybe<ComponentPodcastPodcastPlatformLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type PodcastBySlugResponse = {
  __typename?: "PodcastBySlugResponse";
  current?: Maybe<Podcast>;
};

export type PodcastDefaultContentTemplateDynamicZone =
  | ComponentCommonAudio
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonRelatedContent
  | ComponentCommonTags
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | ComponentPodcastPodcastRelated
  | Error;

export type PodcastDetailPage = {
  __typename?: "PodcastDetailPage";
  /** @deprecated Use root level fields instead */
  attributes: PodcastDetailPage;
  backLinkLabel: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: PodcastDetailPage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  viewAllLabel: Scalars["String"]["output"];
};

export type PodcastDetailPageInput = {
  backLinkLabel?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  viewAllLabel?: InputMaybe<Scalars["String"]["input"]>;
};

export type PodcastEntityResponseCollection = {
  __typename?: "PodcastEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Podcast>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Podcast>;
  pageInfo: Pagination;
};

export type PodcastFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PodcastFiltersInput>>>;
  briefDescription?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  fullDescription?: InputMaybe<StringFilterInput>;
  listenings?: InputMaybe<PodcastListeningTimeFiltersInput>;
  not?: InputMaybe<PodcastFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PodcastFiltersInput>>>;
  platforms?: InputMaybe<ComponentPodcastPodcastPlatformLinkFiltersInput>;
  publicationDate?: InputMaybe<DateFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PodcastInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<Scalars["PodcastDefaultContentTemplateDynamicZoneInput"]["input"]>
  >;
  briefDescription?: InputMaybe<Scalars["String"]["input"]>;
  cover?: InputMaybe<Scalars["ID"]["input"]>;
  fullDescription?: InputMaybe<Scalars["String"]["input"]>;
  listenings?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  platforms?: InputMaybe<
    Array<InputMaybe<ComponentPodcastPodcastPlatformLinkInput>>
  >;
  publicationDate?: InputMaybe<Scalars["Date"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PodcastListPage = {
  __typename?: "PodcastListPage";
  /** @deprecated Use root level fields instead */
  attributes: PodcastListPage;
  card?: Maybe<ComponentPodcastListPageCard>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: PodcastListPage;
  documentId: Scalars["ID"]["output"];
  heroDescription?: Maybe<Scalars["String"]["output"]>;
  heroImage?: Maybe<UploadFile>;
  heroTitle: Scalars["String"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  latestTitle: Scalars["String"]["output"];
  listenAtLabel?: Maybe<Scalars["String"]["output"]>;
  moreButtonTitle: Scalars["String"]["output"];
  pageTitle?: Maybe<Scalars["String"]["output"]>;
  platforms?: Maybe<Array<Maybe<ComponentPodcastPodcastPlatformLink>>>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type PodcastListPagePlatformsArgs = {
  filters?: InputMaybe<ComponentPodcastPodcastPlatformLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type PodcastListPageInput = {
  card?: InputMaybe<ComponentPodcastListPageCardInput>;
  heroDescription?: InputMaybe<Scalars["String"]["input"]>;
  heroImage?: InputMaybe<Scalars["ID"]["input"]>;
  heroTitle?: InputMaybe<Scalars["String"]["input"]>;
  latestTitle?: InputMaybe<Scalars["String"]["input"]>;
  listenAtLabel?: InputMaybe<Scalars["String"]["input"]>;
  moreButtonTitle?: InputMaybe<Scalars["String"]["input"]>;
  pageTitle?: InputMaybe<Scalars["String"]["input"]>;
  platforms?: InputMaybe<
    Array<InputMaybe<ComponentPodcastPodcastPlatformLinkInput>>
  >;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type PodcastListeningTime = {
  __typename?: "PodcastListeningTime";
  /** @deprecated Use root level fields instead */
  attributes: PodcastListeningTime;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: PodcastListeningTime;
  documentId: Scalars["ID"]["output"];
  duration: Scalars["Long"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  listeningTime: Scalars["Long"]["output"];
  podcast?: Maybe<Podcast>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  staff?: Maybe<UsersPermissionsUser>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type PodcastListeningTimeEntityResponseCollection = {
  __typename?: "PodcastListeningTimeEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<PodcastListeningTime>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<PodcastListeningTime>;
  pageInfo: Pagination;
};

export type PodcastListeningTimeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PodcastListeningTimeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  duration?: InputMaybe<LongFilterInput>;
  listeningTime?: InputMaybe<LongFilterInput>;
  not?: InputMaybe<PodcastListeningTimeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PodcastListeningTimeFiltersInput>>>;
  podcast?: InputMaybe<PodcastFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  staff?: InputMaybe<UsersPermissionsUserFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PodcastListeningTimeInput = {
  duration?: InputMaybe<Scalars["Long"]["input"]>;
  listeningTime?: InputMaybe<Scalars["Long"]["input"]>;
  podcast?: InputMaybe<Scalars["ID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  staff?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PodcastListeningTimeRelationResponseCollection = {
  __typename?: "PodcastListeningTimeRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<PodcastListeningTime>;
  nodes: Array<PodcastListeningTime>;
};

export type PodcastPlatform = {
  __typename?: "PodcastPlatform";
  /** @deprecated Use root level fields instead */
  attributes: PodcastPlatform;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: PodcastPlatform;
  documentId: Scalars["ID"]["output"];
  icon: UploadFile;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type PodcastPlatformEntityResponseCollection = {
  __typename?: "PodcastPlatformEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<PodcastPlatform>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<PodcastPlatform>;
  pageInfo: Pagination;
};

export type PodcastPlatformFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PodcastPlatformFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PodcastPlatformFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PodcastPlatformFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PodcastPlatformInput = {
  icon?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type PodcastRelationResponseCollection = {
  __typename?: "PodcastRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Podcast>;
  nodes: Array<Podcast>;
};

export type PrivacyPolicyPage = {
  __typename?: "PrivacyPolicyPage";
  DefaultContentTemplate: Array<
    Maybe<PrivacyPolicyPageDefaultContentTemplateDynamicZone>
  >;
  /** @deprecated Use root level fields instead */
  attributes: PrivacyPolicyPage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: PrivacyPolicyPage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type PrivacyPolicyPageDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type PrivacyPolicyPageInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<
      Scalars["PrivacyPolicyPageDefaultContentTemplateDynamicZoneInput"]["input"]
    >
  >;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProfilePage = {
  __typename?: "ProfilePage";
  /** @deprecated Use root level fields instead */
  attributes: ProfilePage;
  closeAccountButtonlabel?: Maybe<Scalars["String"]["output"]>;
  confirmAccountClosureDescription?: Maybe<Scalars["String"]["output"]>;
  confirmAccountClosureTitle?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ProfilePage;
  documentId: Scalars["ID"]["output"];
  editProfileButtonLabel?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  latestResourcesDownloadedTitle?: Maybe<Scalars["String"]["output"]>;
  noDownloadedResourcesMessage?: Maybe<Scalars["String"]["output"]>;
  policyLinksSection?: Maybe<ComponentProfilePolicyLinksSection>;
  profileInfoSection: ComponentProfileProfileInfoSection;
  profileNotificationsSection: ComponentProfileProfileNotificationsSection;
  profilePasswordSection: ComponentProfileProfilePasswordSection;
  profileSubTraitsSection: ComponentProfileProfileSubtraitsSection;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  statsAndStreaks?: Maybe<ComponentProfilePageStatsAndStreaks>;
  traitTrackingSection?: Maybe<ComponentProfileTraitTrackingSection>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  welcomeTitle: Scalars["String"]["output"];
};

export type ProfilePageInput = {
  closeAccountButtonlabel?: InputMaybe<Scalars["String"]["input"]>;
  confirmAccountClosureDescription?: InputMaybe<Scalars["String"]["input"]>;
  confirmAccountClosureTitle?: InputMaybe<Scalars["String"]["input"]>;
  editProfileButtonLabel?: InputMaybe<Scalars["String"]["input"]>;
  latestResourcesDownloadedTitle?: InputMaybe<Scalars["String"]["input"]>;
  noDownloadedResourcesMessage?: InputMaybe<Scalars["String"]["input"]>;
  policyLinksSection?: InputMaybe<ComponentProfilePolicyLinksSectionInput>;
  profileInfoSection?: InputMaybe<ComponentProfileProfileInfoSectionInput>;
  profileNotificationsSection?: InputMaybe<ComponentProfileProfileNotificationsSectionInput>;
  profilePasswordSection?: InputMaybe<ComponentProfileProfilePasswordSectionInput>;
  profileSubTraitsSection?: InputMaybe<ComponentProfileProfileSubtraitsSectionInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  statsAndStreaks?: InputMaybe<ComponentProfilePageStatsAndStreaksInput>;
  traitTrackingSection?: InputMaybe<ComponentProfileTraitTrackingSectionInput>;
  welcomeTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export enum PublicationStatus {
  Draft = "DRAFT",
  Published = "PUBLISHED",
}

export type Query = {
  __typename?: "Query";
  aboutPage?: Maybe<AboutPage>;
  accessControlList?: Maybe<AccessControlList>;
  accessControlLists: Array<Maybe<AccessControlList>>;
  accessControlLists_connection?: Maybe<AccessControlListEntityResponseCollection>;
  adminPage?: Maybe<AdminPage>;
  answer?: Maybe<Answer>;
  answers: Array<Maybe<Answer>>;
  answers_connection?: Maybe<AnswerEntityResponseCollection>;
  author?: Maybe<Author>;
  authors: Array<Maybe<Author>>;
  authors_connection?: Maybe<AuthorEntityResponseCollection>;
  awarenessDaysKnowledgeBases: Array<KnowledgeBaseEntity>;
  bookmark?: Maybe<Bookmark>;
  bookmarkPage?: Maybe<BookmarkPage>;
  bookmarks: Array<Maybe<Bookmark>>;
  bookmarks_connection?: Maybe<BookmarkEntityResponseCollection>;
  calendar?: Maybe<Calendar>;
  calendarPage?: Maybe<CalendarPage>;
  calendars: Array<Maybe<Calendar>>;
  calendars_connection?: Maybe<CalendarEntityResponseCollection>;
  completedTask?: Maybe<CompletedTask>;
  completedTasks: Array<Maybe<CompletedTask>>;
  completedTasks_connection?: Maybe<CompletedTaskEntityResponseCollection>;
  cookiesPage?: Maybe<CookiesPage>;
  copyrightPage?: Maybe<CopyrightPage>;
  course?: Maybe<Course>;
  courseCategories: Array<Maybe<CourseCategory>>;
  courseCategories_connection?: Maybe<CourseCategoryEntityResponseCollection>;
  courseCategory?: Maybe<CourseCategory>;
  courseFeedback?: Maybe<CourseFeedback>;
  courseFeedbacks: Array<Maybe<CourseFeedback>>;
  courseFeedbacks_connection?: Maybe<CourseFeedbackEntityResponseCollection>;
  coursePage?: Maybe<CoursePage>;
  courses: Array<Maybe<Course>>;
  courses_connection?: Maybe<CourseEntityResponseCollection>;
  currentSurvey?: Maybe<CurrentSurveyResult>;
  documentsHistoryDocumentHistories: Array<
    Maybe<DocumentsHistoryDocumentHistory>
  >;
  documentsHistoryDocumentHistories_connection?: Maybe<DocumentsHistoryDocumentHistoryEntityResponseCollection>;
  documentsHistoryDocumentHistory?: Maybe<DocumentsHistoryDocumentHistory>;
  edwinGroupStrapiV5AuditLogsEdwinGroupAuditLog?: Maybe<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog>;
  edwinGroupStrapiV5AuditLogsEdwinGroupAuditLogs: Array<
    Maybe<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLog>
  >;
  edwinGroupStrapiV5AuditLogsEdwinGroupAuditLogs_connection?: Maybe<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogEntityResponseCollection>;
  edwinPluginSsoV5Roles?: Maybe<EdwinPluginSsoV5Roles>;
  edwinPluginSsoV5SsoRoles: Array<Maybe<EdwinPluginSsoV5Roles>>;
  edwinPluginSsoV5SsoRoles_connection?: Maybe<EdwinPluginSsoV5RolesEntityResponseCollection>;
  edwinPluginSsoV5Whitelists: Array<Maybe<EdwinPluginSsoV5Whitelists>>;
  edwinPluginSsoV5Whitelists_connection?: Maybe<EdwinPluginSsoV5WhitelistsEntityResponseCollection>;
  emailTemplate?: Maybe<EmailTemplate>;
  emotionsByMonth?: Maybe<EmotionsPerDay>;
  emotionsByMonthManager?: Maybe<Array<Maybe<EmotionsPerDayManager>>>;
  fetchMyBookmarks?: Maybe<FetchMyBookmarksResponse>;
  fetchMySchools?: Maybe<Array<School>>;
  fetchUserDownloadedResources?: Maybe<Array<Maybe<Resource>>>;
  fetchUserStreak?: Maybe<Streak>;
  fetchWildcardAdmin?: Maybe<Array<Wildcard>>;
  fetchWildcardUser?: Maybe<Array<Wildcard>>;
  fetchLatestUpdates?: Maybe<Array<LatestUpdate>>;
  filteredKeyDates?: Maybe<KeyDateConnectionWithSchools>;
  forgotPassword?: Maybe<ForgotPassword>;
  frequencyByMonth?: Maybe<Frequency>;
  frequencyByMonthManager?: Maybe<Array<Maybe<FrequencyBySchool>>>;
  getSchoolMood?: Maybe<Array<SchoolMood>>;
  getUserTrackingData?: Maybe<UserTrackingDataResult>;
  globalFooter?: Maybe<GlobalFooter>;
  globalMenu?: Maybe<GlobalMenu>;
  homeFinishedPage?: Maybe<HomeFinishedPage>;
  homePage?: Maybe<HomePage>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  importedUser?: Maybe<ImportedUser>;
  importedUsers: Array<Maybe<ImportedUser>>;
  importedUsers_connection?: Maybe<ImportedUserEntityResponseCollection>;
  interactionsGa?: Maybe<InteractionsGa>;
  interactionsGas: Array<Maybe<InteractionsGa>>;
  interactionsGas_connection?: Maybe<InteractionsGaEntityResponseCollection>;
  invitedUser?: Maybe<InvitedUser>;
  invitedUsers: Array<Maybe<InvitedUser>>;
  invitedUsers_connection?: Maybe<InvitedUserEntityResponseCollection>;
  keyDate?: Maybe<KeyDate>;
  keyDatePage?: Maybe<KeyDatePage>;
  keyDates: Array<Maybe<KeyDate>>;
  keyDates_connection?: Maybe<KeyDateEntityResponseCollection>;
  knowledgeBase?: Maybe<KnowledgeBase>;
  knowledgeBaseCategories: Array<Maybe<KnowledgeBaseCategory>>;
  knowledgeBaseCategories_connection?: Maybe<KnowledgeBaseCategoryEntityResponseCollection>;
  knowledgeBaseCategory?: Maybe<KnowledgeBaseCategory>;
  knowledgeBasePage?: Maybe<KnowledgeBasePage>;
  knowledgeBaseType?: Maybe<KnowledgeBaseType>;
  knowledgeBaseTypes: Array<Maybe<KnowledgeBaseType>>;
  knowledgeBaseTypesWithPublishedItems: Array<KnowledgeBaseTypeWithItems>;
  knowledgeBaseTypes_connection?: Maybe<KnowledgeBaseTypeEntityResponseCollection>;
  knowledgeBases: Array<Maybe<KnowledgeBase>>;
  knowledgeBases_connection?: Maybe<KnowledgeBaseEntityResponseCollection>;
  leadershipWheel?: Maybe<LeadershipWheel>;
  leadershipWheelPage?: Maybe<LeadershipWheelPage>;
  leadershipWheelTracker?: Maybe<Array<Maybe<LeadershipWheelTrackerResult>>>;
  leadershipWheels: Array<Maybe<LeadershipWheel>>;
  leadershipWheels_connection?: Maybe<LeadershipWheelEntityResponseCollection>;
  learn?: Maybe<Learn>;
  learnItem?: Maybe<LearnItem>;
  learnItems: Array<Maybe<LearnItem>>;
  learnItems_connection?: Maybe<LearnItemEntityResponseCollection>;
  learnPage?: Maybe<LearnPage>;
  learns: Array<Maybe<Learn>>;
  learns_connection?: Maybe<LearnEntityResponseCollection>;
  like?: Maybe<Like>;
  likes: Array<Maybe<Like>>;
  likes_connection?: Maybe<LikeEntityResponseCollection>;
  location?: Maybe<Location>;
  locations: Array<Maybe<Location>>;
  locations_connection?: Maybe<LocationEntityResponseCollection>;
  logKeyDateScraping?: Maybe<LogKeyDateScraping>;
  logKeyDateScrapings: Array<Maybe<LogKeyDateScraping>>;
  logKeyDateScrapings_connection?: Maybe<LogKeyDateScrapingEntityResponseCollection>;
  loginPage?: Maybe<LoginPage>;
  loginTracker?: Maybe<LoginTracker>;
  loginTrackers: Array<Maybe<LoginTracker>>;
  loginTrackers_connection?: Maybe<LoginTrackerEntityResponseCollection>;
  manageUsersPage?: Maybe<ManageUsersPage>;
  me?: Maybe<UsersPermissionsMe>;
  measure?: Maybe<Measure>;
  measures: Array<Maybe<Measure>>;
  measures_connection?: Maybe<MeasureEntityResponseCollection>;
  microExercisePrompt?: Maybe<MicroExercisePrompt>;
  microExercisePrompts: Array<Maybe<MicroExercisePrompt>>;
  microExercisePrompts_connection?: Maybe<MicroExercisePromptEntityResponseCollection>;
  notFoundPage?: Maybe<NotFoundPage>;
  notification?: Maybe<Notification>;
  notificationSystem?: Maybe<NotificationSystem>;
  notificationSystems: Array<Maybe<NotificationSystem>>;
  notificationSystems_connection?: Maybe<NotificationSystemEntityResponseCollection>;
  notificationTemplate?: Maybe<NotificationTemplate>;
  notificationTemplates: Array<Maybe<NotificationTemplate>>;
  notificationTemplates_connection?: Maybe<NotificationTemplateEntityResponseCollection>;
  notificationUser?: Maybe<NotificationUser>;
  notificationUsers: Array<Maybe<NotificationUser>>;
  notificationUsers_connection?: Maybe<NotificationUserEntityResponseCollection>;
  notifications: Array<Maybe<Notification>>;
  notifications_connection?: Maybe<NotificationEntityResponseCollection>;
  onBoardingPage?: Maybe<OnBoardingPage>;
  podcast?: Maybe<Podcast>;
  podcastBySlug?: Maybe<PodcastBySlugResponse>;
  podcastDetailPage?: Maybe<PodcastDetailPage>;
  podcastListPage?: Maybe<PodcastListPage>;
  podcastListeningTime?: Maybe<PodcastListeningTime>;
  podcastListeningTimes: Array<Maybe<PodcastListeningTime>>;
  podcastListeningTimes_connection?: Maybe<PodcastListeningTimeEntityResponseCollection>;
  podcastPlatform?: Maybe<PodcastPlatform>;
  podcastPlatforms: Array<Maybe<PodcastPlatform>>;
  podcastPlatforms_connection?: Maybe<PodcastPlatformEntityResponseCollection>;
  podcasts: Array<Maybe<Podcast>>;
  podcasts_connection?: Maybe<PodcastEntityResponseCollection>;
  privacyPolicyPage?: Maybe<PrivacyPolicyPage>;
  profilePage?: Maybe<ProfilePage>;
  question?: Maybe<Question>;
  questions: Array<Maybe<Question>>;
  questions_connection?: Maybe<QuestionEntityResponseCollection>;
  quote?: Maybe<Quote>;
  quotePage?: Maybe<QuotePage>;
  quotes: Array<Maybe<Quote>>;
  quotes_connection?: Maybe<QuoteEntityResponseCollection>;
  registerPage?: Maybe<RegisterPage>;
  resource?: Maybe<Resource>;
  resourceAsset?: Maybe<ResourceAsset>;
  resourceAssetDownloadHistories: Array<Maybe<ResourceAssetDownloadHistory>>;
  resourceAssetDownloadHistories_connection?: Maybe<ResourceAssetDownloadHistoryEntityResponseCollection>;
  resourceAssetDownloadHistory?: Maybe<ResourceAssetDownloadHistory>;
  resourceAssetHistories: Array<Maybe<ResourceAssetHistory>>;
  resourceAssetHistories_connection?: Maybe<ResourceAssetHistoryEntityResponseCollection>;
  resourceAssetHistory?: Maybe<ResourceAssetHistory>;
  resourceAssets: Array<Maybe<ResourceAsset>>;
  resourceAssets_connection?: Maybe<ResourceAssetEntityResponseCollection>;
  resourceCategories: Array<Maybe<ResourceCategory>>;
  resourceCategories_connection?: Maybe<ResourceCategoryEntityResponseCollection>;
  resourceCategory?: Maybe<ResourceCategory>;
  resourceHistories: Array<Maybe<ResourceHistory>>;
  resourceHistories_connection?: Maybe<ResourceHistoryEntityResponseCollection>;
  resourceHistory?: Maybe<ResourceHistory>;
  resourceHubPage?: Maybe<ResourceHubPage>;
  resourceType?: Maybe<ResourceType>;
  resourceTypes: Array<Maybe<ResourceType>>;
  resourceTypes_connection?: Maybe<ResourceTypeEntityResponseCollection>;
  resources: Array<Maybe<Resource>>;
  resources_connection?: Maybe<ResourceEntityResponseCollection>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  scale?: Maybe<Scale>;
  scales: Array<Maybe<Scale>>;
  scales_connection?: Maybe<ScaleEntityResponseCollection>;
  scheduledEmail?: Maybe<ScheduledEmail>;
  scheduledEmails: Array<Maybe<ScheduledEmail>>;
  scheduledEmails_connection?: Maybe<ScheduledEmailEntityResponseCollection>;
  school?: Maybe<School>;
  schools: Array<Maybe<School>>;
  schools_connection?: Maybe<SchoolEntityResponseCollection>;
  searchPage?: Maybe<SearchPage>;
  searchUnified?: Maybe<SearchUnifiedConnection>;
  sectionType?: Maybe<SectionType>;
  sectionTypes: Array<Maybe<SectionType>>;
  sectionTypes_connection?: Maybe<SectionTypeEntityResponseCollection>;
  step1?: Maybe<Step1>;
  step2?: Maybe<Step2>;
  step3?: Maybe<Step3>;
  step4?: Maybe<Step4>;
  step5?: Maybe<Step5>;
  subscription?: Maybe<Subscription>;
  subscriptions: Array<Maybe<Subscription>>;
  subscriptions_connection?: Maybe<SubscriptionEntityResponseCollection>;
  survey?: Maybe<Survey>;
  surveyMethodologies: Array<Maybe<SurveyMethodology>>;
  surveyMethodologies_connection?: Maybe<SurveyMethodologyEntityResponseCollection>;
  surveyMethodology?: Maybe<SurveyMethodology>;
  surveyResults?: Maybe<SurveyResult>;
  surveyUser?: Maybe<SurveyUser>;
  surveyUsers: Array<Maybe<SurveyUser>>;
  surveyUsers_connection?: Maybe<SurveyUserEntityResponseCollection>;
  surveys: Array<Maybe<Survey>>;
  surveysByUser?: Maybe<Array<Maybe<SurveysByUserResponse>>>;
  surveysResponsesCategories?: Maybe<SurveyCategoryResponse>;
  surveysResponsesQuestions?: Maybe<SurveyQuestionsResponse>;
  surveys_connection?: Maybe<SurveyEntityResponseCollection>;
  termAndCondition?: Maybe<TermAndCondition>;
  termsAndConditionsPage?: Maybe<TermsAndConditionsPage>;
  topBookmarkKnowledgeBases?: Maybe<Array<KnowledgeBaseEntity>>;
  topicLabel?: Maybe<TopicLabel>;
  topicLabels: Array<Maybe<TopicLabel>>;
  topicLabels_connection?: Maybe<TopicLabelEntityResponseCollection>;
  tracking?: Maybe<Tracking>;
  trackings: Array<Maybe<Tracking>>;
  trackings_connection?: Maybe<TrackingEntityResponseCollection>;
  trendingKnowledgeBases: Array<KnowledgeBase>;
  uploadFile?: Maybe<UploadFile>;
  uploadFiles: Array<Maybe<UploadFile>>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  validCategoryIdsForKnowledgeBaseType: Array<Scalars["ID"]["output"]>;
  watermarkSettings?: Maybe<WatermarkSettings>;
  wildcard?: Maybe<Wildcard>;
  wildcards: Array<Maybe<Wildcard>>;
  wildcards_connection?: Maybe<WildcardEntityResponseCollection>;
};

export type QueryAboutPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAccessControlListArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAccessControlListsArgs = {
  filters?: InputMaybe<AccessControlListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAccessControlLists_ConnectionArgs = {
  filters?: InputMaybe<AccessControlListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAdminPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAnswerArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAnswersArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAnswers_ConnectionArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAuthorArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAuthorsArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAuthors_ConnectionArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAwarenessDaysKnowledgeBasesArgs = {
  limit: Scalars["Int"]["input"];
};

export type QueryBookmarkArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBookmarkPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBookmarksArgs = {
  filters?: InputMaybe<BookmarkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBookmarks_ConnectionArgs = {
  filters?: InputMaybe<BookmarkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCalendarArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCalendarPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCalendarsArgs = {
  filters?: InputMaybe<CalendarFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCalendars_ConnectionArgs = {
  filters?: InputMaybe<CalendarFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCompletedTaskArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCompletedTasksArgs = {
  filters?: InputMaybe<CompletedTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCompletedTasks_ConnectionArgs = {
  filters?: InputMaybe<CompletedTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCookiesPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCopyrightPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCourseArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCourseCategoriesArgs = {
  filters?: InputMaybe<CourseCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCourseCategories_ConnectionArgs = {
  filters?: InputMaybe<CourseCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCourseCategoryArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCourseFeedbackArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCourseFeedbacksArgs = {
  filters?: InputMaybe<CourseFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCourseFeedbacks_ConnectionArgs = {
  filters?: InputMaybe<CourseFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCoursePageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCoursesArgs = {
  filters?: InputMaybe<CourseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCourses_ConnectionArgs = {
  filters?: InputMaybe<CourseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryDocumentsHistoryDocumentHistoriesArgs = {
  filters?: InputMaybe<DocumentsHistoryDocumentHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryDocumentsHistoryDocumentHistories_ConnectionArgs = {
  filters?: InputMaybe<DocumentsHistoryDocumentHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryDocumentsHistoryDocumentHistoryArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryEdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryEdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogsArgs = {
  filters?: InputMaybe<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryEdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogs_ConnectionArgs =
  {
    filters?: InputMaybe<EdwinGroupStrapiV5AuditLogsEdwinGroupAuditLogFiltersInput>;
    pagination?: InputMaybe<PaginationArg>;
    sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    status?: InputMaybe<PublicationStatus>;
  };

export type QueryEdwinPluginSsoV5RolesArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryEdwinPluginSsoV5SsoRolesArgs = {
  filters?: InputMaybe<EdwinPluginSsoV5RolesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryEdwinPluginSsoV5SsoRoles_ConnectionArgs = {
  filters?: InputMaybe<EdwinPluginSsoV5RolesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryEdwinPluginSsoV5WhitelistsArgs = {
  filters?: InputMaybe<EdwinPluginSsoV5WhitelistsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryEdwinPluginSsoV5Whitelists_ConnectionArgs = {
  filters?: InputMaybe<EdwinPluginSsoV5WhitelistsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryEmailTemplateArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryEmotionsByMonthArgs = {
  date: Scalars["Date"]["input"];
};

export type QueryEmotionsByMonthManagerArgs = {
  date: Scalars["Date"]["input"];
};

export type QueryFetchMyBookmarksArgs = {
  category?: InputMaybe<BookmarkCategory>;
  knowledgeBaseType?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  relationId?: InputMaybe<Scalars["String"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryFetchMySchoolsArgs = {
  asRegularUser?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryFetchUserDownloadedResourcesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFetchUserStreakArgs = {
  type: Scalars["String"]["input"];
};

export type QueryFilteredKeyDatesArgs = {
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  schoolContextDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  sectionType?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryForgotPasswordArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryGetSchoolMoodArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGlobalFooterArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryGlobalMenuArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryHomeFinishedPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryHomePageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryI18NLocaleArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryImportedUserArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryImportedUsersArgs = {
  filters?: InputMaybe<ImportedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryImportedUsers_ConnectionArgs = {
  filters?: InputMaybe<ImportedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryInteractionsGaArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryInteractionsGasArgs = {
  filters?: InputMaybe<InteractionsGaFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryInteractionsGas_ConnectionArgs = {
  filters?: InputMaybe<InteractionsGaFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryInvitedUserArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryInvitedUsersArgs = {
  filters?: InputMaybe<InvitedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryInvitedUsers_ConnectionArgs = {
  filters?: InputMaybe<InvitedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKeyDateArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKeyDatePageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKeyDatesArgs = {
  filters?: InputMaybe<KeyDateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKeyDates_ConnectionArgs = {
  filters?: InputMaybe<KeyDateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKnowledgeBaseArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKnowledgeBaseCategoriesArgs = {
  filters?: InputMaybe<KnowledgeBaseCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKnowledgeBaseCategories_ConnectionArgs = {
  filters?: InputMaybe<KnowledgeBaseCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKnowledgeBaseCategoryArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKnowledgeBasePageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKnowledgeBaseTypeArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKnowledgeBaseTypesArgs = {
  filters?: InputMaybe<KnowledgeBaseTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKnowledgeBaseTypes_ConnectionArgs = {
  filters?: InputMaybe<KnowledgeBaseTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKnowledgeBasesArgs = {
  filters?: InputMaybe<KnowledgeBaseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryKnowledgeBases_ConnectionArgs = {
  filters?: InputMaybe<KnowledgeBaseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLeadershipWheelArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLeadershipWheelPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLeadershipWheelTrackerArgs = {
  endDay: Scalars["Date"]["input"];
  startDay: Scalars["Date"]["input"];
};

export type QueryLeadershipWheelsArgs = {
  filters?: InputMaybe<LeadershipWheelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLeadershipWheels_ConnectionArgs = {
  filters?: InputMaybe<LeadershipWheelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLearnArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLearnItemArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLearnItemsArgs = {
  filters?: InputMaybe<LearnItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLearnItems_ConnectionArgs = {
  filters?: InputMaybe<LearnItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLearnPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLearnsArgs = {
  filters?: InputMaybe<LearnFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLearns_ConnectionArgs = {
  filters?: InputMaybe<LearnFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLikeArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLikesArgs = {
  filters?: InputMaybe<LikeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLikes_ConnectionArgs = {
  filters?: InputMaybe<LikeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLocationArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLocationsArgs = {
  filters?: InputMaybe<LocationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLocations_ConnectionArgs = {
  filters?: InputMaybe<LocationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLogKeyDateScrapingArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLogKeyDateScrapingsArgs = {
  filters?: InputMaybe<LogKeyDateScrapingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLogKeyDateScrapings_ConnectionArgs = {
  filters?: InputMaybe<LogKeyDateScrapingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLoginPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLoginTrackerArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLoginTrackersArgs = {
  filters?: InputMaybe<LoginTrackerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLoginTrackers_ConnectionArgs = {
  filters?: InputMaybe<LoginTrackerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryManageUsersPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryMeasureArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryMeasuresArgs = {
  filters?: InputMaybe<MeasureFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryMeasures_ConnectionArgs = {
  filters?: InputMaybe<MeasureFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryMicroExercisePromptArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryMicroExercisePromptsArgs = {
  filters?: InputMaybe<MicroExercisePromptFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryMicroExercisePrompts_ConnectionArgs = {
  filters?: InputMaybe<MicroExercisePromptFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotFoundPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotificationArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotificationSystemArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotificationSystemsArgs = {
  filters?: InputMaybe<NotificationSystemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotificationSystems_ConnectionArgs = {
  filters?: InputMaybe<NotificationSystemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotificationTemplateArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotificationTemplatesArgs = {
  filters?: InputMaybe<NotificationTemplateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotificationTemplates_ConnectionArgs = {
  filters?: InputMaybe<NotificationTemplateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotificationUserArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotificationUsersArgs = {
  filters?: InputMaybe<NotificationUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotificationUsers_ConnectionArgs = {
  filters?: InputMaybe<NotificationUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotificationsArgs = {
  filters?: InputMaybe<NotificationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNotifications_ConnectionArgs = {
  filters?: InputMaybe<NotificationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryOnBoardingPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPodcastArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPodcastBySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type QueryPodcastDetailPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPodcastListPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPodcastListeningTimeArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPodcastListeningTimesArgs = {
  filters?: InputMaybe<PodcastListeningTimeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPodcastListeningTimes_ConnectionArgs = {
  filters?: InputMaybe<PodcastListeningTimeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPodcastPlatformArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPodcastPlatformsArgs = {
  filters?: InputMaybe<PodcastPlatformFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPodcastPlatforms_ConnectionArgs = {
  filters?: InputMaybe<PodcastPlatformFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPodcastsArgs = {
  filters?: InputMaybe<PodcastFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPodcasts_ConnectionArgs = {
  filters?: InputMaybe<PodcastFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPrivacyPolicyPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryProfilePageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryQuestionArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryQuestionsArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryQuestions_ConnectionArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryQuoteArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryQuotePageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryQuotesArgs = {
  filters?: InputMaybe<QuoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryQuotes_ConnectionArgs = {
  filters?: InputMaybe<QuoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryRegisterPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceAssetArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceAssetDownloadHistoriesArgs = {
  filters?: InputMaybe<ResourceAssetDownloadHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceAssetDownloadHistories_ConnectionArgs = {
  filters?: InputMaybe<ResourceAssetDownloadHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceAssetDownloadHistoryArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceAssetHistoriesArgs = {
  filters?: InputMaybe<ResourceAssetHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceAssetHistories_ConnectionArgs = {
  filters?: InputMaybe<ResourceAssetHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceAssetHistoryArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceAssetsArgs = {
  filters?: InputMaybe<ResourceAssetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceAssets_ConnectionArgs = {
  filters?: InputMaybe<ResourceAssetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceCategoriesArgs = {
  filters?: InputMaybe<ResourceCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceCategories_ConnectionArgs = {
  filters?: InputMaybe<ResourceCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceCategoryArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceHistoriesArgs = {
  filters?: InputMaybe<ResourceHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceHistories_ConnectionArgs = {
  filters?: InputMaybe<ResourceHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceHistoryArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceHubPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceTypeArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceTypesArgs = {
  filters?: InputMaybe<ResourceTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourceTypes_ConnectionArgs = {
  filters?: InputMaybe<ResourceTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResourcesArgs = {
  filters?: InputMaybe<ResourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryResources_ConnectionArgs = {
  filters?: InputMaybe<ResourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryScaleArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryScalesArgs = {
  filters?: InputMaybe<ScaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryScales_ConnectionArgs = {
  filters?: InputMaybe<ScaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryScheduledEmailArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryScheduledEmailsArgs = {
  filters?: InputMaybe<ScheduledEmailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryScheduledEmails_ConnectionArgs = {
  filters?: InputMaybe<ScheduledEmailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySchoolArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySchoolsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySchools_ConnectionArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySearchPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySearchUnifiedArgs = {
  contentTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  schoolContextDocumentId: Scalars["ID"]["input"];
  searchTerm?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySectionTypeArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySectionTypesArgs = {
  filters?: InputMaybe<SectionTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySectionTypes_ConnectionArgs = {
  filters?: InputMaybe<SectionTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryStep1Args = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryStep2Args = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryStep3Args = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryStep4Args = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryStep5Args = {
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySubscriptionArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySubscriptionsArgs = {
  filters?: InputMaybe<SubscriptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySubscriptions_ConnectionArgs = {
  filters?: InputMaybe<SubscriptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySurveyArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySurveyMethodologiesArgs = {
  filters?: InputMaybe<SurveyMethodologyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySurveyMethodologies_ConnectionArgs = {
  filters?: InputMaybe<SurveyMethodologyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySurveyMethodologyArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySurveyUserArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySurveyUsersArgs = {
  filters?: InputMaybe<SurveyUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySurveyUsers_ConnectionArgs = {
  filters?: InputMaybe<SurveyUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySurveysArgs = {
  filters?: InputMaybe<SurveyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuerySurveysResponsesCategoriesArgs = {
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  surveyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QuerySurveysResponsesQuestionsArgs = {
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  surveyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QuerySurveys_ConnectionArgs = {
  filters?: InputMaybe<SurveyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTermAndConditionArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTermsAndConditionsPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTopBookmarkKnowledgeBasesArgs = {
  limit: Scalars["Int"]["input"];
};

export type QueryTopicLabelArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTopicLabelsArgs = {
  filters?: InputMaybe<TopicLabelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTopicLabels_ConnectionArgs = {
  filters?: InputMaybe<TopicLabelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTrackingArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTrackingsArgs = {
  filters?: InputMaybe<TrackingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTrackings_ConnectionArgs = {
  filters?: InputMaybe<TrackingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTrendingKnowledgeBasesArgs = {
  limit: Scalars["Int"]["input"];
};

export type QueryUploadFileArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryValidCategoryIdsForKnowledgeBaseTypeArgs = {
  knowledgeBaseTypeDocumentId: Scalars["ID"]["input"];
};

export type QueryWatermarkSettingsArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryWildcardArgs = {
  documentId: Scalars["ID"]["input"];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryWildcardsArgs = {
  filters?: InputMaybe<WildcardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryWildcards_ConnectionArgs = {
  filters?: InputMaybe<WildcardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type Question = {
  __typename?: "Question";
  answers: Array<Maybe<Answer>>;
  answers_connection?: Maybe<AnswerRelationResponseCollection>;
  /** @deprecated Use root level fields instead */
  attributes: Question;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Question;
  date?: Maybe<Scalars["Date"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  identifier?: Maybe<Scalars["String"]["output"]>;
  measure?: Maybe<Measure>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  question: Scalars["String"]["output"];
  scale?: Maybe<Scale>;
  surveys: Array<Maybe<Survey>>;
  surveys_connection?: Maybe<SurveyRelationResponseCollection>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  user_question_answereds: Array<Maybe<SurveyUser>>;
  user_question_answereds_connection?: Maybe<SurveyUserRelationResponseCollection>;
};

export type QuestionAnswersArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QuestionAnswers_ConnectionArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QuestionSurveysArgs = {
  filters?: InputMaybe<SurveyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QuestionSurveys_ConnectionArgs = {
  filters?: InputMaybe<SurveyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QuestionUser_Question_AnsweredsArgs = {
  filters?: InputMaybe<SurveyUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QuestionUser_Question_Answereds_ConnectionArgs = {
  filters?: InputMaybe<SurveyUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QuestionEntity = {
  __typename?: "QuestionEntity";
  attributes?: Maybe<Question>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type QuestionEntityResponseCollection = {
  __typename?: "QuestionEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Question>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Question>;
  pageInfo: Pagination;
};

export type QuestionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<QuestionFiltersInput>>>;
  answers?: InputMaybe<AnswerFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  identifier?: InputMaybe<StringFilterInput>;
  measure?: InputMaybe<MeasureFiltersInput>;
  not?: InputMaybe<QuestionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<QuestionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  question?: InputMaybe<StringFilterInput>;
  scale?: InputMaybe<ScaleFiltersInput>;
  surveys?: InputMaybe<SurveyFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user_question_answereds?: InputMaybe<SurveyUserFiltersInput>;
};

export type QuestionInput = {
  answers?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  date?: InputMaybe<Scalars["Date"]["input"]>;
  identifier?: InputMaybe<Scalars["String"]["input"]>;
  measure?: InputMaybe<Scalars["ID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  question?: InputMaybe<Scalars["String"]["input"]>;
  scale?: InputMaybe<Scalars["ID"]["input"]>;
  surveys?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  user_question_answereds?: InputMaybe<
    Array<InputMaybe<Scalars["ID"]["input"]>>
  >;
};

export type QuestionRelationResponseCollection = {
  __typename?: "QuestionRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Question>;
  nodes: Array<Question>;
};

export type Quote = {
  __typename?: "Quote";
  /** @deprecated Use root level fields instead */
  attributes: Quote;
  author?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Quote;
  date?: Maybe<Scalars["Date"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  links?: Maybe<ComponentCommonLinkList>;
  occupation?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  quote?: Maybe<Scalars["String"]["output"]>;
  quoteWithLinks?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type QuoteEntityResponseCollection = {
  __typename?: "QuoteEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Quote>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Quote>;
  pageInfo: Pagination;
};

export type QuoteFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<QuoteFiltersInput>>>;
  author?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  links?: InputMaybe<ComponentCommonLinkListFiltersInput>;
  not?: InputMaybe<QuoteFiltersInput>;
  occupation?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<QuoteFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  quote?: InputMaybe<StringFilterInput>;
  quoteWithLinks?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type QuoteInput = {
  author?: InputMaybe<Scalars["String"]["input"]>;
  date?: InputMaybe<Scalars["Date"]["input"]>;
  links?: InputMaybe<ComponentCommonLinkListInput>;
  occupation?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  quote?: InputMaybe<Scalars["String"]["input"]>;
  quoteWithLinks?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuotePage = {
  __typename?: "QuotePage";
  /** @deprecated Use root level fields instead */
  attributes: QuotePage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  cta: ComponentCommonButton;
  /** @deprecated Use root level fields instead */
  data: QuotePage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  quoteOfTheDayTitle: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type QuotePageInput = {
  cta?: InputMaybe<ComponentCommonButtonInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  quoteOfTheDayTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type RegisterPage = {
  __typename?: "RegisterPage";
  /** @deprecated Use root level fields instead */
  attributes: RegisterPage;
  choosePassword: Scalars["String"]["output"];
  createYourAccountCta: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: RegisterPage;
  description: Scalars["String"]["output"];
  documentId: Scalars["ID"]["output"];
  fieldErrors?: Maybe<ComponentRegisterRegisterFieldErrors>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  image: UploadFile;
  pageImage: UploadFile;
  popUpMessages?: Maybe<ComponentRegisterToastMessagesRegister>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  registerTitle: Scalars["String"]["output"];
  repeatYourPassword: Scalars["String"]["output"];
  schoolCode: Scalars["String"]["output"];
  successRegisterPopUpMessage?: Maybe<Scalars["String"]["output"]>;
  successRegisterPopUpTitle?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  welcomeToTItle: Scalars["String"]["output"];
  yourEmail: Scalars["String"]["output"];
  yourFirstName: Scalars["String"]["output"];
  yourLastName: Scalars["String"]["output"];
};

export type RegisterPageInput = {
  choosePassword?: InputMaybe<Scalars["String"]["input"]>;
  createYourAccountCta?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  fieldErrors?: InputMaybe<ComponentRegisterRegisterFieldErrorsInput>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  pageImage?: InputMaybe<Scalars["ID"]["input"]>;
  popUpMessages?: InputMaybe<ComponentRegisterToastMessagesRegisterInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  registerTitle?: InputMaybe<Scalars["String"]["input"]>;
  repeatYourPassword?: InputMaybe<Scalars["String"]["input"]>;
  schoolCode?: InputMaybe<Scalars["String"]["input"]>;
  successRegisterPopUpMessage?: InputMaybe<Scalars["String"]["input"]>;
  successRegisterPopUpTitle?: InputMaybe<Scalars["String"]["input"]>;
  welcomeToTItle?: InputMaybe<Scalars["String"]["input"]>;
  yourEmail?: InputMaybe<Scalars["String"]["input"]>;
  yourFirstName?: InputMaybe<Scalars["String"]["input"]>;
  yourLastName?: InputMaybe<Scalars["String"]["input"]>;
};

export type Resource = {
  __typename?: "Resource";
  DefaultContentTemplate?: Maybe<
    Array<Maybe<ResourceDefaultContentTemplateDynamicZone>>
  >;
  assetsCount?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: Resource;
  briefDescription?: Maybe<Scalars["String"]["output"]>;
  category?: Maybe<ResourceCategory>;
  cover?: Maybe<UploadFile>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Resource;
  documentId: Scalars["ID"]["output"];
  expireResourceStatusAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publicationDate?: Maybe<Scalars["Date"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  resourceHistory: Array<Maybe<ResourceHistory>>;
  resourceHistory_connection?: Maybe<ResourceHistoryRelationResponseCollection>;
  resourceStatus?: Maybe<Enum_Resource_Resourcestatus>;
  restrictedSharing?: Maybe<Scalars["Boolean"]["output"]>;
  schools: Array<Maybe<School>>;
  schools_connection?: Maybe<SchoolRelationResponseCollection>;
  slug: Scalars["String"]["output"];
  staff: Array<Maybe<UsersPermissionsUser>>;
  staff_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  subHeader?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  type?: Maybe<ResourceType>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ResourceResourceHistoryArgs = {
  filters?: InputMaybe<ResourceHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ResourceResourceHistory_ConnectionArgs = {
  filters?: InputMaybe<ResourceHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ResourceSchoolsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ResourceSchools_ConnectionArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ResourceStaffArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ResourceStaff_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ResourceAsset = {
  __typename?: "ResourceAsset";
  /** @deprecated Use root level fields instead */
  attributes: ResourceAsset;
  content: UploadFile;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ResourceAsset;
  description?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  previewContent?: Maybe<UploadFile>;
  previewStatus?: Maybe<Enum_Resourceasset_Previewstatus>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  resourceAssetHistory: Array<Maybe<ResourceAssetHistory>>;
  resourceAssetHistory_connection?: Maybe<ResourceAssetHistoryRelationResponseCollection>;
  scanStatus?: Maybe<Enum_Resourceasset_Scanstatus>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ResourceAssetResourceAssetHistoryArgs = {
  filters?: InputMaybe<ResourceAssetHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ResourceAssetResourceAssetHistory_ConnectionArgs = {
  filters?: InputMaybe<ResourceAssetHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ResourceAssetDownloadHistory = {
  __typename?: "ResourceAssetDownloadHistory";
  accessType: Enum_Resourceassetdownloadhistory_Accesstype;
  /** @deprecated Use root level fields instead */
  attributes: ResourceAssetDownloadHistory;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ResourceAssetDownloadHistory;
  documentId: Scalars["ID"]["output"];
  downloadedAt: Scalars["DateTime"]["output"];
  file?: Maybe<ResourceAsset>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  staff?: Maybe<UsersPermissionsUser>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  version?: Maybe<Scalars["Int"]["output"]>;
};

export type ResourceAssetDownloadHistoryEntityResponseCollection = {
  __typename?: "ResourceAssetDownloadHistoryEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ResourceAssetDownloadHistory>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ResourceAssetDownloadHistory>;
  pageInfo: Pagination;
};

export type ResourceAssetDownloadHistoryFiltersInput = {
  accessType?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ResourceAssetDownloadHistoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  downloadedAt?: InputMaybe<DateTimeFilterInput>;
  file?: InputMaybe<ResourceAssetFiltersInput>;
  not?: InputMaybe<ResourceAssetDownloadHistoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResourceAssetDownloadHistoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  staff?: InputMaybe<UsersPermissionsUserFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  version?: InputMaybe<IntFilterInput>;
};

export type ResourceAssetDownloadHistoryInput = {
  accessType?: InputMaybe<Enum_Resourceassetdownloadhistory_Accesstype>;
  downloadedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  file?: InputMaybe<Scalars["ID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  staff?: InputMaybe<Scalars["ID"]["input"]>;
  version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ResourceAssetEntityResponseCollection = {
  __typename?: "ResourceAssetEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ResourceAsset>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ResourceAsset>;
  pageInfo: Pagination;
};

export type ResourceAssetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ResourceAssetFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ResourceAssetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResourceAssetFiltersInput>>>;
  previewStatus?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  resourceAssetHistory?: InputMaybe<ResourceAssetHistoryFiltersInput>;
  scanStatus?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ResourceAssetHistory = {
  __typename?: "ResourceAssetHistory";
  asset?: Maybe<ResourceAsset>;
  /** @deprecated Use root level fields instead */
  attributes: ResourceAssetHistory;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ResourceAssetHistory;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type ResourceAssetHistoryEntityResponseCollection = {
  __typename?: "ResourceAssetHistoryEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ResourceAssetHistory>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ResourceAssetHistory>;
  pageInfo: Pagination;
};

export type ResourceAssetHistoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ResourceAssetHistoryFiltersInput>>>;
  asset?: InputMaybe<ResourceAssetFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ResourceAssetHistoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResourceAssetHistoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  version?: InputMaybe<IntFilterInput>;
};

export type ResourceAssetHistoryInput = {
  asset?: InputMaybe<Scalars["ID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ResourceAssetHistoryRelationResponseCollection = {
  __typename?: "ResourceAssetHistoryRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ResourceAssetHistory>;
  nodes: Array<ResourceAssetHistory>;
};

export type ResourceAssetInput = {
  content?: InputMaybe<Scalars["ID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  previewContent?: InputMaybe<Scalars["ID"]["input"]>;
  previewStatus?: InputMaybe<Enum_Resourceasset_Previewstatus>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  resourceAssetHistory?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  scanStatus?: InputMaybe<Enum_Resourceasset_Scanstatus>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ResourceAssetRelationResponseCollection = {
  __typename?: "ResourceAssetRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ResourceAsset>;
  nodes: Array<ResourceAsset>;
};

export type ResourceCategory = {
  __typename?: "ResourceCategory";
  /** @deprecated Use root level fields instead */
  attributes: ResourceCategory;
  category: Scalars["String"]["output"];
  color?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ResourceCategory;
  documentId: Scalars["ID"]["output"];
  icon?: Maybe<UploadFile>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  rootCategory?: Maybe<ResourceCategory>;
  subCategories: Array<Maybe<ResourceCategory>>;
  subCategories_connection?: Maybe<ResourceCategoryRelationResponseCollection>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ResourceCategorySubCategoriesArgs = {
  filters?: InputMaybe<ResourceCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ResourceCategorySubCategories_ConnectionArgs = {
  filters?: InputMaybe<ResourceCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ResourceCategoryEntityResponseCollection = {
  __typename?: "ResourceCategoryEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ResourceCategory>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ResourceCategory>;
  pageInfo: Pagination;
};

export type ResourceCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ResourceCategoryFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ResourceCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResourceCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  rootCategory?: InputMaybe<ResourceCategoryFiltersInput>;
  subCategories?: InputMaybe<ResourceCategoryFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ResourceCategoryInput = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  color?: InputMaybe<Scalars["String"]["input"]>;
  icon?: InputMaybe<Scalars["ID"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  rootCategory?: InputMaybe<Scalars["ID"]["input"]>;
  subCategories?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type ResourceCategoryRelationResponseCollection = {
  __typename?: "ResourceCategoryRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ResourceCategory>;
  nodes: Array<ResourceCategory>;
};

export type ResourceDefaultContentTemplateDynamicZone =
  | ComponentCommonAudio
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonQuote
  | ComponentCommonRelatedContent
  | ComponentCommonTags
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | ComponentResourceAssets
  | ComponentResourceResourcesRelated
  | Error;

export type ResourceEntityResponseCollection = {
  __typename?: "ResourceEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Resource>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Resource>;
  pageInfo: Pagination;
};

export type ResourceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ResourceFiltersInput>>>;
  briefDescription?: InputMaybe<StringFilterInput>;
  category?: InputMaybe<ResourceCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  expireResourceStatusAt?: InputMaybe<DateTimeFilterInput>;
  not?: InputMaybe<ResourceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResourceFiltersInput>>>;
  publicationDate?: InputMaybe<DateFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  resourceHistory?: InputMaybe<ResourceHistoryFiltersInput>;
  resourceStatus?: InputMaybe<StringFilterInput>;
  restrictedSharing?: InputMaybe<BooleanFilterInput>;
  schools?: InputMaybe<SchoolFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  staff?: InputMaybe<UsersPermissionsUserFiltersInput>;
  subHeader?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<ResourceTypeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ResourceHistory = {
  __typename?: "ResourceHistory";
  /** @deprecated Use root level fields instead */
  attributes: ResourceHistory;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ResourceHistory;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  resource?: Maybe<Resource>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  version: Scalars["String"]["output"];
};

export type ResourceHistoryEntityResponseCollection = {
  __typename?: "ResourceHistoryEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ResourceHistory>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ResourceHistory>;
  pageInfo: Pagination;
};

export type ResourceHistoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ResourceHistoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ResourceHistoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResourceHistoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  resource?: InputMaybe<ResourceFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  version?: InputMaybe<StringFilterInput>;
};

export type ResourceHistoryInput = {
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  resource?: InputMaybe<Scalars["ID"]["input"]>;
  version?: InputMaybe<Scalars["String"]["input"]>;
};

export type ResourceHistoryRelationResponseCollection = {
  __typename?: "ResourceHistoryRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ResourceHistory>;
  nodes: Array<ResourceHistory>;
};

export type ResourceHubPage = {
  __typename?: "ResourceHubPage";
  /** @deprecated Use root level fields instead */
  attributes: ResourceHubPage;
  cardLinkText?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ResourceHubPage;
  description?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["ID"]["output"];
  downloadAllButtonText?: Maybe<Scalars["String"]["output"]>;
  downloadButtonText?: Maybe<Scalars["String"]["output"]>;
  howToUseThisTitle?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  loadMoreText?: Maybe<Scalars["String"]["output"]>;
  noResultsText?: Maybe<Scalars["String"]["output"]>;
  previewButtonText?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  resultsTitle?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ResourceHubPageInput = {
  cardLinkText?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  downloadAllButtonText?: InputMaybe<Scalars["String"]["input"]>;
  downloadButtonText?: InputMaybe<Scalars["String"]["input"]>;
  howToUseThisTitle?: InputMaybe<Scalars["String"]["input"]>;
  loadMoreText?: InputMaybe<Scalars["String"]["input"]>;
  noResultsText?: InputMaybe<Scalars["String"]["input"]>;
  previewButtonText?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  resultsTitle?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ResourceInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<Scalars["ResourceDefaultContentTemplateDynamicZoneInput"]["input"]>
  >;
  briefDescription?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["ID"]["input"]>;
  cover?: InputMaybe<Scalars["ID"]["input"]>;
  expireResourceStatusAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  publicationDate?: InputMaybe<Scalars["Date"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  resourceHistory?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  resourceStatus?: InputMaybe<Enum_Resource_Resourcestatus>;
  restrictedSharing?: InputMaybe<Scalars["Boolean"]["input"]>;
  schools?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  staff?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  subHeader?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ResourceRelationResponseCollection = {
  __typename?: "ResourceRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Resource>;
  nodes: Array<Resource>;
};

export type ResourceType = {
  __typename?: "ResourceType";
  /** @deprecated Use root level fields instead */
  attributes: ResourceType;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ResourceType;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  type: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ResourceTypeEntityResponseCollection = {
  __typename?: "ResourceTypeEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ResourceType>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ResourceType>;
  pageInfo: Pagination;
};

export type ResourceTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ResourceTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ResourceTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResourceTypeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ResourceTypeInput = {
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type ResponseCollectionMeta = {
  __typename?: "ResponseCollectionMeta";
  pagination: Pagination;
};

export type ReviewWorkflowsWorkflow = {
  __typename?: "ReviewWorkflowsWorkflow";
  /** @deprecated Use root level fields instead */
  attributes: ReviewWorkflowsWorkflow;
  contentTypes: Scalars["JSON"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ReviewWorkflowsWorkflow;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: "ReviewWorkflowsWorkflowEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ReviewWorkflowsWorkflow>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  contentTypes?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars["JSON"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  stageRequiredToPublish?: InputMaybe<Scalars["ID"]["input"]>;
  stages?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: "ReviewWorkflowsWorkflowStage";
  /** @deprecated Use root level fields instead */
  attributes: ReviewWorkflowsWorkflowStage;
  color?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ReviewWorkflowsWorkflowStage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: "ReviewWorkflowsWorkflowStageEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ReviewWorkflowsWorkflowStage>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  workflow?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: "ReviewWorkflowsWorkflowStageRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ReviewWorkflowsWorkflowStage>;
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type Scale = {
  __typename?: "Scale";
  /** @deprecated Use root level fields instead */
  attributes: Scale;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Scale;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  options?: Maybe<Array<Maybe<ComponentSurveyAnswers>>>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  questions: Array<Maybe<Question>>;
  questions_connection?: Maybe<QuestionRelationResponseCollection>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ScaleOptionsArgs = {
  filters?: InputMaybe<ComponentSurveyAnswersFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ScaleQuestionsArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ScaleQuestions_ConnectionArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ScaleEntityResponseCollection = {
  __typename?: "ScaleEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Scale>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Scale>;
  pageInfo: Pagination;
};

export type ScaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ScaleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ScaleFiltersInput>;
  options?: InputMaybe<ComponentSurveyAnswersFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ScaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  questions?: InputMaybe<QuestionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ScaleInput = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  options?: InputMaybe<Array<InputMaybe<ComponentSurveyAnswersInput>>>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  questions?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type ScheduledEmail = {
  __typename?: "ScheduledEmail";
  /** @deprecated Use root level fields instead */
  attributes: ScheduledEmail;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: ScheduledEmail;
  documentId: Scalars["ID"]["output"];
  emailStatus?: Maybe<Enum_Scheduledemail_Emailstatus>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  sentDate?: Maybe<Scalars["DateTime"]["output"]>;
  type?: Maybe<Enum_Scheduledemail_Type>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  users?: Maybe<Scalars["JSON"]["output"]>;
};

export type ScheduledEmailEntityResponseCollection = {
  __typename?: "ScheduledEmailEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<ScheduledEmail>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ScheduledEmail>;
  pageInfo: Pagination;
};

export type ScheduledEmailFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ScheduledEmailFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  emailStatus?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ScheduledEmailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ScheduledEmailFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sentDate?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<JsonFilterInput>;
};

export type ScheduledEmailInput = {
  emailStatus?: InputMaybe<Enum_Scheduledemail_Emailstatus>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  sentDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  type?: InputMaybe<Enum_Scheduledemail_Type>;
  users?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type School = {
  __typename?: "School";
  active: Scalars["Boolean"]["output"];
  answers: Array<Maybe<Answer>>;
  answers_connection?: Maybe<AnswerRelationResponseCollection>;
  /** @deprecated Use root level fields instead */
  attributes: School;
  code?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: School;
  documentId: Scalars["ID"]["output"];
  domains?: Maybe<Array<Maybe<ComponentSchollDomains>>>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  imported_users: Array<Maybe<ImportedUser>>;
  imported_users_connection?: Maybe<ImportedUserRelationResponseCollection>;
  invactivationReason?: Maybe<Scalars["String"]["output"]>;
  invited_users: Array<Maybe<InvitedUser>>;
  invited_users_connection?: Maybe<InvitedUserRelationResponseCollection>;
  keyDates: Array<Maybe<KeyDate>>;
  keyDates_connection?: Maybe<KeyDateRelationResponseCollection>;
  location?: Maybe<Scalars["String"]["output"]>;
  logoMAT?: Maybe<UploadFile>;
  name: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  schools: Array<Maybe<School>>;
  schools_connection?: Maybe<SchoolRelationResponseCollection>;
  subscription?: Maybe<Subscription>;
  surveys: Array<Maybe<Survey>>;
  surveys_connection?: Maybe<SurveyRelationResponseCollection>;
  termDates?: Maybe<ComponentSchollTermDates>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  wildcards: Array<Maybe<Wildcard>>;
  wildcards_connection?: Maybe<WildcardRelationResponseCollection>;
  wondeApiToken?: Maybe<Scalars["String"]["output"]>;
  wondeRoles?: Maybe<Array<Maybe<ComponentSchollWondeRoles>>>;
  wondeSchoolId?: Maybe<Scalars["String"]["output"]>;
};

export type SchoolAnswersArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolAnswers_ConnectionArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolDomainsArgs = {
  filters?: InputMaybe<ComponentSchollDomainsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolImported_UsersArgs = {
  filters?: InputMaybe<ImportedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolImported_Users_ConnectionArgs = {
  filters?: InputMaybe<ImportedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolInvited_UsersArgs = {
  filters?: InputMaybe<InvitedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolInvited_Users_ConnectionArgs = {
  filters?: InputMaybe<InvitedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolKeyDatesArgs = {
  filters?: InputMaybe<KeyDateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolKeyDates_ConnectionArgs = {
  filters?: InputMaybe<KeyDateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolSchoolsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolSchools_ConnectionArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolSurveysArgs = {
  filters?: InputMaybe<SurveyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolSurveys_ConnectionArgs = {
  filters?: InputMaybe<SurveyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolWildcardsArgs = {
  filters?: InputMaybe<WildcardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolWildcards_ConnectionArgs = {
  filters?: InputMaybe<WildcardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolWondeRolesArgs = {
  filters?: InputMaybe<ComponentSchollWondeRolesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SchoolEntityResponseCollection = {
  __typename?: "SchoolEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<School>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<School>;
  pageInfo: Pagination;
};

export type SchoolFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SchoolFiltersInput>>>;
  answers?: InputMaybe<AnswerFiltersInput>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  domains?: InputMaybe<ComponentSchollDomainsFiltersInput>;
  imported_users?: InputMaybe<ImportedUserFiltersInput>;
  invactivationReason?: InputMaybe<StringFilterInput>;
  invited_users?: InputMaybe<InvitedUserFiltersInput>;
  keyDates?: InputMaybe<KeyDateFiltersInput>;
  location?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SchoolFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SchoolFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  schools?: InputMaybe<SchoolFiltersInput>;
  subscription?: InputMaybe<SubscriptionFiltersInput>;
  surveys?: InputMaybe<SurveyFiltersInput>;
  termDates?: InputMaybe<ComponentSchollTermDatesFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  wildcards?: InputMaybe<WildcardFiltersInput>;
  wondeApiToken?: InputMaybe<StringFilterInput>;
  wondeRoles?: InputMaybe<ComponentSchollWondeRolesFiltersInput>;
  wondeSchoolId?: InputMaybe<StringFilterInput>;
};

export type SchoolInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  answers?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  code?: InputMaybe<Scalars["String"]["input"]>;
  domains?: InputMaybe<Array<InputMaybe<ComponentSchollDomainsInput>>>;
  imported_users?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  invactivationReason?: InputMaybe<Scalars["String"]["input"]>;
  invited_users?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  keyDates?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  logoMAT?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  schools?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  subscription?: InputMaybe<Scalars["ID"]["input"]>;
  surveys?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  termDates?: InputMaybe<ComponentSchollTermDatesInput>;
  wildcards?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  wondeApiToken?: InputMaybe<Scalars["String"]["input"]>;
  wondeRoles?: InputMaybe<Array<InputMaybe<ComponentSchollWondeRolesInput>>>;
  wondeSchoolId?: InputMaybe<Scalars["String"]["input"]>;
};

export type SchoolMood = {
  __typename?: "SchoolMood";
  data?: Maybe<Array<MoodData>>;
  emotions?: Maybe<Array<EmotionCount>>;
  schoolId?: Maybe<Scalars["String"]["output"]>;
  schoolName?: Maybe<Scalars["String"]["output"]>;
};

export type SchoolRelationResponseCollection = {
  __typename?: "SchoolRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<School>;
  nodes: Array<School>;
};

export type SearchItem = Course | KnowledgeBase | Podcast | Resource;

export type SearchPage = {
  __typename?: "SearchPage";
  /** @deprecated Use root level fields instead */
  attributes: SearchPage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: SearchPage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  noRecordsFoundText: Scalars["String"]["output"];
  placeholder: Scalars["String"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  yourResultsTitle: Scalars["String"]["output"];
};

export type SearchPageInput = {
  noRecordsFoundText?: InputMaybe<Scalars["String"]["input"]>;
  placeholder?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  yourResultsTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type SearchUnifiedConnection = {
  __typename?: "SearchUnifiedConnection";
  nodes?: Maybe<Array<Maybe<SearchItem>>>;
  pageInfo?: Maybe<SearchUnifiedPageInfo>;
};

export type SearchUnifiedPageInfo = {
  __typename?: "SearchUnifiedPageInfo";
  page?: Maybe<Scalars["Int"]["output"]>;
  pageCount?: Maybe<Scalars["Int"]["output"]>;
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type SectionType = {
  __typename?: "SectionType";
  /** @deprecated Use root level fields instead */
  attributes: SectionType;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: SectionType;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  value: Scalars["String"]["output"];
};

export type SectionTypeEntityResponseCollection = {
  __typename?: "SectionTypeEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<SectionType>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<SectionType>;
  pageInfo: Pagination;
};

export type SectionTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SectionTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SectionTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SectionTypeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type SectionTypeInput = {
  label?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type Step1 = {
  __typename?: "Step1";
  /** @deprecated Use root level fields instead */
  attributes: Step1;
  content: ComponentOnBoardingOnBoardingContainer;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Step1;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type Step1Input = {
  content?: InputMaybe<ComponentOnBoardingOnBoardingContainerInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Step2 = {
  __typename?: "Step2";
  /** @deprecated Use root level fields instead */
  attributes: Step2;
  content: ComponentOnBoardingOnBoardingContainer;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Step2;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type Step2Input = {
  content?: InputMaybe<ComponentOnBoardingOnBoardingContainerInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Step3 = {
  __typename?: "Step3";
  /** @deprecated Use root level fields instead */
  attributes: Step3;
  content?: Maybe<ComponentOnBoardingOnBoardingContainer>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Step3;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type Step3Input = {
  content?: InputMaybe<ComponentOnBoardingOnBoardingContainerInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Step4 = {
  __typename?: "Step4";
  ageBracket?: Maybe<ComponentCommonFieldSelect>;
  /** @deprecated Use root level fields instead */
  attributes: Step4;
  content?: Maybe<ComponentOnBoardingOnBoardingContainer>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Step4;
  documentId: Scalars["ID"]["output"];
  gender?: Maybe<ComponentCommonFieldSelect>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  location?: Maybe<ComponentCommonField>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  role?: Maybe<ComponentCommonField>;
  roles?: Maybe<Array<Maybe<ComponentCommonRoles>>>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type Step4RolesArgs = {
  filters?: InputMaybe<ComponentCommonRolesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type Step4Input = {
  ageBracket?: InputMaybe<ComponentCommonFieldSelectInput>;
  content?: InputMaybe<ComponentOnBoardingOnBoardingContainerInput>;
  gender?: InputMaybe<ComponentCommonFieldSelectInput>;
  location?: InputMaybe<ComponentCommonFieldInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  role?: InputMaybe<ComponentCommonFieldInput>;
  roles?: InputMaybe<Array<InputMaybe<ComponentCommonRolesInput>>>;
};

export type Step5 = {
  __typename?: "Step5";
  /** @deprecated Use root level fields instead */
  attributes: Step5;
  content: ComponentOnBoardingOnBoardingContainer;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Step5;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type Step5Input = {
  content?: InputMaybe<ComponentOnBoardingOnBoardingContainerInput>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Streak = {
  __typename?: "Streak";
  currentStreak?: Maybe<Scalars["Int"]["output"]>;
  lastDay?: Maybe<Scalars["Date"]["output"]>;
  maxStreak?: Maybe<Scalars["Int"]["output"]>;
  streak?: Maybe<Scalars["Int"]["output"]>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contains?: InputMaybe<Scalars["String"]["input"]>;
  containsi?: InputMaybe<Scalars["String"]["input"]>;
  endsWith?: InputMaybe<Scalars["String"]["input"]>;
  eq?: InputMaybe<Scalars["String"]["input"]>;
  eqi?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  ne?: InputMaybe<Scalars["String"]["input"]>;
  nei?: InputMaybe<Scalars["String"]["input"]>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars["String"]["input"]>;
  notContainsi?: InputMaybe<Scalars["String"]["input"]>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  notNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  null?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
};

export type Subscription = {
  __typename?: "Subscription";
  /** @deprecated Use root level fields instead */
  attributes: Subscription;
  bookmark: Scalars["Boolean"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Subscription;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  knowledgeBase: Scalars["Boolean"]["output"];
  learn: Scalars["Boolean"]["output"];
  mission: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  podcast: Scalars["Boolean"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  resourceHub: Scalars["Boolean"]["output"];
  search: Scalars["Boolean"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type SubscriptionEntityResponseCollection = {
  __typename?: "SubscriptionEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Subscription>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Subscription>;
  pageInfo: Pagination;
};

export type SubscriptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubscriptionFiltersInput>>>;
  bookmark?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  knowledgeBase?: InputMaybe<BooleanFilterInput>;
  learn?: InputMaybe<BooleanFilterInput>;
  mission?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SubscriptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubscriptionFiltersInput>>>;
  podcast?: InputMaybe<BooleanFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  resourceHub?: InputMaybe<BooleanFilterInput>;
  search?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubscriptionInput = {
  bookmark?: InputMaybe<Scalars["Boolean"]["input"]>;
  knowledgeBase?: InputMaybe<Scalars["Boolean"]["input"]>;
  learn?: InputMaybe<Scalars["Boolean"]["input"]>;
  mission?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  podcast?: InputMaybe<Scalars["Boolean"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  resourceHub?: InputMaybe<Scalars["Boolean"]["input"]>;
  search?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Survey = {
  __typename?: "Survey";
  answers: Array<Maybe<Answer>>;
  answers_connection?: Maybe<AnswerRelationResponseCollection>;
  /** @deprecated Use root level fields instead */
  attributes: Survey;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Survey;
  documentId: Scalars["ID"]["output"];
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  questions: Array<Maybe<Question>>;
  questions_connection?: Maybe<QuestionRelationResponseCollection>;
  schools: Array<Maybe<School>>;
  schools_connection?: Maybe<SchoolRelationResponseCollection>;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type SurveyAnswersArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SurveyAnswers_ConnectionArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SurveyQuestionsArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SurveyQuestions_ConnectionArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SurveySchoolsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SurveySchools_ConnectionArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SurveyAnswer = {
  __typename?: "SurveyAnswer";
  color?: Maybe<Scalars["String"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  percentage?: Maybe<Scalars["Float"]["output"]>;
  value?: Maybe<Scalars["Int"]["output"]>;
};

export type SurveyAnswerEntry = {
  __typename?: "SurveyAnswerEntry";
  answer?: Maybe<SurveyAnswer>;
  key?: Maybe<Scalars["String"]["output"]>;
};

export type SurveyCaption = {
  __typename?: "SurveyCaption";
  color?: Maybe<Scalars["String"]["output"]>;
  key?: Maybe<Scalars["String"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
};

export type SurveyCategory = {
  __typename?: "SurveyCategory";
  answers?: Maybe<Array<Maybe<SurveyAnswerEntry>>>;
  key?: Maybe<Scalars["String"]["output"]>;
  measure?: Maybe<Scalars["String"]["output"]>;
  questions?: Maybe<Scalars["Int"]["output"]>;
  responses?: Maybe<Scalars["Int"]["output"]>;
};

export type SurveyCategoryResponse = {
  __typename?: "SurveyCategoryResponse";
  captions?: Maybe<Array<Maybe<SurveyCaption>>>;
  data?: Maybe<Array<Maybe<SurveyCategory>>>;
  schools?: Maybe<Array<Maybe<SurveySchool>>>;
};

export type SurveyEntity = {
  __typename?: "SurveyEntity";
  attributes?: Maybe<Survey>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type SurveyEntityResponseCollection = {
  __typename?: "SurveyEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Survey>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Survey>;
  pageInfo: Pagination;
};

export type SurveyFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SurveyFiltersInput>>>;
  answers?: InputMaybe<AnswerFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SurveyFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SurveyFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  questions?: InputMaybe<QuestionFiltersInput>;
  schools?: InputMaybe<SchoolFiltersInput>;
  startDate?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SurveyInput = {
  answers?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  questions?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  schools?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type SurveyMethodology = {
  __typename?: "SurveyMethodology";
  a?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: SurveyMethodology;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: SurveyMethodology;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type SurveyMethodologyEntityResponseCollection = {
  __typename?: "SurveyMethodologyEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<SurveyMethodology>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<SurveyMethodology>;
  pageInfo: Pagination;
};

export type SurveyMethodologyFiltersInput = {
  a?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SurveyMethodologyFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<SurveyMethodologyFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SurveyMethodologyFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SurveyMethodologyInput = {
  a?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type SurveyQuestion = {
  __typename?: "SurveyQuestion";
  answers?: Maybe<Array<Maybe<SurveyAnswerEntry>>>;
  date?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  measure?: Maybe<Scalars["String"]["output"]>;
  question?: Maybe<Scalars["String"]["output"]>;
  responses?: Maybe<Scalars["Int"]["output"]>;
  uniqueId?: Maybe<Scalars["String"]["output"]>;
};

export type SurveyQuestionsResponse = {
  __typename?: "SurveyQuestionsResponse";
  captions?: Maybe<Array<Maybe<SurveyCaption>>>;
  data?: Maybe<Array<Maybe<SurveyQuestion>>>;
  schools?: Maybe<Array<Maybe<SurveySchool>>>;
};

export type SurveyRelationResponseCollection = {
  __typename?: "SurveyRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Survey>;
  nodes: Array<Survey>;
};

export type SurveyResult = {
  __typename?: "SurveyResult";
  measures?: Maybe<Array<Maybe<CustomMeasure>>>;
};

export type SurveySchool = {
  __typename?: "SurveySchool";
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type SurveyUser = {
  __typename?: "SurveyUser";
  answerDate?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: SurveyUser;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: SurveyUser;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  question?: Maybe<Question>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  user?: Maybe<UsersPermissionsUser>;
};

export type SurveyUserEntityResponseCollection = {
  __typename?: "SurveyUserEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<SurveyUser>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<SurveyUser>;
  pageInfo: Pagination;
};

export type SurveyUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SurveyUserFiltersInput>>>;
  answerDate?: InputMaybe<DateFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<SurveyUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SurveyUserFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  question?: InputMaybe<QuestionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type SurveyUserInput = {
  answerDate?: InputMaybe<Scalars["Date"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  question?: InputMaybe<Scalars["ID"]["input"]>;
  user?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SurveyUserRelationResponseCollection = {
  __typename?: "SurveyUserRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<SurveyUser>;
  nodes: Array<SurveyUser>;
};

export type SurveysByUserResponse = {
  __typename?: "SurveysByUserResponse";
  endDate?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["String"]["output"]>;
};

export type TermAndCondition = {
  __typename?: "TermAndCondition";
  /** @deprecated Use root level fields instead */
  attributes: TermAndCondition;
  content?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: TermAndCondition;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type TermAndConditionInput = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type TermsAndConditionsPage = {
  __typename?: "TermsAndConditionsPage";
  DefaultContentTemplate: Array<
    Maybe<TermsAndConditionsPageDefaultContentTemplateDynamicZone>
  >;
  /** @deprecated Use root level fields instead */
  attributes: TermsAndConditionsPage;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: TermsAndConditionsPage;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type TermsAndConditionsPageDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type TermsAndConditionsPageInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<
      Scalars["TermsAndConditionsPageDefaultContentTemplateDynamicZoneInput"]["input"]
    >
  >;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type TopicLabel = {
  __typename?: "TopicLabel";
  /** @deprecated Use root level fields instead */
  attributes: TopicLabel;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: TopicLabel;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  value: Scalars["String"]["output"];
};

export type TopicLabelEntityResponseCollection = {
  __typename?: "TopicLabelEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<TopicLabel>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<TopicLabel>;
  pageInfo: Pagination;
};

export type TopicLabelFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TopicLabelFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<TopicLabelFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TopicLabelFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type TopicLabelInput = {
  label?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type Tracking = {
  __typename?: "Tracking";
  action: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  attributes: Tracking;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: Tracking;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  staff?: Maybe<UsersPermissionsUser>;
  timestamp?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  users_permissions_user?: Maybe<UsersPermissionsUser>;
};

export type TrackingEntityResponseCollection = {
  __typename?: "TrackingEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Tracking>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Tracking>;
  pageInfo: Pagination;
};

export type TrackingFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TrackingFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<TrackingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TrackingFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  staff?: InputMaybe<UsersPermissionsUserFiltersInput>;
  timestamp?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users_permissions_user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type TrackingInput = {
  action?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  staff?: InputMaybe<Scalars["ID"]["input"]>;
  timestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  users_permissions_user?: InputMaybe<Scalars["ID"]["input"]>;
};

export type TrackingRelationResponseCollection = {
  __typename?: "TrackingRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Tracking>;
  nodes: Array<Tracking>;
};

export type UploadFile = {
  __typename?: "UploadFile";
  alternativeText?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use root level fields instead */
  attributes: UploadFile;
  caption?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: UploadFile;
  documentId: Scalars["ID"]["output"];
  ext?: Maybe<Scalars["String"]["output"]>;
  formats?: Maybe<Scalars["JSON"]["output"]>;
  hash: Scalars["String"]["output"];
  height?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  mime: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  previewUrl?: Maybe<Scalars["String"]["output"]>;
  provider: Scalars["String"]["output"];
  provider_metadata?: Maybe<Scalars["JSON"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars["Float"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  url: Scalars["String"]["output"];
  width?: Maybe<Scalars["Int"]["output"]>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: "UploadFileEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<UploadFile>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UserTrackingDataResult = {
  __typename?: "UserTrackingDataResult";
  dailyStreak?: Maybe<Scalars["Int"]["output"]>;
  emotionsTracked?: Maybe<Scalars["Int"]["output"]>;
  streakRecord?: Maybe<Scalars["Int"]["output"]>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: "UsersPermissionsCreateRolePayload";
  ok: Scalars["Boolean"]["output"];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: "UsersPermissionsDeleteRolePayload";
  ok: Scalars["Boolean"]["output"];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  provider?: Scalars["String"]["input"];
};

export type UsersPermissionsLoginPayload = {
  __typename?: "UsersPermissionsLoginPayload";
  jwt?: Maybe<Scalars["String"]["output"]>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: "UsersPermissionsMe";
  blocked?: Maybe<Scalars["Boolean"]["output"]>;
  confirmed?: Maybe<Scalars["Boolean"]["output"]>;
  documentId: Scalars["ID"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars["String"]["output"];
};

export type UsersPermissionsMeRole = {
  __typename?: "UsersPermissionsMeRole";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  type?: Maybe<Scalars["String"]["output"]>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: "UsersPermissionsPasswordPayload";
  ok: Scalars["Boolean"]["output"];
};

export type UsersPermissionsPermission = {
  __typename?: "UsersPermissionsPermission";
  action: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  attributes: UsersPermissionsPermission;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: UsersPermissionsPermission;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: "UsersPermissionsPermissionRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<UsersPermissionsPermission>;
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

export type UsersPermissionsRole = {
  __typename?: "UsersPermissionsRole";
  /** @deprecated Use root level fields instead */
  attributes: UsersPermissionsRole;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: UsersPermissionsRole;
  description?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};

export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: "UsersPermissionsRoleEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<UsersPermissionsRole>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  users?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: "UsersPermissionsUpdateRolePayload";
  ok: Scalars["Boolean"]["output"];
};

export type UsersPermissionsUser = {
  __typename?: "UsersPermissionsUser";
  access_control_list?: Maybe<AccessControlList>;
  ageBracket?: Maybe<Scalars["String"]["output"]>;
  answers: Array<Maybe<Answer>>;
  answers_connection?: Maybe<AnswerRelationResponseCollection>;
  /** @deprecated Use root level fields instead */
  attributes: UsersPermissionsUser;
  blocked?: Maybe<Scalars["Boolean"]["output"]>;
  confirmationEmailSent?: Maybe<Scalars["Boolean"]["output"]>;
  confirmed?: Maybe<Scalars["Boolean"]["output"]>;
  course_feedbacks: Array<Maybe<CourseFeedback>>;
  course_feedbacks_connection?: Maybe<CourseFeedbackRelationResponseCollection>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: UsersPermissionsUser;
  documentId: Scalars["ID"]["output"];
  email: Scalars["String"]["output"];
  forename?: Maybe<Scalars["String"]["output"]>;
  gender?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  isLeadershipWheelTrackingDisabled?: Maybe<Scalars["Boolean"]["output"]>;
  lastLoginAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastLoginIp?: Maybe<Scalars["String"]["output"]>;
  lastLoginUserAgent?: Maybe<Scalars["String"]["output"]>;
  location?: Maybe<Scalars["String"]["output"]>;
  onboardCharacterExerciseCompleted: Scalars["Boolean"]["output"];
  onboardHomeCompleted: Scalars["Boolean"]["output"];
  onboardLeadershipWheelCompleted: Scalars["Boolean"]["output"];
  onboardQuestionsCompleted: Scalars["Boolean"]["output"];
  onboardingStartDate?: Maybe<Scalars["Date"]["output"]>;
  photo?: Maybe<UploadFile>;
  previousLoginAt?: Maybe<Scalars["DateTime"]["output"]>;
  previousLoginIp?: Maybe<Scalars["String"]["output"]>;
  previousLoginUserAgent?: Maybe<Scalars["String"]["output"]>;
  profile?: Maybe<Scalars["String"]["output"]>;
  provider?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  registrationDevice?: Maybe<Enum_Userspermissionsuser_Registrationdevice>;
  role?: Maybe<UsersPermissionsRole>;
  school?: Maybe<School>;
  surname?: Maybe<Scalars["String"]["output"]>;
  survey_users: Array<Maybe<SurveyUser>>;
  survey_users_connection?: Maybe<SurveyUserRelationResponseCollection>;
  trackings: Array<Maybe<Tracking>>;
  trackings_connection?: Maybe<TrackingRelationResponseCollection>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  username: Scalars["String"]["output"];
};

export type UsersPermissionsUserAnswersArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsUserAnswers_ConnectionArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsUserCourse_FeedbacksArgs = {
  filters?: InputMaybe<CourseFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsUserCourse_Feedbacks_ConnectionArgs = {
  filters?: InputMaybe<CourseFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsUserSurvey_UsersArgs = {
  filters?: InputMaybe<SurveyUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsUserSurvey_Users_ConnectionArgs = {
  filters?: InputMaybe<SurveyUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsUserTrackingsArgs = {
  filters?: InputMaybe<TrackingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsUserTrackings_ConnectionArgs = {
  filters?: InputMaybe<TrackingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: "UsersPermissionsUserEntityResponse";
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: "UsersPermissionsUserEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<UsersPermissionsUser>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  access_control_list?: InputMaybe<AccessControlListFiltersInput>;
  ageBracket?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  answers?: InputMaybe<AnswerFiltersInput>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationEmailSent?: InputMaybe<BooleanFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  course_feedbacks?: InputMaybe<CourseFeedbackFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  forename?: InputMaybe<StringFilterInput>;
  gender?: InputMaybe<StringFilterInput>;
  isLeadershipWheelTrackingDisabled?: InputMaybe<BooleanFilterInput>;
  location?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  onboardCharacterExerciseCompleted?: InputMaybe<BooleanFilterInput>;
  onboardHomeCompleted?: InputMaybe<BooleanFilterInput>;
  onboardLeadershipWheelCompleted?: InputMaybe<BooleanFilterInput>;
  onboardQuestionsCompleted?: InputMaybe<BooleanFilterInput>;
  onboardingStartDate?: InputMaybe<DateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  profile?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  registrationDevice?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  school?: InputMaybe<SchoolFiltersInput>;
  surname?: InputMaybe<StringFilterInput>;
  survey_users?: InputMaybe<SurveyUserFiltersInput>;
  trackings?: InputMaybe<TrackingFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  access_control_list?: InputMaybe<Scalars["ID"]["input"]>;
  ageBracket?: InputMaybe<Scalars["String"]["input"]>;
  answers?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  blocked?: InputMaybe<Scalars["Boolean"]["input"]>;
  confirmationEmailSent?: InputMaybe<Scalars["Boolean"]["input"]>;
  confirmed?: InputMaybe<Scalars["Boolean"]["input"]>;
  course_feedbacks?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  forename?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<Scalars["String"]["input"]>;
  isLeadershipWheelTrackingDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  onboardCharacterExerciseCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  onboardHomeCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  onboardLeadershipWheelCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  onboardQuestionsCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  onboardingStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  photo?: InputMaybe<Scalars["ID"]["input"]>;
  profile?: InputMaybe<Scalars["String"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  registrationDevice?: InputMaybe<Enum_Userspermissionsuser_Registrationdevice>;
  role?: InputMaybe<Scalars["ID"]["input"]>;
  school?: InputMaybe<Scalars["ID"]["input"]>;
  surname?: InputMaybe<Scalars["String"]["input"]>;
  survey_users?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  trackings?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: "UsersPermissionsUserRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<UsersPermissionsUser>;
  nodes: Array<UsersPermissionsUser>;
};

export type WatermarkSettings = {
  __typename?: "WatermarkSettings";
  /** @deprecated Use root level fields instead */
  attributes: WatermarkSettings;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: WatermarkSettings;
  documentId: Scalars["ID"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  textTemplate?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type WatermarkSettingsInput = {
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  textTemplate?: InputMaybe<Scalars["String"]["input"]>;
};

export type Wildcard = {
  __typename?: "Wildcard";
  /** @deprecated Use root level fields instead */
  attributes: Wildcard;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  cta?: Maybe<ComponentWildcardCta>;
  ctaText: Scalars["String"]["output"];
  /** @deprecated Use root level fields instead */
  data: Wildcard;
  description: Scalars["String"]["output"];
  documentId: Scalars["ID"]["output"];
  endDate: Scalars["Date"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  schools: Array<Maybe<School>>;
  schools_connection?: Maybe<SchoolRelationResponseCollection>;
  startDate: Scalars["Date"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  wildcardStatus: Enum_Wildcard_Wildcardstatus;
};

export type LatestUpdate = {
  __typename?: "LatestUpdate";
  /** @deprecated Use root level fields instead */
  attributes: LatestUpdate;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Use root level fields instead */
  data: LatestUpdate;
  documentId: Scalars["ID"]["output"];
  endDate: Scalars["Date"]["output"];
  /** @deprecated Use `documentId` instead */
  id: Scalars["ID"]["output"];
  latestUpdateStatus: Enum_Latestupdate_Latestupdatestatus;
  link?: Maybe<ComponentCommonLink>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  startDate: Scalars["Date"]["output"];
  text: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum Enum_Latestupdate_Latestupdatestatus {
  Draft = "DRAFT",
  Published = "PUBLISHED",
  Deleted = "DELETED",
}

export type WildcardSchoolsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type WildcardSchools_ConnectionArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type WildcardEntityResponseCollection = {
  __typename?: "WildcardEntityResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Wildcard>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Wildcard>;
  pageInfo: Pagination;
};

export type WildcardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<WildcardFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  cta?: InputMaybe<ComponentWildcardCtaFiltersInput>;
  ctaText?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  not?: InputMaybe<WildcardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<WildcardFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  schools?: InputMaybe<SchoolFiltersInput>;
  startDate?: InputMaybe<DateFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  wildcardStatus?: InputMaybe<StringFilterInput>;
};

export type WildcardInput = {
  cta?: InputMaybe<ComponentWildcardCtaInput>;
  ctaText?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  schools?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  wildcardStatus?: InputMaybe<Enum_Wildcard_Wildcardstatus>;
};

export type WildcardRelationResponseCollection = {
  __typename?: "WildcardRelationResponseCollection";
  /** @deprecated Use `nodes` field instead */
  data: Array<Wildcard>;
  nodes: Array<Wildcard>;
};

type DefaultContentTemplateFragment_ComponentCommonAudio_Fragment = {
  __typename: "ComponentCommonAudio";
};

type DefaultContentTemplateFragment_ComponentCommonAuthor_Fragment = {
  __typename: "ComponentCommonAuthor";
  publicationDate: any;
  author?: {
    __typename?: "Author";
    data: {
      __typename?: "Author";
      attributes: { __typename?: "Author"; name: string; role?: string | null };
    };
  } | null;
};

type DefaultContentTemplateFragment_ComponentCommonAuthorDetailed_Fragment = {
  __typename: "ComponentCommonAuthorDetailed";
};

type DefaultContentTemplateFragment_ComponentCommonBullet_Fragment = {
  __typename: "ComponentCommonBullet";
};

type DefaultContentTemplateFragment_ComponentCommonDivider_Fragment = {
  __typename: "ComponentCommonDivider";
  id: string;
};

type DefaultContentTemplateFragment_ComponentCommonDownloadableContentList_Fragment =
  { __typename: "ComponentCommonDownloadableContentList" };

type DefaultContentTemplateFragment_ComponentCommonEmbedded_Fragment = {
  __typename: "ComponentCommonEmbedded";
  link: string;
  provider: Enum_Componentcommonembedded_Provider;
};

type DefaultContentTemplateFragment_ComponentCommonFaqComponent_Fragment = {
  __typename: "ComponentCommonFaqComponent";
};

type DefaultContentTemplateFragment_ComponentCommonH3_Fragment = {
  __typename: "ComponentCommonH3";
  text: string;
};

type DefaultContentTemplateFragment_ComponentCommonMedia_Fragment = {
  __typename: "ComponentCommonMedia";
  media: {
    __typename?: "UploadFile";
    data: {
      __typename?: "UploadFile";
      attributes: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      };
    };
  };
};

type DefaultContentTemplateFragment_ComponentCommonQuote_Fragment = {
  __typename: "ComponentCommonQuote";
};

type DefaultContentTemplateFragment_ComponentCommonRelatedContent_Fragment = {
  __typename: "ComponentCommonRelatedContent";
};

type DefaultContentTemplateFragment_ComponentCommonTags_Fragment = {
  __typename: "ComponentCommonTags";
};

type DefaultContentTemplateFragment_ComponentCommonTextEditor_Fragment = {
  __typename: "ComponentCommonTextEditor";
  markdownText?: string | null;
};

type DefaultContentTemplateFragment_ComponentCommonTitle_Fragment = {
  __typename: "ComponentCommonTitle";
  title: string;
};

type DefaultContentTemplateFragment_ComponentDefaultContentTemplateTimer_Fragment =
  { __typename: "ComponentDefaultContentTemplateTimer" };

type DefaultContentTemplateFragment_ComponentKnowledgeBaseKnowledgeBaseRelated_Fragment =
  { __typename: "ComponentKnowledgeBaseKnowledgeBaseRelated" };

type DefaultContentTemplateFragment_Error_Fragment = { __typename: "Error" };

export type DefaultContentTemplateFragmentFragment =
  | DefaultContentTemplateFragment_ComponentCommonAudio_Fragment
  | DefaultContentTemplateFragment_ComponentCommonAuthor_Fragment
  | DefaultContentTemplateFragment_ComponentCommonAuthorDetailed_Fragment
  | DefaultContentTemplateFragment_ComponentCommonBullet_Fragment
  | DefaultContentTemplateFragment_ComponentCommonDivider_Fragment
  | DefaultContentTemplateFragment_ComponentCommonDownloadableContentList_Fragment
  | DefaultContentTemplateFragment_ComponentCommonEmbedded_Fragment
  | DefaultContentTemplateFragment_ComponentCommonFaqComponent_Fragment
  | DefaultContentTemplateFragment_ComponentCommonH3_Fragment
  | DefaultContentTemplateFragment_ComponentCommonMedia_Fragment
  | DefaultContentTemplateFragment_ComponentCommonQuote_Fragment
  | DefaultContentTemplateFragment_ComponentCommonRelatedContent_Fragment
  | DefaultContentTemplateFragment_ComponentCommonTags_Fragment
  | DefaultContentTemplateFragment_ComponentCommonTextEditor_Fragment
  | DefaultContentTemplateFragment_ComponentCommonTitle_Fragment
  | DefaultContentTemplateFragment_ComponentDefaultContentTemplateTimer_Fragment
  | DefaultContentTemplateFragment_ComponentKnowledgeBaseKnowledgeBaseRelated_Fragment
  | DefaultContentTemplateFragment_Error_Fragment;

export type ImageFragmentFragment = {
  __typename?: "UploadFile";
  attributes: {
    __typename?: "UploadFile";
    url: string;
    alternativeText?: string | null;
    mime: string;
  };
};

export type KnowledgeBaseBaseFragmentFragment = {
  __typename?: "KnowledgeBase";
  createdAt?: any | null;
  publishedAt?: any | null;
  title: string;
  slug: string;
  duration?: string | null;
  briefDescription: string;
  knowledgeBaseType?: {
    __typename?: "KnowledgeBaseType";
    data: {
      __typename?: "KnowledgeBaseType";
      id: string;
      attributes: { __typename?: "KnowledgeBaseType"; type: string };
    };
  } | null;
  cover: {
    __typename?: "UploadFile";
    data: {
      __typename?: "UploadFile";
      attributes: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      };
    };
  };
  DefaultContentTemplate: Array<
    | { __typename: "ComponentCommonAudio" }
    | { __typename: "ComponentCommonAuthor" }
    | {
        __typename: "ComponentCommonAuthorDetailed";
        authors?: {
          __typename?: "AuthorRelationResponseCollection";
          data: Array<{
            __typename?: "Author";
            attributes: {
              __typename?: "Author";
              name: string;
              role?: string | null;
              bio?: string | null;
              avatar: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  };
                };
              };
            };
          }>;
        } | null;
      }
    | { __typename: "ComponentCommonBullet" }
    | { __typename: "ComponentCommonDivider" }
    | { __typename: "ComponentCommonDownloadableContentList" }
    | { __typename: "ComponentCommonEmbedded" }
    | { __typename: "ComponentCommonFaqComponent" }
    | { __typename: "ComponentCommonH3" }
    | { __typename: "ComponentCommonMedia" }
    | { __typename: "ComponentCommonQuote" }
    | { __typename: "ComponentCommonRelatedContent" }
    | { __typename: "ComponentCommonTags" }
    | { __typename: "ComponentCommonTextEditor" }
    | { __typename: "ComponentCommonTitle" }
    | { __typename: "ComponentDefaultContentTemplateTimer" }
    | { __typename: "ComponentKnowledgeBaseKnowledgeBaseRelated" }
    | { __typename: "Error" }
    | null
  >;
};

export type KnowledgeBaseCategoryFragmentFragment = {
  __typename?: "KnowledgeBaseCategory";
  documentId: string;
  category: string;
  subCategories?: {
    __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
    nodes: Array<{
      __typename?: "KnowledgeBaseCategory";
      documentId: string;
      category: string;
      subCategories?: {
        __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
        nodes: Array<{
          __typename?: "KnowledgeBaseCategory";
          documentId: string;
          category: string;
          subCategories?: {
            __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
            nodes: Array<{
              __typename?: "KnowledgeBaseCategory";
              documentId: string;
              category: string;
            }>;
          } | null;
        }>;
      } | null;
    }>;
  } | null;
};

export type LearnFragmentFragment = {
  __typename?: "Learn";
  completed?: boolean | null;
  completedAt?: any | null;
  users_permissions_user?: {
    __typename?: "UsersPermissionsUser";
    data: { __typename?: "UsersPermissionsUser"; id: string };
  } | null;
  course?: {
    __typename?: "Course";
    data: {
      __typename?: "Course";
      id: string;
      attributes: {
        __typename?: "Course";
        title: string;
        slug?: string | null;
        description: string;
        thumbnail: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        course_category?: {
          __typename?: "CourseCategory";
          data: {
            __typename?: "CourseCategory";
            attributes: {
              __typename?: "CourseCategory";
              name: string;
              description?: string | null;
            };
          };
        } | null;
        modules?: Array<{
          __typename?: "ComponentLearnCourseModule";
          id: string;
          title: string;
          moduleStableId: string;
          lessons?: Array<{
            __typename?: "ComponentLearnCourseLesson";
            id: string;
            title: string;
            lessonStableId: string;
            authors: Array<{
              __typename?: "Author";
              data: {
                __typename?: "Author";
                attributes: { __typename?: "Author"; name: string };
              };
            } | null>;
          } | null> | null;
        } | null> | null;
      };
    };
  } | null;
  learn_items?: {
    __typename?: "LearnItemRelationResponseCollection";
    data: Array<{
      __typename?: "LearnItem";
      attributes: {
        __typename?: "LearnItem";
        idModule: string;
        idLesson: string;
      };
    }>;
  } | null;
};

export type PodcastBaseFragmentFragment = {
  __typename?: "Podcast";
  documentId: string;
  title: string;
  slug: string;
  briefDescription: string;
  publicationDate: any;
  cover: {
    __typename?: "UploadFile";
    url: string;
    alternativeText?: string | null;
    mime: string;
  };
};

export type PodcastDetailFragmentFragment = {
  __typename?: "Podcast";
  documentId: string;
  title: string;
  slug: string;
  briefDescription: string;
  fullDescription?: string | null;
  publicationDate: any;
  createdAt?: any | null;
  publishedAt?: any | null;
  platforms?: Array<{
    __typename?: "ComponentPodcastPodcastPlatformLink";
    url: string;
    platform?: {
      __typename?: "PodcastPlatform";
      name: string;
      icon: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      };
    } | null;
  } | null> | null;
  cover: {
    __typename?: "UploadFile";
    url: string;
    alternativeText?: string | null;
    mime: string;
  };
};

type PodcastDefaultContentTemplateFragment_ComponentCommonAudio_Fragment = {
  __typename: "ComponentCommonAudio";
  transcription?: string | null;
  audio: { __typename?: "UploadFile"; url: string; name: string };
};

type PodcastDefaultContentTemplateFragment_ComponentCommonAuthor_Fragment = {
  __typename: "ComponentCommonAuthor";
};

type PodcastDefaultContentTemplateFragment_ComponentCommonAuthorDetailed_Fragment =
  {
    __typename: "ComponentCommonAuthorDetailed";
    authors?: {
      __typename?: "AuthorRelationResponseCollection";
      nodes: Array<{
        __typename?: "Author";
        name: string;
        role?: string | null;
        bio?: string | null;
        avatar: {
          __typename?: "UploadFile";
          url: string;
          alternativeText?: string | null;
        };
      }>;
    } | null;
  };

type PodcastDefaultContentTemplateFragment_ComponentCommonBullet_Fragment = {
  __typename: "ComponentCommonBullet";
  item: Array<{ __typename?: "ComponentCommonList"; text: string } | null>;
};

type PodcastDefaultContentTemplateFragment_ComponentCommonDivider_Fragment = {
  __typename: "ComponentCommonDivider";
  id: string;
};

type PodcastDefaultContentTemplateFragment_ComponentCommonDownloadableContentList_Fragment =
  {
    __typename: "ComponentCommonDownloadableContentList";
    list?: Array<{
      __typename?: "ComponentCommonDownloadableContent";
      title: string;
      description?: string | null;
      content: { __typename?: "UploadFile"; url: string };
    } | null> | null;
  };

type PodcastDefaultContentTemplateFragment_ComponentCommonEmbedded_Fragment = {
  __typename: "ComponentCommonEmbedded";
  link: string;
  provider: Enum_Componentcommonembedded_Provider;
};

type PodcastDefaultContentTemplateFragment_ComponentCommonFaqComponent_Fragment =
  {
    __typename: "ComponentCommonFaqComponent";
    faq?: Array<{
      __typename?: "ComponentCommonFaq";
      title: string;
      description: string;
    } | null> | null;
  };

type PodcastDefaultContentTemplateFragment_ComponentCommonH3_Fragment = {
  __typename: "ComponentCommonH3";
  text: string;
};

type PodcastDefaultContentTemplateFragment_ComponentCommonMedia_Fragment = {
  __typename: "ComponentCommonMedia";
  media: {
    __typename?: "UploadFile";
    url: string;
    alternativeText?: string | null;
  };
};

type PodcastDefaultContentTemplateFragment_ComponentCommonQuote_Fragment = {
  __typename: "ComponentCommonQuote";
  quote: string;
};

type PodcastDefaultContentTemplateFragment_ComponentCommonRelatedContent_Fragment =
  { __typename: "ComponentCommonRelatedContent"; id: string };

type PodcastDefaultContentTemplateFragment_ComponentCommonTags_Fragment = {
  __typename: "ComponentCommonTags";
  id: string;
};

type PodcastDefaultContentTemplateFragment_ComponentCommonTextEditor_Fragment =
  { __typename: "ComponentCommonTextEditor"; markdownText?: string | null };

type PodcastDefaultContentTemplateFragment_ComponentCommonTitle_Fragment = {
  __typename: "ComponentCommonTitle";
  title: string;
};

type PodcastDefaultContentTemplateFragment_ComponentPodcastPodcastRelated_Fragment =
  {
    __typename: "ComponentPodcastPodcastRelated";
    id: string;
    podcasts?: {
      __typename?: "PodcastRelationResponseCollection";
      nodes: Array<{
        __typename?: "Podcast";
        documentId: string;
        title: string;
        slug: string;
        briefDescription: string;
        publicationDate: any;
        listenings: Array<{
          __typename?: "PodcastListeningTime";
          documentId: string;
          listeningTime: any;
          duration: any;
        } | null>;
        cover: {
          __typename?: "UploadFile";
          url: string;
          alternativeText?: string | null;
          mime: string;
        };
      }>;
    } | null;
  };

type PodcastDefaultContentTemplateFragment_Error_Fragment = {
  __typename: "Error";
};

export type PodcastDefaultContentTemplateFragmentFragment =
  | PodcastDefaultContentTemplateFragment_ComponentCommonAudio_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonAuthor_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonAuthorDetailed_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonBullet_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonDivider_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonDownloadableContentList_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonEmbedded_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonFaqComponent_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonH3_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonMedia_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonQuote_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonRelatedContent_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonTags_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonTextEditor_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentCommonTitle_Fragment
  | PodcastDefaultContentTemplateFragment_ComponentPodcastPodcastRelated_Fragment
  | PodcastDefaultContentTemplateFragment_Error_Fragment;

export type ResourceBaseFragmentFragment = {
  __typename?: "Resource";
  documentId: string;
  createdAt?: any | null;
  publishedAt?: any | null;
  title: string;
  slug: string;
  resourceStatus?: Enum_Resource_Resourcestatus | null;
  expireResourceStatusAt?: any | null;
  publicationDate?: any | null;
  subHeader?: string | null;
  type?: {
    __typename?: "ResourceType";
    data: {
      __typename?: "ResourceType";
      id: string;
      attributes: { __typename?: "ResourceType"; type: string };
    };
  } | null;
  category?: {
    __typename?: "ResourceCategory";
    data: {
      __typename?: "ResourceCategory";
      id: string;
      attributes: { __typename?: "ResourceCategory"; category: string };
    };
  } | null;
  cover?: {
    __typename?: "UploadFile";
    data: {
      __typename?: "UploadFile";
      attributes: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      };
    };
  } | null;
  DefaultContentTemplate?: Array<
    | { __typename: "ComponentCommonAudio" }
    | { __typename: "ComponentCommonAuthor" }
    | {
        __typename: "ComponentCommonAuthorDetailed";
        authors?: {
          __typename?: "AuthorRelationResponseCollection";
          data: Array<{
            __typename?: "Author";
            attributes: {
              __typename?: "Author";
              name: string;
              role?: string | null;
              bio?: string | null;
              avatar: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  };
                };
              };
            };
          }>;
        } | null;
      }
    | { __typename: "ComponentCommonDivider" }
    | { __typename: "ComponentCommonDownloadableContentList" }
    | { __typename: "ComponentCommonEmbedded" }
    | { __typename: "ComponentCommonFaqComponent" }
    | { __typename: "ComponentCommonH3" }
    | { __typename: "ComponentCommonQuote" }
    | { __typename: "ComponentCommonRelatedContent" }
    | { __typename: "ComponentCommonTags" }
    | { __typename: "ComponentCommonTextEditor" }
    | { __typename: "ComponentCommonTitle" }
    | { __typename: "ComponentResourceAssets" }
    | { __typename: "ComponentResourceResourcesRelated" }
    | { __typename: "Error" }
    | null
  > | null;
};

export type ResourceTypeFragmentFragment = {
  __typename?: "ResourceType";
  documentId: string;
  type: string;
};

export type ResourceCategoryFragmentFragment = {
  __typename?: "ResourceCategory";
  documentId: string;
  category: string;
  subCategories: Array<{
    __typename?: "ResourceCategory";
    data: {
      __typename?: "ResourceCategory";
      id: string;
      attributes: { __typename?: "ResourceCategory"; category: string };
    };
  } | null>;
};

export type ResourceAssetFragmentFragment = {
  __typename?: "ResourceAsset";
  documentId: string;
  title: string;
  description?: string | null;
  content: {
    __typename?: "UploadFile";
    data: {
      __typename?: "UploadFile";
      attributes: {
        __typename?: "UploadFile";
        url: string;
        name: string;
        ext?: string | null;
        mime: string;
        size: number;
      };
    };
  };
};

export type SeoFragmentFragment = {
  __typename?: "ComponentSharedSeo";
  metaTitle: string;
  metaDescription: string;
  keywords?: string | null;
  metaRobots?: string | null;
  structuredData?: any | null;
  metaViewport?: string | null;
  canonicalURL?: string | null;
  metaImage?: {
    __typename?: "UploadFile";
    data: {
      __typename?: "UploadFile";
      attributes: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      };
    };
  } | null;
  metaSocial?: Array<{
    __typename?: "ComponentSharedMetaSocial";
    socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork;
    title: string;
    description: string;
    image?: {
      __typename?: "UploadFile";
      data: {
        __typename?: "UploadFile";
        attributes: {
          __typename?: "UploadFile";
          url: string;
          alternativeText?: string | null;
          mime: string;
        };
      };
    } | null;
  } | null> | null;
};

export type CreateLoginTrackerMutationVariables = Exact<{
  input: LoginTrackerInput;
}>;

export type CreateLoginTrackerMutation = {
  __typename?: "Mutation";
  createLoginTracker?: {
    __typename?: "LoginTracker";
    data: {
      __typename?: "LoginTracker";
      attributes: {
        __typename?: "LoginTracker";
        streakCounter?: number | null;
        day?: any | null;
      };
    };
  } | null;
};

export type LoginMutationVariables = Exact<{
  input: UsersPermissionsLoginInput;
}>;

export type LoginMutation = {
  __typename?: "Mutation";
  login: {
    __typename?: "UsersPermissionsLoginPayload";
    jwt?: string | null;
    user: {
      __typename?: "UsersPermissionsMe";
      id: string;
      email?: string | null;
    };
  };
};

export type RegisterMutationVariables = Exact<{
  input: UsersPermissionsRegisterInput;
}>;

export type RegisterMutation = {
  __typename?: "Mutation";
  register: {
    __typename?: "UsersPermissionsLoginPayload";
    user: { __typename?: "UsersPermissionsMe"; id: string };
  };
};

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type ForgotPasswordMutation = {
  __typename?: "Mutation";
  forgotPassword?: {
    __typename?: "UsersPermissionsPasswordPayload";
    ok: boolean;
  } | null;
};

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars["String"]["input"];
  passwordConfirmation: Scalars["String"]["input"];
  code: Scalars["String"]["input"];
}>;

export type ResetPasswordMutation = {
  __typename?: "Mutation";
  resetPassword?: {
    __typename?: "UsersPermissionsLoginPayload";
    jwt?: string | null;
  } | null;
};

export type AddBookmarkMutationVariables = Exact<{
  data: BookmarkInput;
}>;

export type AddBookmarkMutation = {
  __typename?: "Mutation";
  createBookmark?: {
    __typename?: "Bookmark";
    data: {
      __typename?: "Bookmark";
      attributes: { __typename?: "Bookmark"; createdAt?: any | null };
    };
  } | null;
};

export type DeleteBookmarkMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteBookmarkMutation = {
  __typename?: "Mutation";
  deleteBookmark?: { __typename: "DeleteMutationResponse" } | null;
};

export type CompletedTaskMutationVariables = Exact<{
  data: CompletedTaskInput;
}>;

export type CompletedTaskMutation = {
  __typename?: "Mutation";
  createCompletedTask?: {
    __typename?: "CompletedTask";
    data: {
      __typename?: "CompletedTask";
      attributes: { __typename?: "CompletedTask"; createdAt?: any | null };
    };
  } | null;
};

export type CreatePodcastListeningTimeMutationVariables = Exact<{
  input: PodcastListeningTimeInput;
}>;

export type CreatePodcastListeningTimeMutation = {
  __typename?: "Mutation";
  createPodcastListeningTime?: {
    __typename?: "PodcastListeningTime";
    id: string;
    documentId: string;
    listeningTime: any;
    duration: any;
  } | null;
};

export type UpdatePodcastListeningTimeMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: PodcastListeningTimeInput;
}>;

export type UpdatePodcastListeningTimeMutation = {
  __typename?: "Mutation";
  updatePodcastListeningTime?: {
    __typename?: "PodcastListeningTime";
    createdAt?: any | null;
  } | null;
};

export type CompleteLessonMutationVariables = Exact<{
  idLesson: Scalars["String"]["input"];
  idModule: Scalars["String"]["input"];
  idLearn: Scalars["ID"]["input"];
}>;

export type CompleteLessonMutation = {
  __typename?: "Mutation";
  createLearnItem?: {
    __typename?: "LearnItem";
    data: {
      __typename?: "LearnItem";
      id: string;
      attributes: {
        __typename?: "LearnItem";
        learn?: {
          __typename?: "Learn";
          data: {
            __typename?: "Learn";
            attributes: {
              __typename?: "Learn";
              completed?: boolean | null;
              completedAt?: any | null;
              users_permissions_user?: {
                __typename?: "UsersPermissionsUser";
                data: { __typename?: "UsersPermissionsUser"; id: string };
              } | null;
              course?: {
                __typename?: "Course";
                data: {
                  __typename?: "Course";
                  id: string;
                  attributes: {
                    __typename?: "Course";
                    title: string;
                    slug?: string | null;
                    description: string;
                    thumbnail: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                    course_category?: {
                      __typename?: "CourseCategory";
                      data: {
                        __typename?: "CourseCategory";
                        attributes: {
                          __typename?: "CourseCategory";
                          name: string;
                          description?: string | null;
                        };
                      };
                    } | null;
                    modules?: Array<{
                      __typename?: "ComponentLearnCourseModule";
                      id: string;
                      title: string;
                      moduleStableId: string;
                      lessons?: Array<{
                        __typename?: "ComponentLearnCourseLesson";
                        id: string;
                        title: string;
                        lessonStableId: string;
                        authors: Array<{
                          __typename?: "Author";
                          data: {
                            __typename?: "Author";
                            attributes: { __typename?: "Author"; name: string };
                          };
                        } | null>;
                      } | null> | null;
                    } | null> | null;
                  };
                };
              } | null;
              learn_items?: {
                __typename?: "LearnItemRelationResponseCollection";
                data: Array<{
                  __typename?: "LearnItem";
                  attributes: {
                    __typename?: "LearnItem";
                    idModule: string;
                    idLesson: string;
                  };
                }>;
              } | null;
            };
          };
        } | null;
      };
    };
  } | null;
};

export type CreateLearnMutationVariables = Exact<{
  staffId: Scalars["ID"]["input"];
  idCourse: Scalars["ID"]["input"];
}>;

export type CreateLearnMutation = {
  __typename?: "Mutation";
  createLearn?: {
    __typename?: "Learn";
    data: {
      __typename?: "Learn";
      id: string;
      documentId: string;
      attributes: {
        __typename?: "Learn";
        completed?: boolean | null;
        completedAt?: any | null;
        users_permissions_user?: {
          __typename?: "UsersPermissionsUser";
          data: { __typename?: "UsersPermissionsUser"; id: string };
        } | null;
        course?: {
          __typename?: "Course";
          data: {
            __typename?: "Course";
            id: string;
            attributes: {
              __typename?: "Course";
              title: string;
              slug?: string | null;
              description: string;
              thumbnail: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  };
                };
              };
              course_category?: {
                __typename?: "CourseCategory";
                data: {
                  __typename?: "CourseCategory";
                  attributes: {
                    __typename?: "CourseCategory";
                    name: string;
                    description?: string | null;
                  };
                };
              } | null;
              modules?: Array<{
                __typename?: "ComponentLearnCourseModule";
                id: string;
                title: string;
                moduleStableId: string;
                lessons?: Array<{
                  __typename?: "ComponentLearnCourseLesson";
                  id: string;
                  title: string;
                  lessonStableId: string;
                  authors: Array<{
                    __typename?: "Author";
                    data: {
                      __typename?: "Author";
                      attributes: { __typename?: "Author"; name: string };
                    };
                  } | null>;
                } | null> | null;
              } | null> | null;
            };
          };
        } | null;
        learn_items?: {
          __typename?: "LearnItemRelationResponseCollection";
          data: Array<{
            __typename?: "LearnItem";
            attributes: {
              __typename?: "LearnItem";
              idModule: string;
              idLesson: string;
            };
          }>;
        } | null;
      };
    };
  } | null;
};

export type CompleteLearnMutationVariables = Exact<{
  idLearn: Scalars["ID"]["input"];
}>;

export type CompleteLearnMutation = {
  __typename?: "Mutation";
  updateLearn?: {
    __typename?: "Learn";
    data: {
      __typename?: "Learn";
      id: string;
      attributes: {
        __typename?: "Learn";
        completed?: boolean | null;
        completedAt?: any | null;
        users_permissions_user?: {
          __typename?: "UsersPermissionsUser";
          data: { __typename?: "UsersPermissionsUser"; id: string };
        } | null;
        course?: {
          __typename?: "Course";
          data: {
            __typename?: "Course";
            id: string;
            attributes: {
              __typename?: "Course";
              title: string;
              slug?: string | null;
              description: string;
              thumbnail: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  };
                };
              };
              course_category?: {
                __typename?: "CourseCategory";
                data: {
                  __typename?: "CourseCategory";
                  attributes: {
                    __typename?: "CourseCategory";
                    name: string;
                    description?: string | null;
                  };
                };
              } | null;
              modules?: Array<{
                __typename?: "ComponentLearnCourseModule";
                id: string;
                title: string;
                moduleStableId: string;
                lessons?: Array<{
                  __typename?: "ComponentLearnCourseLesson";
                  id: string;
                  title: string;
                  lessonStableId: string;
                  authors: Array<{
                    __typename?: "Author";
                    data: {
                      __typename?: "Author";
                      attributes: { __typename?: "Author"; name: string };
                    };
                  } | null>;
                } | null> | null;
              } | null> | null;
            };
          };
        } | null;
        learn_items?: {
          __typename?: "LearnItemRelationResponseCollection";
          data: Array<{
            __typename?: "LearnItem";
            attributes: {
              __typename?: "LearnItem";
              idModule: string;
              idLesson: string;
            };
          }>;
        } | null;
      };
    };
  } | null;
};

export type CreateCourseFeedbackMutationVariables = Exact<{
  data: CourseFeedbackInput;
}>;

export type CreateCourseFeedbackMutation = {
  __typename?: "Mutation";
  createCourseFeedback?: {
    __typename?: "CourseFeedback";
    data: { __typename?: "CourseFeedback"; id: string };
  } | null;
};

export type MarkNotificationClickedMutationVariables = Exact<{
  documentId: Scalars["ID"]["input"];
  data: NotificationUserInput;
}>;

export type MarkNotificationClickedMutation = {
  __typename?: "Mutation";
  updateNotificationUser?: {
    __typename?: "NotificationUser";
    documentId: string;
    clickedAt?: any | null;
    seenAt?: any | null;
    deliveredAt?: any | null;
  } | null;
};

export type MarkNotificationSeenMutationVariables = Exact<{
  documentId: Scalars["ID"]["input"];
  data: NotificationUserInput;
}>;

export type MarkNotificationSeenMutation = {
  __typename?: "Mutation";
  updateNotificationUser?: {
    __typename?: "NotificationUser";
    documentId: string;
    clickedAt?: any | null;
    seenAt?: any | null;
    deliveredAt?: any | null;
  } | null;
};

export type CreateNotificationUserMutationVariables = Exact<{
  data: NotificationUserInput;
}>;

export type CreateNotificationUserMutation = {
  __typename?: "Mutation";
  createNotificationUser?: {
    __typename?: "NotificationUser";
    documentId: string;
    deliveredAt?: any | null;
    clickedAt?: any | null;
    seenAt?: any | null;
    notification?: { __typename?: "Notification"; documentId: string } | null;
    user?: { __typename?: "UsersPermissionsUser"; documentId: string } | null;
  } | null;
};

export type UpdateUsersPermissionsUserMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UsersPermissionsUserInput;
}>;

export type UpdateUsersPermissionsUserMutation = {
  __typename?: "Mutation";
  updateUsersPermissionsUser: {
    __typename?: "UsersPermissionsUserEntityResponse";
    data?: {
      __typename?: "UsersPermissionsUser";
      attributes: {
        __typename?: "UsersPermissionsUser";
        updatedAt?: any | null;
      };
    } | null;
  };
};

export type UpdateUserOnboardingWeeklyQuestionsMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UsersPermissionsUserInput;
}>;

export type UpdateUserOnboardingWeeklyQuestionsMutation = {
  __typename?: "Mutation";
  updateUsersPermissionsUser: {
    __typename?: "UsersPermissionsUserEntityResponse";
    data?: {
      __typename?: "UsersPermissionsUser";
      attributes: {
        __typename?: "UsersPermissionsUser";
        username: string;
        onboardQuestionsCompleted: boolean;
      };
    } | null;
  };
};

export type UpdateStaffOnboardLeadershipWheelMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UsersPermissionsUserInput;
}>;

export type UpdateStaffOnboardLeadershipWheelMutation = {
  __typename?: "Mutation";
  updateUsersPermissionsUser: {
    __typename?: "UsersPermissionsUserEntityResponse";
    data?: {
      __typename?: "UsersPermissionsUser";
      attributes: {
        __typename?: "UsersPermissionsUser";
        username: string;
        onboardLeadershipWheelCompleted: boolean;
      };
    } | null;
  };
};

export type UpdateUserSwipeHintMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UsersPermissionsUserInput;
}>;

export type UpdateUserSwipeHintMutation = {
  __typename?: "Mutation";
  updateUsersPermissionsUser: {
    __typename?: "UsersPermissionsUserEntityResponse";
    data?: {
      __typename?: "UsersPermissionsUser";
      attributes: { __typename?: "UsersPermissionsUser"; username: string };
    } | null;
  };
};

export type UpdateUserOnboardingQuestionsMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UsersPermissionsUserInput;
}>;

export type UpdateUserOnboardingQuestionsMutation = {
  __typename?: "Mutation";
  updateUsersPermissionsUser: {
    __typename?: "UsersPermissionsUserEntityResponse";
    data?: {
      __typename?: "UsersPermissionsUser";
      attributes: {
        __typename?: "UsersPermissionsUser";
        username: string;
        onboardQuestionsCompleted: boolean;
      };
    } | null;
  };
};

export type UpdateUserOnboardingMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UsersPermissionsUserInput;
}>;

export type UpdateUserOnboardingMutation = {
  __typename?: "Mutation";
  updateUsersPermissionsUser: {
    __typename?: "UsersPermissionsUserEntityResponse";
    data?: {
      __typename?: "UsersPermissionsUser";
      attributes: {
        __typename?: "UsersPermissionsUser";
        username: string;
        onboardHomeCompleted: boolean;
      };
    } | null;
  };
};

export type UpdateStaffProfileMutationVariables = Exact<{
  staffId: Scalars["ID"]["input"];
  profile?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  ageBracket?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateStaffProfileMutation = {
  __typename?: "Mutation";
  updateUsersPermissionsUser: {
    __typename?: "UsersPermissionsUserEntityResponse";
    data?: {
      __typename?: "UsersPermissionsUser";
      attributes: {
        __typename?: "UsersPermissionsUser";
        updatedAt?: any | null;
      };
    } | null;
  };
};

export type CreateResourceAssetDownloadHistoryMutationVariables = Exact<{
  data: ResourceAssetDownloadHistoryInput;
}>;

export type CreateResourceAssetDownloadHistoryMutation = {
  __typename?: "Mutation";
  createResourceAssetDownloadHistory?: {
    __typename?: "ResourceAssetDownloadHistory";
    documentId: string;
    downloadedAt: any;
    version?: number | null;
  } | null;
};

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  passwordConfirmation: Scalars["String"]["input"];
}>;

export type ChangePasswordMutation = {
  __typename?: "Mutation";
  changePassword?: { __typename: "UsersPermissionsLoginPayload" } | null;
};

export type UpdateUserMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  data: UsersPermissionsUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: "Mutation";
  updateUsersPermissionsUser: {
    __typename?: "UsersPermissionsUserEntityResponse";
    data?: {
      __typename?: "UsersPermissionsUser";
      updatedAt?: any | null;
    } | null;
  };
};

export type AboutPageQueryVariables = Exact<{ [key: string]: never }>;

export type AboutPageQuery = {
  __typename?: "Query";
  aboutPage?: {
    __typename?: "AboutPage";
    data: {
      __typename?: "AboutPage";
      id: string;
      attributes: {
        __typename?: "AboutPage";
        pageTitle: string;
        DefaultContentTemplate: Array<
          | {
              __typename: "ComponentCommonAuthor";
              publicationDate: any;
              author?: {
                __typename?: "Author";
                data: {
                  __typename?: "Author";
                  attributes: { __typename?: "Author"; name: string };
                };
              } | null;
            }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | {
              __typename: "ComponentCommonBullet";
              item: Array<{
                __typename?: "ComponentCommonList";
                text: string;
              } | null>;
            }
          | { __typename: "ComponentCommonDivider"; id: string }
          | {
              __typename: "ComponentCommonDownloadableContentList";
              list?: Array<{
                __typename?: "ComponentCommonDownloadableContent";
                id: string;
                title: string;
                description?: string | null;
                content: {
                  __typename?: "UploadFile";
                  data: {
                    __typename?: "UploadFile";
                    attributes: { __typename?: "UploadFile"; url: string };
                  };
                };
              } | null> | null;
            }
          | {
              __typename: "ComponentCommonEmbedded";
              link: string;
              provider: Enum_Componentcommonembedded_Provider;
            }
          | {
              __typename: "ComponentCommonFaqComponent";
              faq?: Array<{
                __typename?: "ComponentCommonFaq";
                title: string;
                description: string;
              } | null> | null;
            }
          | { __typename: "ComponentCommonH3"; text: string }
          | {
              __typename: "ComponentCommonMedia";
              media: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                  };
                };
              };
            }
          | { __typename: "ComponentCommonQuote"; quote: string }
          | {
              __typename: "ComponentCommonTextEditor";
              markdownText?: string | null;
            }
          | { __typename: "ComponentCommonTitle"; title: string }
          | { __typename: "Error" }
          | null
        >;
      };
    };
  } | null;
};

export type FetchAdminPageQueryVariables = Exact<{ [key: string]: never }>;

export type FetchAdminPageQuery = {
  __typename?: "Query";
  adminPage?: {
    __typename?: "AdminPage";
    adminTabs?: {
      __typename?: "ComponentReportingToolsAdminTabs";
      manageStaff?: string | null;
      reportingTools?: string | null;
    } | null;
  } | null;
};

export type FetchKnowledgeBasesByIdsQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars["ID"]["input"]>>
    | InputMaybe<Scalars["ID"]["input"]>
  >;
}>;

export type FetchKnowledgeBasesByIdsQuery = {
  __typename?: "Query";
  knowledgebases?: {
    __typename?: "KnowledgeBaseEntityResponseCollection";
    data: Array<{
      __typename?: "KnowledgeBase";
      id: string;
      documentId: string;
      attributes: {
        __typename?: "KnowledgeBase";
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        knowledgeBaseType?: {
          __typename?: "KnowledgeBaseType";
          data: {
            __typename?: "KnowledgeBaseType";
            id: string;
            attributes: { __typename?: "KnowledgeBaseType"; type: string };
          };
        } | null;
        cover: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        DefaultContentTemplate: Array<
          | { __typename: "ComponentCommonAudio" }
          | { __typename: "ComponentCommonAuthor" }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | { __typename: "ComponentCommonBullet" }
          | { __typename: "ComponentCommonDivider" }
          | { __typename: "ComponentCommonDownloadableContentList" }
          | { __typename: "ComponentCommonEmbedded" }
          | { __typename: "ComponentCommonFaqComponent" }
          | { __typename: "ComponentCommonH3" }
          | { __typename: "ComponentCommonMedia" }
          | { __typename: "ComponentCommonQuote" }
          | { __typename: "ComponentCommonRelatedContent" }
          | { __typename: "ComponentCommonTags" }
          | { __typename: "ComponentCommonTextEditor" }
          | { __typename: "ComponentCommonTitle" }
          | { __typename: "ComponentDefaultContentTemplateTimer" }
          | { __typename: "ComponentKnowledgeBaseKnowledgeBaseRelated" }
          | { __typename: "Error" }
          | null
        >;
      };
    }>;
  } | null;
};

export type BookmarksPageableByUserIdQueryVariables = Exact<{
  staffId: Scalars["ID"]["input"];
  size: Scalars["Int"]["input"];
}>;

export type BookmarksPageableByUserIdQuery = {
  __typename?: "Query";
  bookmarks?: {
    __typename?: "BookmarkEntityResponseCollection";
    data: Array<{
      __typename?: "Bookmark";
      attributes: {
        __typename?: "Bookmark";
        relationId?: string | null;
        metadata?: any | null;
      };
    }>;
    meta: {
      __typename?: "ResponseCollectionMeta";
      pagination: { __typename?: "Pagination"; total: number };
    };
  } | null;
};

export type AllBookmarksPageableByUserIdQueryVariables = Exact<{
  filters?: InputMaybe<BookmarkFiltersInput>;
  size: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AllBookmarksPageableByUserIdQuery = {
  __typename?: "Query";
  bookmarks?: {
    __typename?: "BookmarkEntityResponseCollection";
    data: Array<{
      __typename?: "Bookmark";
      documentId: string;
      attributes: {
        __typename?: "Bookmark";
        relationId?: string | null;
        metadata?: any | null;
        category?: Enum_Bookmark_Category | null;
        knowledgeBaseType?: {
          __typename?: "KnowledgeBaseType";
          data: {
            __typename?: "KnowledgeBaseType";
            attributes: { __typename?: "KnowledgeBaseType"; type: string };
          };
        } | null;
      };
    }>;
    meta: {
      __typename?: "ResponseCollectionMeta";
      pagination: {
        __typename?: "Pagination";
        total: number;
        page: number;
        pageCount: number;
      };
    };
  } | null;
};

export type ExistByRelationIdQueryVariables = Exact<{
  relationId: Scalars["String"]["input"];
  staffId: Scalars["ID"]["input"];
}>;

export type ExistByRelationIdQuery = {
  __typename?: "Query";
  bookmarks?: {
    __typename?: "BookmarkEntityResponseCollection";
    data: Array<{
      __typename?: "Bookmark";
      attributes: { __typename?: "Bookmark"; createdAt?: any | null };
    }>;
  } | null;
};

export type FindByRelationIdQueryVariables = Exact<{
  relationId: Scalars["String"]["input"];
  staffId: Scalars["ID"]["input"];
}>;

export type FindByRelationIdQuery = {
  __typename?: "Query";
  bookmarks?: {
    __typename?: "BookmarkEntityResponseCollection";
    data: Array<{ __typename?: "Bookmark"; id: string; documentId: string }>;
  } | null;
};

export type BookmarkPageQueryVariables = Exact<{ [key: string]: never }>;

export type BookmarkPageQuery = {
  __typename?: "Query";
  bookmarkPage?: {
    __typename?: "BookmarkPage";
    pageTitle?: string | null;
    description?: string | null;
    openButtonTxt?: string | null;
    searchPlaceholder?: string | null;
    loadingText?: string | null;
    emptyStateText?: string | null;
    removeFromBookmarksText?: string | null;
    goToResourceText?: string | null;
    tabKnowledgeBase?: string | null;
    tabPodcast?: string | null;
    tabLearn?: string | null;
    tabResource?: string | null;
    sections?: Array<{
      __typename?: "ComponentBookmarkSections";
      key: string;
      value: string;
    } | null> | null;
  } | null;
};

export type FetchMyBookmarksQueryVariables = Exact<{
  category?: InputMaybe<BookmarkCategory>;
  knowledgeBaseType?: InputMaybe<Scalars["String"]["input"]>;
  relationId?: InputMaybe<Scalars["String"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type FetchMyBookmarksQuery = {
  __typename?: "Query";
  fetchMyBookmarks?: {
    __typename?: "FetchMyBookmarksResponse";
    types?: Array<string | null> | null;
    results?: Array<{
      __typename?: "Bookmark";
      relationId?: string | null;
      metadata?: any | null;
      category?: Enum_Bookmark_Category | null;
      knowledgeBaseType?: {
        __typename?: "KnowledgeBaseType";
        type: string;
      } | null;
    } | null> | null;
    pagination?: {
      __typename?: "FetchMyBookmarksPagination";
      page?: number | null;
      pageSize?: number | null;
      pageCount?: number | null;
      total?: number | null;
    } | null;
  } | null;
};

export type CharacterAwarenessDaysCalendarPageQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CharacterAwarenessDaysCalendarPageQuery = {
  __typename?: "Query";
  calendarPage?: {
    __typename?: "CalendarPage";
    data: {
      __typename?: "CalendarPage";
      documentId: string;
      title: string;
      description?: string | null;
      downloadButtonText?: string | null;
      NoDaysMonthText?: string | null;
      monthThemesTitle?: string | null;
      file?: { __typename?: "UploadFile"; url: string } | null;
      calendarFeedbackMessage?: {
        __typename?: "ComponentCalendarCalendarFeedbackMessage";
        calendarPermissionDenied?: string | null;
        calendarNotFound?: string | null;
        eventAlreadyExists?: string | null;
        eventAddedSuccessGoogle?: string | null;
        eventAddedSuccessApple?: string | null;
        eventAddedSuccessGeneric?: string | null;
      } | null;
    };
  } | null;
};

export type CalendarByYearQueryVariables = Exact<{
  year: Scalars["Int"]["input"];
}>;

export type CalendarByYearQuery = {
  __typename?: "Query";
  calendars?: {
    __typename?: "CalendarEntityResponseCollection";
    data: Array<{
      __typename?: "Calendar";
      attributes: {
        __typename?: "Calendar";
        year?: number | null;
        eventDays?: Array<{
          __typename?: "ComponentCommonDays";
          startDate: any;
          name: string;
          wholeMonth?: boolean | null;
          description?: string | null;
          endDate?: any | null;
          related_knowledge_base?: {
            __typename?: "KnowledgeBase";
            data: {
              __typename?: "KnowledgeBase";
              attributes: { __typename?: "KnowledgeBase"; slug: string };
            };
          } | null;
        } | null> | null;
      };
    }>;
  } | null;
};

export type CharacterAwarenessDaysCalendarPageV5QueryVariables = Exact<{
  [key: string]: never;
}>;

export type CharacterAwarenessDaysCalendarPageV5Query = {
  __typename?: "Query";
  calendarPage?: {
    __typename?: "CalendarPage";
    documentId: string;
    title: string;
    description?: string | null;
    downloadButtonText?: string | null;
    NoDaysMonthText?: string | null;
    monthThemesTitle?: string | null;
    file?: { __typename?: "UploadFile"; url: string } | null;
    calendarFeedbackMessage?: {
      __typename?: "ComponentCalendarCalendarFeedbackMessage";
      calendarPermissionDenied?: string | null;
      calendarNotFound?: string | null;
      eventAlreadyExists?: string | null;
      eventAddedSuccessGoogle?: string | null;
      eventAddedSuccessApple?: string | null;
      eventAddedSuccessGeneric?: string | null;
    } | null;
  } | null;
};

export type CalendarByYearV5QueryVariables = Exact<{
  year: Scalars["Int"]["input"];
}>;

export type CalendarByYearV5Query = {
  __typename?: "Query";
  calendars?: {
    __typename?: "CalendarEntityResponseCollection";
    nodes: Array<{
      __typename?: "Calendar";
      year?: number | null;
      eventDays?: Array<{
        __typename?: "ComponentCommonDays";
        startDate: any;
        name: string;
        wholeMonth?: boolean | null;
        description?: string | null;
        endDate?: any | null;
        related_knowledge_base?: {
          __typename?: "KnowledgeBase";
          slug: string;
        } | null;
      } | null> | null;
    }>;
  } | null;
};

export type CookiesPageQueryVariables = Exact<{ [key: string]: never }>;

export type CookiesPageQuery = {
  __typename?: "Query";
  cookiesPage?: {
    __typename?: "CookiesPage";
    data: {
      __typename?: "CookiesPage";
      id: string;
      attributes: {
        __typename?: "CookiesPage";
        title: string;
        DefaultContentTemplate: Array<
          | {
              __typename: "ComponentCommonAuthor";
              publicationDate: any;
              author?: {
                __typename?: "Author";
                data: {
                  __typename?: "Author";
                  attributes: { __typename?: "Author"; name: string };
                };
              } | null;
            }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | {
              __typename: "ComponentCommonBullet";
              item: Array<{
                __typename?: "ComponentCommonList";
                text: string;
              } | null>;
            }
          | { __typename: "ComponentCommonDivider"; id: string }
          | {
              __typename: "ComponentCommonDownloadableContentList";
              list?: Array<{
                __typename?: "ComponentCommonDownloadableContent";
                id: string;
                title: string;
                description?: string | null;
                content: {
                  __typename?: "UploadFile";
                  data: {
                    __typename?: "UploadFile";
                    attributes: { __typename?: "UploadFile"; url: string };
                  };
                };
              } | null> | null;
            }
          | {
              __typename: "ComponentCommonEmbedded";
              link: string;
              provider: Enum_Componentcommonembedded_Provider;
            }
          | {
              __typename: "ComponentCommonFaqComponent";
              faq?: Array<{
                __typename?: "ComponentCommonFaq";
                title: string;
                description: string;
              } | null> | null;
            }
          | { __typename: "ComponentCommonH3"; text: string }
          | {
              __typename: "ComponentCommonMedia";
              media: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                  };
                };
              };
            }
          | { __typename: "ComponentCommonQuote"; quote: string }
          | {
              __typename: "ComponentCommonTextEditor";
              markdownText?: string | null;
            }
          | { __typename: "ComponentCommonTitle"; title: string }
          | { __typename: "Error" }
          | null
        >;
      };
    };
  } | null;
};

export type CopyrightPageQueryVariables = Exact<{ [key: string]: never }>;

export type CopyrightPageQuery = {
  __typename?: "Query";
  copyrightPage?: {
    __typename?: "CopyrightPage";
    data: {
      __typename?: "CopyrightPage";
      id: string;
      attributes: {
        __typename?: "CopyrightPage";
        title: string;
        DefaultContentTemplate: Array<
          | {
              __typename: "ComponentCommonAuthor";
              publicationDate: any;
              author?: {
                __typename?: "Author";
                data: {
                  __typename?: "Author";
                  attributes: { __typename?: "Author"; name: string };
                };
              } | null;
            }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | {
              __typename: "ComponentCommonBullet";
              item: Array<{
                __typename?: "ComponentCommonList";
                text: string;
              } | null>;
            }
          | { __typename: "ComponentCommonDivider"; id: string }
          | {
              __typename: "ComponentCommonDownloadableContentList";
              list?: Array<{
                __typename?: "ComponentCommonDownloadableContent";
                id: string;
                title: string;
                description?: string | null;
                content: {
                  __typename?: "UploadFile";
                  data: {
                    __typename?: "UploadFile";
                    attributes: { __typename?: "UploadFile"; url: string };
                  };
                };
              } | null> | null;
            }
          | {
              __typename: "ComponentCommonEmbedded";
              link: string;
              provider: Enum_Componentcommonembedded_Provider;
            }
          | {
              __typename: "ComponentCommonFaqComponent";
              faq?: Array<{
                __typename?: "ComponentCommonFaq";
                title: string;
                description: string;
              } | null> | null;
            }
          | { __typename: "ComponentCommonH3"; text: string }
          | {
              __typename: "ComponentCommonMedia";
              media: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                  };
                };
              };
            }
          | { __typename: "ComponentCommonQuote"; quote: string }
          | {
              __typename: "ComponentCommonTextEditor";
              markdownText?: string | null;
            }
          | { __typename: "ComponentCommonTitle"; title: string }
          | { __typename: "Error" }
          | null
        >;
      };
    };
  } | null;
};

export type QueryFooterQueryVariables = Exact<{ [key: string]: never }>;

export type QueryFooterQuery = {
  __typename?: "Query";
  globalFooter?: {
    __typename?: "GlobalFooter";
    copyright?: string | null;
    phone?: string | null;
    email?: string | null;
    linkedinUrl?: string | null;
    links?: Array<{
      __typename?: "ComponentCommonLink";
      text: string;
      url?: string | null;
      file?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      } | null;
    } | null> | null;
    edwinPeoplelogo: {
      __typename?: "UploadFile";
      url: string;
      alternativeText?: string | null;
    };
    partOfLogo?: { __typename?: "UploadFile"; url: string } | null;
    bestPlacesToWorkLogo?: { __typename?: "UploadFile"; url: string } | null;
  } | null;
};

export type QueryMenuQueryVariables = Exact<{ [key: string]: never }>;

export type QueryMenuQuery = {
  __typename?: "Query";
  globalMenu?: {
    __typename?: "GlobalMenu";
    data: {
      __typename?: "GlobalMenu";
      attributes: {
        __typename?: "GlobalMenu";
        logo: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        mobileLogo: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        links?: Array<{
          __typename?: "ComponentCommonLink";
          text: string;
          url?: string | null;
        } | null> | null;
      };
    };
  } | null;
};

export type NotFoundPageQueryVariables = Exact<{ [key: string]: never }>;

export type NotFoundPageQuery = {
  __typename?: "Query";
  notFoundPage?: {
    __typename?: "NotFoundPage";
    data: {
      __typename?: "NotFoundPage";
      attributes: {
        __typename?: "NotFoundPage";
        title: string;
        description: string;
        cta: string;
        image: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
      };
    };
  } | null;
};

export type QueryTermsAndConditionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type QueryTermsAndConditionsQuery = {
  __typename?: "Query";
  termAndCondition?: {
    __typename?: "TermAndCondition";
    data: {
      __typename?: "TermAndCondition";
      attributes: {
        __typename?: "TermAndCondition";
        title: string;
        content?: string | null;
      };
    };
  } | null;
};

export type FetchLatestKnowledgeBaseForHomeQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchLatestKnowledgeBaseForHomeQuery = {
  __typename?: "Query";
  knowledgeBases?: {
    __typename?: "KnowledgeBaseEntityResponseCollection";
    nodes: Array<{
      __typename?: "KnowledgeBase";
      documentId: string;
      title: string;
      slug: string;
      briefDescription: string;
      publicationDate: any;
      knowledgeBaseType?: {
        __typename?: "KnowledgeBaseType";
        documentId: string;
        type: string;
      } | null;
      cover: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      };
    }>;
  } | null;
};

export type FetchLatestPodcastForHomeQueryVariables = Exact<{
  userDocumentId: Scalars["ID"]["input"];
}>;

export type FetchLatestPodcastForHomeQuery = {
  __typename?: "Query";
  podcasts?: {
    __typename?: "PodcastEntityResponseCollection";
    nodes: Array<{
      __typename?: "Podcast";
      documentId: string;
      title: string;
      slug: string;
      briefDescription: string;
      publicationDate: any;
      listenings: Array<{
        __typename?: "PodcastListeningTime";
        documentId: string;
        listeningTime: any;
        duration: any;
      } | null>;
      cover: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      };
    }>;
  } | null;
};

export type DailyTaskHasBeenCompletedQueryVariables = Exact<{
  day: Scalars["Date"]["input"];
  type: Scalars["String"]["input"];
  relationID: Scalars["Int"]["input"];
  staffId: Scalars["ID"]["input"];
}>;

export type DailyTaskHasBeenCompletedQuery = {
  __typename?: "Query";
  completedTasks?: {
    __typename?: "CompletedTaskEntityResponseCollection";
    data: Array<{
      __typename?: "CompletedTask";
      attributes: { __typename?: "CompletedTask"; metadata: any };
    }>;
  } | null;
};

export type DailyTrackingLeadershipWheelQueryVariables = Exact<{
  startDay: Scalars["Date"]["input"];
  endDay: Scalars["Date"]["input"];
}>;

export type DailyTrackingLeadershipWheelQuery = {
  __typename?: "Query";
  leadershipWheelTracker?: Array<{
    __typename?: "LeadershipWheelTrackerResult";
    focusArea?: string | null;
    day?: string | null;
    isDisabledTracking?: boolean | null;
  } | null> | null;
};

export type GetUserTrackingDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserTrackingDataQuery = {
  __typename?: "Query";
  getUserTrackingData?: {
    __typename?: "UserTrackingDataResult";
    dailyStreak?: number | null;
    streakRecord?: number | null;
    emotionsTracked?: number | null;
  } | null;
};

export type FetchUserStreakQueryVariables = Exact<{
  type: Scalars["String"]["input"];
}>;

export type FetchUserStreakQuery = {
  __typename?: "Query";
  fetchUserStreak?: {
    __typename?: "Streak";
    total?: number | null;
    streak?: number | null;
  } | null;
};

export type HomeFinishedQueryVariables = Exact<{ [key: string]: never }>;

export type HomeFinishedQuery = {
  __typename?: "Query";
  homeFinishedPage?: {
    __typename?: "HomeFinishedPage";
    data: {
      __typename?: "HomeFinishedPage";
      attributes: {
        __typename?: "HomeFinishedPage";
        continueYourWeelbeingJourneyTitle: string;
        knowledgeBasesTitle: string;
        knowledgeBasesDescription: string;
        toolkitsTitle: string;
        toolkitsDescription: string;
        messageSection: {
          __typename?: "ComponentCommonMessageSection";
          youAreDoneTitle: string;
          comeBackTitle: string;
        };
      };
    };
  } | null;
};

export type HomePageQueryVariables = Exact<{ [key: string]: never }>;

export type HomePageQuery = {
  __typename?: "Query";
  homePage?: {
    __typename?: "HomePage";
    headerSection: {
      __typename?: "ComponentHomeHeaderSection";
      helloLabel: string;
      description: string;
      icon?: { __typename?: "UploadFile"; url: string } | null;
    };
    resourceSection?: {
      __typename?: "ComponentHomeResourceSection";
      title?: string | null;
      description?: string | null;
      viewAllResourcesLabel?: string | null;
      categories?: {
        __typename?: "ResourceCategoryRelationResponseCollection";
        nodes: Array<{
          __typename?: "ResourceCategory";
          documentId: string;
          category: string;
          color?: string | null;
          icon?: { __typename?: "UploadFile"; url: string } | null;
          subCategories: Array<{
            __typename?: "ResourceCategory";
            documentId: string;
            category: string;
            color?: string | null;
          } | null>;
          rootCategory?: {
            __typename?: "ResourceCategory";
            documentId: string;
            category: string;
          } | null;
        }>;
      } | null;
    } | null;
    keyDatesSection?: {
      __typename?: "ComponentHomeKeyDatesSection";
      title?: string | null;
      description?: string | null;
      viewAllKeyDatesLabel?: string | null;
      icon?: { __typename?: "UploadFile"; url: string } | null;
    } | null;
    leadershipWheelSection?: {
      __typename?: "ComponentHomeLeadershipWheelSection";
      title?: string | null;
      description?: string | null;
      btnText?: string | null;
      image?: {
        __typename?: "UploadFile";
        data: {
          __typename?: "UploadFile";
          attributes: {
            __typename?: "UploadFile";
            url: string;
            alternativeText?: string | null;
            mime: string;
          };
        };
      } | null;
    } | null;
    articlesAndPodcastsSection?: {
      __typename?: "ComponentHomeArticlesAndPodcastsSection";
      title?: string | null;
      description?: string | null;
      readNowArticle?: string | null;
      viewAllArticle?: string | null;
      listenNowPodcast?: string | null;
      viewAllPodcasts?: string | null;
      icon?: { __typename?: "UploadFile"; url: string } | null;
    } | null;
    latestUpdatesSection?: {
      __typename?: "ComponentHomeLatestUpdatesSection";
      title: string;
    } | null;
  } | null;
};

export type LeadershipWheelQueryVariables = Exact<{ [key: string]: never }>;

export type LeadershipWheelQuery = {
  __typename?: "Query";
  leadershipWheel?: {
    __typename?: "LeadershipWheelEntityResponseCollection";
    data: Array<{
      __typename?: "LeadershipWheel";
      id: string;
      attributes: {
        __typename?: "LeadershipWheel";
        focusArea: string;
        description: string;
        typeSection: {
          __typename?: "ComponentLeadershipWheelTypeSection";
          mainGradientFrom: string;
          mainGradientTo: string;
          secondaryGradientFrom: string;
          secondaryGradientTo: string;
          tertiaryGradientFrom?: string | null;
          tertiaryGradientTo?: string | null;
        };
        subFocusArea?: Array<{
          __typename?: "ComponentLeadershipWheelSubTrait";
          focusArea: string;
          description: string;
          microExercisePrompt?: {
            __typename?: "MicroExercisePrompt";
            title: string;
            documentId: string;
            publishedAt?: any | null;
            type: Enum_Microexerciseprompt_Type;
            content: string;
          } | null;
        } | null> | null;
        overallMoodIcon?: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: { __typename?: "UploadFile"; url: string };
          };
        } | null;
      };
    }>;
  } | null;
};

export type LeadershipWheelPageQueryVariables = Exact<{ [key: string]: never }>;

export type LeadershipWheelPageQuery = {
  __typename?: "Query";
  leadershipWheelPage?: {
    __typename?: "LeadershipWheelPage";
    data: {
      __typename?: "LeadershipWheelPage";
      attributes: {
        __typename?: "LeadershipWheelPage";
        relatedContentTitle?: string | null;
        howAreYouFeelingTitle: string;
        youAreTitle: string;
        howAreYouTitle: string;
        changeMyAnswerCta: string;
        wellDoneTitle: string;
        goToYourMoodTracker?: string | null;
        resetTheWheel?: string | null;
        calendarTitle?: string | null;
        bottomText?: string | null;
        traitDetailsTitle?: string | null;
        messages?: {
          __typename?: "ComponentLeadershipWheelMessages";
          initial?: string | null;
          trait?: string | null;
          subTrait?: string | null;
          initialTitle?: string | null;
          traitTitle?: string | null;
          subTraitTitle?: string | null;
          privacyStatement?: string | null;
        } | null;
        onboarding?: {
          __typename?: "ComponentLeadershipWheelOnboarding";
          steps?: Array<{
            __typename?: "ComponentCommonSteps";
            title: string;
            description: string;
            textBtn: string;
            image: {
              __typename?: "UploadFile";
              data: {
                __typename?: "UploadFile";
                attributes: {
                  __typename?: "UploadFile";
                  url: string;
                  alternativeText?: string | null;
                  mime: string;
                };
              };
            };
          } | null> | null;
        } | null;
        TraitNotFound?: {
          __typename?: "ComponentCommonRawTextWithLinks";
          text?: string | null;
          finalState?: {
            __typename?: "ComponentLeadershipWheelFinalState";
            redirectToCurrentCharacterExercise?: boolean | null;
            redirectToCalendar?: boolean | null;
            course?: {
              __typename?: "Course";
              data: {
                __typename?: "Course";
                attributes: { __typename?: "Course"; slug?: string | null };
              };
            } | null;
            knowledgeBase?: {
              __typename?: "KnowledgeBase";
              data: {
                __typename?: "KnowledgeBase";
                attributes: { __typename?: "KnowledgeBase"; slug: string };
              };
            } | null;
          } | null;
        } | null;
      };
    };
  } | null;
};

export type QuotePageQueryVariables = Exact<{ [key: string]: never }>;

export type QuotePageQuery = {
  __typename?: "Query";
  quotePage?: {
    __typename?: "QuotePage";
    data: {
      __typename?: "QuotePage";
      attributes: {
        __typename?: "QuotePage";
        quoteOfTheDayTitle: string;
        cta: {
          __typename?: "ComponentCommonButton";
          text: string;
          link: string;
        };
      };
    };
  } | null;
};

export type QuoteQueryVariables = Exact<{
  date?: InputMaybe<DateFilterInput>;
}>;

export type QuoteQuery = {
  __typename?: "Query";
  quotes?: {
    __typename?: "QuoteEntityResponseCollection";
    data: Array<{
      __typename?: "Quote";
      id: string;
      attributes: {
        __typename?: "Quote";
        quote?: string | null;
        author?: string | null;
        date?: any | null;
        occupation?: string | null;
        quoteWithLinks?: string | null;
        links?: {
          __typename?: "ComponentCommonLinkList";
          redirectToCalendar?: boolean | null;
          redirectToLeadershipWheel?: boolean | null;
          podcast?: {
            __typename?: "KnowledgeBase";
            data: {
              __typename?: "KnowledgeBase";
              attributes: { __typename?: "KnowledgeBase"; slug: string };
            };
          } | null;
          course?: {
            __typename?: "Course";
            data: {
              __typename?: "Course";
              attributes: { __typename?: "Course"; slug?: string | null };
            };
          } | null;
          knowledgeBase?: {
            __typename?: "KnowledgeBase";
            data: {
              __typename?: "KnowledgeBase";
              attributes: { __typename?: "KnowledgeBase"; slug: string };
            };
          } | null;
        } | null;
      };
    }>;
  } | null;
};

export type KeyDateFragmentFragment = {
  __typename?: "KeyDate";
  documentId: string;
  title: string;
  description?: string | null;
  dateType?: Enum_Keydate_Datetype | null;
  startDate?: any | null;
  endDate?: any | null;
  relativeRule?: string | null;
  month?: string | null;
  requiresReview?: boolean | null;
  isDeleted?: boolean | null;
  originalText?: string | null;
  source?: string | null;
  academicYear?: string | null;
  bookYourPlaceUrl?: string | null;
  learnMoreUrl?: string | null;
  sectionType?: {
    __typename?: "SectionType";
    documentId: string;
    value: string;
    label?: string | null;
  } | null;
  topicLabel?: {
    __typename?: "TopicLabel";
    documentId: string;
    value: string;
    label?: string | null;
  } | null;
  schools: Array<{
    __typename?: "School";
    documentId: string;
    name: string;
  } | null>;
};

export type KeyDatesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  schoolContextDocumentId: Scalars["ID"]["input"];
}>;

export type KeyDatesQuery = {
  __typename?: "Query";
  keyDates?: {
    __typename?: "KeyDateConnectionWithSchools";
    nodes?: Array<{
      __typename?: "KeyDate";
      documentId: string;
      title: string;
      description?: string | null;
      dateType?: Enum_Keydate_Datetype | null;
      startDate?: any | null;
      endDate?: any | null;
      relativeRule?: string | null;
      month?: string | null;
      requiresReview?: boolean | null;
      isDeleted?: boolean | null;
      originalText?: string | null;
      source?: string | null;
      academicYear?: string | null;
      bookYourPlaceUrl?: string | null;
      learnMoreUrl?: string | null;
      sectionType?: {
        __typename?: "SectionType";
        documentId: string;
        value: string;
        label?: string | null;
      } | null;
      topicLabel?: {
        __typename?: "TopicLabel";
        documentId: string;
        value: string;
        label?: string | null;
      } | null;
      schools: Array<{
        __typename?: "School";
        documentId: string;
        name: string;
      } | null>;
    } | null> | null;
    pageInfo?: {
      __typename?: "PageInfo";
      page?: number | null;
      pageCount?: number | null;
      total?: number | null;
      pageSize?: number | null;
    } | null;
  } | null;
  keyDatePage?: {
    __typename?: "KeyDatePage";
    title: string;
    calendarTitle: string;
    description?: string | null;
    searchPlaceholder?: string | null;
    previousMonthButton?: string | null;
    nextMonthButton?: string | null;
    noKeyDatesFoundText?: string | null;
    bookYourPlaceLabel?: string | null;
    learnMoreLabel?: string | null;
    deadlineLabel?: string | null;
    addToCalendarLabel?: string | null;
    calendarAppleLabel?: string | null;
    calendarGoogleLabel?: string | null;
    calendarOutlookLabel?: string | null;
    tagTrustAction?: string | null;
    tagReminder?: string | null;
    tagAwarenessDay?: string | null;
    tagEvent?: string | null;
    tagPayment?: string | null;
    tagAnnouncement?: string | null;
  } | null;
};

export type KeyDatesListQueryVariables = Exact<{
  page: Scalars["Int"]["input"];
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  sectionType?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  schoolContextDocumentId: Scalars["ID"]["input"];
}>;

export type KeyDatesListQuery = {
  __typename?: "Query";
  keyDates?: {
    __typename?: "KeyDateConnectionWithSchools";
    nodes?: Array<{
      __typename?: "KeyDate";
      documentId: string;
      title: string;
      description?: string | null;
      dateType?: Enum_Keydate_Datetype | null;
      startDate?: any | null;
      endDate?: any | null;
      relativeRule?: string | null;
      month?: string | null;
      requiresReview?: boolean | null;
      isDeleted?: boolean | null;
      originalText?: string | null;
      source?: string | null;
      academicYear?: string | null;
      bookYourPlaceUrl?: string | null;
      learnMoreUrl?: string | null;
      sectionType?: {
        __typename?: "SectionType";
        documentId: string;
        value: string;
        label?: string | null;
      } | null;
      topicLabel?: {
        __typename?: "TopicLabel";
        documentId: string;
        value: string;
        label?: string | null;
      } | null;
      schools: Array<{
        __typename?: "School";
        documentId: string;
        name: string;
      } | null>;
    } | null> | null;
    pageInfo?: {
      __typename?: "PageInfo";
      page?: number | null;
      pageCount?: number | null;
      total?: number | null;
      pageSize?: number | null;
    } | null;
  } | null;
  keyDatePage?: {
    __typename?: "KeyDatePage";
    title: string;
    calendarTitle: string;
    description?: string | null;
    searchPlaceholder?: string | null;
    previousMonthButton?: string | null;
    nextMonthButton?: string | null;
    noKeyDatesFoundText?: string | null;
    bookYourPlaceLabel?: string | null;
    learnMoreLabel?: string | null;
    deadlineLabel?: string | null;
    addToCalendarLabel?: string | null;
    calendarAppleLabel?: string | null;
    calendarGoogleLabel?: string | null;
    calendarOutlookLabel?: string | null;
    tagTrustAction?: string | null;
    tagReminder?: string | null;
    tagAwarenessDay?: string | null;
    tagEvent?: string | null;
    tagPayment?: string | null;
    tagAnnouncement?: string | null;
  } | null;
};

export type SectionTypesQueryVariables = Exact<{ [key: string]: never }>;

export type SectionTypesQuery = {
  __typename?: "Query";
  sectionTypes: Array<{
    __typename?: "SectionType";
    documentId: string;
    value: string;
    label?: string | null;
  } | null>;
};

export type TopicLabelsQueryVariables = Exact<{ [key: string]: never }>;

export type TopicLabelsQuery = {
  __typename?: "Query";
  topicLabels: Array<{
    __typename?: "TopicLabel";
    documentId: string;
    value: string;
    label?: string | null;
  } | null>;
};

export type KnowledgeBaseCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type KnowledgeBaseCategoriesQuery = {
  __typename?: "Query";
  knowledgeBaseCategories: Array<{
    __typename?: "KnowledgeBaseCategory";
    documentId: string;
    category: string;
    subCategories?: {
      __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
      nodes: Array<{
        __typename?: "KnowledgeBaseCategory";
        documentId: string;
        category: string;
        subCategories?: {
          __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
          nodes: Array<{
            __typename?: "KnowledgeBaseCategory";
            documentId: string;
            category: string;
            subCategories?: {
              __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
              nodes: Array<{
                __typename?: "KnowledgeBaseCategory";
                documentId: string;
                category: string;
              }>;
            } | null;
          }>;
        } | null;
      }>;
    } | null;
  } | null>;
};

export type KnowledgeBasesListQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  categoryDocumentIds?: InputMaybe<
    Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
  >;
  knowledgeBaseTypeDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type KnowledgeBasesListQuery = {
  __typename?: "Query";
  knowledgebases?: {
    __typename?: "KnowledgeBaseEntityResponseCollection";
    nodes: Array<{
      __typename?: "KnowledgeBase";
      documentId: string;
      title: string;
      slug: string;
      briefDescription: string;
      publicationDate: any;
      duration?: string | null;
      knowledgeBaseType?: {
        __typename?: "KnowledgeBaseType";
        documentId: string;
        type: string;
      } | null;
      category?: {
        __typename?: "KnowledgeBaseCategory";
        documentId: string;
        category: string;
      } | null;
      cover: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      };
    }>;
    pageInfo: {
      __typename?: "Pagination";
      page: number;
      pageCount: number;
      total: number;
      pageSize: number;
    };
  } | null;
};

export type KnowledgeBaseCategoryQueryVariables = Exact<{
  documentId: Scalars["ID"]["input"];
}>;

export type KnowledgeBaseCategoryQuery = {
  __typename?: "Query";
  knowledgeBaseCategory?: {
    __typename?: "KnowledgeBaseCategory";
    documentId: string;
    category: string;
    subCategories?: {
      __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
      nodes: Array<{
        __typename?: "KnowledgeBaseCategory";
        documentId: string;
        category: string;
        subCategories?: {
          __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
          nodes: Array<{
            __typename?: "KnowledgeBaseCategory";
            documentId: string;
            category: string;
            subCategories?: {
              __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
              nodes: Array<{
                __typename?: "KnowledgeBaseCategory";
                documentId: string;
                category: string;
              }>;
            } | null;
          }>;
        } | null;
      }>;
    } | null;
  } | null;
};

export type ValidCategoryIdsForKnowledgeBaseTypeQueryVariables = Exact<{
  knowledgeBaseTypeDocumentId: Scalars["ID"]["input"];
}>;

export type ValidCategoryIdsForKnowledgeBaseTypeQuery = {
  __typename?: "Query";
  validCategoryIdsForKnowledgeBaseType: Array<string>;
};

export type KnowledgeBaseQueryVariables = Exact<{
  slug?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type KnowledgeBaseQuery = {
  __typename?: "Query";
  knowledgeBases?: {
    __typename?: "KnowledgeBaseEntityResponseCollection";
    data: Array<{
      __typename?: "KnowledgeBase";
      id: string;
      documentId: string;
      publicationDate: any;
      attributes: {
        __typename?: "KnowledgeBase";
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        subHeader?: string | null;
        knowledgeBaseType?: {
          __typename?: "KnowledgeBaseType";
          data: {
            __typename?: "KnowledgeBaseType";
            id: string;
            documentId: string;
            attributes: { __typename?: "KnowledgeBaseType"; type: string };
          };
        } | null;
        cover: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        DefaultContentTemplate: Array<
          | {
              __typename: "ComponentCommonAudio";
              transcription?: string | null;
              audio: { __typename?: "UploadFile"; url: string };
            }
          | { __typename: "ComponentCommonAuthor" }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | {
              __typename: "ComponentCommonBullet";
              item: Array<{
                __typename?: "ComponentCommonList";
                text: string;
              } | null>;
            }
          | { __typename: "ComponentCommonDivider"; id: string }
          | {
              __typename: "ComponentCommonDownloadableContentList";
              list?: Array<{
                __typename?: "ComponentCommonDownloadableContent";
                title: string;
                description?: string | null;
                content: {
                  __typename?: "UploadFile";
                  data: {
                    __typename?: "UploadFile";
                    attributes: { __typename?: "UploadFile"; url: string };
                  };
                };
              } | null> | null;
            }
          | {
              __typename: "ComponentCommonEmbedded";
              link: string;
              provider: Enum_Componentcommonembedded_Provider;
            }
          | {
              __typename: "ComponentCommonFaqComponent";
              faq?: Array<{
                __typename?: "ComponentCommonFaq";
                title: string;
                description: string;
              } | null> | null;
            }
          | { __typename: "ComponentCommonH3"; text: string }
          | {
              __typename: "ComponentCommonMedia";
              media: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                  };
                };
              };
            }
          | { __typename: "ComponentCommonQuote"; quote: string }
          | { __typename: "ComponentCommonRelatedContent"; id: string }
          | { __typename: "ComponentCommonTags"; id: string }
          | {
              __typename: "ComponentCommonTextEditor";
              markdownText?: string | null;
            }
          | { __typename: "ComponentCommonTitle"; title: string }
          | {
              __typename: "ComponentDefaultContentTemplateTimer";
              timerType: Enum_Componentdefaultcontenttemplatetimer_Type;
              timerAudio?: {
                __typename?: "ComponentTimerTimerAudio";
                title: string;
                prompt?: string | null;
                spokenGuidance?: {
                  __typename?: "UploadFile";
                  data: {
                    __typename?: "UploadFile";
                    attributes: {
                      __typename?: "UploadFile";
                      name: string;
                      url: string;
                    };
                  };
                } | null;
              } | null;
              timerPrompt?: {
                __typename?: "ComponentTimerTimerPrompt";
                title: string;
                prompt: string;
                durationInSeconds?: any | null;
              } | null;
              timerVideo?: {
                __typename?: "ComponentTimerTimerVideo";
                videoTitle: string;
                video: {
                  __typename?: "UploadFile";
                  data: {
                    __typename?: "UploadFile";
                    attributes: {
                      __typename?: "UploadFile";
                      name: string;
                      url: string;
                      height?: number | null;
                      width?: number | null;
                    };
                  };
                };
              } | null;
              timerAudioLabels?: {
                __typename?: "ComponentTimerTimerAudioLabels";
                title?: string | null;
                startExerciseButton: string;
                thankYouTitle: string;
                backDailyBubbleButton: string;
                playButtonLabel?: string | null;
                pauseButtonLabel?: string | null;
                stopButtonLabel?: string | null;
                restartButtonLabel?: string | null;
                minutes: Array<{
                  __typename?: "ComponentCommonMinutes";
                  id: string;
                  minute?: number | null;
                } | null>;
              } | null;
              timerPromptLabels?: {
                __typename?: "ComponentTimerTimerPromptLabels";
                title?: string | null;
                backDailyBubbleButton: string;
                startExerciseButton: string;
                thankYouTitle?: string | null;
                playButtonLabel?: string | null;
                pauseButtonLabel?: string | null;
                stopButtonLabel?: string | null;
                restartButtonLabel?: string | null;
              } | null;
              timerVideoLabels?: {
                __typename?: "ComponentTimerTimerVideoLabels";
                title?: string | null;
                backDailyBubbleButton: string;
                thankYouTitle: string;
              } | null;
            }
          | {
              __typename: "ComponentKnowledgeBaseKnowledgeBaseRelated";
              knowledgeBases?: {
                __typename?: "KnowledgeBaseRelationResponseCollection";
                data: Array<{
                  __typename?: "KnowledgeBase";
                  attributes: {
                    __typename?: "KnowledgeBase";
                    createdAt?: any | null;
                    publishedAt?: any | null;
                    title: string;
                    slug: string;
                    duration?: string | null;
                    briefDescription: string;
                    knowledgeBaseType?: {
                      __typename?: "KnowledgeBaseType";
                      data: {
                        __typename?: "KnowledgeBaseType";
                        id: string;
                        attributes: {
                          __typename?: "KnowledgeBaseType";
                          type: string;
                        };
                      };
                    } | null;
                    cover: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                    DefaultContentTemplate: Array<
                      | { __typename: "ComponentCommonAudio" }
                      | { __typename: "ComponentCommonAuthor" }
                      | {
                          __typename: "ComponentCommonAuthorDetailed";
                          authors?: {
                            __typename?: "AuthorRelationResponseCollection";
                            data: Array<{
                              __typename?: "Author";
                              attributes: {
                                __typename?: "Author";
                                name: string;
                                role?: string | null;
                                bio?: string | null;
                                avatar: {
                                  __typename?: "UploadFile";
                                  data: {
                                    __typename?: "UploadFile";
                                    attributes: {
                                      __typename?: "UploadFile";
                                      url: string;
                                      alternativeText?: string | null;
                                      mime: string;
                                    };
                                  };
                                };
                              };
                            }>;
                          } | null;
                        }
                      | { __typename: "ComponentCommonBullet" }
                      | { __typename: "ComponentCommonDivider" }
                      | { __typename: "ComponentCommonDownloadableContentList" }
                      | { __typename: "ComponentCommonEmbedded" }
                      | { __typename: "ComponentCommonFaqComponent" }
                      | { __typename: "ComponentCommonH3" }
                      | { __typename: "ComponentCommonMedia" }
                      | { __typename: "ComponentCommonQuote" }
                      | { __typename: "ComponentCommonRelatedContent" }
                      | { __typename: "ComponentCommonTags" }
                      | { __typename: "ComponentCommonTextEditor" }
                      | { __typename: "ComponentCommonTitle" }
                      | { __typename: "ComponentDefaultContentTemplateTimer" }
                      | {
                          __typename: "ComponentKnowledgeBaseKnowledgeBaseRelated";
                        }
                      | { __typename: "Error" }
                      | null
                    >;
                  };
                }>;
              } | null;
            }
          | { __typename: "Error" }
          | null
        >;
      };
    }>;
  } | null;
};

export type FetchLatestKnowledgeBasePageableQueryVariables = Exact<{
  kinds?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  page: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type FetchLatestKnowledgeBasePageableQuery = {
  __typename?: "Query";
  knowledgeBases?: {
    __typename?: "KnowledgeBaseEntityResponseCollection";
    data: Array<{
      __typename?: "KnowledgeBase";
      id: string;
      attributes: {
        __typename?: "KnowledgeBase";
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        knowledgeBaseType?: {
          __typename?: "KnowledgeBaseType";
          data: {
            __typename?: "KnowledgeBaseType";
            id: string;
            attributes: { __typename?: "KnowledgeBaseType"; type: string };
          };
        } | null;
        cover: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        DefaultContentTemplate: Array<
          | { __typename: "ComponentCommonAudio" }
          | { __typename: "ComponentCommonAuthor" }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | { __typename: "ComponentCommonBullet" }
          | { __typename: "ComponentCommonDivider" }
          | { __typename: "ComponentCommonDownloadableContentList" }
          | { __typename: "ComponentCommonEmbedded" }
          | { __typename: "ComponentCommonFaqComponent" }
          | { __typename: "ComponentCommonH3" }
          | { __typename: "ComponentCommonMedia" }
          | { __typename: "ComponentCommonQuote" }
          | { __typename: "ComponentCommonRelatedContent" }
          | { __typename: "ComponentCommonTags" }
          | { __typename: "ComponentCommonTextEditor" }
          | { __typename: "ComponentCommonTitle" }
          | { __typename: "ComponentDefaultContentTemplateTimer" }
          | { __typename: "ComponentKnowledgeBaseKnowledgeBaseRelated" }
          | { __typename: "Error" }
          | null
        >;
      };
    }>;
    meta: {
      __typename?: "ResponseCollectionMeta";
      pagination: {
        __typename?: "Pagination";
        page: number;
        pageCount: number;
        total: number;
      };
    };
  } | null;
};

export type FetchLatestKnowledgeBaseQueryVariables = Exact<{
  slug?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type FetchLatestKnowledgeBaseQuery = {
  __typename?: "Query";
  knowledgeBases?: {
    __typename?: "KnowledgeBaseEntityResponseCollection";
    data: Array<{
      __typename?: "KnowledgeBase";
      id: string;
      attributes: {
        __typename?: "KnowledgeBase";
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        knowledgeBaseType?: {
          __typename?: "KnowledgeBaseType";
          data: {
            __typename?: "KnowledgeBaseType";
            id: string;
            attributes: { __typename?: "KnowledgeBaseType"; type: string };
          };
        } | null;
        cover: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        DefaultContentTemplate: Array<
          | { __typename: "ComponentCommonAudio" }
          | { __typename: "ComponentCommonAuthor" }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | { __typename: "ComponentCommonBullet" }
          | { __typename: "ComponentCommonDivider" }
          | { __typename: "ComponentCommonDownloadableContentList" }
          | { __typename: "ComponentCommonEmbedded" }
          | { __typename: "ComponentCommonFaqComponent" }
          | { __typename: "ComponentCommonH3" }
          | { __typename: "ComponentCommonMedia" }
          | { __typename: "ComponentCommonQuote" }
          | { __typename: "ComponentCommonRelatedContent" }
          | { __typename: "ComponentCommonTags" }
          | { __typename: "ComponentCommonTextEditor" }
          | { __typename: "ComponentCommonTitle" }
          | { __typename: "ComponentDefaultContentTemplateTimer" }
          | { __typename: "ComponentKnowledgeBaseKnowledgeBaseRelated" }
          | { __typename: "Error" }
          | null
        >;
      };
    }>;
  } | null;
};

export type FetchKnowledgeBaseTypesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchKnowledgeBaseTypesQuery = {
  __typename?: "Query";
  knowledgeBaseTypes: Array<{
    __typename?: "KnowledgeBaseType";
    documentId: string;
    type: string;
  } | null>;
};

export type FetchKnowledgeBaseTypesWithPublishedItemsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchKnowledgeBaseTypesWithPublishedItemsQuery = {
  __typename?: "Query";
  knowledgeBaseTypesWithPublishedItems: Array<{
    __typename?: "KnowledgeBaseTypeWithItems";
    documentId: string;
    type: string;
  }>;
};

export type FindPodcastListeningTimeQueryVariables = Exact<{
  filters?: InputMaybe<PodcastListeningTimeFiltersInput>;
}>;

export type FindPodcastListeningTimeQuery = {
  __typename?: "Query";
  podcastListeningTimes: Array<{
    __typename?: "PodcastListeningTime";
    documentId: string;
    id: string;
    listeningTime: any;
    duration: any;
  } | null>;
};

export type KnowledgeBasePageQueryVariables = Exact<{ [key: string]: never }>;

export type KnowledgeBasePageQuery = {
  __typename?: "Query";
  knowledgeBasePage?: {
    __typename?: "KnowledgeBasePage";
    title: string;
    description?: string | null;
    moreButtonTitle: string;
    contentTemplateLabels?: {
      __typename?: "ComponentCommonContentTemplateLabels";
      downloadableContentLabel?: string | null;
    } | null;
  } | null;
  knowledgeBaseCategories: Array<{
    __typename?: "KnowledgeBaseCategory";
    documentId: string;
    category: string;
    subCategories?: {
      __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
      nodes: Array<{
        __typename?: "KnowledgeBaseCategory";
        documentId: string;
        category: string;
        subCategories?: {
          __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
          nodes: Array<{
            __typename?: "KnowledgeBaseCategory";
            documentId: string;
            category: string;
            subCategories?: {
              __typename?: "KnowledgeBaseCategoryRelationResponseCollection";
              nodes: Array<{
                __typename?: "KnowledgeBaseCategory";
                documentId: string;
                category: string;
              }>;
            } | null;
          }>;
        } | null;
      }>;
    } | null;
  } | null>;
};

export type CourseQueryVariables = Exact<{
  slug?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type CourseQuery = {
  __typename?: "Query";
  courses?: {
    __typename?: "CourseEntityResponseCollection";
    data: Array<{
      __typename?: "Course";
      id: string;
      documentId: string;
      attributes: {
        __typename?: "Course";
        title: string;
        slug?: string | null;
        description: string;
        duration?: string | null;
        textContent?: {
          __typename?: "ComponentCommonTextEditor";
          markdownText?: string | null;
        } | null;
        course_category?: {
          __typename?: "CourseCategory";
          data: {
            __typename?: "CourseCategory";
            attributes: {
              __typename?: "CourseCategory";
              name: string;
              description?: string | null;
            };
          };
        } | null;
        courseCompletedSection?: {
          __typename?: "ComponentLearnCourseCompletedSection";
          title: string;
          message: string;
        } | null;
        thumbnail: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        hero: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        modules?: Array<{
          __typename?: "ComponentLearnCourseModule";
          id: string;
          title: string;
          description: string;
          moduleStableId: string;
          lessons?: Array<{
            __typename?: "ComponentLearnCourseLesson";
            id: string;
            title: string;
            description: string;
            lessonStableId: string;
            duration?: string | null;
            textContent?: {
              __typename?: "ComponentCommonTextEditor";
              markdownText?: string | null;
            } | null;
            thumbnail: {
              __typename?: "UploadFile";
              data: {
                __typename?: "UploadFile";
                attributes: {
                  __typename?: "UploadFile";
                  url: string;
                  alternativeText?: string | null;
                  mime: string;
                };
              };
            };
            authors?: {
              __typename?: "AuthorRelationResponseCollection";
              data: Array<{
                __typename?: "Author";
                attributes: {
                  __typename?: "Author";
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: "UploadFile";
                    data: {
                      __typename?: "UploadFile";
                      attributes: {
                        __typename?: "UploadFile";
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      };
                    };
                  };
                };
              }>;
            } | null;
          } | null> | null;
        } | null> | null;
      };
    }>;
  } | null;
};

export type CourseLessonQueryVariables = Exact<{
  slug?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type CourseLessonQuery = {
  __typename?: "Query";
  courses?: {
    __typename?: "CourseEntityResponseCollection";
    data: Array<{
      __typename?: "Course";
      id: string;
      documentId: string;
      attributes: {
        __typename?: "Course";
        title: string;
        slug?: string | null;
        duration?: string | null;
        description: string;
        feedbackQuestions?: Array<{
          __typename?: "ComponentLearnQuestions";
          question: string;
        } | null> | null;
        textContent?: {
          __typename?: "ComponentCommonTextEditor";
          markdownText?: string | null;
        } | null;
        course_category?: {
          __typename?: "CourseCategory";
          data: {
            __typename?: "CourseCategory";
            attributes: {
              __typename?: "CourseCategory";
              name: string;
              description?: string | null;
            };
          };
        } | null;
        thumbnail: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        hero: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        modules?: Array<{
          __typename?: "ComponentLearnCourseModule";
          id: string;
          title: string;
          description: string;
          moduleStableId: string;
          lessons?: Array<{
            __typename?: "ComponentLearnCourseLesson";
            id: string;
            duration?: string | null;
            title: string;
            description: string;
            lessonStableId: string;
            textContent?: {
              __typename?: "ComponentCommonTextEditor";
              markdownText?: string | null;
            } | null;
            objectivesSection?: {
              __typename?: "ComponentCommonObjectivesSection";
              id: string;
              title: string;
              objectives?: Array<{
                __typename?: "ComponentCommonObjectives";
                description: string;
              } | null> | null;
            } | null;
            thumbnail: {
              __typename?: "UploadFile";
              data: {
                __typename?: "UploadFile";
                attributes: {
                  __typename?: "UploadFile";
                  url: string;
                  alternativeText?: string | null;
                  mime: string;
                };
              };
            };
            highlightContent?: {
              __typename?: "ComponentLearnHighlightContent";
              audio?: {
                __typename?: "ComponentCommonAudio";
                transcription?: string | null;
                audio: {
                  __typename?: "UploadFile";
                  data: {
                    __typename?: "UploadFile";
                    attributes: { __typename?: "UploadFile"; url: string };
                  };
                };
              } | null;
              embedded?: {
                __typename?: "ComponentCommonEmbedded";
                link: string;
                provider: Enum_Componentcommonembedded_Provider;
              } | null;
              image?: {
                __typename?: "ComponentCommonMedia";
                media: {
                  __typename?: "UploadFile";
                  data: {
                    __typename?: "UploadFile";
                    attributes: {
                      __typename?: "UploadFile";
                      url: string;
                      alternativeText?: string | null;
                      mime: string;
                    };
                  };
                };
              } | null;
            } | null;
            downloadableContent?: Array<{
              __typename?: "ComponentCommonDownloadableContent";
              title: string;
              description?: string | null;
              content: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: { __typename?: "UploadFile"; url: string };
                };
              };
            } | null> | null;
            faq?: Array<{
              __typename?: "ComponentCommonFaq";
              title: string;
              description: string;
            } | null> | null;
            authors?: {
              __typename?: "AuthorRelationResponseCollection";
              data: Array<{
                __typename?: "Author";
                attributes: {
                  __typename?: "Author";
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: "UploadFile";
                    data: {
                      __typename?: "UploadFile";
                      attributes: {
                        __typename?: "UploadFile";
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      };
                    };
                  };
                };
              }>;
            } | null;
          } | null> | null;
        } | null> | null;
      };
    }>;
  } | null;
};

export type FetchLatestCoursesQueryVariables = Exact<{
  slug?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type FetchLatestCoursesQuery = {
  __typename?: "Query";
  courses?: {
    __typename?: "CourseEntityResponseCollection";
    data: Array<{
      __typename?: "Course";
      id: string;
      documentId: string;
      attributes: {
        __typename?: "Course";
        title: string;
        slug?: string | null;
        description: string;
        thumbnail: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        modules?: Array<{
          __typename?: "ComponentLearnCourseModule";
          id: string;
          lessons?: Array<{
            __typename?: "ComponentLearnCourseLesson";
            id: string;
            authors: Array<{
              __typename?: "Author";
              data: {
                __typename?: "Author";
                attributes: {
                  __typename?: "Author";
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: "UploadFile";
                    data: {
                      __typename?: "UploadFile";
                      attributes: {
                        __typename?: "UploadFile";
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      };
                    };
                  };
                };
              };
            } | null>;
          } | null> | null;
        } | null> | null;
      };
    }>;
  } | null;
};

export type FetchCoursesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  publishedAt?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type FetchCoursesQuery = {
  __typename?: "Query";
  courses?: {
    __typename?: "CourseEntityResponseCollection";
    data: Array<{
      __typename?: "Course";
      id: string;
      documentId: string;
      attributes: {
        __typename?: "Course";
        title: string;
        slug?: string | null;
        duration?: string | null;
        description: string;
        thumbnail: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        course_category?: {
          __typename?: "CourseCategory";
          data: {
            __typename?: "CourseCategory";
            attributes: {
              __typename?: "CourseCategory";
              name: string;
              description?: string | null;
            };
          };
        } | null;
        modules?: Array<{
          __typename?: "ComponentLearnCourseModule";
          id: string;
          lessons?: Array<{
            __typename?: "ComponentLearnCourseLesson";
            id: string;
            authors?: {
              __typename?: "AuthorRelationResponseCollection";
              data: Array<{
                __typename?: "Author";
                attributes: {
                  __typename?: "Author";
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: "UploadFile";
                    data: {
                      __typename?: "UploadFile";
                      attributes: {
                        __typename?: "UploadFile";
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      };
                    };
                  };
                };
              }>;
            } | null;
          } | null> | null;
        } | null> | null;
      };
    }>;
  } | null;
};

export type FetchCoursesPageableQueryVariables = Exact<{
  page: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type FetchCoursesPageableQuery = {
  __typename?: "Query";
  courses?: {
    __typename?: "CourseEntityResponseCollection";
    data: Array<{
      __typename?: "Course";
      id: string;
      attributes: {
        __typename?: "Course";
        title: string;
        slug?: string | null;
        description: string;
        duration?: string | null;
        thumbnail: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        course_category?: {
          __typename?: "CourseCategory";
          data: {
            __typename?: "CourseCategory";
            attributes: {
              __typename?: "CourseCategory";
              name: string;
              description?: string | null;
            };
          };
        } | null;
        modules?: Array<{
          __typename?: "ComponentLearnCourseModule";
          id: string;
          lessons?: Array<{
            __typename?: "ComponentLearnCourseLesson";
            id: string;
            authors?: {
              __typename?: "AuthorRelationResponseCollection";
              data: Array<{
                __typename?: "Author";
                attributes: {
                  __typename?: "Author";
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: "UploadFile";
                    data: {
                      __typename?: "UploadFile";
                      attributes: {
                        __typename?: "UploadFile";
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      };
                    };
                  };
                };
              }>;
            } | null;
          } | null> | null;
        } | null> | null;
      };
    }>;
    meta: {
      __typename?: "ResponseCollectionMeta";
      pagination: {
        __typename?: "Pagination";
        page: number;
        pageCount: number;
        total: number;
      };
    };
  } | null;
};

export type FetchLearnQueryVariables = Exact<{
  staffId: Scalars["ID"]["input"];
  completed?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type FetchLearnQuery = {
  __typename?: "Query";
  learn?: {
    __typename?: "LearnEntityResponseCollection";
    data: Array<{
      __typename?: "Learn";
      id: string;
      documentId: string;
      attributes: {
        __typename?: "Learn";
        completed?: boolean | null;
        completedAt?: any | null;
        users_permissions_user?: {
          __typename?: "UsersPermissionsUser";
          data: { __typename?: "UsersPermissionsUser"; id: string };
        } | null;
        course?: {
          __typename?: "Course";
          data: {
            __typename?: "Course";
            id: string;
            attributes: {
              __typename?: "Course";
              title: string;
              slug?: string | null;
              description: string;
              thumbnail: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  };
                };
              };
              course_category?: {
                __typename?: "CourseCategory";
                data: {
                  __typename?: "CourseCategory";
                  attributes: {
                    __typename?: "CourseCategory";
                    name: string;
                    description?: string | null;
                  };
                };
              } | null;
              modules?: Array<{
                __typename?: "ComponentLearnCourseModule";
                id: string;
                title: string;
                moduleStableId: string;
                lessons?: Array<{
                  __typename?: "ComponentLearnCourseLesson";
                  id: string;
                  title: string;
                  lessonStableId: string;
                  authors: Array<{
                    __typename?: "Author";
                    data: {
                      __typename?: "Author";
                      attributes: { __typename?: "Author"; name: string };
                    };
                  } | null>;
                } | null> | null;
              } | null> | null;
            };
          };
        } | null;
        learn_items?: {
          __typename?: "LearnItemRelationResponseCollection";
          data: Array<{
            __typename?: "LearnItem";
            attributes: {
              __typename?: "LearnItem";
              idModule: string;
              idLesson: string;
            };
          }>;
        } | null;
      };
    }>;
  } | null;
};

export type FetchCourseLearnQueryVariables = Exact<{
  staffId: Scalars["ID"]["input"];
  courseSlug: Scalars["String"]["input"];
}>;

export type FetchCourseLearnQuery = {
  __typename?: "Query";
  learn?: {
    __typename?: "LearnEntityResponseCollection";
    data: Array<{
      __typename?: "Learn";
      id: string;
      documentId: string;
      attributes: {
        __typename?: "Learn";
        completed?: boolean | null;
        completedAt?: any | null;
        users_permissions_user?: {
          __typename?: "UsersPermissionsUser";
          data: { __typename?: "UsersPermissionsUser"; id: string };
        } | null;
        course?: {
          __typename?: "Course";
          data: {
            __typename?: "Course";
            id: string;
            attributes: {
              __typename?: "Course";
              title: string;
              slug?: string | null;
              description: string;
              thumbnail: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  };
                };
              };
              course_category?: {
                __typename?: "CourseCategory";
                data: {
                  __typename?: "CourseCategory";
                  attributes: {
                    __typename?: "CourseCategory";
                    name: string;
                    description?: string | null;
                  };
                };
              } | null;
              modules?: Array<{
                __typename?: "ComponentLearnCourseModule";
                id: string;
                title: string;
                moduleStableId: string;
                lessons?: Array<{
                  __typename?: "ComponentLearnCourseLesson";
                  id: string;
                  title: string;
                  lessonStableId: string;
                  authors: Array<{
                    __typename?: "Author";
                    data: {
                      __typename?: "Author";
                      attributes: { __typename?: "Author"; name: string };
                    };
                  } | null>;
                } | null> | null;
              } | null> | null;
            };
          };
        } | null;
        learn_items?: {
          __typename?: "LearnItemRelationResponseCollection";
          data: Array<{
            __typename?: "LearnItem";
            attributes: {
              __typename?: "LearnItem";
              idModule: string;
              idLesson: string;
            };
          }>;
        } | null;
      };
    }>;
  } | null;
};

export type CoursePageQueryVariables = Exact<{ [key: string]: never }>;

export type CoursePageQuery = {
  __typename?: "Query";
  coursePage?: {
    __typename?: "CoursePage";
    data: {
      __typename?: "CoursePage";
      attributes: {
        __typename?: "CoursePage";
        lesson?: {
          __typename?: "ComponentCoursePageLesson";
          beginButtonLabel?: string | null;
          watchAgainButtonlabel?: string | null;
          lockedButtonlabel?: string | null;
          offlineModeLockedButtonLabel?: string | null;
        } | null;
      };
    };
  } | null;
};

export type LearnPageQueryVariables = Exact<{ [key: string]: never }>;

export type LearnPageQuery = {
  __typename?: "Query";
  learnPage?: {
    __typename?: "LearnPage";
    data: {
      __typename?: "LearnPage";
      attributes: {
        __typename?: "LearnPage";
        emptyInProgressCoursesMessage?: string | null;
        emptyCompletedCoursesMessage?: string | null;
        emptyCoursesMessage?: string | null;
        learnHighlight?: {
          __typename?: "ComponentCommonLearnHighlight";
          title: string;
          description: string;
          image: {
            __typename?: "UploadFile";
            data: {
              __typename?: "UploadFile";
              attributes: {
                __typename?: "UploadFile";
                url: string;
                alternativeText?: string | null;
                mime: string;
              };
            };
          };
        } | null;
        markLessonAsCompleteButton?: {
          __typename?: "ComponentLearnMarkAsCompleteButton";
          markAsCompleteLabel?: string | null;
          completedLabel?: string | null;
        } | null;
        markCourseAsCompleted?: {
          __typename?: "ComponentLearnMarkAsCompleteButton";
          markAsCompleteLabel?: string | null;
          completedLabel?: string | null;
        } | null;
        contentTemplateLabels?: {
          __typename?: "ComponentCommonContentTemplateLabels";
          downloadableContentLabel?: string | null;
        } | null;
      };
    };
  } | null;
};

export type CourseFeedbackPageQueryVariables = Exact<{ [key: string]: never }>;

export type CourseFeedbackPageQuery = {
  __typename?: "Query";
  learnPage?: {
    __typename?: "LearnPage";
    data: {
      __typename?: "LearnPage";
      attributes: {
        __typename?: "LearnPage";
        markCourseAsCompleted?: {
          __typename?: "ComponentLearnMarkAsCompleteButton";
          completedLabel?: string | null;
        } | null;
        feedbackSection?: {
          __typename?: "ComponentLearnFeebackSection";
          title: string;
          description: string;
          submitYourFeedback?: string | null;
          enterYourFeedback: string;
          sendFeedback: string;
        } | null;
        modalLeavePage?: {
          __typename?: "ComponentLearnModalLeavePage";
          title: string;
          description?: string | null;
          confirmButton: string;
          cancelButton: string;
        } | null;
      };
    };
  } | null;
};

export type FetchUserTrackingQueryVariables = Exact<{ [key: string]: never }>;

export type FetchUserTrackingQuery = {
  __typename?: "Query";
  getUserTrackingData?: {
    __typename?: "UserTrackingDataResult";
    dailyStreak?: number | null;
    streakRecord?: number | null;
    emotionsTracked?: number | null;
  } | null;
};

export type FetchLoginTrackerQueryVariables = Exact<{
  startDay: Scalars["Date"]["input"];
  endDay: Scalars["Date"]["input"];
  staffId: Scalars["ID"]["input"];
}>;

export type FetchLoginTrackerQuery = {
  __typename?: "Query";
  loginTrackers?: {
    __typename?: "LoginTrackerEntityResponseCollection";
    data: Array<{
      __typename?: "LoginTracker";
      attributes: {
        __typename?: "LoginTracker";
        streakCounter?: number | null;
        day?: any | null;
      };
    }>;
  } | null;
};

export type ForgotPasswordPageQueryVariables = Exact<{ [key: string]: never }>;

export type ForgotPasswordPageQuery = {
  __typename?: "Query";
  forgotPassword?: {
    __typename?: "ForgotPassword";
    data: {
      __typename?: "ForgotPassword";
      attributes: {
        __typename?: "ForgotPassword";
        forgotPasswordTitle: string;
        forgotPasswordDescription: string;
        customerEmailAddressTitle: string;
        sendMeCta: string;
        backToLoginCta: string;
        chooseANewPasswordTitle: string;
        passwordsShouldBeDescription: string;
        yourNewPassword: string;
        repeatYourPassword: string;
        resetMyPasswordCta: string;
        pageImage: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        feedback?: {
          __typename?: "ComponentRegisterFeedbackFeedback";
          emailSent?: {
            __typename?: "ComponentCommonEmailSent";
            title?: string | null;
            description?: string | null;
          } | null;
          passwordResetSuccess?: {
            __typename?: "ComponentCommonEmailSent";
            title?: string | null;
            description?: string | null;
          } | null;
          passwordResetError?: {
            __typename?: "ComponentCommonEmailSent";
            title?: string | null;
            description?: string | null;
          } | null;
        } | null;
      };
    };
  } | null;
};

export type LoginPageQueryVariables = Exact<{ [key: string]: never }>;

export type LoginPageQuery = {
  __typename?: "Query";
  loginPage?: {
    __typename?: "LoginPage";
    data: {
      __typename?: "LoginPage";
      attributes: {
        __typename?: "LoginPage";
        loginTitle: string;
        yourEmailTitle: string;
        yourPasswordTitle: string;
        rememberMeTitle: string;
        loginCta: string;
        forgotYourPasswordCta: string;
        confirmEmailTitle: string;
        pleaseLoginTItle: string;
        pageImage: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        fieldErrors?: {
          __typename?: "ComponentLoginLoginFieldErrors";
          identifierRequired?: string | null;
          passwordRequired?: string | null;
        } | null;
        popUpMessages?: {
          __typename?: "ComponentLoginToastMessagesLogin";
          success?: {
            __typename?: "ComponentCommonToast";
            title?: string | null;
            message?: string | null;
          } | null;
          error?: {
            __typename?: "ComponentCommonToast";
            title?: string | null;
            message?: string | null;
          } | null;
        } | null;
      };
    };
  } | null;
};

export type RegisterPageQueryVariables = Exact<{ [key: string]: never }>;

export type RegisterPageQuery = {
  __typename?: "Query";
  registerPage?: {
    __typename?: "RegisterPage";
    data: {
      __typename?: "RegisterPage";
      attributes: {
        __typename?: "RegisterPage";
        registerTitle: string;
        description: string;
        yourEmail: string;
        schoolCode: string;
        yourFirstName: string;
        yourLastName: string;
        choosePassword: string;
        repeatYourPassword: string;
        createYourAccountCta: string;
        welcomeToTItle: string;
        successRegisterPopUpTitle?: string | null;
        successRegisterPopUpMessage?: string | null;
        pageImage: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        image: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        fieldErrors?: {
          __typename?: "ComponentRegisterRegisterFieldErrors";
          surnameRequired?: string | null;
          forenameRequired?: string | null;
          emailRequired?: string | null;
          schoolCodeRequired?: string | null;
          passwordRequired?: string | null;
          termsAndConditionsRequired?: string | null;
          confirmPasswordRequired?: string | null;
          confirmPasswordDidNotMatch?: string | null;
        } | null;
        popUpMessages?: {
          __typename?: "ComponentRegisterToastMessagesRegister";
          success?: {
            __typename?: "ComponentCommonToast";
            title?: string | null;
            message?: string | null;
          } | null;
          error?: {
            __typename?: "ComponentCommonToast";
            title?: string | null;
            message?: string | null;
          } | null;
        } | null;
      };
    };
  } | null;
};

export type FetchManageStaffPageQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchManageStaffPageQuery = {
  __typename?: "Query";
  manageUsersPage?: {
    __typename?: "ManageUsersPage";
    title?: string | null;
    description?: string | null;
    staffListTitle?: string | null;
    inviteStaff?: {
      __typename?: "ComponentReportingToolsInviteUsers";
      title?: string | null;
      description?: string | null;
      inviteStaff?: string | null;
      importStaffSpreadsheet?: string | null;
      toastStaffInvitedTitle?: string | null;
      toastStaffInvitedDescription?: string | null;
      dialogTitle?: string | null;
      dialogDescription?: string | null;
      dialogConfirmButton?: string | null;
    } | null;
    staffImportFromSpreadsheetDialog?: {
      __typename?: "ComponentAdminManagementUserImportFromFileModal";
      title?: string | null;
      description?: string | null;
      closeButtonText?: string | null;
      importStaffButtonText?: string | null;
      uploadFileButtonText?: string | null;
      previewTitle: string;
      toastStaffImportedTitle?: string | null;
      toastStaffImportedDescription?: string | null;
    } | null;
    staffEmptyState?: {
      __typename?: "ComponentReportingToolsUsersEmptyState";
      title?: string | null;
      description?: string | null;
    } | null;
    staffStatus?: {
      __typename?: "ComponentReportingToolsStaffStatus";
      pendingInviteMessage?: string | null;
      invitedPendingSignUpMessage?: string | null;
      registeredPendingOnboardingMessage?: string | null;
      registeredOnboardedMessage?: string | null;
      invitedPendingSignUpColor?: string | null;
      registeredPendingOnboardingColor?: string | null;
      registeredOnboardedColor?: string | null;
      pendingInviteColor?: string | null;
    } | null;
  } | null;
};

export type NotificationsQueryVariables = Exact<{
  filters?: InputMaybe<NotificationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  schoolContextDocumentId: Scalars["ID"]["input"];
}>;

export type NotificationsQuery = {
  __typename?: "Query";
  notifications_connection?: {
    __typename?: "NotificationEntityResponseCollection";
    nodes: Array<{
      __typename?: "Notification";
      documentId: string;
      link: string;
      isCustom: boolean;
      priority: Enum_Notification_Priority;
      customTemplate?: string | null;
      createdAt?: any | null;
      publishedAt?: any | null;
      template?: {
        __typename?: "NotificationTemplate";
        documentId: string;
        type: Enum_Notificationtemplate_Type;
        category: Enum_Notificationtemplate_Category;
        template: string;
      } | null;
      resource?: {
        __typename?: "Resource";
        documentId: string;
        title: string;
        slug: string;
        cover?: {
          __typename?: "UploadFile";
          url: string;
          alternativeText?: string | null;
        } | null;
      } | null;
      schools: Array<{
        __typename?: "School";
        documentId: string;
        name: string;
      } | null>;
    }>;
    pageInfo: {
      __typename?: "Pagination";
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  } | null;
};

export type NotificationByIdQueryVariables = Exact<{
  documentId: Scalars["ID"]["input"];
}>;

export type NotificationByIdQuery = {
  __typename?: "Query";
  notification?: {
    __typename?: "Notification";
    documentId: string;
    link: string;
    isCustom: boolean;
    priority: Enum_Notification_Priority;
    customTemplate?: string | null;
    createdAt?: any | null;
    publishedAt?: any | null;
    template?: {
      __typename?: "NotificationTemplate";
      documentId: string;
      type: Enum_Notificationtemplate_Type;
      category: Enum_Notificationtemplate_Category;
      template: string;
    } | null;
    resource?: {
      __typename?: "Resource";
      documentId: string;
      title: string;
      slug: string;
      cover?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      } | null;
    } | null;
    schools: Array<{
      __typename?: "School";
      documentId: string;
      name: string;
    } | null>;
  } | null;
};

export type UserNotificationsQueryVariables = Exact<{
  filters?: InputMaybe<NotificationUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type UserNotificationsQuery = {
  __typename?: "Query";
  notificationUsers_connection?: {
    __typename?: "NotificationUserEntityResponseCollection";
    nodes: Array<{
      __typename?: "NotificationUser";
      documentId: string;
      deliveredAt?: any | null;
      clickedAt?: any | null;
      seenAt?: any | null;
      notification?: {
        __typename?: "Notification";
        documentId: string;
        link: string;
        isCustom: boolean;
        priority: Enum_Notification_Priority;
        customTemplate?: string | null;
        createdAt?: any | null;
        publishedAt?: any | null;
        template?: {
          __typename?: "NotificationTemplate";
          documentId: string;
          type: Enum_Notificationtemplate_Type;
          category: Enum_Notificationtemplate_Category;
          template: string;
        } | null;
        resource?: {
          __typename?: "Resource";
          documentId: string;
          title: string;
          slug: string;
          cover?: {
            __typename?: "UploadFile";
            url: string;
            alternativeText?: string | null;
          } | null;
        } | null;
      } | null;
    }>;
    pageInfo: {
      __typename?: "Pagination";
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  } | null;
};

export type UnreadNotificationsCountQueryVariables = Exact<{
  filters?: InputMaybe<NotificationUserFiltersInput>;
}>;

export type UnreadNotificationsCountQuery = {
  __typename?: "Query";
  notificationUsers_connection?: {
    __typename?: "NotificationUserEntityResponseCollection";
    pageInfo: { __typename?: "Pagination"; total: number };
  } | null;
};

export type NotificationTemplatesQueryVariables = Exact<{
  filters?: InputMaybe<NotificationTemplateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type NotificationTemplatesQuery = {
  __typename?: "Query";
  notificationTemplates_connection?: {
    __typename?: "NotificationTemplateEntityResponseCollection";
    nodes: Array<{
      __typename?: "NotificationTemplate";
      documentId: string;
      type: Enum_Notificationtemplate_Type;
      category: Enum_Notificationtemplate_Category;
      template: string;
      createdAt?: any | null;
    }>;
    pageInfo: {
      __typename?: "Pagination";
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  } | null;
};

export type OnBoardingQueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingQuery = {
  __typename?: "Query";
  onBoardingPage?: {
    __typename?: "OnBoardingPage";
    logo?: {
      __typename?: "UploadFile";
      url: string;
      alternativeText?: string | null;
    } | null;
  } | null;
  step1?: {
    __typename?: "Step1";
    content: {
      __typename?: "ComponentOnBoardingOnBoardingContainer";
      title: string;
      description?: string | null;
      image?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      } | null;
      button?: {
        __typename?: "ComponentCommonButton";
        text: string;
        link: string;
      } | null;
    };
  } | null;
  step2?: {
    __typename?: "Step2";
    content: {
      __typename?: "ComponentOnBoardingOnBoardingContainer";
      title: string;
      description?: string | null;
      image?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      } | null;
      button?: {
        __typename?: "ComponentCommonButton";
        text: string;
        link: string;
      } | null;
    };
  } | null;
  step3?: {
    __typename?: "Step3";
    content?: {
      __typename?: "ComponentOnBoardingOnBoardingContainer";
      title: string;
      description?: string | null;
      image?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      } | null;
      button?: {
        __typename?: "ComponentCommonButton";
        text: string;
        link: string;
      } | null;
    } | null;
  } | null;
  step4?: {
    __typename?: "Step4";
    content?: {
      __typename?: "ComponentOnBoardingOnBoardingContainer";
      title: string;
      description?: string | null;
      image?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      } | null;
      button?: {
        __typename?: "ComponentCommonButton";
        text: string;
        link: string;
      } | null;
    } | null;
    roles?: Array<{
      __typename?: "ComponentCommonRoles";
      role?: string | null;
    } | null> | null;
    ageBracket?: {
      __typename?: "ComponentCommonFieldSelect";
      label: string;
      placeholder: string;
      options?: Array<{
        __typename?: "ComponentCommonText";
        option: string;
      } | null> | null;
    } | null;
    role?: {
      __typename?: "ComponentCommonField";
      label: string;
      placeholder: string;
    } | null;
    gender?: {
      __typename?: "ComponentCommonFieldSelect";
      label: string;
      placeholder: string;
      options?: Array<{
        __typename?: "ComponentCommonText";
        option: string;
      } | null> | null;
    } | null;
    location?: {
      __typename?: "ComponentCommonField";
      label: string;
      placeholder: string;
    } | null;
  } | null;
  step5?: {
    __typename?: "Step5";
    content: {
      __typename?: "ComponentOnBoardingOnBoardingContainer";
      title: string;
      description?: string | null;
      image?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      } | null;
      button?: {
        __typename?: "ComponentCommonButton";
        text: string;
        link: string;
      } | null;
    };
  } | null;
};

export type OnBoardingStep1QueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingStep1Query = {
  __typename?: "Query";
  step1?: {
    __typename?: "Step1";
    data: {
      __typename?: "Step1";
      attributes: {
        __typename?: "Step1";
        content: {
          __typename?: "ComponentOnBoardingOnBoardingContainer";
          title: string;
          description?: string | null;
          image?: {
            __typename?: "UploadFile";
            data: {
              __typename?: "UploadFile";
              attributes: {
                __typename?: "UploadFile";
                url: string;
                alternativeText?: string | null;
              };
            };
          } | null;
          button?: {
            __typename?: "ComponentCommonButton";
            text: string;
            link: string;
          } | null;
        };
      };
    };
  } | null;
};

export type OnBoardingStep2QueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingStep2Query = {
  __typename?: "Query";
  step2?: {
    __typename?: "Step2";
    data: {
      __typename?: "Step2";
      attributes: {
        __typename?: "Step2";
        content: {
          __typename?: "ComponentOnBoardingOnBoardingContainer";
          title: string;
          description?: string | null;
          image?: {
            __typename?: "UploadFile";
            data: {
              __typename?: "UploadFile";
              attributes: {
                __typename?: "UploadFile";
                url: string;
                alternativeText?: string | null;
              };
            };
          } | null;
          button?: {
            __typename?: "ComponentCommonButton";
            text: string;
            link: string;
          } | null;
        };
      };
    };
  } | null;
};

export type OnBoardingStep3QueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingStep3Query = {
  __typename?: "Query";
  step3?: {
    __typename?: "Step3";
    data: {
      __typename?: "Step3";
      attributes: {
        __typename?: "Step3";
        content?: {
          __typename?: "ComponentOnBoardingOnBoardingContainer";
          title: string;
          description?: string | null;
          image?: {
            __typename?: "UploadFile";
            data: {
              __typename?: "UploadFile";
              attributes: {
                __typename?: "UploadFile";
                url: string;
                alternativeText?: string | null;
              };
            };
          } | null;
          button?: {
            __typename?: "ComponentCommonButton";
            text: string;
            link: string;
          } | null;
        } | null;
      };
    };
  } | null;
};

export type OnBoardingStep4QueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingStep4Query = {
  __typename?: "Query";
  step4?: {
    __typename?: "Step4";
    data: {
      __typename?: "Step4";
      attributes: {
        __typename?: "Step4";
        content?: {
          __typename?: "ComponentOnBoardingOnBoardingContainer";
          title: string;
          description?: string | null;
          image?: {
            __typename?: "UploadFile";
            data: {
              __typename?: "UploadFile";
              attributes: {
                __typename?: "UploadFile";
                url: string;
                alternativeText?: string | null;
              };
            };
          } | null;
          button?: {
            __typename?: "ComponentCommonButton";
            text: string;
            link: string;
          } | null;
        } | null;
        roles?: Array<{
          __typename?: "ComponentCommonRoles";
          role?: string | null;
        } | null> | null;
        ageBracket?: {
          __typename?: "ComponentCommonFieldSelect";
          label: string;
          placeholder: string;
          options?: Array<{
            __typename?: "ComponentCommonText";
            option: string;
          } | null> | null;
        } | null;
        role?: {
          __typename?: "ComponentCommonField";
          label: string;
          placeholder: string;
        } | null;
        gender?: {
          __typename?: "ComponentCommonFieldSelect";
          label: string;
          placeholder: string;
          options?: Array<{
            __typename?: "ComponentCommonText";
            option: string;
          } | null> | null;
        } | null;
        location?: {
          __typename?: "ComponentCommonField";
          label: string;
          placeholder: string;
        } | null;
      };
    };
  } | null;
};

export type OnBoardingStep5QueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingStep5Query = {
  __typename?: "Query";
  step5?: {
    __typename?: "Step5";
    data: {
      __typename?: "Step5";
      attributes: {
        __typename?: "Step5";
        content: {
          __typename?: "ComponentOnBoardingOnBoardingContainer";
          title: string;
          description?: string | null;
          image?: {
            __typename?: "UploadFile";
            data: {
              __typename?: "UploadFile";
              attributes: {
                __typename?: "UploadFile";
                url: string;
                alternativeText?: string | null;
              };
            };
          } | null;
          button?: {
            __typename?: "ComponentCommonButton";
            text: string;
            link: string;
          } | null;
        };
      };
    };
  } | null;
};

export type PodcastListPageQueryVariables = Exact<{ [key: string]: never }>;

export type PodcastListPageQuery = {
  __typename?: "Query";
  podcastListPage?: {
    __typename?: "PodcastListPage";
    pageTitle?: string | null;
    heroTitle: string;
    heroDescription?: string | null;
    latestTitle: string;
    moreButtonTitle: string;
    listenAtLabel?: string | null;
    heroImage?: {
      __typename?: "UploadFile";
      url: string;
      alternativeText?: string | null;
    } | null;
    platforms?: Array<{
      __typename?: "ComponentPodcastPodcastPlatformLink";
      url: string;
      platform?: {
        __typename?: "PodcastPlatform";
        name: string;
        icon: {
          __typename?: "UploadFile";
          url: string;
          alternativeText?: string | null;
        };
      } | null;
    } | null> | null;
    card?: {
      __typename?: "ComponentPodcastListPageCard";
      watchButtonLabel?: string | null;
      watchAgainButtonLabel?: string | null;
    } | null;
  } | null;
};

export type PodcastDetailPageQueryVariables = Exact<{ [key: string]: never }>;

export type PodcastDetailPageQuery = {
  __typename?: "Query";
  podcastDetailPage?: {
    __typename?: "PodcastDetailPage";
    backLinkLabel: string;
    viewAllLabel: string;
  } | null;
};

export type FetchPodcastsQueryVariables = Exact<{
  page: Scalars["Int"]["input"];
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  userDocumentId: Scalars["ID"]["input"];
}>;

export type FetchPodcastsQuery = {
  __typename?: "Query";
  podcasts?: {
    __typename?: "PodcastEntityResponseCollection";
    nodes: Array<{
      __typename?: "Podcast";
      documentId: string;
      title: string;
      slug: string;
      briefDescription: string;
      publicationDate: any;
      listenings: Array<{
        __typename?: "PodcastListeningTime";
        documentId: string;
        listeningTime: any;
        duration: any;
      } | null>;
      cover: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      };
    }>;
    pageInfo: {
      __typename?: "Pagination";
      page: number;
      pageCount: number;
      total: number;
      pageSize: number;
    };
  } | null;
};

export type FetchSearchPodcastsQueryVariables = Exact<{
  filters?: InputMaybe<PodcastFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  userDocumentId: Scalars["ID"]["input"];
}>;

export type FetchSearchPodcastsQuery = {
  __typename?: "Query";
  podcasts?: {
    __typename?: "PodcastEntityResponseCollection";
    nodes: Array<{
      __typename?: "Podcast";
      documentId: string;
      title: string;
      slug: string;
      briefDescription: string;
      publicationDate: any;
      listenings: Array<{
        __typename?: "PodcastListeningTime";
        documentId: string;
        listeningTime: any;
        duration: any;
      } | null>;
      cover: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      };
    }>;
    pageInfo: {
      __typename?: "Pagination";
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  } | null;
};

export type PodcastBySlugQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
  userDocumentId: Scalars["ID"]["input"];
}>;

export type PodcastBySlugQuery = {
  __typename?: "Query";
  podcastBySlug?: {
    __typename?: "PodcastBySlugResponse";
    current?: {
      __typename?: "Podcast";
      documentId: string;
      title: string;
      slug: string;
      briefDescription: string;
      fullDescription?: string | null;
      publicationDate: any;
      createdAt?: any | null;
      publishedAt?: any | null;
      listenings: Array<{
        __typename?: "PodcastListeningTime";
        documentId: string;
        listeningTime: any;
        duration: any;
      } | null>;
      DefaultContentTemplate: Array<
        | {
            __typename: "ComponentCommonAudio";
            transcription?: string | null;
            audio: { __typename?: "UploadFile"; url: string; name: string };
          }
        | { __typename: "ComponentCommonAuthor" }
        | {
            __typename: "ComponentCommonAuthorDetailed";
            authors?: {
              __typename?: "AuthorRelationResponseCollection";
              nodes: Array<{
                __typename?: "Author";
                name: string;
                role?: string | null;
                bio?: string | null;
                avatar: {
                  __typename?: "UploadFile";
                  url: string;
                  alternativeText?: string | null;
                };
              }>;
            } | null;
          }
        | {
            __typename: "ComponentCommonBullet";
            item: Array<{
              __typename?: "ComponentCommonList";
              text: string;
            } | null>;
          }
        | { __typename: "ComponentCommonDivider"; id: string }
        | {
            __typename: "ComponentCommonDownloadableContentList";
            list?: Array<{
              __typename?: "ComponentCommonDownloadableContent";
              title: string;
              description?: string | null;
              content: { __typename?: "UploadFile"; url: string };
            } | null> | null;
          }
        | {
            __typename: "ComponentCommonEmbedded";
            link: string;
            provider: Enum_Componentcommonembedded_Provider;
          }
        | {
            __typename: "ComponentCommonFaqComponent";
            faq?: Array<{
              __typename?: "ComponentCommonFaq";
              title: string;
              description: string;
            } | null> | null;
          }
        | { __typename: "ComponentCommonH3"; text: string }
        | {
            __typename: "ComponentCommonMedia";
            media: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
            };
          }
        | { __typename: "ComponentCommonQuote"; quote: string }
        | { __typename: "ComponentCommonRelatedContent"; id: string }
        | { __typename: "ComponentCommonTags"; id: string }
        | {
            __typename: "ComponentCommonTextEditor";
            markdownText?: string | null;
          }
        | { __typename: "ComponentCommonTitle"; title: string }
        | {
            __typename: "ComponentPodcastPodcastRelated";
            id: string;
            podcasts?: {
              __typename?: "PodcastRelationResponseCollection";
              nodes: Array<{
                __typename?: "Podcast";
                documentId: string;
                title: string;
                slug: string;
                briefDescription: string;
                publicationDate: any;
                listenings: Array<{
                  __typename?: "PodcastListeningTime";
                  documentId: string;
                  listeningTime: any;
                  duration: any;
                } | null>;
                cover: {
                  __typename?: "UploadFile";
                  url: string;
                  alternativeText?: string | null;
                  mime: string;
                };
              }>;
            } | null;
          }
        | { __typename: "Error" }
        | null
      >;
      platforms?: Array<{
        __typename?: "ComponentPodcastPodcastPlatformLink";
        url: string;
        platform?: {
          __typename?: "PodcastPlatform";
          name: string;
          icon: {
            __typename?: "UploadFile";
            url: string;
            alternativeText?: string | null;
          };
        } | null;
      } | null> | null;
      cover: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      };
    } | null;
  } | null;
};

export type PrivacyPolicyPageQueryVariables = Exact<{ [key: string]: never }>;

export type PrivacyPolicyPageQuery = {
  __typename?: "Query";
  privacyPolicyPage?: {
    __typename?: "PrivacyPolicyPage";
    data: {
      __typename?: "PrivacyPolicyPage";
      id: string;
      attributes: {
        __typename?: "PrivacyPolicyPage";
        title: string;
        DefaultContentTemplate: Array<
          | {
              __typename: "ComponentCommonAuthor";
              publicationDate: any;
              author?: {
                __typename?: "Author";
                data: {
                  __typename?: "Author";
                  attributes: { __typename?: "Author"; name: string };
                };
              } | null;
            }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | {
              __typename: "ComponentCommonBullet";
              item: Array<{
                __typename?: "ComponentCommonList";
                text: string;
              } | null>;
            }
          | { __typename: "ComponentCommonDivider"; id: string }
          | {
              __typename: "ComponentCommonDownloadableContentList";
              list?: Array<{
                __typename?: "ComponentCommonDownloadableContent";
                id: string;
                title: string;
                description?: string | null;
                content: {
                  __typename?: "UploadFile";
                  data: {
                    __typename?: "UploadFile";
                    attributes: { __typename?: "UploadFile"; url: string };
                  };
                };
              } | null> | null;
            }
          | {
              __typename: "ComponentCommonEmbedded";
              link: string;
              provider: Enum_Componentcommonembedded_Provider;
            }
          | {
              __typename: "ComponentCommonFaqComponent";
              faq?: Array<{
                __typename?: "ComponentCommonFaq";
                title: string;
                description: string;
              } | null> | null;
            }
          | { __typename: "ComponentCommonH3"; text: string }
          | {
              __typename: "ComponentCommonMedia";
              media: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                  };
                };
              };
            }
          | { __typename: "ComponentCommonQuote"; quote: string }
          | {
              __typename: "ComponentCommonTextEditor";
              markdownText?: string | null;
            }
          | { __typename: "ComponentCommonTitle"; title: string }
          | { __typename: "Error" }
          | null
        >;
      };
    };
  } | null;
};

export type FindUsersPermissionsUserByIdQueryVariables = Exact<{
  documentId: Scalars["ID"]["input"];
}>;

export type FindUsersPermissionsUserByIdQuery = {
  __typename?: "Query";
  usersPermissionsUser?: {
    __typename?: "UsersPermissionsUser";
    data: {
      __typename?: "UsersPermissionsUser";
      id: string;
      documentId: string;
      attributes: {
        __typename?: "UsersPermissionsUser";
        username: string;
        email: string;
        provider?: string | null;
        confirmed?: boolean | null;
        blocked?: boolean | null;
        onboardHomeCompleted: boolean;
        location?: string | null;
        forename?: string | null;
        surname?: string | null;
        confirmationEmailSent?: boolean | null;
        ageBracket?: string | null;
        gender?: string | null;
        onboardQuestionsCompleted: boolean;
        isLeadershipWheelTrackingDisabled?: boolean | null;
        onboardLeadershipWheelCompleted: boolean;
        profile?: string | null;
        createdAt?: any | null;
        school?: {
          __typename?: "School";
          data: {
            __typename?: "School";
            id: string;
            documentId: string;
            attributes: {
              __typename?: "School";
              name: string;
              subscription?: {
                __typename?: "Subscription";
                data: {
                  __typename?: "Subscription";
                  attributes: {
                    __typename?: "Subscription";
                    name: string;
                    knowledgeBase: boolean;
                    learn: boolean;
                    search: boolean;
                    bookmark: boolean;
                    mission: boolean;
                    podcast: boolean;
                    resourceHub: boolean;
                  };
                };
              } | null;
            };
          };
        } | null;
        access_control_list?: {
          __typename?: "AccessControlList";
          data: {
            __typename?: "AccessControlList";
            attributes: {
              __typename?: "AccessControlList";
              name: string;
              isInstructor?: boolean | null;
              isMAT?: boolean | null;
              reportingTools?: boolean | null;
              manageStaff?: boolean | null;
            };
          };
        } | null;
        photo?: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
            };
          };
        } | null;
      };
    };
  } | null;
};

export type ProfilePageQueryVariables = Exact<{ [key: string]: never }>;

export type ProfilePageQuery = {
  __typename?: "Query";
  profilePage?: {
    __typename?: "ProfilePage";
    data: {
      __typename?: "ProfilePage";
      attributes: {
        __typename?: "ProfilePage";
        welcomeTitle: string;
        editProfileButtonLabel?: string | null;
        closeAccountButtonlabel?: string | null;
        confirmAccountClosureTitle?: string | null;
        confirmAccountClosureDescription?: string | null;
        profileInfoSection: {
          __typename?: "ComponentProfileProfileInfoSection";
          memberSinceTitle: string;
          youLocationTitle: string;
          editYourInfoCta: string;
          saveYourChangesCta: string;
          saveYourChangesSettingsCta?: string | null;
          surnamePlaceholder: string;
          forenamePlaceholder: string;
        };
        profilePasswordSection: {
          __typename?: "ComponentProfileProfilePasswordSection";
          yourPasswordTitle: string;
          yourCurrentPasswordField: string;
          yourNewPasswordField: string;
          confirmYourPasswordField: string;
          confirmYourChangesCta: string;
        };
        profileNotificationsSection: {
          __typename?: "ComponentProfileProfileNotificationsSection";
          yourNotificationsTitle: string;
          confirmYourChangesCta: string;
        };
        profileSubTraitsSection: {
          __typename?: "ComponentProfileProfileSubtraitsSection";
          yourFocusTitle: string;
          whichAreasTitle: string;
          confirmYouChangesCta: string;
        };
        traitTrackingSection?: {
          __typename?: "ComponentProfileTraitTrackingSection";
          title: string;
          btnStopTrackingLabel: string;
          btnStartTrackingLabel: string;
          notRecordedLabel: string;
          notRecordedDescription?: string | null;
          notRecordedIcon: {
            __typename?: "UploadFile";
            data: {
              __typename?: "UploadFile";
              attributes: {
                __typename?: "UploadFile";
                url: string;
                alternativeText?: string | null;
                mime: string;
              };
            };
          };
          notTrackingIcon: {
            __typename?: "UploadFile";
            data: {
              __typename?: "UploadFile";
              attributes: {
                __typename?: "UploadFile";
                url: string;
                alternativeText?: string | null;
                mime: string;
              };
            };
          };
        } | null;
        statsAndStreaks?: {
          __typename?: "ComponentProfilePageStatsAndStreaks";
          finishingCardStreak?: {
            __typename?: "ComponentProfilePageFinishingCardStreak";
            days?: string | null;
            title?: string | null;
          } | null;
          finishingCardMaxStreak?: {
            __typename?: "ComponentProfilePageFinishingCardMaxStreak";
            days?: string | null;
            title?: string | null;
          } | null;
          finishingCardLeadershipWheel?: {
            __typename?: "ComponentProfilePageFinishingCardTraits";
            traits?: string | null;
          } | null;
        } | null;
      };
    };
  } | null;
};

export type FindUsersPermissionsUserByIdV5QueryVariables = Exact<{
  documentId: Scalars["ID"]["input"];
}>;

export type FindUsersPermissionsUserByIdV5Query = {
  __typename?: "Query";
  fetchMySchools?: Array<{
    __typename?: "School";
    documentId: string;
    name: string;
    code?: string | null;
    logoMAT?: {
      __typename?: "UploadFile";
      url: string;
      alternativeText?: string | null;
    } | null;
    subscription?: {
      __typename?: "Subscription";
      name: string;
      knowledgeBase: boolean;
      learn: boolean;
      search: boolean;
      bookmark: boolean;
      mission: boolean;
      podcast: boolean;
      resourceHub: boolean;
    } | null;
  }> | null;
  usersPermissionsUser?: {
    __typename?: "UsersPermissionsUser";
    id: string;
    documentId: string;
    username: string;
    email: string;
    provider?: string | null;
    confirmed?: boolean | null;
    blocked?: boolean | null;
    onboardHomeCompleted: boolean;
    location?: string | null;
    forename?: string | null;
    surname?: string | null;
    confirmationEmailSent?: boolean | null;
    ageBracket?: string | null;
    gender?: string | null;
    onboardQuestionsCompleted: boolean;
    isLeadershipWheelTrackingDisabled?: boolean | null;
    onboardLeadershipWheelCompleted: boolean;
    profile?: string | null;
    createdAt?: any | null;
    school?: {
      __typename?: "School";
      documentId: string;
      name: string;
      logoMAT?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      } | null;
      subscription?: {
        __typename?: "Subscription";
        name: string;
        knowledgeBase: boolean;
        learn: boolean;
        search: boolean;
        bookmark: boolean;
        mission: boolean;
        podcast: boolean;
        resourceHub: boolean;
      } | null;
    } | null;
    access_control_list?: {
      __typename?: "AccessControlList";
      name: string;
      isInstructor?: boolean | null;
      isMAT?: boolean | null;
      reportingTools?: boolean | null;
      manageStaff?: boolean | null;
    } | null;
    photo?: {
      __typename?: "UploadFile";
      url: string;
      alternativeText?: string | null;
    } | null;
  } | null;
};

export type ProfilePageV5QueryVariables = Exact<{ [key: string]: never }>;

export type ProfilePageV5Query = {
  __typename?: "Query";
  profilePage?: {
    __typename?: "ProfilePage";
    welcomeTitle: string;
    latestResourcesDownloadedTitle?: string | null;
    noDownloadedResourcesMessage?: string | null;
    profileInfoSection: {
      __typename?: "ComponentProfileProfileInfoSection";
      roleTitle?: string | null;
      memberSinceTitle: string;
      youLocationTitle: string;
      editYourInfoCta: string;
      saveYourChangesCta: string;
      surnamePlaceholder: string;
      forenamePlaceholder: string;
    };
    profilePasswordSection: {
      __typename?: "ComponentProfileProfilePasswordSection";
      yourPasswordTitle: string;
      yourCurrentPasswordField: string;
      yourNewPasswordField: string;
      confirmYourPasswordField: string;
      confirmYourChangesCta: string;
    };
    profileNotificationsSection: {
      __typename?: "ComponentProfileProfileNotificationsSection";
      yourNotificationsTitle: string;
      confirmYourChangesCta: string;
    };
    profileSubTraitsSection: {
      __typename?: "ComponentProfileProfileSubtraitsSection";
      yourFocusTitle: string;
      whichAreasTitle: string;
      confirmYouChangesCta: string;
    };
    traitTrackingSection?: {
      __typename?: "ComponentProfileTraitTrackingSection";
      title: string;
      btnStopTrackingLabel: string;
      btnStartTrackingLabel: string;
      notRecordedLabel: string;
      notRecordedDescription?: string | null;
      notRecordedIcon: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      };
      notTrackingIcon: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
      };
    } | null;
    statsAndStreaks?: {
      __typename?: "ComponentProfilePageStatsAndStreaks";
      finishingCardStreak?: {
        __typename?: "ComponentProfilePageFinishingCardStreak";
        days?: string | null;
        title?: string | null;
      } | null;
      finishingCardMaxStreak?: {
        __typename?: "ComponentProfilePageFinishingCardMaxStreak";
        days?: string | null;
        title?: string | null;
      } | null;
      finishingCardLeadershipWheel?: {
        __typename?: "ComponentProfilePageFinishingCardTraits";
        traits?: string | null;
      } | null;
    } | null;
  } | null;
};

export type FetchUserDownloadedResourcesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type FetchUserDownloadedResourcesQuery = {
  __typename?: "Query";
  fetchUserDownloadedResources?: Array<{
    __typename?: "Resource";
    documentId: string;
    title: string;
    slug: string;
    briefDescription?: string | null;
    subHeader?: string | null;
    publicationDate?: any | null;
    resourceStatus?: Enum_Resource_Resourcestatus | null;
    expireResourceStatusAt?: any | null;
    assetsCount?: number | null;
    type?: {
      __typename?: "ResourceType";
      documentId: string;
      type: string;
    } | null;
    category?: {
      __typename?: "ResourceCategory";
      documentId: string;
      category: string;
    } | null;
    cover?: {
      __typename?: "UploadFile";
      url: string;
      alternativeText?: string | null;
      mime: string;
    } | null;
  } | null> | null;
};

export type ResourceHubBaseFragmentFragment = {
  __typename?: "Resource";
  documentId: string;
  title: string;
  slug: string;
  briefDescription?: string | null;
  subHeader?: string | null;
  publicationDate?: any | null;
  resourceStatus?: Enum_Resource_Resourcestatus | null;
  expireResourceStatusAt?: any | null;
  assetsCount?: number | null;
  type?: {
    __typename?: "ResourceType";
    documentId: string;
    type: string;
  } | null;
  category?: {
    __typename?: "ResourceCategory";
    documentId: string;
    category: string;
  } | null;
  cover?: {
    __typename?: "UploadFile";
    url: string;
    alternativeText?: string | null;
    mime: string;
  } | null;
};

type ResourceHubDefaultContentTemplateFragment_ComponentCommonAudio_Fragment = {
  __typename: "ComponentCommonAudio";
  id: string;
  transcription?: string | null;
  audio: { __typename?: "UploadFile"; url: string; name: string };
};

type ResourceHubDefaultContentTemplateFragment_ComponentCommonAuthor_Fragment =
  {
    __typename: "ComponentCommonAuthor";
    id: string;
    publicationDate: any;
    author?: {
      __typename?: "Author";
      name: string;
      role?: string | null;
    } | null;
  };

type ResourceHubDefaultContentTemplateFragment_ComponentCommonAuthorDetailed_Fragment =
  {
    __typename: "ComponentCommonAuthorDetailed";
    id: string;
    authors?: {
      __typename?: "AuthorRelationResponseCollection";
      nodes: Array<{
        __typename?: "Author";
        documentId: string;
        name: string;
        role?: string | null;
        bio?: string | null;
        avatar: {
          __typename?: "UploadFile";
          url: string;
          alternativeText?: string | null;
        };
      }>;
    } | null;
  };

type ResourceHubDefaultContentTemplateFragment_ComponentCommonDivider_Fragment =
  { __typename: "ComponentCommonDivider"; id: string };

type ResourceHubDefaultContentTemplateFragment_ComponentCommonDownloadableContentList_Fragment =
  {
    __typename: "ComponentCommonDownloadableContentList";
    id: string;
    list?: Array<{
      __typename?: "ComponentCommonDownloadableContent";
      id: string;
      title: string;
      description?: string | null;
      content: {
        __typename?: "UploadFile";
        url: string;
        name: string;
        ext?: string | null;
        mime: string;
        size: number;
      };
    } | null> | null;
  };

type ResourceHubDefaultContentTemplateFragment_ComponentCommonEmbedded_Fragment =
  {
    __typename: "ComponentCommonEmbedded";
    id: string;
    link: string;
    provider: Enum_Componentcommonembedded_Provider;
  };

type ResourceHubDefaultContentTemplateFragment_ComponentCommonFaqComponent_Fragment =
  {
    __typename: "ComponentCommonFaqComponent";
    id: string;
    faq?: Array<{
      __typename?: "ComponentCommonFaq";
      title: string;
      description: string;
    } | null> | null;
  };

type ResourceHubDefaultContentTemplateFragment_ComponentCommonH3_Fragment = {
  __typename: "ComponentCommonH3";
  id: string;
  text: string;
};

type ResourceHubDefaultContentTemplateFragment_ComponentCommonQuote_Fragment = {
  __typename: "ComponentCommonQuote";
  id: string;
  quote: string;
};

type ResourceHubDefaultContentTemplateFragment_ComponentCommonRelatedContent_Fragment =
  { __typename: "ComponentCommonRelatedContent"; id: string };

type ResourceHubDefaultContentTemplateFragment_ComponentCommonTags_Fragment = {
  __typename: "ComponentCommonTags";
  id: string;
};

type ResourceHubDefaultContentTemplateFragment_ComponentCommonTextEditor_Fragment =
  {
    __typename: "ComponentCommonTextEditor";
    id: string;
    markdownText?: string | null;
  };

type ResourceHubDefaultContentTemplateFragment_ComponentCommonTitle_Fragment = {
  __typename: "ComponentCommonTitle";
  id: string;
  title: string;
};

type ResourceHubDefaultContentTemplateFragment_ComponentResourceAssets_Fragment =
  {
    __typename: "ComponentResourceAssets";
    id: string;
    sectionTitle?: string | null;
    assets?: {
      __typename?: "ResourceAssetRelationResponseCollection";
      nodes: Array<{
        __typename?: "ResourceAsset";
        documentId: string;
        title: string;
        description?: string | null;
        publishedAt?: any | null;
        updatedAt?: any | null;
        previewStatus?: Enum_Resourceasset_Previewstatus | null;
        scanStatus?: Enum_Resourceasset_Scanstatus | null;
        content: {
          __typename?: "UploadFile";
          url: string;
          name: string;
          ext?: string | null;
          mime: string;
          size: number;
        };
        resourceAssetHistory?: {
          __typename?: "ResourceAssetHistoryRelationResponseCollection";
          nodes: Array<{
            __typename?: "ResourceAssetHistory";
            version: number;
          }>;
        } | null;
      }>;
    } | null;
  };

type ResourceHubDefaultContentTemplateFragment_ComponentResourceResourcesRelated_Fragment =
  {
    __typename: "ComponentResourceResourcesRelated";
    id: string;
    resources?: {
      __typename?: "ResourceRelationResponseCollection";
      nodes: Array<{
        __typename?: "Resource";
        documentId: string;
        title: string;
        slug: string;
        briefDescription?: string | null;
        cover?: {
          __typename?: "UploadFile";
          url: string;
          alternativeText?: string | null;
        } | null;
        type?: { __typename?: "ResourceType"; type: string } | null;
      }>;
    } | null;
  };

type ResourceHubDefaultContentTemplateFragment_Error_Fragment = {
  __typename: "Error";
};

export type ResourceHubDefaultContentTemplateFragmentFragment =
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonAudio_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonAuthor_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonAuthorDetailed_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonDivider_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonDownloadableContentList_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonEmbedded_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonFaqComponent_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonH3_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonQuote_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonRelatedContent_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonTags_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonTextEditor_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentCommonTitle_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentResourceAssets_Fragment
  | ResourceHubDefaultContentTemplateFragment_ComponentResourceResourcesRelated_Fragment
  | ResourceHubDefaultContentTemplateFragment_Error_Fragment;

export type FetchResourceHubListQueryVariables = Exact<{
  page: Scalars["Int"]["input"];
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  categoryDocumentIds?: InputMaybe<
    | Array<InputMaybe<Scalars["ID"]["input"]>>
    | InputMaybe<Scalars["ID"]["input"]>
  >;
  schoolContextDocumentId: Scalars["ID"]["input"];
  userDocumentId: Scalars["ID"]["input"];
}>;

export type FetchResourceHubListQuery = {
  __typename?: "Query";
  resources?: {
    __typename?: "ResourceEntityResponseCollection";
    nodes: Array<{
      __typename?: "Resource";
      documentId: string;
      title: string;
      slug: string;
      briefDescription?: string | null;
      subHeader?: string | null;
      publicationDate?: any | null;
      resourceStatus?: Enum_Resource_Resourcestatus | null;
      expireResourceStatusAt?: any | null;
      assetsCount?: number | null;
      type?: {
        __typename?: "ResourceType";
        documentId: string;
        type: string;
      } | null;
      category?: {
        __typename?: "ResourceCategory";
        documentId: string;
        category: string;
      } | null;
      cover?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      } | null;
    }>;
    pageInfo: {
      __typename?: "Pagination";
      page: number;
      pageCount: number;
      total: number;
      pageSize: number;
    };
  } | null;
};

export type FetchResourceHubBySlugQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type FetchResourceHubBySlugQuery = {
  __typename?: "Query";
  resources_connection?: {
    __typename?: "ResourceEntityResponseCollection";
    nodes: Array<{
      __typename?: "Resource";
      documentId: string;
      title: string;
      slug: string;
      briefDescription?: string | null;
      subHeader?: string | null;
      publicationDate?: any | null;
      resourceStatus?: Enum_Resource_Resourcestatus | null;
      expireResourceStatusAt?: any | null;
      type?: {
        __typename?: "ResourceType";
        documentId: string;
        type: string;
      } | null;
      category?: {
        __typename?: "ResourceCategory";
        documentId: string;
        category: string;
      } | null;
      cover?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      } | null;
      resourceHistory: Array<{
        __typename?: "ResourceHistory";
        documentId: string;
        version: string;
        createdAt?: any | null;
      } | null>;
      DefaultContentTemplate?: Array<
        | {
            __typename: "ComponentCommonAudio";
            id: string;
            transcription?: string | null;
            audio: { __typename?: "UploadFile"; url: string; name: string };
          }
        | {
            __typename: "ComponentCommonAuthor";
            id: string;
            publicationDate: any;
            author?: {
              __typename?: "Author";
              name: string;
              role?: string | null;
            } | null;
          }
        | {
            __typename: "ComponentCommonAuthorDetailed";
            id: string;
            authors?: {
              __typename?: "AuthorRelationResponseCollection";
              nodes: Array<{
                __typename?: "Author";
                documentId: string;
                name: string;
                role?: string | null;
                bio?: string | null;
                avatar: {
                  __typename?: "UploadFile";
                  url: string;
                  alternativeText?: string | null;
                };
              }>;
            } | null;
          }
        | { __typename: "ComponentCommonDivider"; id: string }
        | {
            __typename: "ComponentCommonDownloadableContentList";
            id: string;
            list?: Array<{
              __typename?: "ComponentCommonDownloadableContent";
              id: string;
              title: string;
              description?: string | null;
              content: {
                __typename?: "UploadFile";
                url: string;
                name: string;
                ext?: string | null;
                mime: string;
                size: number;
              };
            } | null> | null;
          }
        | {
            __typename: "ComponentCommonEmbedded";
            id: string;
            link: string;
            provider: Enum_Componentcommonembedded_Provider;
          }
        | {
            __typename: "ComponentCommonFaqComponent";
            id: string;
            faq?: Array<{
              __typename?: "ComponentCommonFaq";
              title: string;
              description: string;
            } | null> | null;
          }
        | { __typename: "ComponentCommonH3"; id: string; text: string }
        | { __typename: "ComponentCommonQuote"; id: string; quote: string }
        | { __typename: "ComponentCommonRelatedContent"; id: string }
        | { __typename: "ComponentCommonTags"; id: string }
        | {
            __typename: "ComponentCommonTextEditor";
            id: string;
            markdownText?: string | null;
          }
        | { __typename: "ComponentCommonTitle"; id: string; title: string }
        | {
            __typename: "ComponentResourceAssets";
            id: string;
            sectionTitle?: string | null;
            assets?: {
              __typename?: "ResourceAssetRelationResponseCollection";
              nodes: Array<{
                __typename?: "ResourceAsset";
                documentId: string;
                title: string;
                description?: string | null;
                publishedAt?: any | null;
                updatedAt?: any | null;
                previewStatus?: Enum_Resourceasset_Previewstatus | null;
                scanStatus?: Enum_Resourceasset_Scanstatus | null;
                content: {
                  __typename?: "UploadFile";
                  url: string;
                  name: string;
                  ext?: string | null;
                  mime: string;
                  size: number;
                };
                resourceAssetHistory?: {
                  __typename?: "ResourceAssetHistoryRelationResponseCollection";
                  nodes: Array<{
                    __typename?: "ResourceAssetHistory";
                    version: number;
                  }>;
                } | null;
              }>;
            } | null;
          }
        | {
            __typename: "ComponentResourceResourcesRelated";
            id: string;
            resources?: {
              __typename?: "ResourceRelationResponseCollection";
              nodes: Array<{
                __typename?: "Resource";
                documentId: string;
                title: string;
                slug: string;
                briefDescription?: string | null;
                cover?: {
                  __typename?: "UploadFile";
                  url: string;
                  alternativeText?: string | null;
                } | null;
                type?: { __typename?: "ResourceType"; type: string } | null;
              }>;
            } | null;
          }
        | { __typename: "Error" }
        | null
      > | null;
    }>;
  } | null;
};

export type FetchResourceHubCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchResourceHubCategoriesQuery = {
  __typename?: "Query";
  resourceCategories: Array<{
    __typename?: "ResourceCategory";
    documentId: string;
    category: string;
    color?: string | null;
    subCategories?: {
      __typename?: "ResourceCategoryRelationResponseCollection";
      nodes: Array<{
        __typename?: "ResourceCategory";
        documentId: string;
        category: string;
        color?: string | null;
        subCategories?: {
          __typename?: "ResourceCategoryRelationResponseCollection";
          nodes: Array<{
            __typename?: "ResourceCategory";
            documentId: string;
            category: string;
            color?: string | null;
            subCategories?: {
              __typename?: "ResourceCategoryRelationResponseCollection";
              nodes: Array<{
                __typename?: "ResourceCategory";
                documentId: string;
                category: string;
                color?: string | null;
              }>;
            } | null;
          }>;
        } | null;
      }>;
    } | null;
  } | null>;
};

export type FetchResourceHubTypesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchResourceHubTypesQuery = {
  __typename?: "Query";
  resourceTypes: Array<{
    __typename?: "ResourceType";
    documentId: string;
    type: string;
  } | null>;
};

export type FetchResourceHubResourcesByCategoryQueryVariables = Exact<{
  categoryDocumentIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  schoolContextDocumentId: Scalars["ID"]["input"];
  userDocumentId: Scalars["ID"]["input"];
}>;

export type FetchResourceHubResourcesByCategoryQuery = {
  __typename?: "Query";
  resources?: {
    __typename?: "ResourceEntityResponseCollection";
    nodes: Array<{
      __typename?: "Resource";
      documentId: string;
      title: string;
      slug: string;
      briefDescription?: string | null;
      subHeader?: string | null;
      publicationDate?: any | null;
      resourceStatus?: Enum_Resource_Resourcestatus | null;
      expireResourceStatusAt?: any | null;
      assetsCount?: number | null;
      type?: {
        __typename?: "ResourceType";
        documentId: string;
        type: string;
      } | null;
      category?: {
        __typename?: "ResourceCategory";
        documentId: string;
        category: string;
      } | null;
      cover?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      } | null;
    }>;
  } | null;
};

export type FetchResourceHubCategoryIdsWithResourcesQueryVariables = Exact<{
  schoolContextDocumentId: Scalars["ID"]["input"];
  userDocumentId: Scalars["ID"]["input"];
}>;

export type FetchResourceHubCategoryIdsWithResourcesQuery = {
  __typename?: "Query";
  resources?: {
    __typename?: "ResourceEntityResponseCollection";
    nodes: Array<{
      __typename?: "Resource";
      category?: { __typename?: "ResourceCategory"; documentId: string } | null;
    }>;
  } | null;
};

export type FetchResourceHubPageQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchResourceHubPageQuery = {
  __typename?: "Query";
  resourceHubPage?: {
    __typename?: "ResourceHubPage";
    title: string;
    description?: string | null;
    cardLinkText?: string | null;
    loadMoreText?: string | null;
    noResultsText?: string | null;
    resultsTitle?: string | null;
    howToUseThisTitle?: string | null;
    downloadButtonText?: string | null;
    previewButtonText?: string | null;
    downloadAllButtonText?: string | null;
  } | null;
};

export type HomeResourceSectionQueryVariables = Exact<{
  categoryDocumentIds:
    | Array<InputMaybe<Scalars["ID"]["input"]>>
    | InputMaybe<Scalars["ID"]["input"]>;
  schoolContextDocumentId: Scalars["ID"]["input"];
  userDocumentId: Scalars["ID"]["input"];
}>;

export type HomeResourceSectionQuery = {
  __typename?: "Query";
  resources?: {
    __typename?: "ResourceEntityResponseCollection";
    nodes: Array<{
      __typename?: "Resource";
      documentId: string;
      title: string;
      slug: string;
      briefDescription?: string | null;
      subHeader?: string | null;
      publicationDate?: any | null;
      resourceStatus?: Enum_Resource_Resourcestatus | null;
      expireResourceStatusAt?: any | null;
      assetsCount?: number | null;
      type?: {
        __typename?: "ResourceType";
        documentId: string;
        type: string;
      } | null;
      category?: {
        __typename?: "ResourceCategory";
        documentId: string;
        category: string;
      } | null;
      cover?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      } | null;
    }>;
  } | null;
};

export type ResourceCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type ResourceCategoriesQuery = {
  __typename?: "Query";
  resourceCategories: Array<{
    __typename?: "ResourceCategory";
    documentId: string;
    category: string;
    subCategories: Array<{
      __typename?: "ResourceCategory";
      data: {
        __typename?: "ResourceCategory";
        id: string;
        attributes: { __typename?: "ResourceCategory"; category: string };
      };
    } | null>;
  } | null>;
};

export type ResourceCategoryQueryVariables = Exact<{
  documentId: Scalars["ID"]["input"];
}>;

export type ResourceCategoryQuery = {
  __typename?: "Query";
  resourceCategory?: {
    __typename?: "ResourceCategory";
    documentId: string;
    category: string;
    subCategories: Array<{
      __typename?: "ResourceCategory";
      data: {
        __typename?: "ResourceCategory";
        id: string;
        attributes: { __typename?: "ResourceCategory"; category: string };
      };
    } | null>;
  } | null;
};

export type ResourceTypesQueryVariables = Exact<{ [key: string]: never }>;

export type ResourceTypesQuery = {
  __typename?: "Query";
  resourceTypes: Array<{
    __typename?: "ResourceType";
    documentId: string;
    type: string;
  } | null>;
};

export type ResourcesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ResourcesQuery = {
  __typename?: "Query";
  resources_connection?: {
    __typename?: "ResourceEntityResponseCollection";
    data: Array<{
      __typename?: "Resource";
      attributes: {
        __typename?: "Resource";
        documentId: string;
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        resourceStatus?: Enum_Resource_Resourcestatus | null;
        expireResourceStatusAt?: any | null;
        publicationDate?: any | null;
        subHeader?: string | null;
        type?: {
          __typename?: "ResourceType";
          data: {
            __typename?: "ResourceType";
            id: string;
            attributes: { __typename?: "ResourceType"; type: string };
          };
        } | null;
        category?: {
          __typename?: "ResourceCategory";
          data: {
            __typename?: "ResourceCategory";
            id: string;
            attributes: { __typename?: "ResourceCategory"; category: string };
          };
        } | null;
        cover?: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        } | null;
        DefaultContentTemplate?: Array<
          | { __typename: "ComponentCommonAudio" }
          | { __typename: "ComponentCommonAuthor" }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | { __typename: "ComponentCommonDivider" }
          | { __typename: "ComponentCommonDownloadableContentList" }
          | { __typename: "ComponentCommonEmbedded" }
          | { __typename: "ComponentCommonFaqComponent" }
          | { __typename: "ComponentCommonH3" }
          | { __typename: "ComponentCommonQuote" }
          | { __typename: "ComponentCommonRelatedContent" }
          | { __typename: "ComponentCommonTags" }
          | { __typename: "ComponentCommonTextEditor" }
          | { __typename: "ComponentCommonTitle" }
          | { __typename: "ComponentResourceAssets" }
          | { __typename: "ComponentResourceResourcesRelated" }
          | { __typename: "Error" }
          | null
        > | null;
      };
    }>;
    meta: {
      __typename?: "ResponseCollectionMeta";
      pagination: {
        __typename?: "Pagination";
        total: number;
        pageCount: number;
        page: number;
        pageSize: number;
      };
    };
  } | null;
};

export type ResourceBySlugQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type ResourceBySlugQuery = {
  __typename?: "Query";
  resources_connection?: {
    __typename?: "ResourceEntityResponseCollection";
    data: Array<{
      __typename?: "Resource";
      id: string;
      attributes: {
        __typename?: "Resource";
        documentId: string;
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        resourceStatus?: Enum_Resource_Resourcestatus | null;
        expireResourceStatusAt?: any | null;
        publicationDate?: any | null;
        subHeader?: string | null;
        DefaultContentTemplate?: Array<
          | {
              __typename: "ComponentCommonAudio";
              transcription?: string | null;
              audio: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    name: string;
                  };
                };
              };
            }
          | {
              __typename: "ComponentCommonAuthor";
              publicationDate: any;
              author?: {
                __typename?: "Author";
                data: {
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                  };
                };
              } | null;
            }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | { __typename: "ComponentCommonDivider"; id: string }
          | { __typename: "ComponentCommonDownloadableContentList" }
          | {
              __typename: "ComponentCommonEmbedded";
              link: string;
              provider: Enum_Componentcommonembedded_Provider;
            }
          | { __typename: "ComponentCommonFaqComponent" }
          | { __typename: "ComponentCommonH3"; text: string }
          | { __typename: "ComponentCommonQuote"; quote: string }
          | { __typename: "ComponentCommonRelatedContent" }
          | { __typename: "ComponentCommonTags" }
          | {
              __typename: "ComponentCommonTextEditor";
              markdownText?: string | null;
            }
          | { __typename: "ComponentCommonTitle"; title: string }
          | {
              __typename: "ComponentResourceAssets";
              assets?: {
                __typename?: "ResourceAssetRelationResponseCollection";
                data: Array<{
                  __typename?: "ResourceAsset";
                  id: string;
                  attributes: {
                    __typename?: "ResourceAsset";
                    title: string;
                    description?: string | null;
                    content: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          name: string;
                          ext?: string | null;
                          mime: string;
                          size: number;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | {
              __typename: "ComponentResourceResourcesRelated";
              resources?: {
                __typename?: "ResourceRelationResponseCollection";
                data: Array<{
                  __typename?: "Resource";
                  attributes: {
                    __typename?: "Resource";
                    title: string;
                    slug: string;
                    cover?: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    } | null;
                    type?: {
                      __typename?: "ResourceType";
                      data: {
                        __typename?: "ResourceType";
                        attributes: {
                          __typename?: "ResourceType";
                          type: string;
                        };
                      };
                    } | null;
                  };
                }>;
              } | null;
            }
          | { __typename: "Error" }
          | null
        > | null;
        type?: {
          __typename?: "ResourceType";
          data: {
            __typename?: "ResourceType";
            id: string;
            attributes: { __typename?: "ResourceType"; type: string };
          };
        } | null;
        category?: {
          __typename?: "ResourceCategory";
          data: {
            __typename?: "ResourceCategory";
            id: string;
            attributes: { __typename?: "ResourceCategory"; category: string };
          };
        } | null;
        cover?: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        } | null;
      };
    }>;
  } | null;
};

export type LatestResourcesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type LatestResourcesQuery = {
  __typename?: "Query";
  resources_connection?: {
    __typename?: "ResourceEntityResponseCollection";
    data: Array<{
      __typename?: "Resource";
      attributes: {
        __typename?: "Resource";
        documentId: string;
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        resourceStatus?: Enum_Resource_Resourcestatus | null;
        expireResourceStatusAt?: any | null;
        publicationDate?: any | null;
        subHeader?: string | null;
        type?: {
          __typename?: "ResourceType";
          data: {
            __typename?: "ResourceType";
            id: string;
            attributes: { __typename?: "ResourceType"; type: string };
          };
        } | null;
        category?: {
          __typename?: "ResourceCategory";
          data: {
            __typename?: "ResourceCategory";
            id: string;
            attributes: { __typename?: "ResourceCategory"; category: string };
          };
        } | null;
        cover?: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        } | null;
        DefaultContentTemplate?: Array<
          | { __typename: "ComponentCommonAudio" }
          | { __typename: "ComponentCommonAuthor" }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | { __typename: "ComponentCommonDivider" }
          | { __typename: "ComponentCommonDownloadableContentList" }
          | { __typename: "ComponentCommonEmbedded" }
          | { __typename: "ComponentCommonFaqComponent" }
          | { __typename: "ComponentCommonH3" }
          | { __typename: "ComponentCommonQuote" }
          | { __typename: "ComponentCommonRelatedContent" }
          | { __typename: "ComponentCommonTags" }
          | { __typename: "ComponentCommonTextEditor" }
          | { __typename: "ComponentCommonTitle" }
          | { __typename: "ComponentResourceAssets" }
          | { __typename: "ComponentResourceResourcesRelated" }
          | { __typename: "Error" }
          | null
        > | null;
      };
    }>;
  } | null;
};

export type ResourcesByTypeQueryVariables = Exact<{
  type: Scalars["String"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ResourcesByTypeQuery = {
  __typename?: "Query";
  resources_connection?: {
    __typename?: "ResourceEntityResponseCollection";
    data: Array<{
      __typename?: "Resource";
      attributes: {
        __typename?: "Resource";
        documentId: string;
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        resourceStatus?: Enum_Resource_Resourcestatus | null;
        expireResourceStatusAt?: any | null;
        publicationDate?: any | null;
        subHeader?: string | null;
        type?: {
          __typename?: "ResourceType";
          data: {
            __typename?: "ResourceType";
            id: string;
            attributes: { __typename?: "ResourceType"; type: string };
          };
        } | null;
        category?: {
          __typename?: "ResourceCategory";
          data: {
            __typename?: "ResourceCategory";
            id: string;
            attributes: { __typename?: "ResourceCategory"; category: string };
          };
        } | null;
        cover?: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        } | null;
        DefaultContentTemplate?: Array<
          | { __typename: "ComponentCommonAudio" }
          | { __typename: "ComponentCommonAuthor" }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | { __typename: "ComponentCommonDivider" }
          | { __typename: "ComponentCommonDownloadableContentList" }
          | { __typename: "ComponentCommonEmbedded" }
          | { __typename: "ComponentCommonFaqComponent" }
          | { __typename: "ComponentCommonH3" }
          | { __typename: "ComponentCommonQuote" }
          | { __typename: "ComponentCommonRelatedContent" }
          | { __typename: "ComponentCommonTags" }
          | { __typename: "ComponentCommonTextEditor" }
          | { __typename: "ComponentCommonTitle" }
          | { __typename: "ComponentResourceAssets" }
          | { __typename: "ComponentResourceResourcesRelated" }
          | { __typename: "Error" }
          | null
        > | null;
      };
    }>;
    meta: {
      __typename?: "ResponseCollectionMeta";
      pagination: {
        __typename?: "Pagination";
        total: number;
        pageCount: number;
        page: number;
        pageSize: number;
      };
    };
  } | null;
};

export type ResourcesByCategoryQueryVariables = Exact<{
  category: Scalars["String"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ResourcesByCategoryQuery = {
  __typename?: "Query";
  resources_connection?: {
    __typename?: "ResourceEntityResponseCollection";
    data: Array<{
      __typename?: "Resource";
      attributes: {
        __typename?: "Resource";
        documentId: string;
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        resourceStatus?: Enum_Resource_Resourcestatus | null;
        expireResourceStatusAt?: any | null;
        publicationDate?: any | null;
        subHeader?: string | null;
        type?: {
          __typename?: "ResourceType";
          data: {
            __typename?: "ResourceType";
            id: string;
            attributes: { __typename?: "ResourceType"; type: string };
          };
        } | null;
        category?: {
          __typename?: "ResourceCategory";
          data: {
            __typename?: "ResourceCategory";
            id: string;
            attributes: { __typename?: "ResourceCategory"; category: string };
          };
        } | null;
        cover?: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        } | null;
        DefaultContentTemplate?: Array<
          | { __typename: "ComponentCommonAudio" }
          | { __typename: "ComponentCommonAuthor" }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | { __typename: "ComponentCommonDivider" }
          | { __typename: "ComponentCommonDownloadableContentList" }
          | { __typename: "ComponentCommonEmbedded" }
          | { __typename: "ComponentCommonFaqComponent" }
          | { __typename: "ComponentCommonH3" }
          | { __typename: "ComponentCommonQuote" }
          | { __typename: "ComponentCommonRelatedContent" }
          | { __typename: "ComponentCommonTags" }
          | { __typename: "ComponentCommonTextEditor" }
          | { __typename: "ComponentCommonTitle" }
          | { __typename: "ComponentResourceAssets" }
          | { __typename: "ComponentResourceResourcesRelated" }
          | { __typename: "Error" }
          | null
        > | null;
      };
    }>;
    meta: {
      __typename?: "ResponseCollectionMeta";
      pagination: {
        __typename?: "Pagination";
        total: number;
        pageCount: number;
        page: number;
        pageSize: number;
      };
    };
  } | null;
};

export type FetchMySchoolsQueryVariables = Exact<{
  asRegularUser?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type FetchMySchoolsQuery = {
  __typename?: "Query";
  fetchMySchools?: Array<{
    __typename?: "School";
    documentId: string;
    name: string;
    code?: string | null;
    logoMAT?: {
      __typename?: "UploadFile";
      url: string;
      alternativeText?: string | null;
    } | null;
    subscription?: {
      __typename?: "Subscription";
      name: string;
      knowledgeBase: boolean;
      learn: boolean;
      search: boolean;
      bookmark: boolean;
      mission: boolean;
      podcast: boolean;
      resourceHub: boolean;
    } | null;
  }> | null;
};

export type FetchSearchPageQueryVariables = Exact<{ [key: string]: never }>;

export type FetchSearchPageQuery = {
  __typename?: "Query";
  searchPage?: {
    __typename?: "SearchPage";
    title: string;
    yourResultsTitle: string;
    noRecordsFoundText: string;
    placeholder: string;
  } | null;
};

export type LatestKnowledgeBasesWithFiltersQueryVariables = Exact<{
  filters?: InputMaybe<KnowledgeBaseFiltersInput>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type LatestKnowledgeBasesWithFiltersQuery = {
  __typename?: "Query";
  knowledgebases?: {
    __typename?: "KnowledgeBaseEntityResponseCollection";
    data: Array<{
      __typename?: "KnowledgeBase";
      id: string;
      attributes: {
        __typename?: "KnowledgeBase";
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        knowledgeBaseType?: {
          __typename?: "KnowledgeBaseType";
          data: {
            __typename?: "KnowledgeBaseType";
            id: string;
            attributes: { __typename?: "KnowledgeBaseType"; type: string };
          };
        } | null;
        cover: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        DefaultContentTemplate: Array<
          | { __typename: "ComponentCommonAudio" }
          | { __typename: "ComponentCommonAuthor" }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | { __typename: "ComponentCommonBullet" }
          | { __typename: "ComponentCommonDivider" }
          | { __typename: "ComponentCommonDownloadableContentList" }
          | { __typename: "ComponentCommonEmbedded" }
          | { __typename: "ComponentCommonFaqComponent" }
          | { __typename: "ComponentCommonH3" }
          | { __typename: "ComponentCommonMedia" }
          | { __typename: "ComponentCommonQuote" }
          | { __typename: "ComponentCommonRelatedContent" }
          | { __typename: "ComponentCommonTags" }
          | { __typename: "ComponentCommonTextEditor" }
          | { __typename: "ComponentCommonTitle" }
          | { __typename: "ComponentDefaultContentTemplateTimer" }
          | { __typename: "ComponentKnowledgeBaseKnowledgeBaseRelated" }
          | { __typename: "Error" }
          | null
        >;
      };
    }>;
    meta: {
      __typename?: "ResponseCollectionMeta";
      pagination: {
        __typename?: "Pagination";
        total: number;
        pageCount: number;
        page: number;
        pageSize: number;
      };
    };
  } | null;
};

export type FetchSearchCoursesPageableQueryVariables = Exact<{
  filters?: InputMaybe<CourseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;

export type FetchSearchCoursesPageableQuery = {
  __typename?: "Query";
  courses?: {
    __typename?: "CourseEntityResponseCollection";
    nodes: Array<{
      __typename?: "Course";
      id: string;
      attributes: {
        __typename?: "Course";
        title: string;
        slug?: string | null;
        description: string;
        duration?: string | null;
        thumbnail: {
          __typename?: "UploadFile";
          data: {
            __typename?: "UploadFile";
            attributes: {
              __typename?: "UploadFile";
              url: string;
              alternativeText?: string | null;
              mime: string;
            };
          };
        };
        course_category?: {
          __typename?: "CourseCategory";
          data: {
            __typename?: "CourseCategory";
            attributes: {
              __typename?: "CourseCategory";
              name: string;
              description?: string | null;
            };
          };
        } | null;
        modules?: Array<{
          __typename?: "ComponentLearnCourseModule";
          id: string;
          lessons?: Array<{
            __typename?: "ComponentLearnCourseLesson";
            id: string;
            authors: Array<{
              __typename?: "Author";
              data: {
                __typename?: "Author";
                attributes: {
                  __typename?: "Author";
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: "UploadFile";
                    data: {
                      __typename?: "UploadFile";
                      attributes: {
                        __typename?: "UploadFile";
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      };
                    };
                  };
                };
              };
            } | null>;
          } | null> | null;
        } | null> | null;
      };
    }>;
    pageInfo: {
      __typename?: "Pagination";
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  } | null;
};

export type FetchSearchResourcesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArg>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  schoolContextDocumentId: Scalars["ID"]["input"];
}>;

export type FetchSearchResourcesQuery = {
  __typename?: "Query";
  resources?: {
    __typename?: "ResourceEntityResponseCollection";
    nodes: Array<{
      __typename?: "Resource";
      documentId: string;
      title: string;
      slug: string;
      briefDescription?: string | null;
      subHeader?: string | null;
      publicationDate?: any | null;
      resourceStatus?: Enum_Resource_Resourcestatus | null;
      expireResourceStatusAt?: any | null;
      assetsCount?: number | null;
      type?: {
        __typename?: "ResourceType";
        documentId: string;
        type: string;
      } | null;
      category?: {
        __typename?: "ResourceCategory";
        documentId: string;
        category: string;
      } | null;
      cover?: {
        __typename?: "UploadFile";
        url: string;
        alternativeText?: string | null;
        mime: string;
      } | null;
    }>;
    pageInfo: {
      __typename?: "Pagination";
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  } | null;
};

export type FetchSearchUnifiedQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars["String"]["input"]>;
  contentTypes?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  schoolContextDocumentId: Scalars["ID"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type FetchSearchUnifiedQuery = {
  __typename?: "Query";
  searchUnified?: {
    __typename?: "SearchUnifiedConnection";
    nodes?: Array<
      | {
          __typename: "Course";
          documentId: string;
          title: string;
          slug?: string | null;
          description: string;
          duration?: string | null;
          thumbnail: {
            __typename?: "UploadFile";
            data: {
              __typename?: "UploadFile";
              attributes: {
                __typename?: "UploadFile";
                url: string;
                alternativeText?: string | null;
                mime: string;
              };
            };
          };
          course_category?: {
            __typename?: "CourseCategory";
            data: {
              __typename?: "CourseCategory";
              attributes: {
                __typename?: "CourseCategory";
                name: string;
                description?: string | null;
              };
            };
          } | null;
        }
      | {
          __typename: "KnowledgeBase";
          documentId: string;
          title: string;
          duration?: string | null;
          briefDescription: string;
          kbSlug: string;
          knowledgeBaseType?: {
            __typename?: "KnowledgeBaseType";
            data: {
              __typename?: "KnowledgeBaseType";
              id: string;
              attributes: { __typename?: "KnowledgeBaseType"; type: string };
            };
          } | null;
          cover: {
            __typename?: "UploadFile";
            data: {
              __typename?: "UploadFile";
              attributes: {
                __typename?: "UploadFile";
                url: string;
                alternativeText?: string | null;
                mime: string;
              };
            };
          };
        }
      | {
          __typename: "Podcast";
          documentId: string;
          title: string;
          podcastSlug: string;
          podcastBriefDescription: string;
          podcastPublicationDate: any;
          podcastCover: {
            __typename?: "UploadFile";
            url: string;
            alternativeText?: string | null;
            mime: string;
          };
          listenings: Array<{
            __typename?: "PodcastListeningTime";
            documentId: string;
            listeningTime: any;
            duration: any;
          } | null>;
        }
      | {
          __typename: "Resource";
          documentId: string;
          title: string;
          subHeader?: string | null;
          publicationDate?: any | null;
          resourceStatus?: Enum_Resource_Resourcestatus | null;
          expireResourceStatusAt?: any | null;
          assetsCount?: number | null;
          resourceSlug: string;
          resourceBriefDescription?: string | null;
          type?: {
            __typename?: "ResourceType";
            documentId: string;
            type: string;
          } | null;
          category?: {
            __typename?: "ResourceCategory";
            documentId: string;
            category: string;
          } | null;
          resourceCover?: {
            __typename?: "UploadFile";
            url: string;
            alternativeText?: string | null;
            mime: string;
          } | null;
        }
      | null
    > | null;
    pageInfo?: {
      __typename?: "SearchUnifiedPageInfo";
      page?: number | null;
      pageSize?: number | null;
      pageCount?: number | null;
      total?: number | null;
    } | null;
  } | null;
};

export type TermsAndConditionsPageQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TermsAndConditionsPageQuery = {
  __typename?: "Query";
  termsAndConditionsPage?: {
    __typename?: "TermsAndConditionsPage";
    data: {
      __typename?: "TermsAndConditionsPage";
      id: string;
      attributes: {
        __typename?: "TermsAndConditionsPage";
        title: string;
        DefaultContentTemplate: Array<
          | {
              __typename: "ComponentCommonAuthor";
              publicationDate: any;
              author?: {
                __typename?: "Author";
                data: {
                  __typename?: "Author";
                  attributes: { __typename?: "Author"; name: string };
                };
              } | null;
            }
          | {
              __typename: "ComponentCommonAuthorDetailed";
              authors?: {
                __typename?: "AuthorRelationResponseCollection";
                data: Array<{
                  __typename?: "Author";
                  attributes: {
                    __typename?: "Author";
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: "UploadFile";
                      data: {
                        __typename?: "UploadFile";
                        attributes: {
                          __typename?: "UploadFile";
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        };
                      };
                    };
                  };
                }>;
              } | null;
            }
          | {
              __typename: "ComponentCommonBullet";
              item: Array<{
                __typename?: "ComponentCommonList";
                text: string;
              } | null>;
            }
          | { __typename: "ComponentCommonDivider"; id: string }
          | {
              __typename: "ComponentCommonDownloadableContentList";
              list?: Array<{
                __typename?: "ComponentCommonDownloadableContent";
                id: string;
                title: string;
                description?: string | null;
                content: {
                  __typename?: "UploadFile";
                  data: {
                    __typename?: "UploadFile";
                    attributes: { __typename?: "UploadFile"; url: string };
                  };
                };
              } | null> | null;
            }
          | {
              __typename: "ComponentCommonEmbedded";
              link: string;
              provider: Enum_Componentcommonembedded_Provider;
            }
          | {
              __typename: "ComponentCommonFaqComponent";
              faq?: Array<{
                __typename?: "ComponentCommonFaq";
                title: string;
                description: string;
              } | null> | null;
            }
          | { __typename: "ComponentCommonH3"; text: string }
          | {
              __typename: "ComponentCommonMedia";
              media: {
                __typename?: "UploadFile";
                data: {
                  __typename?: "UploadFile";
                  attributes: {
                    __typename?: "UploadFile";
                    url: string;
                    alternativeText?: string | null;
                  };
                };
              };
            }
          | { __typename: "ComponentCommonQuote"; quote: string }
          | {
              __typename: "ComponentCommonTextEditor";
              markdownText?: string | null;
            }
          | { __typename: "ComponentCommonTitle"; title: string }
          | { __typename: "Error" }
          | null
        >;
      };
    };
  } | null;
};

export type FetchWildcardQueryVariables = Exact<{ [key: string]: never }>;

export type FetchWildcardQuery = {
  __typename?: "Query";
  fetchWildcardUser?: Array<{
    __typename?: "Wildcard";
    documentId: string;
    startDate: any;
    endDate: any;
    description: string;
    title?: string | null;
    ctaText: string;
    cta?: {
      __typename?: "ComponentWildcardCta";
      redirectToLeadershipWheel?: boolean | null;
      redirectToCalendar?: boolean | null;
      course?: {
        __typename?: "Course";
        documentId: string;
        slug?: string | null;
      } | null;
      knowledgeBase?: {
        __typename?: "KnowledgeBase";
        documentId: string;
        slug: string;
      } | null;
    } | null;
  }> | null;
};

export const DefaultContentTemplateFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DefaultContentTemplateFragment" },
      typeCondition: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "KnowledgeBaseDefaultContentTemplateDynamicZone",
        },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonH3" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "text" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonMedia" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "media" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "data" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "alternativeText",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTitle" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonAuthor" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "author" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "data" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attributes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "role" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publicationDate" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonDivider" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonEmbedded" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "link" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTextEditor" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "markdownText" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonEmbedded" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "link" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DefaultContentTemplateFragmentFragment, unknown>;
export const ImageFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageFragmentFragment, unknown>;
export const KnowledgeBaseBaseFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgeBaseBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgeBase" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgeBaseType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KnowledgeBaseBaseFragmentFragment, unknown>;
export const KnowledgeBaseCategoryFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgeBaseCategoryFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgeBaseCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "subCategories" },
            name: { kind: "Name", value: "subCategories_connection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "subCategories" },
                        name: {
                          kind: "Name",
                          value: "subCategories_connection",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nodes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "category" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "subCategories",
                                    },
                                    name: {
                                      kind: "Name",
                                      value: "subCategories_connection",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "nodes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "category",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KnowledgeBaseCategoryFragmentFragment, unknown>;
export const LearnFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LearnFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Learn" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "completedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users_permissions_user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "course" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "alternativeText",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "mime",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "moduleStableId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lessonStableId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "learn_items" },
            name: { kind: "Name", value: "learn_items_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "999" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idModule" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idLesson" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LearnFragmentFragment, unknown>;
export const PodcastDetailFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PodcastDetailFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Podcast" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "fullDescription" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "platforms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "platform" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "icon" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PodcastDetailFragmentFragment, unknown>;
export const PodcastBaseFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PodcastBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Podcast" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PodcastBaseFragmentFragment, unknown>;
export const PodcastDefaultContentTemplateFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PodcastDefaultContentTemplateFragment" },
      typeCondition: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "PodcastDefaultContentTemplateDynamicZone",
        },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonH3" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "text" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonMedia" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "media" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "alternativeText" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTitle" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonAuthorDetailed" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "authors" },
                  name: { kind: "Name", value: "authors_connection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "role" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "bio" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "avatar" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "alternativeText",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonDivider" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonEmbedded" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "link" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTextEditor" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "markdownText" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonBullet" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "item" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonQuote" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "quote" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonFaqComponent" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faq" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTags" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonRelatedContent" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ComponentCommonDownloadableContentList",
              },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "list" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonAudio" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transcription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "audio" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentPodcastPodcastRelated" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "podcasts" },
                  name: { kind: "Name", value: "podcasts_connection" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "publishedAt" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "notNull" },
                                  value: { kind: "BooleanValue", value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "PodcastBaseFragment",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "listenings" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "filters" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: { kind: "Name", value: "staff" },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "documentId",
                                              },
                                              value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                  {
                                                    kind: "ObjectField",
                                                    name: {
                                                      kind: "Name",
                                                      value: "eq",
                                                    },
                                                    value: {
                                                      kind: "Variable",
                                                      name: {
                                                        kind: "Name",
                                                        value: "userDocumentId",
                                                      },
                                                    },
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "listeningTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "duration" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PodcastBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Podcast" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PodcastDefaultContentTemplateFragmentFragment,
  unknown
>;
export const ResourceBaseFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceBaseFragmentFragment, unknown>;
export const ResourceTypeFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceTypeFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceTypeFragmentFragment, unknown>;
export const ResourceCategoryFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceCategoryFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceCategoryFragmentFragment, unknown>;
export const ResourceAssetFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceAssetFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceAsset" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ext" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mime" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "size" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceAssetFragmentFragment, unknown>;
export const SeoFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SeoFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ComponentSharedSeo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "metaTitle" } },
          { kind: "Field", name: { kind: "Name", value: "metaDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaSocial" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "socialNetwork" },
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "data" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ImageFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "keywords" } },
          { kind: "Field", name: { kind: "Name", value: "metaRobots" } },
          { kind: "Field", name: { kind: "Name", value: "structuredData" } },
          { kind: "Field", name: { kind: "Name", value: "metaViewport" } },
          { kind: "Field", name: { kind: "Name", value: "canonicalURL" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SeoFragmentFragment, unknown>;
export const KeyDateFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeyDateFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeyDate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "dateType" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "relativeRule" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "topicLabel" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "requiresReview" } },
          { kind: "Field", name: { kind: "Name", value: "isDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "originalText" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "academicYear" } },
          { kind: "Field", name: { kind: "Name", value: "bookYourPlaceUrl" } },
          { kind: "Field", name: { kind: "Name", value: "learnMoreUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "schools" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KeyDateFragmentFragment, unknown>;
export const ResourceHubBaseFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceHubBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "assetsCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceHubBaseFragmentFragment, unknown>;
export const ResourceHubDefaultContentTemplateFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ResourceHubDefaultContentTemplateFragment",
      },
      typeCondition: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "ResourceDefaultContentTemplateDynamicZone",
        },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonH3" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTitle" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonAuthorDetailed" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "authors" },
                  name: { kind: "Name", value: "authors_connection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "role" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "bio" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "avatar" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "alternativeText",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonAuthor" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publicationDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "author" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonDivider" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonEmbedded" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "link" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTextEditor" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "markdownText" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonQuote" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "quote" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonFaqComponent" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faq" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTags" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonRelatedContent" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ComponentCommonDownloadableContentList",
              },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "list" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ext" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mime" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "size" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonAudio" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transcription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "audio" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentResourceAssets" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionTitle" },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "assets" },
                  name: { kind: "Name", value: "assets_connection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "publishedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updatedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "previewStatus" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "scanStatus" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ext" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "mime" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "size" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: {
                                kind: "Name",
                                value: "resourceAssetHistory",
                              },
                              name: {
                                kind: "Name",
                                value: "resourceAssetHistory_connection",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nodes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "version",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ComponentResourceResourcesRelated",
              },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "resources" },
                  name: { kind: "Name", value: "resources_connection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "briefDescription" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cover" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "alternativeText",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResourceHubDefaultContentTemplateFragmentFragment,
  unknown
>;
export const CreateLoginTrackerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createLoginTracker" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LoginTrackerInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createLoginTracker" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "streakCounter" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "day" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateLoginTrackerMutation,
  CreateLoginTrackerMutationVariables
>;
export const LoginDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "login" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UsersPermissionsLoginInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "login" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "jwt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "register" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UsersPermissionsRegisterInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "register" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const ForgotPasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "forgotPassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "forgotPassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ok" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForgotPasswordMutation,
  ForgotPasswordMutationVariables
>;
export const ResetPasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "resetPassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "password" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "passwordConfirmation" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resetPassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "password" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "password" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "passwordConfirmation" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "passwordConfirmation" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "code" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "jwt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const AddBookmarkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "addBookmark" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BookmarkInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createBookmark" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddBookmarkMutation, AddBookmarkMutationVariables>;
export const DeleteBookmarkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteBookmark" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteBookmark" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteBookmarkMutation,
  DeleteBookmarkMutationVariables
>;
export const CompletedTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "completedTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CompletedTaskInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCompletedTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompletedTaskMutation,
  CompletedTaskMutationVariables
>;
export const CreatePodcastListeningTimeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createPodcastListeningTime" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PodcastListeningTimeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createPodcastListeningTime" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "listeningTime" },
                },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePodcastListeningTimeMutation,
  CreatePodcastListeningTimeMutationVariables
>;
export const UpdatePodcastListeningTimeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updatePodcastListeningTime" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PodcastListeningTimeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePodcastListeningTime" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePodcastListeningTimeMutation,
  UpdatePodcastListeningTimeMutationVariables
>;
export const CompleteLessonDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "completeLesson" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "idLesson" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "idModule" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "idLearn" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createLearnItem" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "idModule" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "idModule" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "idLesson" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "idLesson" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "learn" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "idLearn" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "learn" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value: "LearnFragment",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LearnFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Learn" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "completedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users_permissions_user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "course" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "alternativeText",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "mime",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "moduleStableId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lessonStableId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "learn_items" },
            name: { kind: "Name", value: "learn_items_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "999" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idModule" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idLesson" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteLessonMutation,
  CompleteLessonMutationVariables
>;
export const CreateLearnDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createLearn" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "staffId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "idCourse" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createLearn" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "users_permissions_user" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "staffId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "course" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "idCourse" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "LearnFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LearnFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Learn" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "completedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users_permissions_user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "course" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "alternativeText",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "mime",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "moduleStableId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lessonStableId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "learn_items" },
            name: { kind: "Name", value: "learn_items_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "999" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idModule" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idLesson" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateLearnMutation, CreateLearnMutationVariables>;
export const CompleteLearnDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "completeLearn" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "idLearn" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateLearn" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "idLearn" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "completed" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "LearnFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LearnFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Learn" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "completedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users_permissions_user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "course" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "alternativeText",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "mime",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "moduleStableId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lessonStableId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "learn_items" },
            name: { kind: "Name", value: "learn_items_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "999" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idModule" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idLesson" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteLearnMutation,
  CompleteLearnMutationVariables
>;
export const CreateCourseFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createCourseFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CourseFeedbackInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCourseFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCourseFeedbackMutation,
  CreateCourseFeedbackMutationVariables
>;
export const MarkNotificationClickedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markNotificationClicked" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "documentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NotificationUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateNotificationUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "documentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "clickedAt" } },
                { kind: "Field", name: { kind: "Name", value: "seenAt" } },
                { kind: "Field", name: { kind: "Name", value: "deliveredAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkNotificationClickedMutation,
  MarkNotificationClickedMutationVariables
>;
export const MarkNotificationSeenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markNotificationSeen" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "documentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NotificationUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateNotificationUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "documentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "clickedAt" } },
                { kind: "Field", name: { kind: "Name", value: "seenAt" } },
                { kind: "Field", name: { kind: "Name", value: "deliveredAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkNotificationSeenMutation,
  MarkNotificationSeenMutationVariables
>;
export const CreateNotificationUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createNotificationUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NotificationUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createNotificationUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "deliveredAt" } },
                { kind: "Field", name: { kind: "Name", value: "clickedAt" } },
                { kind: "Field", name: { kind: "Name", value: "seenAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notification" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNotificationUserMutation,
  CreateNotificationUserMutationVariables
>;
export const UpdateUsersPermissionsUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUsersPermissionsUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UsersPermissionsUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUsersPermissionsUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updatedAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUsersPermissionsUserMutation,
  UpdateUsersPermissionsUserMutationVariables
>;
export const UpdateUserOnboardingWeeklyQuestionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUserOnboardingWeeklyQuestions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UsersPermissionsUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUsersPermissionsUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "username" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "onboardQuestionsCompleted",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserOnboardingWeeklyQuestionsMutation,
  UpdateUserOnboardingWeeklyQuestionsMutationVariables
>;
export const UpdateStaffOnboardLeadershipWheelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateStaffOnboardLeadershipWheel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UsersPermissionsUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUsersPermissionsUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "username" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "onboardLeadershipWheelCompleted",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateStaffOnboardLeadershipWheelMutation,
  UpdateStaffOnboardLeadershipWheelMutationVariables
>;
export const UpdateUserSwipeHintDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUserSwipeHint" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UsersPermissionsUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUsersPermissionsUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "username" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserSwipeHintMutation,
  UpdateUserSwipeHintMutationVariables
>;
export const UpdateUserOnboardingQuestionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUserOnboardingQuestions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UsersPermissionsUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUsersPermissionsUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "username" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "onboardQuestionsCompleted",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserOnboardingQuestionsMutation,
  UpdateUserOnboardingQuestionsMutationVariables
>;
export const UpdateUserOnboardingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUserOnboarding" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UsersPermissionsUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUsersPermissionsUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "username" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "onboardHomeCompleted",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserOnboardingMutation,
  UpdateUserOnboardingMutationVariables
>;
export const UpdateStaffProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateStaffProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "staffId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "profile" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "gender" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "location" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ageBracket" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUsersPermissionsUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "staffId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "profile" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "profile" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "gender" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "gender" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "location" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "location" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ageBracket" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ageBracket" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updatedAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateStaffProfileMutation,
  UpdateStaffProfileMutationVariables
>;
export const CreateResourceAssetDownloadHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createResourceAssetDownloadHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ResourceAssetDownloadHistoryInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createResourceAssetDownloadHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadedAt" },
                },
                { kind: "Field", name: { kind: "Name", value: "version" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateResourceAssetDownloadHistoryMutation,
  CreateResourceAssetDownloadHistoryMutationVariables
>;
export const ChangePasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "changePassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "currentPassword" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "password" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "passwordConfirmation" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changePassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "currentPassword" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "currentPassword" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "password" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "password" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "passwordConfirmation" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "passwordConfirmation" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;
export const UpdateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UsersPermissionsUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUsersPermissionsUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const AboutPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "aboutPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aboutPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageTitle" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "DefaultContentTemplate",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonH3",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonMedia",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "media",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "alternativeText",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTitle",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "author",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "publicationDate",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthorDetailed",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "authors_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonDivider",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTextEditor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "markdownText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonBullet",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "item" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "text",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonQuote",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "quote",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonFaqComponent",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "faq" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "ComponentCommonDownloadableContentList",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "list" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "data",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "attributes",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "url",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AboutPageQuery, AboutPageQueryVariables>;
export const FetchAdminPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FetchAdminPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "adminPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "adminTabs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "manageStaff" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reportingTools" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchAdminPageQuery, FetchAdminPageQueryVariables>;
export const FetchKnowledgeBasesByIdsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchKnowledgeBasesByIds" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "ListType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "knowledgebases" },
            name: { kind: "Name", value: "knowledgeBases_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "createdAt:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "documentId" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "in" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "ids" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "KnowledgeBaseBaseFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgeBaseBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgeBase" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgeBaseType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchKnowledgeBasesByIdsQuery,
  FetchKnowledgeBasesByIdsQueryVariables
>;
export const BookmarksPageableByUserIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "bookmarksPageableByUserId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "staffId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "size" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "bookmarks" },
            name: { kind: "Name", value: "bookmarks_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "size" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "createdAt:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "staff" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "staffId" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "relationId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "metadata" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pagination" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BookmarksPageableByUserIdQuery,
  BookmarksPageableByUserIdQueryVariables
>;
export const AllBookmarksPageableByUserIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "allBookmarksPageableByUserId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "BookmarkFiltersInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "size" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "bookmarks" },
            name: { kind: "Name", value: "bookmarks_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "size" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "createdAt:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "relationId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "metadata" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "knowledgeBaseType",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "type",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pagination" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "page" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageCount" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllBookmarksPageableByUserIdQuery,
  AllBookmarksPageableByUserIdQueryVariables
>;
export const ExistByRelationIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "existByRelationId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "relationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "staffId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "bookmarks" },
            name: { kind: "Name", value: "bookmarks_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "relationId" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "relationId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "staff" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "staffId" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExistByRelationIdQuery,
  ExistByRelationIdQueryVariables
>;
export const FindByRelationIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "findByRelationId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "relationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "staffId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "bookmarks" },
            name: { kind: "Name", value: "bookmarks_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "relationId" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "relationId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "staff" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "staffId" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FindByRelationIdQuery,
  FindByRelationIdQueryVariables
>;
export const BookmarkPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "bookmarkPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bookmarkPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pageTitle" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "openButtonTxt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "searchPlaceholder" },
                },
                { kind: "Field", name: { kind: "Name", value: "loadingText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emptyStateText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "removeFromBookmarksText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "goToResourceText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tabKnowledgeBase" },
                },
                { kind: "Field", name: { kind: "Name", value: "tabPodcast" } },
                { kind: "Field", name: { kind: "Name", value: "tabLearn" } },
                { kind: "Field", name: { kind: "Name", value: "tabResource" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BookmarkPageQuery, BookmarkPageQueryVariables>;
export const FetchMyBookmarksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchMyBookmarks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "BookmarkCategory" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "knowledgeBaseType" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "relationId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchMyBookmarks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "category" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "category" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "knowledgeBaseType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "knowledgeBaseType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "relationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "relationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "search" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "page" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pageSize" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pageSize" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "results" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "relationId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "metadata" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBaseType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "types" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagination" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchMyBookmarksQuery,
  FetchMyBookmarksQueryVariables
>;
export const CharacterAwarenessDaysCalendarPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "characterAwarenessDaysCalendarPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "calendarPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "downloadButtonText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "file" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "calendarFeedbackMessage",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "calendarPermissionDenied",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "calendarNotFound" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "eventAlreadyExists",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "eventAddedSuccessGoogle",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "eventAddedSuccessApple",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "eventAddedSuccessGeneric",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "NoDaysMonthText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "monthThemesTitle" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CharacterAwarenessDaysCalendarPageQuery,
  CharacterAwarenessDaysCalendarPageQueryVariables
>;
export const CalendarByYearDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "calendarByYear" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "year" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "calendars" },
            name: { kind: "Name", value: "calendars_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "year" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "year" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "year" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "eventDays" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "wholeMonth" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "related_knowledge_base",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "attributes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "slug",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CalendarByYearQuery, CalendarByYearQueryVariables>;
export const CharacterAwarenessDaysCalendarPageV5Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "characterAwarenessDaysCalendarPageV5" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "calendarPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadButtonText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "file" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "calendarFeedbackMessage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "calendarPermissionDenied",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "calendarNotFound" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eventAlreadyExists" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "eventAddedSuccessGoogle",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eventAddedSuccessApple" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "eventAddedSuccessGeneric",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "NoDaysMonthText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "monthThemesTitle" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CharacterAwarenessDaysCalendarPageV5Query,
  CharacterAwarenessDaysCalendarPageV5QueryVariables
>;
export const CalendarByYearV5Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "calendarByYearV5" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "year" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "calendars" },
            name: { kind: "Name", value: "calendars_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "year" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "year" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "year" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eventDays" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "wholeMonth" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endDate" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "related_knowledge_base",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CalendarByYearV5Query,
  CalendarByYearV5QueryVariables
>;
export const CookiesPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "cookiesPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cookiesPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "DefaultContentTemplate",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonH3",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonMedia",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "media",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "alternativeText",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTitle",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "author",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "publicationDate",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthorDetailed",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "authors_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonDivider",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTextEditor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "markdownText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonBullet",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "item" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "text",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonQuote",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "quote",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonFaqComponent",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "faq" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "ComponentCommonDownloadableContentList",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "list" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "data",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "attributes",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "url",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CookiesPageQuery, CookiesPageQueryVariables>;
export const CopyrightPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "copyrightPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "copyrightPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "DefaultContentTemplate",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonH3",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonMedia",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "media",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "alternativeText",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTitle",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "author",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "publicationDate",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthorDetailed",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "authors_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonDivider",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTextEditor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "markdownText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonBullet",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "item" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "text",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonQuote",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "quote",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonFaqComponent",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "faq" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "ComponentCommonDownloadableContentList",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "list" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "data",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "attributes",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "url",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CopyrightPageQuery, CopyrightPageQueryVariables>;
export const QueryFooterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "QueryFooter" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "globalFooter" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "file" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edwinPeoplelogo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "alternativeText" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "partOfLogo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bestPlacesToWorkLogo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "copyright" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "linkedinUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueryFooterQuery, QueryFooterQueryVariables>;
export const QueryMenuDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "QueryMenu" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "globalMenu" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "logo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mobileLogo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "links" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "text" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueryMenuQuery, QueryMenuQueryVariables>;
export const NotFoundPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "notFoundPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notFoundPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "image" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cta" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotFoundPageQuery, NotFoundPageQueryVariables>;
export const QueryTermsAndConditionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "QueryTermsAndConditions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "termAndCondition" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  QueryTermsAndConditionsQuery,
  QueryTermsAndConditionsQueryVariables
>;
export const FetchLatestKnowledgeBaseForHomeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchLatestKnowledgeBaseForHome" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "knowledgeBases" },
            name: { kind: "Name", value: "knowledgeBases_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "1" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "briefDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publicationDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBaseType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cover" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mime" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchLatestKnowledgeBaseForHomeQuery,
  FetchLatestKnowledgeBaseForHomeQueryVariables
>;
export const FetchLatestPodcastForHomeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchLatestPodcastForHome" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "podcasts" },
            name: { kind: "Name", value: "podcasts_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "1" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PodcastBaseFragment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listenings" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filters" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "staff" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "documentId",
                                        },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "eq",
                                              },
                                              value: {
                                                kind: "Variable",
                                                name: {
                                                  kind: "Name",
                                                  value: "userDocumentId",
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "listeningTime" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PodcastBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Podcast" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchLatestPodcastForHomeQuery,
  FetchLatestPodcastForHomeQueryVariables
>;
export const DailyTaskHasBeenCompletedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "dailyTaskHasBeenCompleted" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "day" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "relationID" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "staffId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "completedTasks" },
            name: { kind: "Name", value: "completedTasks_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "day" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "day" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "type" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "done" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "relationID" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "relationID" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "staff" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "staffId" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "metadata" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DailyTaskHasBeenCompletedQuery,
  DailyTaskHasBeenCompletedQueryVariables
>;
export const DailyTrackingLeadershipWheelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "dailyTrackingLeadershipWheel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDay" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endDay" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leadershipWheelTracker" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDay" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDay" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endDay" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endDay" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "focusArea" } },
                { kind: "Field", name: { kind: "Name", value: "day" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isDisabledTracking" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DailyTrackingLeadershipWheelQuery,
  DailyTrackingLeadershipWheelQueryVariables
>;
export const GetUserTrackingDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUserTrackingData" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserTrackingData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dailyStreak" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "streakRecord" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emotionsTracked" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserTrackingDataQuery,
  GetUserTrackingDataQueryVariables
>;
export const FetchUserStreakDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchUserStreak" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchUserStreak" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "type" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "total" } },
                { kind: "Field", name: { kind: "Name", value: "streak" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchUserStreakQuery,
  FetchUserStreakQueryVariables
>;
export const HomeFinishedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "homeFinished" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "homeFinishedPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "messageSection" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "youAreDoneTitle",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "comeBackTitle",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "continueYourWeelbeingJourneyTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "knowledgeBasesTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "knowledgeBasesDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "toolkitsTitle" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "toolkitsDescription",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HomeFinishedQuery, HomeFinishedQueryVariables>;
export const HomePageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "HomePage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "homePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "headerSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "helloLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "icon" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resourceSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "viewAllResourcesLabel" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "categories" },
                        name: { kind: "Name", value: "categories_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nodes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "category" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "color" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "icon" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "subCategories",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "documentId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "category",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "color",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "rootCategory",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "documentId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "category",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyDatesSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "viewAllKeyDatesLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "icon" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "leadershipWheelSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "btnText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "ImageFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "articlesAndPodcastsSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "readNowArticle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "viewAllArticle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listenNowPodcast" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "viewAllPodcasts" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "icon" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HomePageQuery, HomePageQueryVariables>;
export const LeadershipWheelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "leadershipWheel" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "leadershipWheel" },
            name: { kind: "Name", value: "leadershipWheels_connection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "typeSection" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "mainGradientFrom",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "mainGradientTo",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "secondaryGradientFrom",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "secondaryGradientTo",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "tertiaryGradientFrom",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "tertiaryGradientTo",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "focusArea" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "subFocusArea" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "focusArea" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "microExercisePrompt",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "documentId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "publishedAt",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "type" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "content",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "overallMoodIcon" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeadershipWheelQuery,
  LeadershipWheelQueryVariables
>;
export const LeadershipWheelPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "leadershipWheelPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leadershipWheelPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "relatedContentTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "howAreYouFeelingTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "youAreTitle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "howAreYouTitle" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "changeMyAnswerCta",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "wellDoneTitle" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "goToYourMoodTracker",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "resetTheWheel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "messages" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "initial" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "trait" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "subTrait" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "initialTitle",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "traitTitle" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "subTraitTitle",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "privacyStatement",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "onboarding" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "steps" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "textBtn",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "image",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "calendarTitle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "bottomText" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "traitDetailsTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "TraitNotFound" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "finalState" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "course",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "slug",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "knowledgeBase",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "slug",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value:
                                              "redirectToCurrentCharacterExercise",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "redirectToCalendar",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "redirectToCalendar",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "text" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeadershipWheelPageQuery,
  LeadershipWheelPageQueryVariables
>;
export const QuotePageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "quotePage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "quotePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "quoteOfTheDayTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cta" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "text" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "link" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuotePageQuery, QuotePageQueryVariables>;
export const QuoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "quote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateFilterInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "quotes" },
            name: { kind: "Name", value: "quotes_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "date" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quote" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "author" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "occupation" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quoteWithLinks" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "links" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "podcast" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "attributes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "slug",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "course" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "attributes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "slug",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "knowledgeBase",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "attributes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "slug",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "redirectToCalendar",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "redirectToLeadershipWheel",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuoteQuery, QuoteQueryVariables>;
export const KeyDatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "KeyDates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "schoolContextDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "keyDates" },
            name: { kind: "Name", value: "filteredKeyDates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: { kind: "IntValue", value: "1" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pageSize" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "schoolContextDocumentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "schoolContextDocumentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "KeyDateFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "keyDatePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "calendarTitle" },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "searchPlaceholder" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousMonthButton" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextMonthButton" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "noKeyDatesFoundText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bookYourPlaceLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "learnMoreLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deadlineLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addToCalendarLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "calendarAppleLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "calendarGoogleLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "calendarOutlookLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tagTrustAction" },
                },
                { kind: "Field", name: { kind: "Name", value: "tagReminder" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tagAwarenessDay" },
                },
                { kind: "Field", name: { kind: "Name", value: "tagEvent" } },
                { kind: "Field", name: { kind: "Name", value: "tagPayment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tagAnnouncement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeyDateFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeyDate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "dateType" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "relativeRule" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "topicLabel" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "requiresReview" } },
          { kind: "Field", name: { kind: "Name", value: "isDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "originalText" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "academicYear" } },
          { kind: "Field", name: { kind: "Name", value: "bookYourPlaceUrl" } },
          { kind: "Field", name: { kind: "Name", value: "learnMoreUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "schools" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KeyDatesQuery, KeyDatesQueryVariables>;
export const KeyDatesListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "KeyDatesList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sectionType" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "title" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "schoolContextDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "keyDates" },
            name: { kind: "Name", value: "filteredKeyDates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "page" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pageSize" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pageSize" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sectionType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sectionType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "title" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "title" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "schoolContextDocumentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "schoolContextDocumentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "KeyDateFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "keyDatePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "calendarTitle" },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "searchPlaceholder" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previousMonthButton" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextMonthButton" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "noKeyDatesFoundText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bookYourPlaceLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "learnMoreLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deadlineLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addToCalendarLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "calendarAppleLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "calendarGoogleLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "calendarOutlookLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tagTrustAction" },
                },
                { kind: "Field", name: { kind: "Name", value: "tagReminder" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tagAwarenessDay" },
                },
                { kind: "Field", name: { kind: "Name", value: "tagEvent" } },
                { kind: "Field", name: { kind: "Name", value: "tagPayment" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tagAnnouncement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeyDateFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KeyDate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "dateType" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "relativeRule" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "topicLabel" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "requiresReview" } },
          { kind: "Field", name: { kind: "Name", value: "isDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "originalText" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "academicYear" } },
          { kind: "Field", name: { kind: "Name", value: "bookYourPlaceUrl" } },
          { kind: "Field", name: { kind: "Name", value: "learnMoreUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "schools" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KeyDatesListQuery, KeyDatesListQueryVariables>;
export const SectionTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SectionTypes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SectionTypesQuery, SectionTypesQueryVariables>;
export const TopicLabelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TopicLabels" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "topicLabels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TopicLabelsQuery, TopicLabelsQueryVariables>;
export const KnowledgeBaseCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgeBaseCategories" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgeBaseCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "KnowledgeBaseCategoryFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgeBaseCategoryFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgeBaseCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "subCategories" },
            name: { kind: "Name", value: "subCategories_connection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "subCategories" },
                        name: {
                          kind: "Name",
                          value: "subCategories_connection",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nodes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "category" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "subCategories",
                                    },
                                    name: {
                                      kind: "Name",
                                      value: "subCategories_connection",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "nodes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "category",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgeBaseCategoriesQuery,
  KnowledgeBaseCategoriesQueryVariables
>;
export const KnowledgeBasesListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgeBasesList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "categoryDocumentIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "knowledgeBaseTypeDocumentId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "knowledgebases" },
            name: { kind: "Name", value: "knowledgeBases_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "in" },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "categoryDocumentIds",
                                    },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "knowledgeBaseType" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "knowledgeBaseTypeDocumentId",
                                    },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "briefDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publicationDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "duration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBaseType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cover" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mime" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgeBasesListQuery,
  KnowledgeBasesListQueryVariables
>;
export const KnowledgeBaseCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgeBaseCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "documentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgeBaseCategory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "documentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "KnowledgeBaseCategoryFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgeBaseCategoryFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgeBaseCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "subCategories" },
            name: { kind: "Name", value: "subCategories_connection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "subCategories" },
                        name: {
                          kind: "Name",
                          value: "subCategories_connection",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nodes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "category" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "subCategories",
                                    },
                                    name: {
                                      kind: "Name",
                                      value: "subCategories_connection",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "nodes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "category",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgeBaseCategoryQuery,
  KnowledgeBaseCategoryQueryVariables
>;
export const ValidCategoryIdsForKnowledgeBaseTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "validCategoryIdsForKnowledgeBaseType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "knowledgeBaseTypeDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "validCategoryIdsForKnowledgeBaseType",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "knowledgeBaseTypeDocumentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "knowledgeBaseTypeDocumentId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ValidCategoryIdsForKnowledgeBaseTypeQuery,
  ValidCategoryIdsForKnowledgeBaseTypeQueryVariables
>;
export const KnowledgeBaseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgeBase" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "knowledgeBases" },
            name: { kind: "Name", value: "knowledgeBases_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "1" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "slug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "in" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "slug" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publicationDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "briefDescription" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "knowledgeBaseType",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "documentId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "type",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "subHeader" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cover" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "DefaultContentTemplate",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonH3",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonMedia",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "media",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "alternativeText",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTitle",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthorDetailed",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "authors_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "ComponentKnowledgeBaseKnowledgeBaseRelated",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "knowledgeBases",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "knowledgeBases_connection",
                                          },
                                          arguments: [
                                            {
                                              kind: "Argument",
                                              name: {
                                                kind: "Name",
                                                value: "filters",
                                              },
                                              value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                  {
                                                    kind: "ObjectField",
                                                    name: {
                                                      kind: "Name",
                                                      value: "publishedAt",
                                                    },
                                                    value: {
                                                      kind: "ObjectValue",
                                                      fields: [
                                                        {
                                                          kind: "ObjectField",
                                                          name: {
                                                            kind: "Name",
                                                            value: "notNull",
                                                          },
                                                          value: {
                                                            kind: "BooleanValue",
                                                            value: true,
                                                          },
                                                        },
                                                      ],
                                                    },
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "KnowledgeBaseBaseFragment",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonDivider",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTextEditor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "markdownText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonBullet",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "item" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "text",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonQuote",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "quote",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonFaqComponent",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "faq" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTags",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonRelatedContent",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "ComponentCommonDownloadableContentList",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "list" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "data",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "attributes",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "url",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAudio",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "transcription",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "audio",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "ComponentDefaultContentTemplateTimer",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "timerType",
                                          },
                                          name: { kind: "Name", value: "type" },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "timerAudio",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "audio",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "prompt",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "spokenGuidance",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "data",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "attributes",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "name",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "url",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "timerPrompt",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "prompt",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "prompt",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "durationInSeconds",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "timerVideo",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "video",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "videoTitle",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "video",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "data",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "attributes",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "name",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "url",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "height",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "width",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "timerAudioLabels",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "audioLabels",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "startExerciseButton",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "thankYouTitle",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "backDailyBubbleButton",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "playButtonLabel",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "pauseButtonLabel",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "stopButtonLabel",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "restartButtonLabel",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "minutes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "minute",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "timerPromptLabels",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "promptLabels",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "backDailyBubbleButton",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "startExerciseButton",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "thankYouTitle",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "playButtonLabel",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "pauseButtonLabel",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "stopButtonLabel",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "restartButtonLabel",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "timerVideoLabels",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "videoLabels",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value:
                                                    "backDailyBubbleButton",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "thankYouTitle",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgeBaseBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgeBase" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgeBaseType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>;
export const FetchLatestKnowledgeBasePageableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchLatestKnowledgeBasePageable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "kinds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "knowledgeBases" },
            name: { kind: "Name", value: "knowledgeBases_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: { kind: "IntValue", value: "8" },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "title" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "containsi" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "search" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "knowledgeBaseType" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "in" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "kinds" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "KnowledgeBaseBaseFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pagination" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "page" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgeBaseBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgeBase" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgeBaseType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchLatestKnowledgeBasePageableQuery,
  FetchLatestKnowledgeBasePageableQueryVariables
>;
export const FetchLatestKnowledgeBaseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchLatestKnowledgeBase" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "knowledgeBases" },
            name: { kind: "Name", value: "knowledgeBases_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "2" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "slug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notIn" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "slug" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "KnowledgeBaseBaseFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgeBaseBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgeBase" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgeBaseType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchLatestKnowledgeBaseQuery,
  FetchLatestKnowledgeBaseQueryVariables
>;
export const FetchKnowledgeBaseTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchKnowledgeBaseTypes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgeBaseTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchKnowledgeBaseTypesQuery,
  FetchKnowledgeBaseTypesQueryVariables
>;
export const FetchKnowledgeBaseTypesWithPublishedItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "fetchKnowledgeBaseTypesWithPublishedItems",
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "knowledgeBaseTypesWithPublishedItems",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchKnowledgeBaseTypesWithPublishedItemsQuery,
  FetchKnowledgeBaseTypesWithPublishedItemsQueryVariables
>;
export const FindPodcastListeningTimeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "findPodcastListeningTime" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PodcastListeningTimeFiltersInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "podcastListeningTimes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "listeningTime" },
                },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FindPodcastListeningTimeQuery,
  FindPodcastListeningTimeQueryVariables
>;
export const KnowledgeBasePageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgeBasePage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgeBasePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "moreButtonTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentTemplateLabels" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "downloadableContentLabel",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgeBaseCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "KnowledgeBaseCategoryFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgeBaseCategoryFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgeBaseCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "subCategories" },
            name: { kind: "Name", value: "subCategories_connection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "subCategories" },
                        name: {
                          kind: "Name",
                          value: "subCategories_connection",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nodes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "category" },
                                  },
                                  {
                                    kind: "Field",
                                    alias: {
                                      kind: "Name",
                                      value: "subCategories",
                                    },
                                    name: {
                                      kind: "Name",
                                      value: "subCategories_connection",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "nodes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "category",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgeBasePageQuery,
  KnowledgeBasePageQueryVariables
>;
export const CourseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "course" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "courses" },
            name: { kind: "Name", value: "courses_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "1" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "slug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "in" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "slug" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "textContent" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "markdownText",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "courseCompletedSection",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "message" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hero" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "moduleStableId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lessonStableId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "duration",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "textContent",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "markdownText",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "thumbnail",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "authors_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseQuery, CourseQueryVariables>;
export const CourseLessonDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "courseLesson" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "courses" },
            name: { kind: "Name", value: "courses_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "1" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "slug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "in" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "slug" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "feedbackQuestions",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "question" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "textContent" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "markdownText",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hero" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "moduleStableId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "duration",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lessonStableId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "textContent",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "markdownText",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "objectivesSection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "objectives",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "description",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "thumbnail",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "highlightContent",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "audio",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "audio",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "data",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "attributes",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "Field",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "url",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "transcription",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "embedded",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "link",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "provider",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "image",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "media",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "data",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "attributes",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "Field",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "url",
                                                                            },
                                                                          },
                                                                          {
                                                                            kind: "Field",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "alternativeText",
                                                                            },
                                                                          },
                                                                          {
                                                                            kind: "Field",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "mime",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "downloadableContent",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "data",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "attributes",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "url",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "faq" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "authors_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseLessonQuery, CourseLessonQueryVariables>;
export const FetchLatestCoursesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchLatestCourses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "courses" },
            name: { kind: "Name", value: "courses_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "2" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "slug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notIn" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "slug" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchLatestCoursesQuery,
  FetchLatestCoursesQueryVariables
>;
export const FetchCoursesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchCourses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "publishedAt" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
          defaultValue: {
            kind: "StringValue",
            value: "publishedAt:asc",
            block: false,
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "courses" },
            name: { kind: "Name", value: "courses_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "publishedAt" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "authors_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchCoursesQuery, FetchCoursesQueryVariables>;
export const FetchCoursesPageableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchCoursesPageable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "courses" },
            name: { kind: "Name", value: "courses_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: { kind: "IntValue", value: "8" },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "title" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "containsi" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "search" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "authors_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pagination" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "page" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchCoursesPageableQuery,
  FetchCoursesPageableQueryVariables
>;
export const FetchLearnDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchLearn" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "staffId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "completed" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "learn" },
            name: { kind: "Name", value: "learns_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "users_permissions_user" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "staffId" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "completed" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "completed" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "LearnFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LearnFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Learn" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "completedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users_permissions_user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "course" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "alternativeText",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "mime",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "moduleStableId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lessonStableId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "learn_items" },
            name: { kind: "Name", value: "learn_items_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "999" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idModule" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idLesson" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchLearnQuery, FetchLearnQueryVariables>;
export const FetchCourseLearnDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchCourseLearn" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "staffId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "courseSlug" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "learn" },
            name: { kind: "Name", value: "learns_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "users_permissions_user" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "staffId" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "course" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "slug" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "courseSlug" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "LearnFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LearnFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Learn" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "completedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users_permissions_user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "course" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "alternativeText",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "mime",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "moduleStableId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lessonStableId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "learn_items" },
            name: { kind: "Name", value: "learn_items_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "999" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idModule" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "idLesson" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchCourseLearnQuery,
  FetchCourseLearnQueryVariables
>;
export const CoursePageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CoursePage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coursePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lesson" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "beginButtonLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "watchAgainButtonlabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "lockedButtonlabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "offlineModeLockedButtonLabel",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoursePageQuery, CoursePageQueryVariables>;
export const LearnPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LearnPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "learnPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "learnHighlight" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "image" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value: "ImageFragment",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "emptyInProgressCoursesMessage",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "emptyCompletedCoursesMessage",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "emptyCoursesMessage",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "markLessonAsCompleteButton",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "markAsCompleteLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "completedLabel",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "markCourseAsCompleted",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "markAsCompleteLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "completedLabel",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "contentTemplateLabels",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "downloadableContentLabel",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LearnPageQuery, LearnPageQueryVariables>;
export const CourseFeedbackPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "courseFeedbackPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "learnPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "markCourseAsCompleted",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "completedLabel",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "feedbackSection" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "submitYourFeedback",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "enterYourFeedback",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "sendFeedback",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modalLeavePage" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "confirmButton",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "cancelButton",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CourseFeedbackPageQuery,
  CourseFeedbackPageQueryVariables
>;
export const FetchUserTrackingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchUserTracking" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserTrackingData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dailyStreak" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "streakRecord" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emotionsTracked" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchUserTrackingQuery,
  FetchUserTrackingQueryVariables
>;
export const FetchLoginTrackerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchLoginTracker" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDay" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endDay" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "staffId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "loginTrackers" },
            name: { kind: "Name", value: "loginTrackers_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "day" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "gte" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "startDay" },
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "lte" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "endDay" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "staff" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "staffId" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "streakCounter" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "day" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchLoginTrackerQuery,
  FetchLoginTrackerQueryVariables
>;
export const ForgotPasswordPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "forgotPasswordPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "forgotPassword" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageImage" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "forgotPasswordTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "forgotPasswordDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "customerEmailAddressTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sendMeCta" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "backToLoginCta" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "chooseANewPasswordTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "passwordsShouldBeDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "yourNewPassword" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "repeatYourPassword",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "resetMyPasswordCta",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "feedback" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "emailSent" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "passwordResetSuccess",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "passwordResetError",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForgotPasswordPageQuery,
  ForgotPasswordPageQueryVariables
>;
export const LoginPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "loginPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "loginPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageImage" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "loginTitle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "yourEmailTitle" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "yourPasswordTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rememberMeTitle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "loginCta" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "forgotYourPasswordCta",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "confirmEmailTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pleaseLoginTItle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fieldErrors" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "identifierRequired",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "passwordRequired",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "popUpMessages" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "success" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "message",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "error" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "message",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginPageQuery, LoginPageQueryVariables>;
export const RegisterPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "registerPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "registerTitle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "yourEmail" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "schoolCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "yourFirstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "yourLastName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "choosePassword" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "repeatYourPassword",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "createYourAccountCta",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "welcomeToTItle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageImage" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "image" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "successRegisterPopUpTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "successRegisterPopUpMessage",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fieldErrors" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surnameRequired",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "forenameRequired",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "emailRequired",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "schoolCodeRequired",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "passwordRequired",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "termsAndConditionsRequired",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "confirmPasswordRequired",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "confirmPasswordDidNotMatch",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "popUpMessages" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "success" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "message",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "error" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "message",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterPageQuery, RegisterPageQueryVariables>;
export const FetchManageStaffPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FetchManageStaffPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "manageUsersPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "staffListTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inviteStaff" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inviteStaff" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "importStaffSpreadsheet" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "toastStaffInvitedTitle" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "toastStaffInvitedDescription",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dialogTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dialogDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dialogConfirmButton" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "staffImportFromSpreadsheetDialog",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "closeButtonText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "importStaffButtonText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "uploadFileButtonText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previewTitle" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "toastStaffImportedTitle",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "toastStaffImportedDescription",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "staffEmptyState" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "staffStatus" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pendingInviteMessage" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "invitedPendingSignUpMessage",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "registeredPendingOnboardingMessage",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "registeredOnboardedMessage",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "invitedPendingSignUpColor",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "registeredPendingOnboardingColor",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "registeredOnboardedColor",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pendingInviteColor" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchManageStaffPageQuery,
  FetchManageStaffPageQueryVariables
>;
export const NotificationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "notifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NotificationFiltersInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pagination" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PaginationArg" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "schoolContextDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notifications_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pagination" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sort" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "link" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isCustom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priority" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customTemplate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "template" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "template" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resource" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cover" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "alternativeText",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "schools" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>;
export const NotificationByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "notificationById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "documentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "documentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "link" } },
                { kind: "Field", name: { kind: "Name", value: "isCustom" } },
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customTemplate" },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "template" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "template" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cover" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "schools" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NotificationByIdQuery,
  NotificationByIdQueryVariables
>;
export const UserNotificationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "userNotifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NotificationUserFiltersInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pagination" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PaginationArg" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notificationUsers_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pagination" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sort" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deliveredAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clickedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seenAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notification" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "link" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isCustom" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "priority" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customTemplate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "publishedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "template" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "category" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "template" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "resource" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "cover" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "alternativeText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserNotificationsQuery,
  UserNotificationsQueryVariables
>;
export const UnreadNotificationsCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "unreadNotificationsCount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NotificationUserFiltersInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notificationUsers_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnreadNotificationsCountQuery,
  UnreadNotificationsCountQueryVariables
>;
export const NotificationTemplatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "notificationTemplates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NotificationTemplateFiltersInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pagination" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PaginationArg" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notificationTemplates_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pagination" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sort" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "template" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NotificationTemplatesQuery,
  NotificationTemplatesQueryVariables
>;
export const OnBoardingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "onBoarding" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "onBoardingPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "alternativeText" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "step1" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "button" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "link" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "step2" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "button" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "link" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "step3" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "button" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "link" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "step4" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "button" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "link" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "roles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ageBracket" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "options" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "option" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "role" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gender" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "options" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "option" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placeholder" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "step5" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "content" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "button" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "link" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnBoardingQuery, OnBoardingQueryVariables>;
export const OnBoardingStep1Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "onBoardingStep1" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "step1" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "image" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "attributes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value:
                                                          "alternativeText",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "button" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnBoardingStep1Query,
  OnBoardingStep1QueryVariables
>;
export const OnBoardingStep2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "onBoardingStep2" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "step2" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "image" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "attributes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value:
                                                          "alternativeText",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "button" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnBoardingStep2Query,
  OnBoardingStep2QueryVariables
>;
export const OnBoardingStep3Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "onBoardingStep3" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "step3" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "image" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "attributes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value:
                                                          "alternativeText",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "button" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnBoardingStep3Query,
  OnBoardingStep3QueryVariables
>;
export const OnBoardingStep4Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "onBoardingStep4" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "step4" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "image" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "attributes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value:
                                                          "alternativeText",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "button" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "roles" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "role" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ageBracket" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "placeholder",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "options" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "option",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "role" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "placeholder",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gender" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "placeholder",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "options" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "option",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "label" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "placeholder",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnBoardingStep4Query,
  OnBoardingStep4QueryVariables
>;
export const OnBoardingStep5Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "onBoardingStep5" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "step5" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "image" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "attributes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value:
                                                          "alternativeText",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "button" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnBoardingStep5Query,
  OnBoardingStep5QueryVariables
>;
export const PodcastListPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "podcastListPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "podcastListPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pageTitle" } },
                { kind: "Field", name: { kind: "Name", value: "heroTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "alternativeText" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "latestTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "moreButtonTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "listenAtLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "platforms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "platform" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "alternativeText",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "card" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "watchButtonLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "watchAgainButtonLabel" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PodcastListPageQuery,
  PodcastListPageQueryVariables
>;
export const PodcastDetailPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "podcastDetailPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "podcastDetailPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backLinkLabel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "viewAllLabel" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PodcastDetailPageQuery,
  PodcastDetailPageQueryVariables
>;
export const FetchPodcastsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchPodcasts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "podcasts" },
            name: { kind: "Name", value: "podcasts_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PodcastBaseFragment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listenings" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filters" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "staff" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "documentId",
                                        },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "eq",
                                              },
                                              value: {
                                                kind: "Variable",
                                                name: {
                                                  kind: "Name",
                                                  value: "userDocumentId",
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "listeningTime" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PodcastBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Podcast" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchPodcastsQuery, FetchPodcastsQueryVariables>;
export const FetchSearchPodcastsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchSearchPodcasts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PodcastFiltersInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pagination" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PaginationArg" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "podcasts" },
            name: { kind: "Name", value: "podcasts_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pagination" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PodcastBaseFragment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listenings" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filters" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "staff" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "documentId",
                                        },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "eq",
                                              },
                                              value: {
                                                kind: "Variable",
                                                name: {
                                                  kind: "Name",
                                                  value: "userDocumentId",
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "listeningTime" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PodcastBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Podcast" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchSearchPodcastsQuery,
  FetchSearchPodcastsQueryVariables
>;
export const PodcastBySlugDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "podcastBySlug" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "podcastBySlug" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "current" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PodcastDetailFragment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listenings" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filters" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "staff" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "documentId",
                                        },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "eq",
                                              },
                                              value: {
                                                kind: "Variable",
                                                name: {
                                                  kind: "Name",
                                                  value: "userDocumentId",
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "listeningTime" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "DefaultContentTemplate" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "PodcastDefaultContentTemplateFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PodcastBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Podcast" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PodcastDetailFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Podcast" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "fullDescription" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "platforms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "platform" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "icon" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PodcastDefaultContentTemplateFragment" },
      typeCondition: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "PodcastDefaultContentTemplateDynamicZone",
        },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonH3" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "text" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonMedia" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "media" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "alternativeText" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTitle" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonAuthorDetailed" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "authors" },
                  name: { kind: "Name", value: "authors_connection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "role" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "bio" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "avatar" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "alternativeText",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonDivider" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonEmbedded" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "link" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTextEditor" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "markdownText" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonBullet" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "item" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonQuote" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "quote" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonFaqComponent" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faq" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTags" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonRelatedContent" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ComponentCommonDownloadableContentList",
              },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "list" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonAudio" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transcription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "audio" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentPodcastPodcastRelated" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "podcasts" },
                  name: { kind: "Name", value: "podcasts_connection" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "publishedAt" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "notNull" },
                                  value: { kind: "BooleanValue", value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "PodcastBaseFragment",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "listenings" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "filters" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: { kind: "Name", value: "staff" },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "documentId",
                                              },
                                              value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                  {
                                                    kind: "ObjectField",
                                                    name: {
                                                      kind: "Name",
                                                      value: "eq",
                                                    },
                                                    value: {
                                                      kind: "Variable",
                                                      name: {
                                                        kind: "Name",
                                                        value: "userDocumentId",
                                                      },
                                                    },
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "listeningTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "duration" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PodcastBySlugQuery, PodcastBySlugQueryVariables>;
export const PrivacyPolicyPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "privacyPolicyPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "privacyPolicyPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "DefaultContentTemplate",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonH3",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonMedia",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "media",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "alternativeText",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTitle",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "author",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "publicationDate",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthorDetailed",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "authors_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonDivider",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTextEditor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "markdownText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonBullet",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "item" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "text",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonQuote",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "quote",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonFaqComponent",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "faq" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "ComponentCommonDownloadableContentList",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "list" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "data",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "attributes",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "url",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PrivacyPolicyPageQuery,
  PrivacyPolicyPageQueryVariables
>;
export const FindUsersPermissionsUserByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "findUsersPermissionsUserById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "documentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "usersPermissionsUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "documentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "username" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "provider" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "confirmed" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blocked" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "onboardHomeCompleted",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "forename" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "surname" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "confirmationEmailSent",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ageBracket" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gender" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "onboardQuestionsCompleted",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "isLeadershipWheelTrackingDisabled",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "onboardLeadershipWheelCompleted",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "profile" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "school" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "documentId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "subscription",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "data",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "attributes",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "name",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "knowledgeBase",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "learn",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "search",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "bookmark",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "mission",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "podcast",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "resourceHub",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "access_control_list",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "isInstructor",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "isMAT",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "reportingTools",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "manageStaff",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "school" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "documentId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "subscription",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "data",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "attributes",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "name",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "knowledgeBase",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "learn",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "search",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "bookmark",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "mission",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "podcast",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "resourceHub",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "photo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "alternativeText",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FindUsersPermissionsUserByIdQuery,
  FindUsersPermissionsUserByIdQueryVariables
>;
export const ProfilePageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "profilePage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "profilePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "welcomeTitle" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "profileInfoSection",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "memberSinceTitle",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "youLocationTitle",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "editYourInfoCta",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "saveYourChangesCta",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "saveYourChangesSettingsCta",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "surnamePlaceholder",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "forenamePlaceholder",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "profilePasswordSection",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "yourPasswordTitle",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "yourCurrentPasswordField",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "yourNewPasswordField",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "confirmYourPasswordField",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "confirmYourChangesCta",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "profileNotificationsSection",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "yourNotificationsTitle",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "confirmYourChangesCta",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "profileSubTraitsSection",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "yourFocusTitle",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "whichAreasTitle",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "confirmYouChangesCta",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "traitTrackingSection",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "btnStopTrackingLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "btnStartTrackingLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "notRecordedLabel",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "notRecordedDescription",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "notRecordedIcon",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value: "ImageFragment",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "notTrackingIcon",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "data" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value: "ImageFragment",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statsAndStreaks" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "finishingCardStreak",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "days" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "finishingCardMaxStreak",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "days" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "finishingCardLeadershipWheel",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "traits",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "editProfileButtonLabel",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "closeAccountButtonlabel",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "confirmAccountClosureTitle",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "confirmAccountClosureDescription",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfilePageQuery, ProfilePageQueryVariables>;
export const FindUsersPermissionsUserByIdV5Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "findUsersPermissionsUserByIdV5" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "documentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchMySchools" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "asRegularUser" },
                value: { kind: "BooleanValue", value: false },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logoMAT" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "alternativeText" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBase" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "learn" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "search" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bookmark" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "podcast" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resourceHub" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usersPermissionsUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "documentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "confirmed" } },
                { kind: "Field", name: { kind: "Name", value: "blocked" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardHomeCompleted" },
                },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                { kind: "Field", name: { kind: "Name", value: "forename" } },
                { kind: "Field", name: { kind: "Name", value: "surname" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "confirmationEmailSent" },
                },
                { kind: "Field", name: { kind: "Name", value: "ageBracket" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboardQuestionsCompleted" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "isLeadershipWheelTrackingDisabled",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "onboardLeadershipWheelCompleted",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "school" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logoMAT" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subscription" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "knowledgeBase" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "learn" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "search" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "bookmark" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mission" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "podcast" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "resourceHub" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "access_control_list" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isInstructor" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "isMAT" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reportingTools" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "manageStaff" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "photo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "alternativeText" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FindUsersPermissionsUserByIdV5Query,
  FindUsersPermissionsUserByIdV5QueryVariables
>;
export const ProfilePageV5Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "profilePageV5" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "profilePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "welcomeTitle" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "latestResourcesDownloadedTitle",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "noDownloadedResourcesMessage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profileInfoSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roleTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "memberSinceTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "youLocationTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "editYourInfoCta" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "saveYourChangesCta" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "surnamePlaceholder" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "forenamePlaceholder" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profilePasswordSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "yourPasswordTitle" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "yourCurrentPasswordField",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "yourNewPasswordField" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "confirmYourPasswordField",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "confirmYourChangesCta" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profileNotificationsSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "yourNotificationsTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "confirmYourChangesCta" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profileSubTraitsSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "yourFocusTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "whichAreasTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "confirmYouChangesCta" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "traitTrackingSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "btnStopTrackingLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "btnStartTrackingLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notRecordedLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notRecordedDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notRecordedIcon" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notTrackingIcon" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statsAndStreaks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "finishingCardStreak" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "days" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "finishingCardMaxStreak" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "days" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "finishingCardLeadershipWheel",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "traits" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfilePageV5Query, ProfilePageV5QueryVariables>;
export const FetchUserDownloadedResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchUserDownloadedResources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchUserDownloadedResources" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ResourceHubBaseFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceHubBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "assetsCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchUserDownloadedResourcesQuery,
  FetchUserDownloadedResourcesQueryVariables
>;
export const FetchResourceHubListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchResourceHubList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "title" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "categoryDocumentIds" },
          },
          type: {
            kind: "ListType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "schoolContextDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "resources" },
            name: { kind: "Name", value: "resources_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "title" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "containsi" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "title" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "in" },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "categoryDocumentIds",
                                    },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: false,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "null" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "or" },
                                value: {
                                  kind: "ListValue",
                                  values: [
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "schools",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                                value: {
                                                  kind: "ObjectValue",
                                                  fields: [
                                                    {
                                                      kind: "ObjectField",
                                                      name: {
                                                        kind: "Name",
                                                        value: "in",
                                                      },
                                                      value: {
                                                        kind: "ListValue",
                                                        values: [
                                                          {
                                                            kind: "Variable",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "schoolContextDocumentId",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "staff",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                                value: {
                                                  kind: "ObjectValue",
                                                  fields: [
                                                    {
                                                      kind: "ObjectField",
                                                      name: {
                                                        kind: "Name",
                                                        value: "eq",
                                                      },
                                                      value: {
                                                        kind: "Variable",
                                                        name: {
                                                          kind: "Name",
                                                          value:
                                                            "userDocumentId",
                                                        },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ResourceHubBaseFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceHubBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "assetsCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchResourceHubListQuery,
  FetchResourceHubListQueryVariables
>;
export const FetchResourceHubBySlugDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchResourceHubBySlug" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resources_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "slug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "slug" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "1" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "briefDescription" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subHeader" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publicationDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resourceStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expireResourceStatusAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "type" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cover" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alternativeText" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mime" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resourceHistory" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "version" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "DefaultContentTemplate" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value:
                                  "ResourceHubDefaultContentTemplateFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: {
        kind: "Name",
        value: "ResourceHubDefaultContentTemplateFragment",
      },
      typeCondition: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "ResourceDefaultContentTemplateDynamicZone",
        },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonH3" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTitle" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonAuthorDetailed" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "authors" },
                  name: { kind: "Name", value: "authors_connection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "role" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "bio" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "avatar" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "alternativeText",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonAuthor" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publicationDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "author" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonDivider" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonEmbedded" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "link" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTextEditor" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "markdownText" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonQuote" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "quote" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonFaqComponent" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "faq" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonTags" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonRelatedContent" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ComponentCommonDownloadableContentList",
              },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "list" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ext" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mime" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "size" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentCommonAudio" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transcription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "audio" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ComponentResourceAssets" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionTitle" },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "assets" },
                  name: { kind: "Name", value: "assets_connection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "publishedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updatedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "previewStatus" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "scanStatus" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "content" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ext" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "mime" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "size" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: {
                                kind: "Name",
                                value: "resourceAssetHistory",
                              },
                              name: {
                                kind: "Name",
                                value: "resourceAssetHistory_connection",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nodes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "version",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ComponentResourceResourcesRelated",
              },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "resources" },
                  name: { kind: "Name", value: "resources_connection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "briefDescription" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cover" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "alternativeText",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchResourceHubBySlugQuery,
  FetchResourceHubBySlugQueryVariables
>;
export const FetchResourceHubCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchResourceHubCategories" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resourceCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "subCategories" },
                  name: { kind: "Name", value: "subCategories_connection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "color" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "subCategories" },
                              name: {
                                kind: "Name",
                                value: "subCategories_connection",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nodes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "documentId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "category",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "color",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "subCategories",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "subCategories_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "nodes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "documentId",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "category",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "color",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchResourceHubCategoriesQuery,
  FetchResourceHubCategoriesQueryVariables
>;
export const FetchResourceHubTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchResourceHubTypes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resourceTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchResourceHubTypesQuery,
  FetchResourceHubTypesQueryVariables
>;
export const FetchResourceHubResourcesByCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchResourceHubResourcesByCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "categoryDocumentIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "schoolContextDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "resources" },
            name: { kind: "Name", value: "resources_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: { kind: "IntValue", value: "1" },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "in" },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "categoryDocumentIds",
                                    },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: false,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "null" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "or" },
                                value: {
                                  kind: "ListValue",
                                  values: [
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "schools",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                                value: {
                                                  kind: "ObjectValue",
                                                  fields: [
                                                    {
                                                      kind: "ObjectField",
                                                      name: {
                                                        kind: "Name",
                                                        value: "in",
                                                      },
                                                      value: {
                                                        kind: "ListValue",
                                                        values: [
                                                          {
                                                            kind: "Variable",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "schoolContextDocumentId",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "staff",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                                value: {
                                                  kind: "ObjectValue",
                                                  fields: [
                                                    {
                                                      kind: "ObjectField",
                                                      name: {
                                                        kind: "Name",
                                                        value: "eq",
                                                      },
                                                      value: {
                                                        kind: "Variable",
                                                        name: {
                                                          kind: "Name",
                                                          value:
                                                            "userDocumentId",
                                                        },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ResourceHubBaseFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceHubBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "assetsCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchResourceHubResourcesByCategoryQuery,
  FetchResourceHubResourcesByCategoryQueryVariables
>;
export const FetchResourceHubCategoryIdsWithResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchResourceHubCategoryIdsWithResources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "schoolContextDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "resources" },
            name: { kind: "Name", value: "resources_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "-1" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: false,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "null" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "or" },
                                value: {
                                  kind: "ListValue",
                                  values: [
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "schools",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                                value: {
                                                  kind: "ObjectValue",
                                                  fields: [
                                                    {
                                                      kind: "ObjectField",
                                                      name: {
                                                        kind: "Name",
                                                        value: "in",
                                                      },
                                                      value: {
                                                        kind: "ListValue",
                                                        values: [
                                                          {
                                                            kind: "Variable",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "schoolContextDocumentId",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "staff",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                                value: {
                                                  kind: "ObjectValue",
                                                  fields: [
                                                    {
                                                      kind: "ObjectField",
                                                      name: {
                                                        kind: "Name",
                                                        value: "eq",
                                                      },
                                                      value: {
                                                        kind: "Variable",
                                                        name: {
                                                          kind: "Name",
                                                          value:
                                                            "userDocumentId",
                                                        },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchResourceHubCategoryIdsWithResourcesQuery,
  FetchResourceHubCategoryIdsWithResourcesQueryVariables
>;
export const FetchResourceHubPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchResourceHubPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resourceHubPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardLinkText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "loadMoreText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "noResultsText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resultsTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "howToUseThisTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadButtonText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "previewButtonText" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadAllButtonText" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchResourceHubPageQuery,
  FetchResourceHubPageQueryVariables
>;
export const HomeResourceSectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "homeResourceSection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "categoryDocumentIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "schoolContextDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "resources" },
            name: { kind: "Name", value: "resources_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: { kind: "IntValue", value: "1" },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: { kind: "IntValue", value: "3" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "documentId" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "in" },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "categoryDocumentIds",
                                    },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: false,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "null" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "or" },
                                value: {
                                  kind: "ListValue",
                                  values: [
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "schools",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                                value: {
                                                  kind: "ObjectValue",
                                                  fields: [
                                                    {
                                                      kind: "ObjectField",
                                                      name: {
                                                        kind: "Name",
                                                        value: "in",
                                                      },
                                                      value: {
                                                        kind: "ListValue",
                                                        values: [
                                                          {
                                                            kind: "Variable",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "schoolContextDocumentId",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "staff",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "documentId",
                                                },
                                                value: {
                                                  kind: "ObjectValue",
                                                  fields: [
                                                    {
                                                      kind: "ObjectField",
                                                      name: {
                                                        kind: "Name",
                                                        value: "eq",
                                                      },
                                                      value: {
                                                        kind: "Variable",
                                                        name: {
                                                          kind: "Name",
                                                          value:
                                                            "userDocumentId",
                                                        },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ResourceHubBaseFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceHubBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "assetsCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HomeResourceSectionQuery,
  HomeResourceSectionQueryVariables
>;
export const ResourceCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "resourceCategories" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resourceCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ResourceCategoryFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceCategoryFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResourceCategoriesQuery,
  ResourceCategoriesQueryVariables
>;
export const ResourceCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "resourceCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "documentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resourceCategory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "documentId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ResourceCategoryFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceCategoryFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "subCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResourceCategoryQuery,
  ResourceCategoryQueryVariables
>;
export const ResourceTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "resourceTypes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resourceTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ResourceTypeFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceTypeFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResourceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceTypesQuery, ResourceTypesQueryVariables>;
export const ResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "resources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resources_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "type" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "category" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "category" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ResourceBaseFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pagination" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "page" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageSize" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourcesQuery, ResourcesQueryVariables>;
export const ResourceBySlugDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "resourceBySlug" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resources_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "slug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "slug" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ResourceBaseFragment",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "DefaultContentTemplate",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonH3",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTitle",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "author",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "publicationDate",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonDivider",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTextEditor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "markdownText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonQuote",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "quote",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAudio",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "audio",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "transcription",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthorDetailed",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "authors_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentResourceAssets",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "assets",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "assets_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "title",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "description",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "content",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "Field",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "attributes",
                                                                            },
                                                                            selectionSet:
                                                                              {
                                                                                kind: "SelectionSet",
                                                                                selections:
                                                                                  [
                                                                                    {
                                                                                      kind: "Field",
                                                                                      name: {
                                                                                        kind: "Name",
                                                                                        value:
                                                                                          "url",
                                                                                      },
                                                                                    },
                                                                                    {
                                                                                      kind: "Field",
                                                                                      name: {
                                                                                        kind: "Name",
                                                                                        value:
                                                                                          "name",
                                                                                      },
                                                                                    },
                                                                                    {
                                                                                      kind: "Field",
                                                                                      name: {
                                                                                        kind: "Name",
                                                                                        value:
                                                                                          "ext",
                                                                                      },
                                                                                    },
                                                                                    {
                                                                                      kind: "Field",
                                                                                      name: {
                                                                                        kind: "Name",
                                                                                        value:
                                                                                          "mime",
                                                                                      },
                                                                                    },
                                                                                    {
                                                                                      kind: "Field",
                                                                                      name: {
                                                                                        kind: "Name",
                                                                                        value:
                                                                                          "size",
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                              },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "ComponentResourceResourcesRelated",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "resources",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "resources_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "title",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "slug",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "cover",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "type",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "Field",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "attributes",
                                                                            },
                                                                            selectionSet:
                                                                              {
                                                                                kind: "SelectionSet",
                                                                                selections:
                                                                                  [
                                                                                    {
                                                                                      kind: "Field",
                                                                                      name: {
                                                                                        kind: "Name",
                                                                                        value:
                                                                                          "type",
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                              },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceBySlugQuery, ResourceBySlugQueryVariables>;
export const LatestResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "latestResources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resources_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ResourceBaseFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LatestResourcesQuery,
  LatestResourcesQueryVariables
>;
export const ResourcesByTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "resourcesByType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resources_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "type" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ResourceBaseFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pagination" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "page" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageSize" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResourcesByTypeQuery,
  ResourcesByTypeQueryVariables
>;
export const ResourcesByCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "resourcesByCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resources_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "category" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "category" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ResourceBaseFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pagination" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "page" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageSize" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResourcesByCategoryQuery,
  ResourcesByCategoryQueryVariables
>;
export const FetchMySchoolsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchMySchools" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "asRegularUser" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchMySchools" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "asRegularUser" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "asRegularUser" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logoMAT" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "alternativeText" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBase" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "learn" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "search" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bookmark" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mission" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "podcast" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "resourceHub" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchMySchoolsQuery, FetchMySchoolsQueryVariables>;
export const FetchSearchPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchSearchPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "searchPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "yourResultsTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "noRecordsFoundText" },
                },
                { kind: "Field", name: { kind: "Name", value: "placeholder" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchSearchPageQuery,
  FetchSearchPageQueryVariables
>;
export const LatestKnowledgeBasesWithFiltersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "latestKnowledgeBasesWithFilters" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "KnowledgeBaseFiltersInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "knowledgebases" },
            name: { kind: "Name", value: "knowledgeBases_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "KnowledgeBaseBaseFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pagination" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "total" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "page" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageSize" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgeBaseBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgeBase" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgeBaseType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ImageFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "DefaultContentTemplate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "ComponentCommonAuthorDetailed",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "authors" },
                        name: { kind: "Name", value: "authors_connection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "data" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "attributes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "role" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bio" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "avatar",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "ImageFragment",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LatestKnowledgeBasesWithFiltersQuery,
  LatestKnowledgeBasesWithFiltersQueryVariables
>;
export const FetchSearchCoursesPageableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchSearchCoursesPageable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CourseFiltersInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pagination" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PaginationArg" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "courses" },
            name: { kind: "Name", value: "courses_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pagination" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "EnumValue", value: "PUBLISHED" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lessons" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchSearchCoursesPageableQuery,
  FetchSearchCoursesPageableQueryVariables
>;
export const FetchSearchResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchSearchResources" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pagination" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PaginationArg" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "title" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "schoolContextDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "resources" },
            name: { kind: "Name", value: "resources_connection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pagination" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "StringValue",
                  value: "publicationDate:desc",
                  block: false,
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "publishedAt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "notNull" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "title" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "containsi" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "title" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: false,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "null" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "restrictedSharing",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "schools" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: {
                                        kind: "Name",
                                        value: "documentId",
                                      },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: { kind: "Name", value: "in" },
                                            value: {
                                              kind: "ListValue",
                                              values: [
                                                {
                                                  kind: "Variable",
                                                  name: {
                                                    kind: "Name",
                                                    value:
                                                      "schoolContextDocumentId",
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ResourceHubBaseFragment",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResourceHubBaseFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resource" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "briefDescription" } },
          { kind: "Field", name: { kind: "Name", value: "subHeader" } },
          { kind: "Field", name: { kind: "Name", value: "publicationDate" } },
          { kind: "Field", name: { kind: "Name", value: "resourceStatus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expireResourceStatusAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "assetsCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cover" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchSearchResourcesQuery,
  FetchSearchResourcesQueryVariables
>;
export const FetchSearchUnifiedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchSearchUnified" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchTerm" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contentTypes" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "schoolContextDocumentId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "searchUnified" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchTerm" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "searchTerm" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contentTypes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contentTypes" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "schoolContextDocumentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "schoolContextDocumentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "page" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pageSize" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pageSize" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Course" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "course_category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "KnowledgeBase" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "kbSlug" },
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "duration" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "knowledgeBaseType",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "attributes",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "type",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "briefDescription" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cover" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "data" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "ImageFragment",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Podcast" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "podcastSlug" },
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              alias: {
                                kind: "Name",
                                value: "podcastBriefDescription",
                              },
                              name: { kind: "Name", value: "briefDescription" },
                            },
                            {
                              kind: "Field",
                              alias: {
                                kind: "Name",
                                value: "podcastPublicationDate",
                              },
                              name: { kind: "Name", value: "publicationDate" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "podcastCover" },
                              name: { kind: "Name", value: "cover" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "alternativeText",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "mime" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "listenings" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "listeningTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "duration" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resource" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "resourceSlug" },
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              alias: {
                                kind: "Name",
                                value: "resourceBriefDescription",
                              },
                              name: { kind: "Name", value: "briefDescription" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "subHeader" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "publicationDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "resourceStatus" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "expireResourceStatusAt",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "assetsCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "documentId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "category" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "resourceCover" },
                              name: { kind: "Name", value: "cover" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "alternativeText",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "mime" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchSearchUnifiedQuery,
  FetchSearchUnifiedQueryVariables
>;
export const TermsAndConditionsPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "termsAndConditionsPage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "termsAndConditionsPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attributes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "DefaultContentTemplate",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonH3",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "text" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonMedia",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "media",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "alternativeText",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTitle",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "author",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "publicationDate",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonAuthorDetailed",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          alias: {
                                            kind: "Name",
                                            value: "authors",
                                          },
                                          name: {
                                            kind: "Name",
                                            value: "authors_connection",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "data",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "attributes",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "name",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "role",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "bio",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "avatar",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "data",
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: "SelectionSet",
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: "FragmentSpread",
                                                                            name: {
                                                                              kind: "Name",
                                                                              value:
                                                                                "ImageFragment",
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonDivider",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonTextEditor",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "markdownText",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonEmbedded",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "provider",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonBullet",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "item" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "text",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonQuote",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "quote",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ComponentCommonFaqComponent",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "faq" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "ComponentCommonDownloadableContentList",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "list" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "content",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "data",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "attributes",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "url",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ImageFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeText" },
                },
                { kind: "Field", name: { kind: "Name", value: "mime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TermsAndConditionsPageQuery,
  TermsAndConditionsPageQueryVariables
>;
export const FetchWildcardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FetchWildcard" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fetchWildcardUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "documentId" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "ctaText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "course" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "knowledgeBase" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "redirectToLeadershipWheel",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "redirectToCalendar" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchWildcardQuery, FetchWildcardQueryVariables>;
